!(function () {
  "use strict";
  var e = {
      463: function (e, t, n) {
        var r = n(791),
          a = n(296);
        function o(e) {
          for (
            var t =
                "https://reactjs.org/docs/error-decoder.html?invariant=" + e,
              n = 1;
            n < arguments.length;
            n++
          )
            t += "&args[]=" + encodeURIComponent(arguments[n]);
          return (
            "Minified React error #" +
            e +
            "; visit " +
            t +
            " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
          );
        }
        var i = new Set(),
          l = {};
        function c(e, t) {
          s(e, t), s(e + "Capture", t);
        }
        function s(e, t) {
          for (l[e] = t, e = 0; e < t.length; e++) i.add(t[e]);
        }
        var u = !(
            "undefined" === typeof window ||
            "undefined" === typeof window.document ||
            "undefined" === typeof window.document.createElement
          ),
          d = Object.prototype.hasOwnProperty,
          p =
            /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
          f = {},
          m = {};
        function h(e, t, n, r, a, o, i) {
          (this.acceptsBooleans = 2 === t || 3 === t || 4 === t),
            (this.attributeName = r),
            (this.attributeNamespace = a),
            (this.mustUseProperty = n),
            (this.propertyName = e),
            (this.type = t),
            (this.sanitizeURL = o),
            (this.removeEmptyString = i);
        }
        var g = {};
        "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style"
          .split(" ")
          .forEach(function (e) {
            g[e] = new h(e, 0, !1, e, null, !1, !1);
          }),
          [
            ["acceptCharset", "accept-charset"],
            ["className", "class"],
            ["htmlFor", "for"],
            ["httpEquiv", "http-equiv"],
          ].forEach(function (e) {
            var t = e[0];
            g[t] = new h(t, 1, !1, e[1], null, !1, !1);
          }),
          ["contentEditable", "draggable", "spellCheck", "value"].forEach(
            function (e) {
              g[e] = new h(e, 2, !1, e.toLowerCase(), null, !1, !1);
            },
          ),
          [
            "autoReverse",
            "externalResourcesRequired",
            "focusable",
            "preserveAlpha",
          ].forEach(function (e) {
            g[e] = new h(e, 2, !1, e, null, !1, !1);
          }),
          "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope"
            .split(" ")
            .forEach(function (e) {
              g[e] = new h(e, 3, !1, e.toLowerCase(), null, !1, !1);
            }),
          ["checked", "multiple", "muted", "selected"].forEach(function (e) {
            g[e] = new h(e, 3, !0, e, null, !1, !1);
          }),
          ["capture", "download"].forEach(function (e) {
            g[e] = new h(e, 4, !1, e, null, !1, !1);
          }),
          ["cols", "rows", "size", "span"].forEach(function (e) {
            g[e] = new h(e, 6, !1, e, null, !1, !1);
          }),
          ["rowSpan", "start"].forEach(function (e) {
            g[e] = new h(e, 5, !1, e.toLowerCase(), null, !1, !1);
          });
        var v = /[\-:]([a-z])/g;
        function b(e) {
          return e[1].toUpperCase();
        }
        function y(e, t, n, r) {
          var a = g.hasOwnProperty(t) ? g[t] : null;
          (null !== a
            ? 0 !== a.type
            : r ||
              !(2 < t.length) ||
              ("o" !== t[0] && "O" !== t[0]) ||
              ("n" !== t[1] && "N" !== t[1])) &&
            ((function (e, t, n, r) {
              if (
                null === t ||
                "undefined" === typeof t ||
                (function (e, t, n, r) {
                  if (null !== n && 0 === n.type) return !1;
                  switch (typeof t) {
                    case "function":
                    case "symbol":
                      return !0;
                    case "boolean":
                      return (
                        !r &&
                        (null !== n
                          ? !n.acceptsBooleans
                          : "data-" !== (e = e.toLowerCase().slice(0, 5)) &&
                            "aria-" !== e)
                      );
                    default:
                      return !1;
                  }
                })(e, t, n, r)
              )
                return !0;
              if (r) return !1;
              if (null !== n)
                switch (n.type) {
                  case 3:
                    return !t;
                  case 4:
                    return !1 === t;
                  case 5:
                    return isNaN(t);
                  case 6:
                    return isNaN(t) || 1 > t;
                }
              return !1;
            })(t, n, a, r) && (n = null),
            r || null === a
              ? (function (e) {
                  return (
                    !!d.call(m, e) ||
                    (!d.call(f, e) &&
                      (p.test(e) ? (m[e] = !0) : ((f[e] = !0), !1)))
                  );
                })(t) &&
                (null === n ? e.removeAttribute(t) : e.setAttribute(t, "" + n))
              : a.mustUseProperty
                ? (e[a.propertyName] = null === n ? 3 !== a.type && "" : n)
                : ((t = a.attributeName),
                  (r = a.attributeNamespace),
                  null === n
                    ? e.removeAttribute(t)
                    : ((n =
                        3 === (a = a.type) || (4 === a && !0 === n)
                          ? ""
                          : "" + n),
                      r ? e.setAttributeNS(r, t, n) : e.setAttribute(t, n))));
        }
        "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height"
          .split(" ")
          .forEach(function (e) {
            var t = e.replace(v, b);
            g[t] = new h(t, 1, !1, e, null, !1, !1);
          }),
          "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type"
            .split(" ")
            .forEach(function (e) {
              var t = e.replace(v, b);
              g[t] = new h(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1, !1);
            }),
          ["xml:base", "xml:lang", "xml:space"].forEach(function (e) {
            var t = e.replace(v, b);
            g[t] = new h(
              t,
              1,
              !1,
              e,
              "http://www.w3.org/XML/1998/namespace",
              !1,
              !1,
            );
          }),
          ["tabIndex", "crossOrigin"].forEach(function (e) {
            g[e] = new h(e, 1, !1, e.toLowerCase(), null, !1, !1);
          }),
          (g.xlinkHref = new h(
            "xlinkHref",
            1,
            !1,
            "xlink:href",
            "http://www.w3.org/1999/xlink",
            !0,
            !1,
          )),
          ["src", "href", "action", "formAction"].forEach(function (e) {
            g[e] = new h(e, 1, !1, e.toLowerCase(), null, !0, !0);
          });
        var x = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
          w = Symbol.for("react.element"),
          k = Symbol.for("react.portal"),
          S = Symbol.for("react.fragment"),
          C = Symbol.for("react.strict_mode"),
          E = Symbol.for("react.profiler"),
          O = Symbol.for("react.provider"),
          A = Symbol.for("react.context"),
          j = Symbol.for("react.forward_ref"),
          L = Symbol.for("react.suspense"),
          N = Symbol.for("react.suspense_list"),
          T = Symbol.for("react.memo"),
          P = Symbol.for("react.lazy");
        Symbol.for("react.scope"), Symbol.for("react.debug_trace_mode");
        var D = Symbol.for("react.offscreen");
        Symbol.for("react.legacy_hidden"),
          Symbol.for("react.cache"),
          Symbol.for("react.tracing_marker");
        var z = Symbol.iterator;
        function M(e) {
          return null === e || "object" !== typeof e
            ? null
            : "function" === typeof (e = (z && e[z]) || e["@@iterator"])
              ? e
              : null;
        }
        var I,
          R = Object.assign;
        function F(e) {
          if (void 0 === I)
            try {
              throw Error();
            } catch (n) {
              var t = n.stack.trim().match(/\n( *(at )?)/);
              I = (t && t[1]) || "";
            }
          return "\n" + I + e;
        }
        var U = !1;
        function H(e, t) {
          if (!e || U) return "";
          U = !0;
          var n = Error.prepareStackTrace;
          Error.prepareStackTrace = void 0;
          try {
            if (t)
              if (
                ((t = function () {
                  throw Error();
                }),
                Object.defineProperty(t.prototype, "props", {
                  set: function () {
                    throw Error();
                  },
                }),
                "object" === typeof Reflect && Reflect.construct)
              ) {
                try {
                  Reflect.construct(t, []);
                } catch (s) {
                  var r = s;
                }
                Reflect.construct(e, [], t);
              } else {
                try {
                  t.call();
                } catch (s) {
                  r = s;
                }
                e.call(t.prototype);
              }
            else {
              try {
                throw Error();
              } catch (s) {
                r = s;
              }
              e();
            }
          } catch (s) {
            if (s && r && "string" === typeof s.stack) {
              for (
                var a = s.stack.split("\n"),
                  o = r.stack.split("\n"),
                  i = a.length - 1,
                  l = o.length - 1;
                1 <= i && 0 <= l && a[i] !== o[l];

              )
                l--;
              for (; 1 <= i && 0 <= l; i--, l--)
                if (a[i] !== o[l]) {
                  if (1 !== i || 1 !== l)
                    do {
                      if ((i--, 0 > --l || a[i] !== o[l])) {
                        var c = "\n" + a[i].replace(" at new ", " at ");
                        return (
                          e.displayName &&
                            c.includes("<anonymous>") &&
                            (c = c.replace("<anonymous>", e.displayName)),
                          c
                        );
                      }
                    } while (1 <= i && 0 <= l);
                  break;
                }
            }
          } finally {
            (U = !1), (Error.prepareStackTrace = n);
          }
          return (e = e ? e.displayName || e.name : "") ? F(e) : "";
        }
        function B(e) {
          switch (e.tag) {
            case 5:
              return F(e.type);
            case 16:
              return F("Lazy");
            case 13:
              return F("Suspense");
            case 19:
              return F("SuspenseList");
            case 0:
            case 2:
            case 15:
              return (e = H(e.type, !1));
            case 11:
              return (e = H(e.type.render, !1));
            case 1:
              return (e = H(e.type, !0));
            default:
              return "";
          }
        }
        function V(e) {
          if (null == e) return null;
          if ("function" === typeof e) return e.displayName || e.name || null;
          if ("string" === typeof e) return e;
          switch (e) {
            case S:
              return "Fragment";
            case k:
              return "Portal";
            case E:
              return "Profiler";
            case C:
              return "StrictMode";
            case L:
              return "Suspense";
            case N:
              return "SuspenseList";
          }
          if ("object" === typeof e)
            switch (e.$$typeof) {
              case A:
                return (e.displayName || "Context") + ".Consumer";
              case O:
                return (e._context.displayName || "Context") + ".Provider";
              case j:
                var t = e.render;
                return (
                  (e = e.displayName) ||
                    (e =
                      "" !== (e = t.displayName || t.name || "")
                        ? "ForwardRef(" + e + ")"
                        : "ForwardRef"),
                  e
                );
              case T:
                return null !== (t = e.displayName || null)
                  ? t
                  : V(e.type) || "Memo";
              case P:
                (t = e._payload), (e = e._init);
                try {
                  return V(e(t));
                } catch (n) {}
            }
          return null;
        }
        function W(e) {
          var t = e.type;
          switch (e.tag) {
            case 24:
              return "Cache";
            case 9:
              return (t.displayName || "Context") + ".Consumer";
            case 10:
              return (t._context.displayName || "Context") + ".Provider";
            case 18:
              return "DehydratedFragment";
            case 11:
              return (
                (e = (e = t.render).displayName || e.name || ""),
                t.displayName ||
                  ("" !== e ? "ForwardRef(" + e + ")" : "ForwardRef")
              );
            case 7:
              return "Fragment";
            case 5:
              return t;
            case 4:
              return "Portal";
            case 3:
              return "Root";
            case 6:
              return "Text";
            case 16:
              return V(t);
            case 8:
              return t === C ? "StrictMode" : "Mode";
            case 22:
              return "Offscreen";
            case 12:
              return "Profiler";
            case 21:
              return "Scope";
            case 13:
              return "Suspense";
            case 19:
              return "SuspenseList";
            case 25:
              return "TracingMarker";
            case 1:
            case 0:
            case 17:
            case 2:
            case 14:
            case 15:
              if ("function" === typeof t)
                return t.displayName || t.name || null;
              if ("string" === typeof t) return t;
          }
          return null;
        }
        function Z(e) {
          switch (typeof e) {
            case "boolean":
            case "number":
            case "string":
            case "undefined":
            case "object":
              return e;
            default:
              return "";
          }
        }
        function G(e) {
          var t = e.type;
          return (
            (e = e.nodeName) &&
            "input" === e.toLowerCase() &&
            ("checkbox" === t || "radio" === t)
          );
        }
        function q(e) {
          e._valueTracker ||
            (e._valueTracker = (function (e) {
              var t = G(e) ? "checked" : "value",
                n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t),
                r = "" + e[t];
              if (
                !e.hasOwnProperty(t) &&
                "undefined" !== typeof n &&
                "function" === typeof n.get &&
                "function" === typeof n.set
              ) {
                var a = n.get,
                  o = n.set;
                return (
                  Object.defineProperty(e, t, {
                    configurable: !0,
                    get: function () {
                      return a.call(this);
                    },
                    set: function (e) {
                      (r = "" + e), o.call(this, e);
                    },
                  }),
                  Object.defineProperty(e, t, { enumerable: n.enumerable }),
                  {
                    getValue: function () {
                      return r;
                    },
                    setValue: function (e) {
                      r = "" + e;
                    },
                    stopTracking: function () {
                      (e._valueTracker = null), delete e[t];
                    },
                  }
                );
              }
            })(e));
        }
        function X(e) {
          if (!e) return !1;
          var t = e._valueTracker;
          if (!t) return !0;
          var n = t.getValue(),
            r = "";
          return (
            e && (r = G(e) ? (e.checked ? "true" : "false") : e.value),
            (e = r) !== n && (t.setValue(e), !0)
          );
        }
        function _(e) {
          if (
            "undefined" ===
            typeof (e =
              e || ("undefined" !== typeof document ? document : void 0))
          )
            return null;
          try {
            return e.activeElement || e.body;
          } catch (t) {
            return e.body;
          }
        }
        function Y(e, t) {
          var n = t.checked;
          return R({}, t, {
            defaultChecked: void 0,
            defaultValue: void 0,
            value: void 0,
            checked: null != n ? n : e._wrapperState.initialChecked,
          });
        }
        function J(e, t) {
          var n = null == t.defaultValue ? "" : t.defaultValue,
            r = null != t.checked ? t.checked : t.defaultChecked;
          (n = Z(null != t.value ? t.value : n)),
            (e._wrapperState = {
              initialChecked: r,
              initialValue: n,
              controlled:
                "checkbox" === t.type || "radio" === t.type
                  ? null != t.checked
                  : null != t.value,
            });
        }
        function K(e, t) {
          null != (t = t.checked) && y(e, "checked", t, !1);
        }
        function Q(e, t) {
          K(e, t);
          var n = Z(t.value),
            r = t.type;
          if (null != n)
            "number" === r
              ? ((0 === n && "" === e.value) || e.value != n) &&
                (e.value = "" + n)
              : e.value !== "" + n && (e.value = "" + n);
          else if ("submit" === r || "reset" === r)
            return void e.removeAttribute("value");
          t.hasOwnProperty("value")
            ? ee(e, t.type, n)
            : t.hasOwnProperty("defaultValue") &&
              ee(e, t.type, Z(t.defaultValue)),
            null == t.checked &&
              null != t.defaultChecked &&
              (e.defaultChecked = !!t.defaultChecked);
        }
        function $(e, t, n) {
          if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
            var r = t.type;
            if (
              !(
                ("submit" !== r && "reset" !== r) ||
                (void 0 !== t.value && null !== t.value)
              )
            )
              return;
            (t = "" + e._wrapperState.initialValue),
              n || t === e.value || (e.value = t),
              (e.defaultValue = t);
          }
          "" !== (n = e.name) && (e.name = ""),
            (e.defaultChecked = !!e._wrapperState.initialChecked),
            "" !== n && (e.name = n);
        }
        function ee(e, t, n) {
          ("number" === t && _(e.ownerDocument) === e) ||
            (null == n
              ? (e.defaultValue = "" + e._wrapperState.initialValue)
              : e.defaultValue !== "" + n && (e.defaultValue = "" + n));
        }
        var te = Array.isArray;
        function ne(e, t, n, r) {
          if (((e = e.options), t)) {
            t = {};
            for (var a = 0; a < n.length; a++) t["$" + n[a]] = !0;
            for (n = 0; n < e.length; n++)
              (a = t.hasOwnProperty("$" + e[n].value)),
                e[n].selected !== a && (e[n].selected = a),
                a && r && (e[n].defaultSelected = !0);
          } else {
            for (n = "" + Z(n), t = null, a = 0; a < e.length; a++) {
              if (e[a].value === n)
                return (
                  (e[a].selected = !0), void (r && (e[a].defaultSelected = !0))
                );
              null !== t || e[a].disabled || (t = e[a]);
            }
            null !== t && (t.selected = !0);
          }
        }
        function re(e, t) {
          if (null != t.dangerouslySetInnerHTML) throw Error(o(91));
          return R({}, t, {
            value: void 0,
            defaultValue: void 0,
            children: "" + e._wrapperState.initialValue,
          });
        }
        function ae(e, t) {
          var n = t.value;
          if (null == n) {
            if (((n = t.children), (t = t.defaultValue), null != n)) {
              if (null != t) throw Error(o(92));
              if (te(n)) {
                if (1 < n.length) throw Error(o(93));
                n = n[0];
              }
              t = n;
            }
            null == t && (t = ""), (n = t);
          }
          e._wrapperState = { initialValue: Z(n) };
        }
        function oe(e, t) {
          var n = Z(t.value),
            r = Z(t.defaultValue);
          null != n &&
            ((n = "" + n) !== e.value && (e.value = n),
            null == t.defaultValue &&
              e.defaultValue !== n &&
              (e.defaultValue = n)),
            null != r && (e.defaultValue = "" + r);
        }
        function ie(e) {
          var t = e.textContent;
          t === e._wrapperState.initialValue &&
            "" !== t &&
            null !== t &&
            (e.value = t);
        }
        function le(e) {
          switch (e) {
            case "svg":
              return "http://www.w3.org/2000/svg";
            case "math":
              return "http://www.w3.org/1998/Math/MathML";
            default:
              return "http://www.w3.org/1999/xhtml";
          }
        }
        function ce(e, t) {
          return null == e || "http://www.w3.org/1999/xhtml" === e
            ? le(t)
            : "http://www.w3.org/2000/svg" === e && "foreignObject" === t
              ? "http://www.w3.org/1999/xhtml"
              : e;
        }
        var se,
          ue,
          de =
            ((ue = function (e, t) {
              if (
                "http://www.w3.org/2000/svg" !== e.namespaceURI ||
                "innerHTML" in e
              )
                e.innerHTML = t;
              else {
                for (
                  (se = se || document.createElement("div")).innerHTML =
                    "<svg>" + t.valueOf().toString() + "</svg>",
                    t = se.firstChild;
                  e.firstChild;

                )
                  e.removeChild(e.firstChild);
                for (; t.firstChild; ) e.appendChild(t.firstChild);
              }
            }),
            "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction
              ? function (e, t, n, r) {
                  MSApp.execUnsafeLocalFunction(function () {
                    return ue(e, t);
                  });
                }
              : ue);
        function pe(e, t) {
          if (t) {
            var n = e.firstChild;
            if (n && n === e.lastChild && 3 === n.nodeType)
              return void (n.nodeValue = t);
          }
          e.textContent = t;
        }
        var fe = {
            animationIterationCount: !0,
            aspectRatio: !0,
            borderImageOutset: !0,
            borderImageSlice: !0,
            borderImageWidth: !0,
            boxFlex: !0,
            boxFlexGroup: !0,
            boxOrdinalGroup: !0,
            columnCount: !0,
            columns: !0,
            flex: !0,
            flexGrow: !0,
            flexPositive: !0,
            flexShrink: !0,
            flexNegative: !0,
            flexOrder: !0,
            gridArea: !0,
            gridRow: !0,
            gridRowEnd: !0,
            gridRowSpan: !0,
            gridRowStart: !0,
            gridColumn: !0,
            gridColumnEnd: !0,
            gridColumnSpan: !0,
            gridColumnStart: !0,
            fontWeight: !0,
            lineClamp: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            tabSize: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0,
            fillOpacity: !0,
            floodOpacity: !0,
            stopOpacity: !0,
            strokeDasharray: !0,
            strokeDashoffset: !0,
            strokeMiterlimit: !0,
            strokeOpacity: !0,
            strokeWidth: !0,
          },
          me = ["Webkit", "ms", "Moz", "O"];
        function he(e, t, n) {
          return null == t || "boolean" === typeof t || "" === t
            ? ""
            : n ||
                "number" !== typeof t ||
                0 === t ||
                (fe.hasOwnProperty(e) && fe[e])
              ? ("" + t).trim()
              : t + "px";
        }
        function ge(e, t) {
          for (var n in ((e = e.style), t))
            if (t.hasOwnProperty(n)) {
              var r = 0 === n.indexOf("--"),
                a = he(n, t[n], r);
              "float" === n && (n = "cssFloat"),
                r ? e.setProperty(n, a) : (e[n] = a);
            }
        }
        Object.keys(fe).forEach(function (e) {
          me.forEach(function (t) {
            (t = t + e.charAt(0).toUpperCase() + e.substring(1)),
              (fe[t] = fe[e]);
          });
        });
        var ve = R(
          { menuitem: !0 },
          {
            area: !0,
            base: !0,
            br: !0,
            col: !0,
            embed: !0,
            hr: !0,
            img: !0,
            input: !0,
            keygen: !0,
            link: !0,
            meta: !0,
            param: !0,
            source: !0,
            track: !0,
            wbr: !0,
          },
        );
        function be(e, t) {
          if (t) {
            if (
              ve[e] &&
              (null != t.children || null != t.dangerouslySetInnerHTML)
            )
              throw Error(o(137, e));
            if (null != t.dangerouslySetInnerHTML) {
              if (null != t.children) throw Error(o(60));
              if (
                "object" !== typeof t.dangerouslySetInnerHTML ||
                !("__html" in t.dangerouslySetInnerHTML)
              )
                throw Error(o(61));
            }
            if (null != t.style && "object" !== typeof t.style)
              throw Error(o(62));
          }
        }
        function ye(e, t) {
          if (-1 === e.indexOf("-")) return "string" === typeof t.is;
          switch (e) {
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
              return !1;
            default:
              return !0;
          }
        }
        var xe = null;
        function we(e) {
          return (
            (e = e.target || e.srcElement || window).correspondingUseElement &&
              (e = e.correspondingUseElement),
            3 === e.nodeType ? e.parentNode : e
          );
        }
        var ke = null,
          Se = null,
          Ce = null;
        function Ee(e) {
          if ((e = ya(e))) {
            if ("function" !== typeof ke) throw Error(o(280));
            var t = e.stateNode;
            t && ((t = wa(t)), ke(e.stateNode, e.type, t));
          }
        }
        function Oe(e) {
          Se ? (Ce ? Ce.push(e) : (Ce = [e])) : (Se = e);
        }
        function Ae() {
          if (Se) {
            var e = Se,
              t = Ce;
            if (((Ce = Se = null), Ee(e), t))
              for (e = 0; e < t.length; e++) Ee(t[e]);
          }
        }
        function je(e, t) {
          return e(t);
        }
        function Le() {}
        var Ne = !1;
        function Te(e, t, n) {
          if (Ne) return e(t, n);
          Ne = !0;
          try {
            return je(e, t, n);
          } finally {
            (Ne = !1), (null !== Se || null !== Ce) && (Le(), Ae());
          }
        }
        function Pe(e, t) {
          var n = e.stateNode;
          if (null === n) return null;
          var r = wa(n);
          if (null === r) return null;
          n = r[t];
          e: switch (t) {
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
              (r = !r.disabled) ||
                (r = !(
                  "button" === (e = e.type) ||
                  "input" === e ||
                  "select" === e ||
                  "textarea" === e
                )),
                (e = !r);
              break e;
            default:
              e = !1;
          }
          if (e) return null;
          if (n && "function" !== typeof n) throw Error(o(231, t, typeof n));
          return n;
        }
        var De = !1;
        if (u)
          try {
            var ze = {};
            Object.defineProperty(ze, "passive", {
              get: function () {
                De = !0;
              },
            }),
              window.addEventListener("test", ze, ze),
              window.removeEventListener("test", ze, ze);
          } catch (ue) {
            De = !1;
          }
        function Me(e, t, n, r, a, o, i, l, c) {
          var s = Array.prototype.slice.call(arguments, 3);
          try {
            t.apply(n, s);
          } catch (u) {
            this.onError(u);
          }
        }
        var Ie = !1,
          Re = null,
          Fe = !1,
          Ue = null,
          He = {
            onError: function (e) {
              (Ie = !0), (Re = e);
            },
          };
        function Be(e, t, n, r, a, o, i, l, c) {
          (Ie = !1), (Re = null), Me.apply(He, arguments);
        }
        function Ve(e) {
          var t = e,
            n = e;
          if (e.alternate) for (; t.return; ) t = t.return;
          else {
            e = t;
            do {
              0 !== (4098 & (t = e).flags) && (n = t.return), (e = t.return);
            } while (e);
          }
          return 3 === t.tag ? n : null;
        }
        function We(e) {
          if (13 === e.tag) {
            var t = e.memoizedState;
            if (
              (null === t &&
                null !== (e = e.alternate) &&
                (t = e.memoizedState),
              null !== t)
            )
              return t.dehydrated;
          }
          return null;
        }
        function Ze(e) {
          if (Ve(e) !== e) throw Error(o(188));
        }
        function Ge(e) {
          return null !==
            (e = (function (e) {
              var t = e.alternate;
              if (!t) {
                if (null === (t = Ve(e))) throw Error(o(188));
                return t !== e ? null : e;
              }
              for (var n = e, r = t; ; ) {
                var a = n.return;
                if (null === a) break;
                var i = a.alternate;
                if (null === i) {
                  if (null !== (r = a.return)) {
                    n = r;
                    continue;
                  }
                  break;
                }
                if (a.child === i.child) {
                  for (i = a.child; i; ) {
                    if (i === n) return Ze(a), e;
                    if (i === r) return Ze(a), t;
                    i = i.sibling;
                  }
                  throw Error(o(188));
                }
                if (n.return !== r.return) (n = a), (r = i);
                else {
                  for (var l = !1, c = a.child; c; ) {
                    if (c === n) {
                      (l = !0), (n = a), (r = i);
                      break;
                    }
                    if (c === r) {
                      (l = !0), (r = a), (n = i);
                      break;
                    }
                    c = c.sibling;
                  }
                  if (!l) {
                    for (c = i.child; c; ) {
                      if (c === n) {
                        (l = !0), (n = i), (r = a);
                        break;
                      }
                      if (c === r) {
                        (l = !0), (r = i), (n = a);
                        break;
                      }
                      c = c.sibling;
                    }
                    if (!l) throw Error(o(189));
                  }
                }
                if (n.alternate !== r) throw Error(o(190));
              }
              if (3 !== n.tag) throw Error(o(188));
              return n.stateNode.current === n ? e : t;
            })(e))
            ? qe(e)
            : null;
        }
        function qe(e) {
          if (5 === e.tag || 6 === e.tag) return e;
          for (e = e.child; null !== e; ) {
            var t = qe(e);
            if (null !== t) return t;
            e = e.sibling;
          }
          return null;
        }
        var Xe = a.unstable_scheduleCallback,
          _e = a.unstable_cancelCallback,
          Ye = a.unstable_shouldYield,
          Je = a.unstable_requestPaint,
          Ke = a.unstable_now,
          Qe = a.unstable_getCurrentPriorityLevel,
          $e = a.unstable_ImmediatePriority,
          et = a.unstable_UserBlockingPriority,
          tt = a.unstable_NormalPriority,
          nt = a.unstable_LowPriority,
          rt = a.unstable_IdlePriority,
          at = null,
          ot = null;
        var it = Math.clz32
            ? Math.clz32
            : function (e) {
                return (e >>>= 0), 0 === e ? 32 : (31 - ((lt(e) / ct) | 0)) | 0;
              },
          lt = Math.log,
          ct = Math.LN2;
        var st = 64,
          ut = 4194304;
        function dt(e) {
          switch (e & -e) {
            case 1:
              return 1;
            case 2:
              return 2;
            case 4:
              return 4;
            case 8:
              return 8;
            case 16:
              return 16;
            case 32:
              return 32;
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return 4194240 & e;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
              return 130023424 & e;
            case 134217728:
              return 134217728;
            case 268435456:
              return 268435456;
            case 536870912:
              return 536870912;
            case 1073741824:
              return 1073741824;
            default:
              return e;
          }
        }
        function pt(e, t) {
          var n = e.pendingLanes;
          if (0 === n) return 0;
          var r = 0,
            a = e.suspendedLanes,
            o = e.pingedLanes,
            i = 268435455 & n;
          if (0 !== i) {
            var l = i & ~a;
            0 !== l ? (r = dt(l)) : 0 !== (o &= i) && (r = dt(o));
          } else 0 !== (i = n & ~a) ? (r = dt(i)) : 0 !== o && (r = dt(o));
          if (0 === r) return 0;
          if (
            0 !== t &&
            t !== r &&
            0 === (t & a) &&
            ((a = r & -r) >= (o = t & -t) || (16 === a && 0 !== (4194240 & o)))
          )
            return t;
          if ((0 !== (4 & r) && (r |= 16 & n), 0 !== (t = e.entangledLanes)))
            for (e = e.entanglements, t &= r; 0 < t; )
              (a = 1 << (n = 31 - it(t))), (r |= e[n]), (t &= ~a);
          return r;
        }
        function ft(e, t) {
          switch (e) {
            case 1:
            case 2:
            case 4:
              return t + 250;
            case 8:
            case 16:
            case 32:
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return t + 5e3;
            default:
              return -1;
          }
        }
        function mt(e) {
          return 0 !== (e = -1073741825 & e.pendingLanes)
            ? e
            : 1073741824 & e
              ? 1073741824
              : 0;
        }
        function ht() {
          var e = st;
          return 0 === (4194240 & (st <<= 1)) && (st = 64), e;
        }
        function gt(e) {
          for (var t = [], n = 0; 31 > n; n++) t.push(e);
          return t;
        }
        function vt(e, t, n) {
          (e.pendingLanes |= t),
            536870912 !== t && ((e.suspendedLanes = 0), (e.pingedLanes = 0)),
            ((e = e.eventTimes)[(t = 31 - it(t))] = n);
        }
        function bt(e, t) {
          var n = (e.entangledLanes |= t);
          for (e = e.entanglements; n; ) {
            var r = 31 - it(n),
              a = 1 << r;
            (a & t) | (e[r] & t) && (e[r] |= t), (n &= ~a);
          }
        }
        var yt = 0;
        function xt(e) {
          return 1 < (e &= -e)
            ? 4 < e
              ? 0 !== (268435455 & e)
                ? 16
                : 536870912
              : 4
            : 1;
        }
        var wt,
          kt,
          St,
          Ct,
          Et,
          Ot = !1,
          At = [],
          jt = null,
          Lt = null,
          Nt = null,
          Tt = new Map(),
          Pt = new Map(),
          Dt = [],
          zt =
            "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(
              " ",
            );
        function Mt(e, t) {
          switch (e) {
            case "focusin":
            case "focusout":
              jt = null;
              break;
            case "dragenter":
            case "dragleave":
              Lt = null;
              break;
            case "mouseover":
            case "mouseout":
              Nt = null;
              break;
            case "pointerover":
            case "pointerout":
              Tt.delete(t.pointerId);
              break;
            case "gotpointercapture":
            case "lostpointercapture":
              Pt.delete(t.pointerId);
          }
        }
        function It(e, t, n, r, a, o) {
          return null === e || e.nativeEvent !== o
            ? ((e = {
                blockedOn: t,
                domEventName: n,
                eventSystemFlags: r,
                nativeEvent: o,
                targetContainers: [a],
              }),
              null !== t && null !== (t = ya(t)) && kt(t),
              e)
            : ((e.eventSystemFlags |= r),
              (t = e.targetContainers),
              null !== a && -1 === t.indexOf(a) && t.push(a),
              e);
        }
        function Rt(e) {
          var t = ba(e.target);
          if (null !== t) {
            var n = Ve(t);
            if (null !== n)
              if (13 === (t = n.tag)) {
                if (null !== (t = We(n)))
                  return (
                    (e.blockedOn = t),
                    void Et(e.priority, function () {
                      St(n);
                    })
                  );
              } else if (
                3 === t &&
                n.stateNode.current.memoizedState.isDehydrated
              )
                return void (e.blockedOn =
                  3 === n.tag ? n.stateNode.containerInfo : null);
          }
          e.blockedOn = null;
        }
        function Ft(e) {
          if (null !== e.blockedOn) return !1;
          for (var t = e.targetContainers; 0 < t.length; ) {
            var n = Yt(e.domEventName, e.eventSystemFlags, t[0], e.nativeEvent);
            if (null !== n)
              return null !== (t = ya(n)) && kt(t), (e.blockedOn = n), !1;
            var r = new (n = e.nativeEvent).constructor(n.type, n);
            (xe = r), n.target.dispatchEvent(r), (xe = null), t.shift();
          }
          return !0;
        }
        function Ut(e, t, n) {
          Ft(e) && n.delete(t);
        }
        function Ht() {
          (Ot = !1),
            null !== jt && Ft(jt) && (jt = null),
            null !== Lt && Ft(Lt) && (Lt = null),
            null !== Nt && Ft(Nt) && (Nt = null),
            Tt.forEach(Ut),
            Pt.forEach(Ut);
        }
        function Bt(e, t) {
          e.blockedOn === t &&
            ((e.blockedOn = null),
            Ot ||
              ((Ot = !0),
              a.unstable_scheduleCallback(a.unstable_NormalPriority, Ht)));
        }
        function Vt(e) {
          function t(t) {
            return Bt(t, e);
          }
          if (0 < At.length) {
            Bt(At[0], e);
            for (var n = 1; n < At.length; n++) {
              var r = At[n];
              r.blockedOn === e && (r.blockedOn = null);
            }
          }
          for (
            null !== jt && Bt(jt, e),
              null !== Lt && Bt(Lt, e),
              null !== Nt && Bt(Nt, e),
              Tt.forEach(t),
              Pt.forEach(t),
              n = 0;
            n < Dt.length;
            n++
          )
            (r = Dt[n]).blockedOn === e && (r.blockedOn = null);
          for (; 0 < Dt.length && null === (n = Dt[0]).blockedOn; )
            Rt(n), null === n.blockedOn && Dt.shift();
        }
        var Wt = x.ReactCurrentBatchConfig,
          Zt = !0;
        function Gt(e, t, n, r) {
          var a = yt,
            o = Wt.transition;
          Wt.transition = null;
          try {
            (yt = 1), Xt(e, t, n, r);
          } finally {
            (yt = a), (Wt.transition = o);
          }
        }
        function qt(e, t, n, r) {
          var a = yt,
            o = Wt.transition;
          Wt.transition = null;
          try {
            (yt = 4), Xt(e, t, n, r);
          } finally {
            (yt = a), (Wt.transition = o);
          }
        }
        function Xt(e, t, n, r) {
          if (Zt) {
            var a = Yt(e, t, n, r);
            if (null === a) Zr(e, t, r, _t, n), Mt(e, r);
            else if (
              (function (e, t, n, r, a) {
                switch (t) {
                  case "focusin":
                    return (jt = It(jt, e, t, n, r, a)), !0;
                  case "dragenter":
                    return (Lt = It(Lt, e, t, n, r, a)), !0;
                  case "mouseover":
                    return (Nt = It(Nt, e, t, n, r, a)), !0;
                  case "pointerover":
                    var o = a.pointerId;
                    return Tt.set(o, It(Tt.get(o) || null, e, t, n, r, a)), !0;
                  case "gotpointercapture":
                    return (
                      (o = a.pointerId),
                      Pt.set(o, It(Pt.get(o) || null, e, t, n, r, a)),
                      !0
                    );
                }
                return !1;
              })(a, e, t, n, r)
            )
              r.stopPropagation();
            else if ((Mt(e, r), 4 & t && -1 < zt.indexOf(e))) {
              for (; null !== a; ) {
                var o = ya(a);
                if (
                  (null !== o && wt(o),
                  null === (o = Yt(e, t, n, r)) && Zr(e, t, r, _t, n),
                  o === a)
                )
                  break;
                a = o;
              }
              null !== a && r.stopPropagation();
            } else Zr(e, t, r, null, n);
          }
        }
        var _t = null;
        function Yt(e, t, n, r) {
          if (((_t = null), null !== (e = ba((e = we(r))))))
            if (null === (t = Ve(e))) e = null;
            else if (13 === (n = t.tag)) {
              if (null !== (e = We(t))) return e;
              e = null;
            } else if (3 === n) {
              if (t.stateNode.current.memoizedState.isDehydrated)
                return 3 === t.tag ? t.stateNode.containerInfo : null;
              e = null;
            } else t !== e && (e = null);
          return (_t = e), null;
        }
        function Jt(e) {
          switch (e) {
            case "cancel":
            case "click":
            case "close":
            case "contextmenu":
            case "copy":
            case "cut":
            case "auxclick":
            case "dblclick":
            case "dragend":
            case "dragstart":
            case "drop":
            case "focusin":
            case "focusout":
            case "input":
            case "invalid":
            case "keydown":
            case "keypress":
            case "keyup":
            case "mousedown":
            case "mouseup":
            case "paste":
            case "pause":
            case "play":
            case "pointercancel":
            case "pointerdown":
            case "pointerup":
            case "ratechange":
            case "reset":
            case "resize":
            case "seeked":
            case "submit":
            case "touchcancel":
            case "touchend":
            case "touchstart":
            case "volumechange":
            case "change":
            case "selectionchange":
            case "textInput":
            case "compositionstart":
            case "compositionend":
            case "compositionupdate":
            case "beforeblur":
            case "afterblur":
            case "beforeinput":
            case "blur":
            case "fullscreenchange":
            case "focus":
            case "hashchange":
            case "popstate":
            case "select":
            case "selectstart":
              return 1;
            case "drag":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "mousemove":
            case "mouseout":
            case "mouseover":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "scroll":
            case "toggle":
            case "touchmove":
            case "wheel":
            case "mouseenter":
            case "mouseleave":
            case "pointerenter":
            case "pointerleave":
              return 4;
            case "message":
              switch (Qe()) {
                case $e:
                  return 1;
                case et:
                  return 4;
                case tt:
                case nt:
                  return 16;
                case rt:
                  return 536870912;
                default:
                  return 16;
              }
            default:
              return 16;
          }
        }
        var Kt = null,
          Qt = null,
          $t = null;
        function en() {
          if ($t) return $t;
          var e,
            t,
            n = Qt,
            r = n.length,
            a = "value" in Kt ? Kt.value : Kt.textContent,
            o = a.length;
          for (e = 0; e < r && n[e] === a[e]; e++);
          var i = r - e;
          for (t = 1; t <= i && n[r - t] === a[o - t]; t++);
          return ($t = a.slice(e, 1 < t ? 1 - t : void 0));
        }
        function tn(e) {
          var t = e.keyCode;
          return (
            "charCode" in e
              ? 0 === (e = e.charCode) && 13 === t && (e = 13)
              : (e = t),
            10 === e && (e = 13),
            32 <= e || 13 === e ? e : 0
          );
        }
        function nn() {
          return !0;
        }
        function rn() {
          return !1;
        }
        function an(e) {
          function t(t, n, r, a, o) {
            for (var i in ((this._reactName = t),
            (this._targetInst = r),
            (this.type = n),
            (this.nativeEvent = a),
            (this.target = o),
            (this.currentTarget = null),
            e))
              e.hasOwnProperty(i) && ((t = e[i]), (this[i] = t ? t(a) : a[i]));
            return (
              (this.isDefaultPrevented = (
                null != a.defaultPrevented
                  ? a.defaultPrevented
                  : !1 === a.returnValue
              )
                ? nn
                : rn),
              (this.isPropagationStopped = rn),
              this
            );
          }
          return (
            R(t.prototype, {
              preventDefault: function () {
                this.defaultPrevented = !0;
                var e = this.nativeEvent;
                e &&
                  (e.preventDefault
                    ? e.preventDefault()
                    : "unknown" !== typeof e.returnValue &&
                      (e.returnValue = !1),
                  (this.isDefaultPrevented = nn));
              },
              stopPropagation: function () {
                var e = this.nativeEvent;
                e &&
                  (e.stopPropagation
                    ? e.stopPropagation()
                    : "unknown" !== typeof e.cancelBubble &&
                      (e.cancelBubble = !0),
                  (this.isPropagationStopped = nn));
              },
              persist: function () {},
              isPersistent: nn,
            }),
            t
          );
        }
        var on,
          ln,
          cn,
          sn = {
            eventPhase: 0,
            bubbles: 0,
            cancelable: 0,
            timeStamp: function (e) {
              return e.timeStamp || Date.now();
            },
            defaultPrevented: 0,
            isTrusted: 0,
          },
          un = an(sn),
          dn = R({}, sn, { view: 0, detail: 0 }),
          pn = an(dn),
          fn = R({}, dn, {
            screenX: 0,
            screenY: 0,
            clientX: 0,
            clientY: 0,
            pageX: 0,
            pageY: 0,
            ctrlKey: 0,
            shiftKey: 0,
            altKey: 0,
            metaKey: 0,
            getModifierState: En,
            button: 0,
            buttons: 0,
            relatedTarget: function (e) {
              return void 0 === e.relatedTarget
                ? e.fromElement === e.srcElement
                  ? e.toElement
                  : e.fromElement
                : e.relatedTarget;
            },
            movementX: function (e) {
              return "movementX" in e
                ? e.movementX
                : (e !== cn &&
                    (cn && "mousemove" === e.type
                      ? ((on = e.screenX - cn.screenX),
                        (ln = e.screenY - cn.screenY))
                      : (ln = on = 0),
                    (cn = e)),
                  on);
            },
            movementY: function (e) {
              return "movementY" in e ? e.movementY : ln;
            },
          }),
          mn = an(fn),
          hn = an(R({}, fn, { dataTransfer: 0 })),
          gn = an(R({}, dn, { relatedTarget: 0 })),
          vn = an(
            R({}, sn, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }),
          ),
          bn = R({}, sn, {
            clipboardData: function (e) {
              return "clipboardData" in e
                ? e.clipboardData
                : window.clipboardData;
            },
          }),
          yn = an(bn),
          xn = an(R({}, sn, { data: 0 })),
          wn = {
            Esc: "Escape",
            Spacebar: " ",
            Left: "ArrowLeft",
            Up: "ArrowUp",
            Right: "ArrowRight",
            Down: "ArrowDown",
            Del: "Delete",
            Win: "OS",
            Menu: "ContextMenu",
            Apps: "ContextMenu",
            Scroll: "ScrollLock",
            MozPrintableKey: "Unidentified",
          },
          kn = {
            8: "Backspace",
            9: "Tab",
            12: "Clear",
            13: "Enter",
            16: "Shift",
            17: "Control",
            18: "Alt",
            19: "Pause",
            20: "CapsLock",
            27: "Escape",
            32: " ",
            33: "PageUp",
            34: "PageDown",
            35: "End",
            36: "Home",
            37: "ArrowLeft",
            38: "ArrowUp",
            39: "ArrowRight",
            40: "ArrowDown",
            45: "Insert",
            46: "Delete",
            112: "F1",
            113: "F2",
            114: "F3",
            115: "F4",
            116: "F5",
            117: "F6",
            118: "F7",
            119: "F8",
            120: "F9",
            121: "F10",
            122: "F11",
            123: "F12",
            144: "NumLock",
            145: "ScrollLock",
            224: "Meta",
          },
          Sn = {
            Alt: "altKey",
            Control: "ctrlKey",
            Meta: "metaKey",
            Shift: "shiftKey",
          };
        function Cn(e) {
          var t = this.nativeEvent;
          return t.getModifierState
            ? t.getModifierState(e)
            : !!(e = Sn[e]) && !!t[e];
        }
        function En() {
          return Cn;
        }
        var On = R({}, dn, {
            key: function (e) {
              if (e.key) {
                var t = wn[e.key] || e.key;
                if ("Unidentified" !== t) return t;
              }
              return "keypress" === e.type
                ? 13 === (e = tn(e))
                  ? "Enter"
                  : String.fromCharCode(e)
                : "keydown" === e.type || "keyup" === e.type
                  ? kn[e.keyCode] || "Unidentified"
                  : "";
            },
            code: 0,
            location: 0,
            ctrlKey: 0,
            shiftKey: 0,
            altKey: 0,
            metaKey: 0,
            repeat: 0,
            locale: 0,
            getModifierState: En,
            charCode: function (e) {
              return "keypress" === e.type ? tn(e) : 0;
            },
            keyCode: function (e) {
              return "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
            },
            which: function (e) {
              return "keypress" === e.type
                ? tn(e)
                : "keydown" === e.type || "keyup" === e.type
                  ? e.keyCode
                  : 0;
            },
          }),
          An = an(On),
          jn = an(
            R({}, fn, {
              pointerId: 0,
              width: 0,
              height: 0,
              pressure: 0,
              tangentialPressure: 0,
              tiltX: 0,
              tiltY: 0,
              twist: 0,
              pointerType: 0,
              isPrimary: 0,
            }),
          ),
          Ln = an(
            R({}, dn, {
              touches: 0,
              targetTouches: 0,
              changedTouches: 0,
              altKey: 0,
              metaKey: 0,
              ctrlKey: 0,
              shiftKey: 0,
              getModifierState: En,
            }),
          ),
          Nn = an(
            R({}, sn, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }),
          ),
          Tn = R({}, fn, {
            deltaX: function (e) {
              return "deltaX" in e
                ? e.deltaX
                : "wheelDeltaX" in e
                  ? -e.wheelDeltaX
                  : 0;
            },
            deltaY: function (e) {
              return "deltaY" in e
                ? e.deltaY
                : "wheelDeltaY" in e
                  ? -e.wheelDeltaY
                  : "wheelDelta" in e
                    ? -e.wheelDelta
                    : 0;
            },
            deltaZ: 0,
            deltaMode: 0,
          }),
          Pn = an(Tn),
          Dn = [9, 13, 27, 32],
          zn = u && "CompositionEvent" in window,
          Mn = null;
        u && "documentMode" in document && (Mn = document.documentMode);
        var In = u && "TextEvent" in window && !Mn,
          Rn = u && (!zn || (Mn && 8 < Mn && 11 >= Mn)),
          Fn = String.fromCharCode(32),
          Un = !1;
        function Hn(e, t) {
          switch (e) {
            case "keyup":
              return -1 !== Dn.indexOf(t.keyCode);
            case "keydown":
              return 229 !== t.keyCode;
            case "keypress":
            case "mousedown":
            case "focusout":
              return !0;
            default:
              return !1;
          }
        }
        function Bn(e) {
          return "object" === typeof (e = e.detail) && "data" in e
            ? e.data
            : null;
        }
        var Vn = !1;
        var Wn = {
          color: !0,
          date: !0,
          datetime: !0,
          "datetime-local": !0,
          email: !0,
          month: !0,
          number: !0,
          password: !0,
          range: !0,
          search: !0,
          tel: !0,
          text: !0,
          time: !0,
          url: !0,
          week: !0,
        };
        function Zn(e) {
          var t = e && e.nodeName && e.nodeName.toLowerCase();
          return "input" === t ? !!Wn[e.type] : "textarea" === t;
        }
        function Gn(e, t, n, r) {
          Oe(r),
            0 < (t = qr(t, "onChange")).length &&
              ((n = new un("onChange", "change", null, n, r)),
              e.push({ event: n, listeners: t }));
        }
        var qn = null,
          Xn = null;
        function _n(e) {
          Fr(e, 0);
        }
        function Yn(e) {
          if (X(xa(e))) return e;
        }
        function Jn(e, t) {
          if ("change" === e) return t;
        }
        var Kn = !1;
        if (u) {
          var Qn;
          if (u) {
            var $n = "oninput" in document;
            if (!$n) {
              var er = document.createElement("div");
              er.setAttribute("oninput", "return;"),
                ($n = "function" === typeof er.oninput);
            }
            Qn = $n;
          } else Qn = !1;
          Kn = Qn && (!document.documentMode || 9 < document.documentMode);
        }
        function tr() {
          qn && (qn.detachEvent("onpropertychange", nr), (Xn = qn = null));
        }
        function nr(e) {
          if ("value" === e.propertyName && Yn(Xn)) {
            var t = [];
            Gn(t, Xn, e, we(e)), Te(_n, t);
          }
        }
        function rr(e, t, n) {
          "focusin" === e
            ? (tr(), (Xn = n), (qn = t).attachEvent("onpropertychange", nr))
            : "focusout" === e && tr();
        }
        function ar(e) {
          if ("selectionchange" === e || "keyup" === e || "keydown" === e)
            return Yn(Xn);
        }
        function or(e, t) {
          if ("click" === e) return Yn(t);
        }
        function ir(e, t) {
          if ("input" === e || "change" === e) return Yn(t);
        }
        var lr =
          "function" === typeof Object.is
            ? Object.is
            : function (e, t) {
                return (
                  (e === t && (0 !== e || 1 / e === 1 / t)) ||
                  (e !== e && t !== t)
                );
              };
        function cr(e, t) {
          if (lr(e, t)) return !0;
          if (
            "object" !== typeof e ||
            null === e ||
            "object" !== typeof t ||
            null === t
          )
            return !1;
          var n = Object.keys(e),
            r = Object.keys(t);
          if (n.length !== r.length) return !1;
          for (r = 0; r < n.length; r++) {
            var a = n[r];
            if (!d.call(t, a) || !lr(e[a], t[a])) return !1;
          }
          return !0;
        }
        function sr(e) {
          for (; e && e.firstChild; ) e = e.firstChild;
          return e;
        }
        function ur(e, t) {
          var n,
            r = sr(e);
          for (e = 0; r; ) {
            if (3 === r.nodeType) {
              if (((n = e + r.textContent.length), e <= t && n >= t))
                return { node: r, offset: t - e };
              e = n;
            }
            e: {
              for (; r; ) {
                if (r.nextSibling) {
                  r = r.nextSibling;
                  break e;
                }
                r = r.parentNode;
              }
              r = void 0;
            }
            r = sr(r);
          }
        }
        function dr(e, t) {
          return (
            !(!e || !t) &&
            (e === t ||
              ((!e || 3 !== e.nodeType) &&
                (t && 3 === t.nodeType
                  ? dr(e, t.parentNode)
                  : "contains" in e
                    ? e.contains(t)
                    : !!e.compareDocumentPosition &&
                      !!(16 & e.compareDocumentPosition(t)))))
          );
        }
        function pr() {
          for (var e = window, t = _(); t instanceof e.HTMLIFrameElement; ) {
            try {
              var n = "string" === typeof t.contentWindow.location.href;
            } catch (r) {
              n = !1;
            }
            if (!n) break;
            t = _((e = t.contentWindow).document);
          }
          return t;
        }
        function fr(e) {
          var t = e && e.nodeName && e.nodeName.toLowerCase();
          return (
            t &&
            (("input" === t &&
              ("text" === e.type ||
                "search" === e.type ||
                "tel" === e.type ||
                "url" === e.type ||
                "password" === e.type)) ||
              "textarea" === t ||
              "true" === e.contentEditable)
          );
        }
        function mr(e) {
          var t = pr(),
            n = e.focusedElem,
            r = e.selectionRange;
          if (
            t !== n &&
            n &&
            n.ownerDocument &&
            dr(n.ownerDocument.documentElement, n)
          ) {
            if (null !== r && fr(n))
              if (
                ((t = r.start),
                void 0 === (e = r.end) && (e = t),
                "selectionStart" in n)
              )
                (n.selectionStart = t),
                  (n.selectionEnd = Math.min(e, n.value.length));
              else if (
                (e =
                  ((t = n.ownerDocument || document) && t.defaultView) ||
                  window).getSelection
              ) {
                e = e.getSelection();
                var a = n.textContent.length,
                  o = Math.min(r.start, a);
                (r = void 0 === r.end ? o : Math.min(r.end, a)),
                  !e.extend && o > r && ((a = r), (r = o), (o = a)),
                  (a = ur(n, o));
                var i = ur(n, r);
                a &&
                  i &&
                  (1 !== e.rangeCount ||
                    e.anchorNode !== a.node ||
                    e.anchorOffset !== a.offset ||
                    e.focusNode !== i.node ||
                    e.focusOffset !== i.offset) &&
                  ((t = t.createRange()).setStart(a.node, a.offset),
                  e.removeAllRanges(),
                  o > r
                    ? (e.addRange(t), e.extend(i.node, i.offset))
                    : (t.setEnd(i.node, i.offset), e.addRange(t)));
              }
            for (t = [], e = n; (e = e.parentNode); )
              1 === e.nodeType &&
                t.push({ element: e, left: e.scrollLeft, top: e.scrollTop });
            for (
              "function" === typeof n.focus && n.focus(), n = 0;
              n < t.length;
              n++
            )
              ((e = t[n]).element.scrollLeft = e.left),
                (e.element.scrollTop = e.top);
          }
        }
        var hr = u && "documentMode" in document && 11 >= document.documentMode,
          gr = null,
          vr = null,
          br = null,
          yr = !1;
        function xr(e, t, n) {
          var r =
            n.window === n
              ? n.document
              : 9 === n.nodeType
                ? n
                : n.ownerDocument;
          yr ||
            null == gr ||
            gr !== _(r) ||
            ("selectionStart" in (r = gr) && fr(r)
              ? (r = { start: r.selectionStart, end: r.selectionEnd })
              : (r = {
                  anchorNode: (r = (
                    (r.ownerDocument && r.ownerDocument.defaultView) ||
                    window
                  ).getSelection()).anchorNode,
                  anchorOffset: r.anchorOffset,
                  focusNode: r.focusNode,
                  focusOffset: r.focusOffset,
                }),
            (br && cr(br, r)) ||
              ((br = r),
              0 < (r = qr(vr, "onSelect")).length &&
                ((t = new un("onSelect", "select", null, t, n)),
                e.push({ event: t, listeners: r }),
                (t.target = gr))));
        }
        function wr(e, t) {
          var n = {};
          return (
            (n[e.toLowerCase()] = t.toLowerCase()),
            (n["Webkit" + e] = "webkit" + t),
            (n["Moz" + e] = "moz" + t),
            n
          );
        }
        var kr = {
            animationend: wr("Animation", "AnimationEnd"),
            animationiteration: wr("Animation", "AnimationIteration"),
            animationstart: wr("Animation", "AnimationStart"),
            transitionend: wr("Transition", "TransitionEnd"),
          },
          Sr = {},
          Cr = {};
        function Er(e) {
          if (Sr[e]) return Sr[e];
          if (!kr[e]) return e;
          var t,
            n = kr[e];
          for (t in n)
            if (n.hasOwnProperty(t) && t in Cr) return (Sr[e] = n[t]);
          return e;
        }
        u &&
          ((Cr = document.createElement("div").style),
          "AnimationEvent" in window ||
            (delete kr.animationend.animation,
            delete kr.animationiteration.animation,
            delete kr.animationstart.animation),
          "TransitionEvent" in window || delete kr.transitionend.transition);
        var Or = Er("animationend"),
          Ar = Er("animationiteration"),
          jr = Er("animationstart"),
          Lr = Er("transitionend"),
          Nr = new Map(),
          Tr =
            "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
              " ",
            );
        function Pr(e, t) {
          Nr.set(e, t), c(t, [e]);
        }
        for (var Dr = 0; Dr < Tr.length; Dr++) {
          var zr = Tr[Dr];
          Pr(zr.toLowerCase(), "on" + (zr[0].toUpperCase() + zr.slice(1)));
        }
        Pr(Or, "onAnimationEnd"),
          Pr(Ar, "onAnimationIteration"),
          Pr(jr, "onAnimationStart"),
          Pr("dblclick", "onDoubleClick"),
          Pr("focusin", "onFocus"),
          Pr("focusout", "onBlur"),
          Pr(Lr, "onTransitionEnd"),
          s("onMouseEnter", ["mouseout", "mouseover"]),
          s("onMouseLeave", ["mouseout", "mouseover"]),
          s("onPointerEnter", ["pointerout", "pointerover"]),
          s("onPointerLeave", ["pointerout", "pointerover"]),
          c(
            "onChange",
            "change click focusin focusout input keydown keyup selectionchange".split(
              " ",
            ),
          ),
          c(
            "onSelect",
            "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
              " ",
            ),
          ),
          c("onBeforeInput", [
            "compositionend",
            "keypress",
            "textInput",
            "paste",
          ]),
          c(
            "onCompositionEnd",
            "compositionend focusout keydown keypress keyup mousedown".split(
              " ",
            ),
          ),
          c(
            "onCompositionStart",
            "compositionstart focusout keydown keypress keyup mousedown".split(
              " ",
            ),
          ),
          c(
            "onCompositionUpdate",
            "compositionupdate focusout keydown keypress keyup mousedown".split(
              " ",
            ),
          );
        var Mr =
            "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
              " ",
            ),
          Ir = new Set(
            "cancel close invalid load scroll toggle".split(" ").concat(Mr),
          );
        function Rr(e, t, n) {
          var r = e.type || "unknown-event";
          (e.currentTarget = n),
            (function (e, t, n, r, a, i, l, c, s) {
              if ((Be.apply(this, arguments), Ie)) {
                if (!Ie) throw Error(o(198));
                var u = Re;
                (Ie = !1), (Re = null), Fe || ((Fe = !0), (Ue = u));
              }
            })(r, t, void 0, e),
            (e.currentTarget = null);
        }
        function Fr(e, t) {
          t = 0 !== (4 & t);
          for (var n = 0; n < e.length; n++) {
            var r = e[n],
              a = r.event;
            r = r.listeners;
            e: {
              var o = void 0;
              if (t)
                for (var i = r.length - 1; 0 <= i; i--) {
                  var l = r[i],
                    c = l.instance,
                    s = l.currentTarget;
                  if (((l = l.listener), c !== o && a.isPropagationStopped()))
                    break e;
                  Rr(a, l, s), (o = c);
                }
              else
                for (i = 0; i < r.length; i++) {
                  if (
                    ((c = (l = r[i]).instance),
                    (s = l.currentTarget),
                    (l = l.listener),
                    c !== o && a.isPropagationStopped())
                  )
                    break e;
                  Rr(a, l, s), (o = c);
                }
            }
          }
          if (Fe) throw ((e = Ue), (Fe = !1), (Ue = null), e);
        }
        function Ur(e, t) {
          var n = t[ha];
          void 0 === n && (n = t[ha] = new Set());
          var r = e + "__bubble";
          n.has(r) || (Wr(t, e, 2, !1), n.add(r));
        }
        function Hr(e, t, n) {
          var r = 0;
          t && (r |= 4), Wr(n, e, r, t);
        }
        var Br = "_reactListening" + Math.random().toString(36).slice(2);
        function Vr(e) {
          if (!e[Br]) {
            (e[Br] = !0),
              i.forEach(function (t) {
                "selectionchange" !== t &&
                  (Ir.has(t) || Hr(t, !1, e), Hr(t, !0, e));
              });
            var t = 9 === e.nodeType ? e : e.ownerDocument;
            null === t || t[Br] || ((t[Br] = !0), Hr("selectionchange", !1, t));
          }
        }
        function Wr(e, t, n, r) {
          switch (Jt(t)) {
            case 1:
              var a = Gt;
              break;
            case 4:
              a = qt;
              break;
            default:
              a = Xt;
          }
          (n = a.bind(null, t, n, e)),
            (a = void 0),
            !De ||
              ("touchstart" !== t && "touchmove" !== t && "wheel" !== t) ||
              (a = !0),
            r
              ? void 0 !== a
                ? e.addEventListener(t, n, { capture: !0, passive: a })
                : e.addEventListener(t, n, !0)
              : void 0 !== a
                ? e.addEventListener(t, n, { passive: a })
                : e.addEventListener(t, n, !1);
        }
        function Zr(e, t, n, r, a) {
          var o = r;
          if (0 === (1 & t) && 0 === (2 & t) && null !== r)
            e: for (;;) {
              if (null === r) return;
              var i = r.tag;
              if (3 === i || 4 === i) {
                var l = r.stateNode.containerInfo;
                if (l === a || (8 === l.nodeType && l.parentNode === a)) break;
                if (4 === i)
                  for (i = r.return; null !== i; ) {
                    var c = i.tag;
                    if (
                      (3 === c || 4 === c) &&
                      ((c = i.stateNode.containerInfo) === a ||
                        (8 === c.nodeType && c.parentNode === a))
                    )
                      return;
                    i = i.return;
                  }
                for (; null !== l; ) {
                  if (null === (i = ba(l))) return;
                  if (5 === (c = i.tag) || 6 === c) {
                    r = o = i;
                    continue e;
                  }
                  l = l.parentNode;
                }
              }
              r = r.return;
            }
          Te(function () {
            var r = o,
              a = we(n),
              i = [];
            e: {
              var l = Nr.get(e);
              if (void 0 !== l) {
                var c = un,
                  s = e;
                switch (e) {
                  case "keypress":
                    if (0 === tn(n)) break e;
                  case "keydown":
                  case "keyup":
                    c = An;
                    break;
                  case "focusin":
                    (s = "focus"), (c = gn);
                    break;
                  case "focusout":
                    (s = "blur"), (c = gn);
                    break;
                  case "beforeblur":
                  case "afterblur":
                    c = gn;
                    break;
                  case "click":
                    if (2 === n.button) break e;
                  case "auxclick":
                  case "dblclick":
                  case "mousedown":
                  case "mousemove":
                  case "mouseup":
                  case "mouseout":
                  case "mouseover":
                  case "contextmenu":
                    c = mn;
                    break;
                  case "drag":
                  case "dragend":
                  case "dragenter":
                  case "dragexit":
                  case "dragleave":
                  case "dragover":
                  case "dragstart":
                  case "drop":
                    c = hn;
                    break;
                  case "touchcancel":
                  case "touchend":
                  case "touchmove":
                  case "touchstart":
                    c = Ln;
                    break;
                  case Or:
                  case Ar:
                  case jr:
                    c = vn;
                    break;
                  case Lr:
                    c = Nn;
                    break;
                  case "scroll":
                    c = pn;
                    break;
                  case "wheel":
                    c = Pn;
                    break;
                  case "copy":
                  case "cut":
                  case "paste":
                    c = yn;
                    break;
                  case "gotpointercapture":
                  case "lostpointercapture":
                  case "pointercancel":
                  case "pointerdown":
                  case "pointermove":
                  case "pointerout":
                  case "pointerover":
                  case "pointerup":
                    c = jn;
                }
                var u = 0 !== (4 & t),
                  d = !u && "scroll" === e,
                  p = u ? (null !== l ? l + "Capture" : null) : l;
                u = [];
                for (var f, m = r; null !== m; ) {
                  var h = (f = m).stateNode;
                  if (
                    (5 === f.tag &&
                      null !== h &&
                      ((f = h),
                      null !== p &&
                        null != (h = Pe(m, p)) &&
                        u.push(Gr(m, h, f))),
                    d)
                  )
                    break;
                  m = m.return;
                }
                0 < u.length &&
                  ((l = new c(l, s, null, n, a)),
                  i.push({ event: l, listeners: u }));
              }
            }
            if (0 === (7 & t)) {
              if (
                ((c = "mouseout" === e || "pointerout" === e),
                (!(l = "mouseover" === e || "pointerover" === e) ||
                  n === xe ||
                  !(s = n.relatedTarget || n.fromElement) ||
                  (!ba(s) && !s[ma])) &&
                  (c || l) &&
                  ((l =
                    a.window === a
                      ? a
                      : (l = a.ownerDocument)
                        ? l.defaultView || l.parentWindow
                        : window),
                  c
                    ? ((c = r),
                      null !==
                        (s = (s = n.relatedTarget || n.toElement)
                          ? ba(s)
                          : null) &&
                        (s !== (d = Ve(s)) || (5 !== s.tag && 6 !== s.tag)) &&
                        (s = null))
                    : ((c = null), (s = r)),
                  c !== s))
              ) {
                if (
                  ((u = mn),
                  (h = "onMouseLeave"),
                  (p = "onMouseEnter"),
                  (m = "mouse"),
                  ("pointerout" !== e && "pointerover" !== e) ||
                    ((u = jn),
                    (h = "onPointerLeave"),
                    (p = "onPointerEnter"),
                    (m = "pointer")),
                  (d = null == c ? l : xa(c)),
                  (f = null == s ? l : xa(s)),
                  ((l = new u(h, m + "leave", c, n, a)).target = d),
                  (l.relatedTarget = f),
                  (h = null),
                  ba(a) === r &&
                    (((u = new u(p, m + "enter", s, n, a)).target = f),
                    (u.relatedTarget = d),
                    (h = u)),
                  (d = h),
                  c && s)
                )
                  e: {
                    for (p = s, m = 0, f = u = c; f; f = Xr(f)) m++;
                    for (f = 0, h = p; h; h = Xr(h)) f++;
                    for (; 0 < m - f; ) (u = Xr(u)), m--;
                    for (; 0 < f - m; ) (p = Xr(p)), f--;
                    for (; m--; ) {
                      if (u === p || (null !== p && u === p.alternate)) break e;
                      (u = Xr(u)), (p = Xr(p));
                    }
                    u = null;
                  }
                else u = null;
                null !== c && _r(i, l, c, u, !1),
                  null !== s && null !== d && _r(i, d, s, u, !0);
              }
              if (
                "select" ===
                  (c =
                    (l = r ? xa(r) : window).nodeName &&
                    l.nodeName.toLowerCase()) ||
                ("input" === c && "file" === l.type)
              )
                var g = Jn;
              else if (Zn(l))
                if (Kn) g = ir;
                else {
                  g = ar;
                  var v = rr;
                }
              else
                (c = l.nodeName) &&
                  "input" === c.toLowerCase() &&
                  ("checkbox" === l.type || "radio" === l.type) &&
                  (g = or);
              switch (
                (g && (g = g(e, r))
                  ? Gn(i, g, n, a)
                  : (v && v(e, l, r),
                    "focusout" === e &&
                      (v = l._wrapperState) &&
                      v.controlled &&
                      "number" === l.type &&
                      ee(l, "number", l.value)),
                (v = r ? xa(r) : window),
                e)
              ) {
                case "focusin":
                  (Zn(v) || "true" === v.contentEditable) &&
                    ((gr = v), (vr = r), (br = null));
                  break;
                case "focusout":
                  br = vr = gr = null;
                  break;
                case "mousedown":
                  yr = !0;
                  break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                  (yr = !1), xr(i, n, a);
                  break;
                case "selectionchange":
                  if (hr) break;
                case "keydown":
                case "keyup":
                  xr(i, n, a);
              }
              var b;
              if (zn)
                e: {
                  switch (e) {
                    case "compositionstart":
                      var y = "onCompositionStart";
                      break e;
                    case "compositionend":
                      y = "onCompositionEnd";
                      break e;
                    case "compositionupdate":
                      y = "onCompositionUpdate";
                      break e;
                  }
                  y = void 0;
                }
              else
                Vn
                  ? Hn(e, n) && (y = "onCompositionEnd")
                  : "keydown" === e &&
                    229 === n.keyCode &&
                    (y = "onCompositionStart");
              y &&
                (Rn &&
                  "ko" !== n.locale &&
                  (Vn || "onCompositionStart" !== y
                    ? "onCompositionEnd" === y && Vn && (b = en())
                    : ((Qt = "value" in (Kt = a) ? Kt.value : Kt.textContent),
                      (Vn = !0))),
                0 < (v = qr(r, y)).length &&
                  ((y = new xn(y, e, null, n, a)),
                  i.push({ event: y, listeners: v }),
                  b ? (y.data = b) : null !== (b = Bn(n)) && (y.data = b))),
                (b = In
                  ? (function (e, t) {
                      switch (e) {
                        case "compositionend":
                          return Bn(t);
                        case "keypress":
                          return 32 !== t.which ? null : ((Un = !0), Fn);
                        case "textInput":
                          return (e = t.data) === Fn && Un ? null : e;
                        default:
                          return null;
                      }
                    })(e, n)
                  : (function (e, t) {
                      if (Vn)
                        return "compositionend" === e || (!zn && Hn(e, t))
                          ? ((e = en()), ($t = Qt = Kt = null), (Vn = !1), e)
                          : null;
                      switch (e) {
                        case "paste":
                        default:
                          return null;
                        case "keypress":
                          if (
                            !(t.ctrlKey || t.altKey || t.metaKey) ||
                            (t.ctrlKey && t.altKey)
                          ) {
                            if (t.char && 1 < t.char.length) return t.char;
                            if (t.which) return String.fromCharCode(t.which);
                          }
                          return null;
                        case "compositionend":
                          return Rn && "ko" !== t.locale ? null : t.data;
                      }
                    })(e, n)) &&
                  0 < (r = qr(r, "onBeforeInput")).length &&
                  ((a = new xn("onBeforeInput", "beforeinput", null, n, a)),
                  i.push({ event: a, listeners: r }),
                  (a.data = b));
            }
            Fr(i, t);
          });
        }
        function Gr(e, t, n) {
          return { instance: e, listener: t, currentTarget: n };
        }
        function qr(e, t) {
          for (var n = t + "Capture", r = []; null !== e; ) {
            var a = e,
              o = a.stateNode;
            5 === a.tag &&
              null !== o &&
              ((a = o),
              null != (o = Pe(e, n)) && r.unshift(Gr(e, o, a)),
              null != (o = Pe(e, t)) && r.push(Gr(e, o, a))),
              (e = e.return);
          }
          return r;
        }
        function Xr(e) {
          if (null === e) return null;
          do {
            e = e.return;
          } while (e && 5 !== e.tag);
          return e || null;
        }
        function _r(e, t, n, r, a) {
          for (var o = t._reactName, i = []; null !== n && n !== r; ) {
            var l = n,
              c = l.alternate,
              s = l.stateNode;
            if (null !== c && c === r) break;
            5 === l.tag &&
              null !== s &&
              ((l = s),
              a
                ? null != (c = Pe(n, o)) && i.unshift(Gr(n, c, l))
                : a || (null != (c = Pe(n, o)) && i.push(Gr(n, c, l)))),
              (n = n.return);
          }
          0 !== i.length && e.push({ event: t, listeners: i });
        }
        var Yr = /\r\n?/g,
          Jr = /\u0000|\uFFFD/g;
        function Kr(e) {
          return ("string" === typeof e ? e : "" + e)
            .replace(Yr, "\n")
            .replace(Jr, "");
        }
        function Qr(e, t, n) {
          if (((t = Kr(t)), Kr(e) !== t && n)) throw Error(o(425));
        }
        function $r() {}
        var ea = null,
          ta = null;
        function na(e, t) {
          return (
            "textarea" === e ||
            "noscript" === e ||
            "string" === typeof t.children ||
            "number" === typeof t.children ||
            ("object" === typeof t.dangerouslySetInnerHTML &&
              null !== t.dangerouslySetInnerHTML &&
              null != t.dangerouslySetInnerHTML.__html)
          );
        }
        var ra = "function" === typeof setTimeout ? setTimeout : void 0,
          aa = "function" === typeof clearTimeout ? clearTimeout : void 0,
          oa = "function" === typeof Promise ? Promise : void 0,
          ia =
            "function" === typeof queueMicrotask
              ? queueMicrotask
              : "undefined" !== typeof oa
                ? function (e) {
                    return oa.resolve(null).then(e).catch(la);
                  }
                : ra;
        function la(e) {
          setTimeout(function () {
            throw e;
          });
        }
        function ca(e, t) {
          var n = t,
            r = 0;
          do {
            var a = n.nextSibling;
            if ((e.removeChild(n), a && 8 === a.nodeType))
              if ("/$" === (n = a.data)) {
                if (0 === r) return e.removeChild(a), void Vt(t);
                r--;
              } else ("$" !== n && "$?" !== n && "$!" !== n) || r++;
            n = a;
          } while (n);
          Vt(t);
        }
        function sa(e) {
          for (; null != e; e = e.nextSibling) {
            var t = e.nodeType;
            if (1 === t || 3 === t) break;
            if (8 === t) {
              if ("$" === (t = e.data) || "$!" === t || "$?" === t) break;
              if ("/$" === t) return null;
            }
          }
          return e;
        }
        function ua(e) {
          e = e.previousSibling;
          for (var t = 0; e; ) {
            if (8 === e.nodeType) {
              var n = e.data;
              if ("$" === n || "$!" === n || "$?" === n) {
                if (0 === t) return e;
                t--;
              } else "/$" === n && t++;
            }
            e = e.previousSibling;
          }
          return null;
        }
        var da = Math.random().toString(36).slice(2),
          pa = "__reactFiber$" + da,
          fa = "__reactProps$" + da,
          ma = "__reactContainer$" + da,
          ha = "__reactEvents$" + da,
          ga = "__reactListeners$" + da,
          va = "__reactHandles$" + da;
        function ba(e) {
          var t = e[pa];
          if (t) return t;
          for (var n = e.parentNode; n; ) {
            if ((t = n[ma] || n[pa])) {
              if (
                ((n = t.alternate),
                null !== t.child || (null !== n && null !== n.child))
              )
                for (e = ua(e); null !== e; ) {
                  if ((n = e[pa])) return n;
                  e = ua(e);
                }
              return t;
            }
            n = (e = n).parentNode;
          }
          return null;
        }
        function ya(e) {
          return !(e = e[pa] || e[ma]) ||
            (5 !== e.tag && 6 !== e.tag && 13 !== e.tag && 3 !== e.tag)
            ? null
            : e;
        }
        function xa(e) {
          if (5 === e.tag || 6 === e.tag) return e.stateNode;
          throw Error(o(33));
        }
        function wa(e) {
          return e[fa] || null;
        }
        var ka = [],
          Sa = -1;
        function Ca(e) {
          return { current: e };
        }
        function Ea(e) {
          0 > Sa || ((e.current = ka[Sa]), (ka[Sa] = null), Sa--);
        }
        function Oa(e, t) {
          Sa++, (ka[Sa] = e.current), (e.current = t);
        }
        var Aa = {},
          ja = Ca(Aa),
          La = Ca(!1),
          Na = Aa;
        function Ta(e, t) {
          var n = e.type.contextTypes;
          if (!n) return Aa;
          var r = e.stateNode;
          if (r && r.__reactInternalMemoizedUnmaskedChildContext === t)
            return r.__reactInternalMemoizedMaskedChildContext;
          var a,
            o = {};
          for (a in n) o[a] = t[a];
          return (
            r &&
              (((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext =
                t),
              (e.__reactInternalMemoizedMaskedChildContext = o)),
            o
          );
        }
        function Pa(e) {
          return null !== (e = e.childContextTypes) && void 0 !== e;
        }
        function Da() {
          Ea(La), Ea(ja);
        }
        function za(e, t, n) {
          if (ja.current !== Aa) throw Error(o(168));
          Oa(ja, t), Oa(La, n);
        }
        function Ma(e, t, n) {
          var r = e.stateNode;
          if (
            ((t = t.childContextTypes), "function" !== typeof r.getChildContext)
          )
            return n;
          for (var a in (r = r.getChildContext()))
            if (!(a in t)) throw Error(o(108, W(e) || "Unknown", a));
          return R({}, n, r);
        }
        function Ia(e) {
          return (
            (e =
              ((e = e.stateNode) &&
                e.__reactInternalMemoizedMergedChildContext) ||
              Aa),
            (Na = ja.current),
            Oa(ja, e),
            Oa(La, La.current),
            !0
          );
        }
        function Ra(e, t, n) {
          var r = e.stateNode;
          if (!r) throw Error(o(169));
          n
            ? ((e = Ma(e, t, Na)),
              (r.__reactInternalMemoizedMergedChildContext = e),
              Ea(La),
              Ea(ja),
              Oa(ja, e))
            : Ea(La),
            Oa(La, n);
        }
        var Fa = null,
          Ua = !1,
          Ha = !1;
        function Ba(e) {
          null === Fa ? (Fa = [e]) : Fa.push(e);
        }
        function Va() {
          if (!Ha && null !== Fa) {
            Ha = !0;
            var e = 0,
              t = yt;
            try {
              var n = Fa;
              for (yt = 1; e < n.length; e++) {
                var r = n[e];
                do {
                  r = r(!0);
                } while (null !== r);
              }
              (Fa = null), (Ua = !1);
            } catch (a) {
              throw (null !== Fa && (Fa = Fa.slice(e + 1)), Xe($e, Va), a);
            } finally {
              (yt = t), (Ha = !1);
            }
          }
          return null;
        }
        var Wa = [],
          Za = 0,
          Ga = null,
          qa = 0,
          Xa = [],
          _a = 0,
          Ya = null,
          Ja = 1,
          Ka = "";
        function Qa(e, t) {
          (Wa[Za++] = qa), (Wa[Za++] = Ga), (Ga = e), (qa = t);
        }
        function $a(e, t, n) {
          (Xa[_a++] = Ja), (Xa[_a++] = Ka), (Xa[_a++] = Ya), (Ya = e);
          var r = Ja;
          e = Ka;
          var a = 32 - it(r) - 1;
          (r &= ~(1 << a)), (n += 1);
          var o = 32 - it(t) + a;
          if (30 < o) {
            var i = a - (a % 5);
            (o = (r & ((1 << i) - 1)).toString(32)),
              (r >>= i),
              (a -= i),
              (Ja = (1 << (32 - it(t) + a)) | (n << a) | r),
              (Ka = o + e);
          } else (Ja = (1 << o) | (n << a) | r), (Ka = e);
        }
        function eo(e) {
          null !== e.return && (Qa(e, 1), $a(e, 1, 0));
        }
        function to(e) {
          for (; e === Ga; )
            (Ga = Wa[--Za]), (Wa[Za] = null), (qa = Wa[--Za]), (Wa[Za] = null);
          for (; e === Ya; )
            (Ya = Xa[--_a]),
              (Xa[_a] = null),
              (Ka = Xa[--_a]),
              (Xa[_a] = null),
              (Ja = Xa[--_a]),
              (Xa[_a] = null);
        }
        var no = null,
          ro = null,
          ao = !1,
          oo = null;
        function io(e, t) {
          var n = Ts(5, null, null, 0);
          (n.elementType = "DELETED"),
            (n.stateNode = t),
            (n.return = e),
            null === (t = e.deletions)
              ? ((e.deletions = [n]), (e.flags |= 16))
              : t.push(n);
        }
        function lo(e, t) {
          switch (e.tag) {
            case 5:
              var n = e.type;
              return (
                null !==
                  (t =
                    1 !== t.nodeType ||
                    n.toLowerCase() !== t.nodeName.toLowerCase()
                      ? null
                      : t) &&
                ((e.stateNode = t), (no = e), (ro = sa(t.firstChild)), !0)
              );
            case 6:
              return (
                null !==
                  (t = "" === e.pendingProps || 3 !== t.nodeType ? null : t) &&
                ((e.stateNode = t), (no = e), (ro = null), !0)
              );
            case 13:
              return (
                null !== (t = 8 !== t.nodeType ? null : t) &&
                ((n = null !== Ya ? { id: Ja, overflow: Ka } : null),
                (e.memoizedState = {
                  dehydrated: t,
                  treeContext: n,
                  retryLane: 1073741824,
                }),
                ((n = Ts(18, null, null, 0)).stateNode = t),
                (n.return = e),
                (e.child = n),
                (no = e),
                (ro = null),
                !0)
              );
            default:
              return !1;
          }
        }
        function co(e) {
          return 0 !== (1 & e.mode) && 0 === (128 & e.flags);
        }
        function so(e) {
          if (ao) {
            var t = ro;
            if (t) {
              var n = t;
              if (!lo(e, t)) {
                if (co(e)) throw Error(o(418));
                t = sa(n.nextSibling);
                var r = no;
                t && lo(e, t)
                  ? io(r, n)
                  : ((e.flags = (-4097 & e.flags) | 2), (ao = !1), (no = e));
              }
            } else {
              if (co(e)) throw Error(o(418));
              (e.flags = (-4097 & e.flags) | 2), (ao = !1), (no = e);
            }
          }
        }
        function uo(e) {
          for (
            e = e.return;
            null !== e && 5 !== e.tag && 3 !== e.tag && 13 !== e.tag;

          )
            e = e.return;
          no = e;
        }
        function po(e) {
          if (e !== no) return !1;
          if (!ao) return uo(e), (ao = !0), !1;
          var t;
          if (
            ((t = 3 !== e.tag) &&
              !(t = 5 !== e.tag) &&
              (t =
                "head" !== (t = e.type) &&
                "body" !== t &&
                !na(e.type, e.memoizedProps)),
            t && (t = ro))
          ) {
            if (co(e)) throw (fo(), Error(o(418)));
            for (; t; ) io(e, t), (t = sa(t.nextSibling));
          }
          if ((uo(e), 13 === e.tag)) {
            if (!(e = null !== (e = e.memoizedState) ? e.dehydrated : null))
              throw Error(o(317));
            e: {
              for (e = e.nextSibling, t = 0; e; ) {
                if (8 === e.nodeType) {
                  var n = e.data;
                  if ("/$" === n) {
                    if (0 === t) {
                      ro = sa(e.nextSibling);
                      break e;
                    }
                    t--;
                  } else ("$" !== n && "$!" !== n && "$?" !== n) || t++;
                }
                e = e.nextSibling;
              }
              ro = null;
            }
          } else ro = no ? sa(e.stateNode.nextSibling) : null;
          return !0;
        }
        function fo() {
          for (var e = ro; e; ) e = sa(e.nextSibling);
        }
        function mo() {
          (ro = no = null), (ao = !1);
        }
        function ho(e) {
          null === oo ? (oo = [e]) : oo.push(e);
        }
        var go = x.ReactCurrentBatchConfig;
        function vo(e, t, n) {
          if (
            null !== (e = n.ref) &&
            "function" !== typeof e &&
            "object" !== typeof e
          ) {
            if (n._owner) {
              if ((n = n._owner)) {
                if (1 !== n.tag) throw Error(o(309));
                var r = n.stateNode;
              }
              if (!r) throw Error(o(147, e));
              var a = r,
                i = "" + e;
              return null !== t &&
                null !== t.ref &&
                "function" === typeof t.ref &&
                t.ref._stringRef === i
                ? t.ref
                : ((t = function (e) {
                    var t = a.refs;
                    null === e ? delete t[i] : (t[i] = e);
                  }),
                  (t._stringRef = i),
                  t);
            }
            if ("string" !== typeof e) throw Error(o(284));
            if (!n._owner) throw Error(o(290, e));
          }
          return e;
        }
        function bo(e, t) {
          throw (
            ((e = Object.prototype.toString.call(t)),
            Error(
              o(
                31,
                "[object Object]" === e
                  ? "object with keys {" + Object.keys(t).join(", ") + "}"
                  : e,
              ),
            ))
          );
        }
        function yo(e) {
          return (0, e._init)(e._payload);
        }
        function xo(e) {
          function t(t, n) {
            if (e) {
              var r = t.deletions;
              null === r ? ((t.deletions = [n]), (t.flags |= 16)) : r.push(n);
            }
          }
          function n(n, r) {
            if (!e) return null;
            for (; null !== r; ) t(n, r), (r = r.sibling);
            return null;
          }
          function r(e, t) {
            for (e = new Map(); null !== t; )
              null !== t.key ? e.set(t.key, t) : e.set(t.index, t),
                (t = t.sibling);
            return e;
          }
          function a(e, t) {
            return ((e = Ds(e, t)).index = 0), (e.sibling = null), e;
          }
          function i(t, n, r) {
            return (
              (t.index = r),
              e
                ? null !== (r = t.alternate)
                  ? (r = r.index) < n
                    ? ((t.flags |= 2), n)
                    : r
                  : ((t.flags |= 2), n)
                : ((t.flags |= 1048576), n)
            );
          }
          function l(t) {
            return e && null === t.alternate && (t.flags |= 2), t;
          }
          function c(e, t, n, r) {
            return null === t || 6 !== t.tag
              ? (((t = Rs(n, e.mode, r)).return = e), t)
              : (((t = a(t, n)).return = e), t);
          }
          function s(e, t, n, r) {
            var o = n.type;
            return o === S
              ? d(e, t, n.props.children, r, n.key)
              : null !== t &&
                  (t.elementType === o ||
                    ("object" === typeof o &&
                      null !== o &&
                      o.$$typeof === P &&
                      yo(o) === t.type))
                ? (((r = a(t, n.props)).ref = vo(e, t, n)), (r.return = e), r)
                : (((r = zs(n.type, n.key, n.props, null, e.mode, r)).ref = vo(
                    e,
                    t,
                    n,
                  )),
                  (r.return = e),
                  r);
          }
          function u(e, t, n, r) {
            return null === t ||
              4 !== t.tag ||
              t.stateNode.containerInfo !== n.containerInfo ||
              t.stateNode.implementation !== n.implementation
              ? (((t = Fs(n, e.mode, r)).return = e), t)
              : (((t = a(t, n.children || [])).return = e), t);
          }
          function d(e, t, n, r, o) {
            return null === t || 7 !== t.tag
              ? (((t = Ms(n, e.mode, r, o)).return = e), t)
              : (((t = a(t, n)).return = e), t);
          }
          function p(e, t, n) {
            if (("string" === typeof t && "" !== t) || "number" === typeof t)
              return ((t = Rs("" + t, e.mode, n)).return = e), t;
            if ("object" === typeof t && null !== t) {
              switch (t.$$typeof) {
                case w:
                  return (
                    ((n = zs(t.type, t.key, t.props, null, e.mode, n)).ref = vo(
                      e,
                      null,
                      t,
                    )),
                    (n.return = e),
                    n
                  );
                case k:
                  return ((t = Fs(t, e.mode, n)).return = e), t;
                case P:
                  return p(e, (0, t._init)(t._payload), n);
              }
              if (te(t) || M(t))
                return ((t = Ms(t, e.mode, n, null)).return = e), t;
              bo(e, t);
            }
            return null;
          }
          function f(e, t, n, r) {
            var a = null !== t ? t.key : null;
            if (("string" === typeof n && "" !== n) || "number" === typeof n)
              return null !== a ? null : c(e, t, "" + n, r);
            if ("object" === typeof n && null !== n) {
              switch (n.$$typeof) {
                case w:
                  return n.key === a ? s(e, t, n, r) : null;
                case k:
                  return n.key === a ? u(e, t, n, r) : null;
                case P:
                  return f(e, t, (a = n._init)(n._payload), r);
              }
              if (te(n) || M(n)) return null !== a ? null : d(e, t, n, r, null);
              bo(e, n);
            }
            return null;
          }
          function m(e, t, n, r, a) {
            if (("string" === typeof r && "" !== r) || "number" === typeof r)
              return c(t, (e = e.get(n) || null), "" + r, a);
            if ("object" === typeof r && null !== r) {
              switch (r.$$typeof) {
                case w:
                  return s(
                    t,
                    (e = e.get(null === r.key ? n : r.key) || null),
                    r,
                    a,
                  );
                case k:
                  return u(
                    t,
                    (e = e.get(null === r.key ? n : r.key) || null),
                    r,
                    a,
                  );
                case P:
                  return m(e, t, n, (0, r._init)(r._payload), a);
              }
              if (te(r) || M(r))
                return d(t, (e = e.get(n) || null), r, a, null);
              bo(t, r);
            }
            return null;
          }
          function h(a, o, l, c) {
            for (
              var s = null, u = null, d = o, h = (o = 0), g = null;
              null !== d && h < l.length;
              h++
            ) {
              d.index > h ? ((g = d), (d = null)) : (g = d.sibling);
              var v = f(a, d, l[h], c);
              if (null === v) {
                null === d && (d = g);
                break;
              }
              e && d && null === v.alternate && t(a, d),
                (o = i(v, o, h)),
                null === u ? (s = v) : (u.sibling = v),
                (u = v),
                (d = g);
            }
            if (h === l.length) return n(a, d), ao && Qa(a, h), s;
            if (null === d) {
              for (; h < l.length; h++)
                null !== (d = p(a, l[h], c)) &&
                  ((o = i(d, o, h)),
                  null === u ? (s = d) : (u.sibling = d),
                  (u = d));
              return ao && Qa(a, h), s;
            }
            for (d = r(a, d); h < l.length; h++)
              null !== (g = m(d, a, h, l[h], c)) &&
                (e &&
                  null !== g.alternate &&
                  d.delete(null === g.key ? h : g.key),
                (o = i(g, o, h)),
                null === u ? (s = g) : (u.sibling = g),
                (u = g));
            return (
              e &&
                d.forEach(function (e) {
                  return t(a, e);
                }),
              ao && Qa(a, h),
              s
            );
          }
          function g(a, l, c, s) {
            var u = M(c);
            if ("function" !== typeof u) throw Error(o(150));
            if (null == (c = u.call(c))) throw Error(o(151));
            for (
              var d = (u = null), h = l, g = (l = 0), v = null, b = c.next();
              null !== h && !b.done;
              g++, b = c.next()
            ) {
              h.index > g ? ((v = h), (h = null)) : (v = h.sibling);
              var y = f(a, h, b.value, s);
              if (null === y) {
                null === h && (h = v);
                break;
              }
              e && h && null === y.alternate && t(a, h),
                (l = i(y, l, g)),
                null === d ? (u = y) : (d.sibling = y),
                (d = y),
                (h = v);
            }
            if (b.done) return n(a, h), ao && Qa(a, g), u;
            if (null === h) {
              for (; !b.done; g++, b = c.next())
                null !== (b = p(a, b.value, s)) &&
                  ((l = i(b, l, g)),
                  null === d ? (u = b) : (d.sibling = b),
                  (d = b));
              return ao && Qa(a, g), u;
            }
            for (h = r(a, h); !b.done; g++, b = c.next())
              null !== (b = m(h, a, g, b.value, s)) &&
                (e &&
                  null !== b.alternate &&
                  h.delete(null === b.key ? g : b.key),
                (l = i(b, l, g)),
                null === d ? (u = b) : (d.sibling = b),
                (d = b));
            return (
              e &&
                h.forEach(function (e) {
                  return t(a, e);
                }),
              ao && Qa(a, g),
              u
            );
          }
          return function e(r, o, i, c) {
            if (
              ("object" === typeof i &&
                null !== i &&
                i.type === S &&
                null === i.key &&
                (i = i.props.children),
              "object" === typeof i && null !== i)
            ) {
              switch (i.$$typeof) {
                case w:
                  e: {
                    for (var s = i.key, u = o; null !== u; ) {
                      if (u.key === s) {
                        if ((s = i.type) === S) {
                          if (7 === u.tag) {
                            n(r, u.sibling),
                              ((o = a(u, i.props.children)).return = r),
                              (r = o);
                            break e;
                          }
                        } else if (
                          u.elementType === s ||
                          ("object" === typeof s &&
                            null !== s &&
                            s.$$typeof === P &&
                            yo(s) === u.type)
                        ) {
                          n(r, u.sibling),
                            ((o = a(u, i.props)).ref = vo(r, u, i)),
                            (o.return = r),
                            (r = o);
                          break e;
                        }
                        n(r, u);
                        break;
                      }
                      t(r, u), (u = u.sibling);
                    }
                    i.type === S
                      ? (((o = Ms(i.props.children, r.mode, c, i.key)).return =
                          r),
                        (r = o))
                      : (((c = zs(
                          i.type,
                          i.key,
                          i.props,
                          null,
                          r.mode,
                          c,
                        )).ref = vo(r, o, i)),
                        (c.return = r),
                        (r = c));
                  }
                  return l(r);
                case k:
                  e: {
                    for (u = i.key; null !== o; ) {
                      if (o.key === u) {
                        if (
                          4 === o.tag &&
                          o.stateNode.containerInfo === i.containerInfo &&
                          o.stateNode.implementation === i.implementation
                        ) {
                          n(r, o.sibling),
                            ((o = a(o, i.children || [])).return = r),
                            (r = o);
                          break e;
                        }
                        n(r, o);
                        break;
                      }
                      t(r, o), (o = o.sibling);
                    }
                    ((o = Fs(i, r.mode, c)).return = r), (r = o);
                  }
                  return l(r);
                case P:
                  return e(r, o, (u = i._init)(i._payload), c);
              }
              if (te(i)) return h(r, o, i, c);
              if (M(i)) return g(r, o, i, c);
              bo(r, i);
            }
            return ("string" === typeof i && "" !== i) || "number" === typeof i
              ? ((i = "" + i),
                null !== o && 6 === o.tag
                  ? (n(r, o.sibling), ((o = a(o, i)).return = r), (r = o))
                  : (n(r, o), ((o = Rs(i, r.mode, c)).return = r), (r = o)),
                l(r))
              : n(r, o);
          };
        }
        var wo = xo(!0),
          ko = xo(!1),
          So = Ca(null),
          Co = null,
          Eo = null,
          Oo = null;
        function Ao() {
          Oo = Eo = Co = null;
        }
        function jo(e) {
          var t = So.current;
          Ea(So), (e._currentValue = t);
        }
        function Lo(e, t, n) {
          for (; null !== e; ) {
            var r = e.alternate;
            if (
              ((e.childLanes & t) !== t
                ? ((e.childLanes |= t), null !== r && (r.childLanes |= t))
                : null !== r && (r.childLanes & t) !== t && (r.childLanes |= t),
              e === n)
            )
              break;
            e = e.return;
          }
        }
        function No(e, t) {
          (Co = e),
            (Oo = Eo = null),
            null !== (e = e.dependencies) &&
              null !== e.firstContext &&
              (0 !== (e.lanes & t) && (yl = !0), (e.firstContext = null));
        }
        function To(e) {
          var t = e._currentValue;
          if (Oo !== e)
            if (
              ((e = { context: e, memoizedValue: t, next: null }), null === Eo)
            ) {
              if (null === Co) throw Error(o(308));
              (Eo = e), (Co.dependencies = { lanes: 0, firstContext: e });
            } else Eo = Eo.next = e;
          return t;
        }
        var Po = null;
        function Do(e) {
          null === Po ? (Po = [e]) : Po.push(e);
        }
        function zo(e, t, n, r) {
          var a = t.interleaved;
          return (
            null === a
              ? ((n.next = n), Do(t))
              : ((n.next = a.next), (a.next = n)),
            (t.interleaved = n),
            Mo(e, r)
          );
        }
        function Mo(e, t) {
          e.lanes |= t;
          var n = e.alternate;
          for (null !== n && (n.lanes |= t), n = e, e = e.return; null !== e; )
            (e.childLanes |= t),
              null !== (n = e.alternate) && (n.childLanes |= t),
              (n = e),
              (e = e.return);
          return 3 === n.tag ? n.stateNode : null;
        }
        var Io = !1;
        function Ro(e) {
          e.updateQueue = {
            baseState: e.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: { pending: null, interleaved: null, lanes: 0 },
            effects: null,
          };
        }
        function Fo(e, t) {
          (e = e.updateQueue),
            t.updateQueue === e &&
              (t.updateQueue = {
                baseState: e.baseState,
                firstBaseUpdate: e.firstBaseUpdate,
                lastBaseUpdate: e.lastBaseUpdate,
                shared: e.shared,
                effects: e.effects,
              });
        }
        function Uo(e, t) {
          return {
            eventTime: e,
            lane: t,
            tag: 0,
            payload: null,
            callback: null,
            next: null,
          };
        }
        function Ho(e, t, n) {
          var r = e.updateQueue;
          if (null === r) return null;
          if (((r = r.shared), 0 !== (2 & jc))) {
            var a = r.pending;
            return (
              null === a ? (t.next = t) : ((t.next = a.next), (a.next = t)),
              (r.pending = t),
              Mo(e, n)
            );
          }
          return (
            null === (a = r.interleaved)
              ? ((t.next = t), Do(r))
              : ((t.next = a.next), (a.next = t)),
            (r.interleaved = t),
            Mo(e, n)
          );
        }
        function Bo(e, t, n) {
          if (
            null !== (t = t.updateQueue) &&
            ((t = t.shared), 0 !== (4194240 & n))
          ) {
            var r = t.lanes;
            (n |= r &= e.pendingLanes), (t.lanes = n), bt(e, n);
          }
        }
        function Vo(e, t) {
          var n = e.updateQueue,
            r = e.alternate;
          if (null !== r && n === (r = r.updateQueue)) {
            var a = null,
              o = null;
            if (null !== (n = n.firstBaseUpdate)) {
              do {
                var i = {
                  eventTime: n.eventTime,
                  lane: n.lane,
                  tag: n.tag,
                  payload: n.payload,
                  callback: n.callback,
                  next: null,
                };
                null === o ? (a = o = i) : (o = o.next = i), (n = n.next);
              } while (null !== n);
              null === o ? (a = o = t) : (o = o.next = t);
            } else a = o = t;
            return (
              (n = {
                baseState: r.baseState,
                firstBaseUpdate: a,
                lastBaseUpdate: o,
                shared: r.shared,
                effects: r.effects,
              }),
              void (e.updateQueue = n)
            );
          }
          null === (e = n.lastBaseUpdate)
            ? (n.firstBaseUpdate = t)
            : (e.next = t),
            (n.lastBaseUpdate = t);
        }
        function Wo(e, t, n, r) {
          var a = e.updateQueue;
          Io = !1;
          var o = a.firstBaseUpdate,
            i = a.lastBaseUpdate,
            l = a.shared.pending;
          if (null !== l) {
            a.shared.pending = null;
            var c = l,
              s = c.next;
            (c.next = null), null === i ? (o = s) : (i.next = s), (i = c);
            var u = e.alternate;
            null !== u &&
              (l = (u = u.updateQueue).lastBaseUpdate) !== i &&
              (null === l ? (u.firstBaseUpdate = s) : (l.next = s),
              (u.lastBaseUpdate = c));
          }
          if (null !== o) {
            var d = a.baseState;
            for (i = 0, u = s = c = null, l = o; ; ) {
              var p = l.lane,
                f = l.eventTime;
              if ((r & p) === p) {
                null !== u &&
                  (u = u.next =
                    {
                      eventTime: f,
                      lane: 0,
                      tag: l.tag,
                      payload: l.payload,
                      callback: l.callback,
                      next: null,
                    });
                e: {
                  var m = e,
                    h = l;
                  switch (((p = t), (f = n), h.tag)) {
                    case 1:
                      if ("function" === typeof (m = h.payload)) {
                        d = m.call(f, d, p);
                        break e;
                      }
                      d = m;
                      break e;
                    case 3:
                      m.flags = (-65537 & m.flags) | 128;
                    case 0:
                      if (
                        null ===
                          (p =
                            "function" === typeof (m = h.payload)
                              ? m.call(f, d, p)
                              : m) ||
                        void 0 === p
                      )
                        break e;
                      d = R({}, d, p);
                      break e;
                    case 2:
                      Io = !0;
                  }
                }
                null !== l.callback &&
                  0 !== l.lane &&
                  ((e.flags |= 64),
                  null === (p = a.effects) ? (a.effects = [l]) : p.push(l));
              } else
                (f = {
                  eventTime: f,
                  lane: p,
                  tag: l.tag,
                  payload: l.payload,
                  callback: l.callback,
                  next: null,
                }),
                  null === u ? ((s = u = f), (c = d)) : (u = u.next = f),
                  (i |= p);
              if (null === (l = l.next)) {
                if (null === (l = a.shared.pending)) break;
                (l = (p = l).next),
                  (p.next = null),
                  (a.lastBaseUpdate = p),
                  (a.shared.pending = null);
              }
            }
            if (
              (null === u && (c = d),
              (a.baseState = c),
              (a.firstBaseUpdate = s),
              (a.lastBaseUpdate = u),
              null !== (t = a.shared.interleaved))
            ) {
              a = t;
              do {
                (i |= a.lane), (a = a.next);
              } while (a !== t);
            } else null === o && (a.shared.lanes = 0);
            (Ic |= i), (e.lanes = i), (e.memoizedState = d);
          }
        }
        function Zo(e, t, n) {
          if (((e = t.effects), (t.effects = null), null !== e))
            for (t = 0; t < e.length; t++) {
              var r = e[t],
                a = r.callback;
              if (null !== a) {
                if (((r.callback = null), (r = n), "function" !== typeof a))
                  throw Error(o(191, a));
                a.call(r);
              }
            }
        }
        var Go = {},
          qo = Ca(Go),
          Xo = Ca(Go),
          _o = Ca(Go);
        function Yo(e) {
          if (e === Go) throw Error(o(174));
          return e;
        }
        function Jo(e, t) {
          switch ((Oa(_o, t), Oa(Xo, e), Oa(qo, Go), (e = t.nodeType))) {
            case 9:
            case 11:
              t = (t = t.documentElement) ? t.namespaceURI : ce(null, "");
              break;
            default:
              t = ce(
                (t = (e = 8 === e ? t.parentNode : t).namespaceURI || null),
                (e = e.tagName),
              );
          }
          Ea(qo), Oa(qo, t);
        }
        function Ko() {
          Ea(qo), Ea(Xo), Ea(_o);
        }
        function Qo(e) {
          Yo(_o.current);
          var t = Yo(qo.current),
            n = ce(t, e.type);
          t !== n && (Oa(Xo, e), Oa(qo, n));
        }
        function $o(e) {
          Xo.current === e && (Ea(qo), Ea(Xo));
        }
        var ei = Ca(0);
        function ti(e) {
          for (var t = e; null !== t; ) {
            if (13 === t.tag) {
              var n = t.memoizedState;
              if (
                null !== n &&
                (null === (n = n.dehydrated) ||
                  "$?" === n.data ||
                  "$!" === n.data)
              )
                return t;
            } else if (19 === t.tag && void 0 !== t.memoizedProps.revealOrder) {
              if (0 !== (128 & t.flags)) return t;
            } else if (null !== t.child) {
              (t.child.return = t), (t = t.child);
              continue;
            }
            if (t === e) break;
            for (; null === t.sibling; ) {
              if (null === t.return || t.return === e) return null;
              t = t.return;
            }
            (t.sibling.return = t.return), (t = t.sibling);
          }
          return null;
        }
        var ni = [];
        function ri() {
          for (var e = 0; e < ni.length; e++)
            ni[e]._workInProgressVersionPrimary = null;
          ni.length = 0;
        }
        var ai = x.ReactCurrentDispatcher,
          oi = x.ReactCurrentBatchConfig,
          ii = 0,
          li = null,
          ci = null,
          si = null,
          ui = !1,
          di = !1,
          pi = 0,
          fi = 0;
        function mi() {
          throw Error(o(321));
        }
        function hi(e, t) {
          if (null === t) return !1;
          for (var n = 0; n < t.length && n < e.length; n++)
            if (!lr(e[n], t[n])) return !1;
          return !0;
        }
        function gi(e, t, n, r, a, i) {
          if (
            ((ii = i),
            (li = t),
            (t.memoizedState = null),
            (t.updateQueue = null),
            (t.lanes = 0),
            (ai.current = null === e || null === e.memoizedState ? $i : el),
            (e = n(r, a)),
            di)
          ) {
            i = 0;
            do {
              if (((di = !1), (pi = 0), 25 <= i)) throw Error(o(301));
              (i += 1),
                (si = ci = null),
                (t.updateQueue = null),
                (ai.current = tl),
                (e = n(r, a));
            } while (di);
          }
          if (
            ((ai.current = Qi),
            (t = null !== ci && null !== ci.next),
            (ii = 0),
            (si = ci = li = null),
            (ui = !1),
            t)
          )
            throw Error(o(300));
          return e;
        }
        function vi() {
          var e = 0 !== pi;
          return (pi = 0), e;
        }
        function bi() {
          var e = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null,
          };
          return (
            null === si ? (li.memoizedState = si = e) : (si = si.next = e), si
          );
        }
        function yi() {
          if (null === ci) {
            var e = li.alternate;
            e = null !== e ? e.memoizedState : null;
          } else e = ci.next;
          var t = null === si ? li.memoizedState : si.next;
          if (null !== t) (si = t), (ci = e);
          else {
            if (null === e) throw Error(o(310));
            (e = {
              memoizedState: (ci = e).memoizedState,
              baseState: ci.baseState,
              baseQueue: ci.baseQueue,
              queue: ci.queue,
              next: null,
            }),
              null === si ? (li.memoizedState = si = e) : (si = si.next = e);
          }
          return si;
        }
        function xi(e, t) {
          return "function" === typeof t ? t(e) : t;
        }
        function wi(e) {
          var t = yi(),
            n = t.queue;
          if (null === n) throw Error(o(311));
          n.lastRenderedReducer = e;
          var r = ci,
            a = r.baseQueue,
            i = n.pending;
          if (null !== i) {
            if (null !== a) {
              var l = a.next;
              (a.next = i.next), (i.next = l);
            }
            (r.baseQueue = a = i), (n.pending = null);
          }
          if (null !== a) {
            (i = a.next), (r = r.baseState);
            var c = (l = null),
              s = null,
              u = i;
            do {
              var d = u.lane;
              if ((ii & d) === d)
                null !== s &&
                  (s = s.next =
                    {
                      lane: 0,
                      action: u.action,
                      hasEagerState: u.hasEagerState,
                      eagerState: u.eagerState,
                      next: null,
                    }),
                  (r = u.hasEagerState ? u.eagerState : e(r, u.action));
              else {
                var p = {
                  lane: d,
                  action: u.action,
                  hasEagerState: u.hasEagerState,
                  eagerState: u.eagerState,
                  next: null,
                };
                null === s ? ((c = s = p), (l = r)) : (s = s.next = p),
                  (li.lanes |= d),
                  (Ic |= d);
              }
              u = u.next;
            } while (null !== u && u !== i);
            null === s ? (l = r) : (s.next = c),
              lr(r, t.memoizedState) || (yl = !0),
              (t.memoizedState = r),
              (t.baseState = l),
              (t.baseQueue = s),
              (n.lastRenderedState = r);
          }
          if (null !== (e = n.interleaved)) {
            a = e;
            do {
              (i = a.lane), (li.lanes |= i), (Ic |= i), (a = a.next);
            } while (a !== e);
          } else null === a && (n.lanes = 0);
          return [t.memoizedState, n.dispatch];
        }
        function ki(e) {
          var t = yi(),
            n = t.queue;
          if (null === n) throw Error(o(311));
          n.lastRenderedReducer = e;
          var r = n.dispatch,
            a = n.pending,
            i = t.memoizedState;
          if (null !== a) {
            n.pending = null;
            var l = (a = a.next);
            do {
              (i = e(i, l.action)), (l = l.next);
            } while (l !== a);
            lr(i, t.memoizedState) || (yl = !0),
              (t.memoizedState = i),
              null === t.baseQueue && (t.baseState = i),
              (n.lastRenderedState = i);
          }
          return [i, r];
        }
        function Si() {}
        function Ci(e, t) {
          var n = li,
            r = yi(),
            a = t(),
            i = !lr(r.memoizedState, a);
          if (
            (i && ((r.memoizedState = a), (yl = !0)),
            (r = r.queue),
            Ii(Ai.bind(null, n, r, e), [e]),
            r.getSnapshot !== t ||
              i ||
              (null !== si && 1 & si.memoizedState.tag))
          ) {
            if (
              ((n.flags |= 2048),
              Ti(9, Oi.bind(null, n, r, a, t), void 0, null),
              null === Lc)
            )
              throw Error(o(349));
            0 !== (30 & ii) || Ei(n, t, a);
          }
          return a;
        }
        function Ei(e, t, n) {
          (e.flags |= 16384),
            (e = { getSnapshot: t, value: n }),
            null === (t = li.updateQueue)
              ? ((t = { lastEffect: null, stores: null }),
                (li.updateQueue = t),
                (t.stores = [e]))
              : null === (n = t.stores)
                ? (t.stores = [e])
                : n.push(e);
        }
        function Oi(e, t, n, r) {
          (t.value = n), (t.getSnapshot = r), ji(t) && Li(e);
        }
        function Ai(e, t, n) {
          return n(function () {
            ji(t) && Li(e);
          });
        }
        function ji(e) {
          var t = e.getSnapshot;
          e = e.value;
          try {
            var n = t();
            return !lr(e, n);
          } catch (r) {
            return !0;
          }
        }
        function Li(e) {
          var t = Mo(e, 1);
          null !== t && ns(t, e, 1, -1);
        }
        function Ni(e) {
          var t = bi();
          return (
            "function" === typeof e && (e = e()),
            (t.memoizedState = t.baseState = e),
            (e = {
              pending: null,
              interleaved: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: xi,
              lastRenderedState: e,
            }),
            (t.queue = e),
            (e = e.dispatch = _i.bind(null, li, e)),
            [t.memoizedState, e]
          );
        }
        function Ti(e, t, n, r) {
          return (
            (e = { tag: e, create: t, destroy: n, deps: r, next: null }),
            null === (t = li.updateQueue)
              ? ((t = { lastEffect: null, stores: null }),
                (li.updateQueue = t),
                (t.lastEffect = e.next = e))
              : null === (n = t.lastEffect)
                ? (t.lastEffect = e.next = e)
                : ((r = n.next),
                  (n.next = e),
                  (e.next = r),
                  (t.lastEffect = e)),
            e
          );
        }
        function Pi() {
          return yi().memoizedState;
        }
        function Di(e, t, n, r) {
          var a = bi();
          (li.flags |= e),
            (a.memoizedState = Ti(1 | t, n, void 0, void 0 === r ? null : r));
        }
        function zi(e, t, n, r) {
          var a = yi();
          r = void 0 === r ? null : r;
          var o = void 0;
          if (null !== ci) {
            var i = ci.memoizedState;
            if (((o = i.destroy), null !== r && hi(r, i.deps)))
              return void (a.memoizedState = Ti(t, n, o, r));
          }
          (li.flags |= e), (a.memoizedState = Ti(1 | t, n, o, r));
        }
        function Mi(e, t) {
          return Di(8390656, 8, e, t);
        }
        function Ii(e, t) {
          return zi(2048, 8, e, t);
        }
        function Ri(e, t) {
          return zi(4, 2, e, t);
        }
        function Fi(e, t) {
          return zi(4, 4, e, t);
        }
        function Ui(e, t) {
          return "function" === typeof t
            ? ((e = e()),
              t(e),
              function () {
                t(null);
              })
            : null !== t && void 0 !== t
              ? ((e = e()),
                (t.current = e),
                function () {
                  t.current = null;
                })
              : void 0;
        }
        function Hi(e, t, n) {
          return (
            (n = null !== n && void 0 !== n ? n.concat([e]) : null),
            zi(4, 4, Ui.bind(null, t, e), n)
          );
        }
        function Bi() {}
        function Vi(e, t) {
          var n = yi();
          t = void 0 === t ? null : t;
          var r = n.memoizedState;
          return null !== r && null !== t && hi(t, r[1])
            ? r[0]
            : ((n.memoizedState = [e, t]), e);
        }
        function Wi(e, t) {
          var n = yi();
          t = void 0 === t ? null : t;
          var r = n.memoizedState;
          return null !== r && null !== t && hi(t, r[1])
            ? r[0]
            : ((e = e()), (n.memoizedState = [e, t]), e);
        }
        function Zi(e, t, n) {
          return 0 === (21 & ii)
            ? (e.baseState && ((e.baseState = !1), (yl = !0)),
              (e.memoizedState = n))
            : (lr(n, t) ||
                ((n = ht()), (li.lanes |= n), (Ic |= n), (e.baseState = !0)),
              t);
        }
        function Gi(e, t) {
          var n = yt;
          (yt = 0 !== n && 4 > n ? n : 4), e(!0);
          var r = oi.transition;
          oi.transition = {};
          try {
            e(!1), t();
          } finally {
            (yt = n), (oi.transition = r);
          }
        }
        function qi() {
          return yi().memoizedState;
        }
        function Xi(e, t, n) {
          var r = ts(e);
          if (
            ((n = {
              lane: r,
              action: n,
              hasEagerState: !1,
              eagerState: null,
              next: null,
            }),
            Yi(e))
          )
            Ji(t, n);
          else if (null !== (n = zo(e, t, n, r))) {
            ns(n, e, r, es()), Ki(n, t, r);
          }
        }
        function _i(e, t, n) {
          var r = ts(e),
            a = {
              lane: r,
              action: n,
              hasEagerState: !1,
              eagerState: null,
              next: null,
            };
          if (Yi(e)) Ji(t, a);
          else {
            var o = e.alternate;
            if (
              0 === e.lanes &&
              (null === o || 0 === o.lanes) &&
              null !== (o = t.lastRenderedReducer)
            )
              try {
                var i = t.lastRenderedState,
                  l = o(i, n);
                if (((a.hasEagerState = !0), (a.eagerState = l), lr(l, i))) {
                  var c = t.interleaved;
                  return (
                    null === c
                      ? ((a.next = a), Do(t))
                      : ((a.next = c.next), (c.next = a)),
                    void (t.interleaved = a)
                  );
                }
              } catch (s) {}
            null !== (n = zo(e, t, a, r)) &&
              (ns(n, e, r, (a = es())), Ki(n, t, r));
          }
        }
        function Yi(e) {
          var t = e.alternate;
          return e === li || (null !== t && t === li);
        }
        function Ji(e, t) {
          di = ui = !0;
          var n = e.pending;
          null === n ? (t.next = t) : ((t.next = n.next), (n.next = t)),
            (e.pending = t);
        }
        function Ki(e, t, n) {
          if (0 !== (4194240 & n)) {
            var r = t.lanes;
            (n |= r &= e.pendingLanes), (t.lanes = n), bt(e, n);
          }
        }
        var Qi = {
            readContext: To,
            useCallback: mi,
            useContext: mi,
            useEffect: mi,
            useImperativeHandle: mi,
            useInsertionEffect: mi,
            useLayoutEffect: mi,
            useMemo: mi,
            useReducer: mi,
            useRef: mi,
            useState: mi,
            useDebugValue: mi,
            useDeferredValue: mi,
            useTransition: mi,
            useMutableSource: mi,
            useSyncExternalStore: mi,
            useId: mi,
            unstable_isNewReconciler: !1,
          },
          $i = {
            readContext: To,
            useCallback: function (e, t) {
              return (bi().memoizedState = [e, void 0 === t ? null : t]), e;
            },
            useContext: To,
            useEffect: Mi,
            useImperativeHandle: function (e, t, n) {
              return (
                (n = null !== n && void 0 !== n ? n.concat([e]) : null),
                Di(4194308, 4, Ui.bind(null, t, e), n)
              );
            },
            useLayoutEffect: function (e, t) {
              return Di(4194308, 4, e, t);
            },
            useInsertionEffect: function (e, t) {
              return Di(4, 2, e, t);
            },
            useMemo: function (e, t) {
              var n = bi();
              return (
                (t = void 0 === t ? null : t),
                (e = e()),
                (n.memoizedState = [e, t]),
                e
              );
            },
            useReducer: function (e, t, n) {
              var r = bi();
              return (
                (t = void 0 !== n ? n(t) : t),
                (r.memoizedState = r.baseState = t),
                (e = {
                  pending: null,
                  interleaved: null,
                  lanes: 0,
                  dispatch: null,
                  lastRenderedReducer: e,
                  lastRenderedState: t,
                }),
                (r.queue = e),
                (e = e.dispatch = Xi.bind(null, li, e)),
                [r.memoizedState, e]
              );
            },
            useRef: function (e) {
              return (e = { current: e }), (bi().memoizedState = e);
            },
            useState: Ni,
            useDebugValue: Bi,
            useDeferredValue: function (e) {
              return (bi().memoizedState = e);
            },
            useTransition: function () {
              var e = Ni(!1),
                t = e[0];
              return (
                (e = Gi.bind(null, e[1])), (bi().memoizedState = e), [t, e]
              );
            },
            useMutableSource: function () {},
            useSyncExternalStore: function (e, t, n) {
              var r = li,
                a = bi();
              if (ao) {
                if (void 0 === n) throw Error(o(407));
                n = n();
              } else {
                if (((n = t()), null === Lc)) throw Error(o(349));
                0 !== (30 & ii) || Ei(r, t, n);
              }
              a.memoizedState = n;
              var i = { value: n, getSnapshot: t };
              return (
                (a.queue = i),
                Mi(Ai.bind(null, r, i, e), [e]),
                (r.flags |= 2048),
                Ti(9, Oi.bind(null, r, i, n, t), void 0, null),
                n
              );
            },
            useId: function () {
              var e = bi(),
                t = Lc.identifierPrefix;
              if (ao) {
                var n = Ka;
                (t =
                  ":" +
                  t +
                  "R" +
                  (n = (Ja & ~(1 << (32 - it(Ja) - 1))).toString(32) + n)),
                  0 < (n = pi++) && (t += "H" + n.toString(32)),
                  (t += ":");
              } else t = ":" + t + "r" + (n = fi++).toString(32) + ":";
              return (e.memoizedState = t);
            },
            unstable_isNewReconciler: !1,
          },
          el = {
            readContext: To,
            useCallback: Vi,
            useContext: To,
            useEffect: Ii,
            useImperativeHandle: Hi,
            useInsertionEffect: Ri,
            useLayoutEffect: Fi,
            useMemo: Wi,
            useReducer: wi,
            useRef: Pi,
            useState: function () {
              return wi(xi);
            },
            useDebugValue: Bi,
            useDeferredValue: function (e) {
              return Zi(yi(), ci.memoizedState, e);
            },
            useTransition: function () {
              return [wi(xi)[0], yi().memoizedState];
            },
            useMutableSource: Si,
            useSyncExternalStore: Ci,
            useId: qi,
            unstable_isNewReconciler: !1,
          },
          tl = {
            readContext: To,
            useCallback: Vi,
            useContext: To,
            useEffect: Ii,
            useImperativeHandle: Hi,
            useInsertionEffect: Ri,
            useLayoutEffect: Fi,
            useMemo: Wi,
            useReducer: ki,
            useRef: Pi,
            useState: function () {
              return ki(xi);
            },
            useDebugValue: Bi,
            useDeferredValue: function (e) {
              var t = yi();
              return null === ci
                ? (t.memoizedState = e)
                : Zi(t, ci.memoizedState, e);
            },
            useTransition: function () {
              return [ki(xi)[0], yi().memoizedState];
            },
            useMutableSource: Si,
            useSyncExternalStore: Ci,
            useId: qi,
            unstable_isNewReconciler: !1,
          };
        function nl(e, t) {
          if (e && e.defaultProps) {
            for (var n in ((t = R({}, t)), (e = e.defaultProps)))
              void 0 === t[n] && (t[n] = e[n]);
            return t;
          }
          return t;
        }
        function rl(e, t, n, r) {
          (n =
            null === (n = n(r, (t = e.memoizedState))) || void 0 === n
              ? t
              : R({}, t, n)),
            (e.memoizedState = n),
            0 === e.lanes && (e.updateQueue.baseState = n);
        }
        var al = {
          isMounted: function (e) {
            return !!(e = e._reactInternals) && Ve(e) === e;
          },
          enqueueSetState: function (e, t, n) {
            e = e._reactInternals;
            var r = es(),
              a = ts(e),
              o = Uo(r, a);
            (o.payload = t),
              void 0 !== n && null !== n && (o.callback = n),
              null !== (t = Ho(e, o, a)) && (ns(t, e, a, r), Bo(t, e, a));
          },
          enqueueReplaceState: function (e, t, n) {
            e = e._reactInternals;
            var r = es(),
              a = ts(e),
              o = Uo(r, a);
            (o.tag = 1),
              (o.payload = t),
              void 0 !== n && null !== n && (o.callback = n),
              null !== (t = Ho(e, o, a)) && (ns(t, e, a, r), Bo(t, e, a));
          },
          enqueueForceUpdate: function (e, t) {
            e = e._reactInternals;
            var n = es(),
              r = ts(e),
              a = Uo(n, r);
            (a.tag = 2),
              void 0 !== t && null !== t && (a.callback = t),
              null !== (t = Ho(e, a, r)) && (ns(t, e, r, n), Bo(t, e, r));
          },
        };
        function ol(e, t, n, r, a, o, i) {
          return "function" === typeof (e = e.stateNode).shouldComponentUpdate
            ? e.shouldComponentUpdate(r, o, i)
            : !t.prototype ||
                !t.prototype.isPureReactComponent ||
                !cr(n, r) ||
                !cr(a, o);
        }
        function il(e, t, n) {
          var r = !1,
            a = Aa,
            o = t.contextType;
          return (
            "object" === typeof o && null !== o
              ? (o = To(o))
              : ((a = Pa(t) ? Na : ja.current),
                (o = (r = null !== (r = t.contextTypes) && void 0 !== r)
                  ? Ta(e, a)
                  : Aa)),
            (t = new t(n, o)),
            (e.memoizedState =
              null !== t.state && void 0 !== t.state ? t.state : null),
            (t.updater = al),
            (e.stateNode = t),
            (t._reactInternals = e),
            r &&
              (((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext =
                a),
              (e.__reactInternalMemoizedMaskedChildContext = o)),
            t
          );
        }
        function ll(e, t, n, r) {
          (e = t.state),
            "function" === typeof t.componentWillReceiveProps &&
              t.componentWillReceiveProps(n, r),
            "function" === typeof t.UNSAFE_componentWillReceiveProps &&
              t.UNSAFE_componentWillReceiveProps(n, r),
            t.state !== e && al.enqueueReplaceState(t, t.state, null);
        }
        function cl(e, t, n, r) {
          var a = e.stateNode;
          (a.props = n), (a.state = e.memoizedState), (a.refs = {}), Ro(e);
          var o = t.contextType;
          "object" === typeof o && null !== o
            ? (a.context = To(o))
            : ((o = Pa(t) ? Na : ja.current), (a.context = Ta(e, o))),
            (a.state = e.memoizedState),
            "function" === typeof (o = t.getDerivedStateFromProps) &&
              (rl(e, t, o, n), (a.state = e.memoizedState)),
            "function" === typeof t.getDerivedStateFromProps ||
              "function" === typeof a.getSnapshotBeforeUpdate ||
              ("function" !== typeof a.UNSAFE_componentWillMount &&
                "function" !== typeof a.componentWillMount) ||
              ((t = a.state),
              "function" === typeof a.componentWillMount &&
                a.componentWillMount(),
              "function" === typeof a.UNSAFE_componentWillMount &&
                a.UNSAFE_componentWillMount(),
              t !== a.state && al.enqueueReplaceState(a, a.state, null),
              Wo(e, n, a, r),
              (a.state = e.memoizedState)),
            "function" === typeof a.componentDidMount && (e.flags |= 4194308);
        }
        function sl(e, t) {
          try {
            var n = "",
              r = t;
            do {
              (n += B(r)), (r = r.return);
            } while (r);
            var a = n;
          } catch (o) {
            a = "\nError generating stack: " + o.message + "\n" + o.stack;
          }
          return { value: e, source: t, stack: a, digest: null };
        }
        function ul(e, t, n) {
          return {
            value: e,
            source: null,
            stack: null != n ? n : null,
            digest: null != t ? t : null,
          };
        }
        function dl(e, t) {
          try {
            console.error(t.value);
          } catch (n) {
            setTimeout(function () {
              throw n;
            });
          }
        }
        var pl = "function" === typeof WeakMap ? WeakMap : Map;
        function fl(e, t, n) {
          ((n = Uo(-1, n)).tag = 3), (n.payload = { element: null });
          var r = t.value;
          return (
            (n.callback = function () {
              Zc || ((Zc = !0), (Gc = r)), dl(0, t);
            }),
            n
          );
        }
        function ml(e, t, n) {
          (n = Uo(-1, n)).tag = 3;
          var r = e.type.getDerivedStateFromError;
          if ("function" === typeof r) {
            var a = t.value;
            (n.payload = function () {
              return r(a);
            }),
              (n.callback = function () {
                dl(0, t);
              });
          }
          var o = e.stateNode;
          return (
            null !== o &&
              "function" === typeof o.componentDidCatch &&
              (n.callback = function () {
                dl(0, t),
                  "function" !== typeof r &&
                    (null === qc ? (qc = new Set([this])) : qc.add(this));
                var e = t.stack;
                this.componentDidCatch(t.value, {
                  componentStack: null !== e ? e : "",
                });
              }),
            n
          );
        }
        function hl(e, t, n) {
          var r = e.pingCache;
          if (null === r) {
            r = e.pingCache = new pl();
            var a = new Set();
            r.set(t, a);
          } else void 0 === (a = r.get(t)) && ((a = new Set()), r.set(t, a));
          a.has(n) || (a.add(n), (e = Es.bind(null, e, t, n)), t.then(e, e));
        }
        function gl(e) {
          do {
            var t;
            if (
              ((t = 13 === e.tag) &&
                (t = null === (t = e.memoizedState) || null !== t.dehydrated),
              t)
            )
              return e;
            e = e.return;
          } while (null !== e);
          return null;
        }
        function vl(e, t, n, r, a) {
          return 0 === (1 & e.mode)
            ? (e === t
                ? (e.flags |= 65536)
                : ((e.flags |= 128),
                  (n.flags |= 131072),
                  (n.flags &= -52805),
                  1 === n.tag &&
                    (null === n.alternate
                      ? (n.tag = 17)
                      : (((t = Uo(-1, 1)).tag = 2), Ho(n, t, 1))),
                  (n.lanes |= 1)),
              e)
            : ((e.flags |= 65536), (e.lanes = a), e);
        }
        var bl = x.ReactCurrentOwner,
          yl = !1;
        function xl(e, t, n, r) {
          t.child = null === e ? ko(t, null, n, r) : wo(t, e.child, n, r);
        }
        function wl(e, t, n, r, a) {
          n = n.render;
          var o = t.ref;
          return (
            No(t, a),
            (r = gi(e, t, n, r, o, a)),
            (n = vi()),
            null === e || yl
              ? (ao && n && eo(t), (t.flags |= 1), xl(e, t, r, a), t.child)
              : ((t.updateQueue = e.updateQueue),
                (t.flags &= -2053),
                (e.lanes &= ~a),
                Zl(e, t, a))
          );
        }
        function kl(e, t, n, r, a) {
          if (null === e) {
            var o = n.type;
            return "function" !== typeof o ||
              Ps(o) ||
              void 0 !== o.defaultProps ||
              null !== n.compare ||
              void 0 !== n.defaultProps
              ? (((e = zs(n.type, null, r, t, t.mode, a)).ref = t.ref),
                (e.return = t),
                (t.child = e))
              : ((t.tag = 15), (t.type = o), Sl(e, t, o, r, a));
          }
          if (((o = e.child), 0 === (e.lanes & a))) {
            var i = o.memoizedProps;
            if (
              (n = null !== (n = n.compare) ? n : cr)(i, r) &&
              e.ref === t.ref
            )
              return Zl(e, t, a);
          }
          return (
            (t.flags |= 1),
            ((e = Ds(o, r)).ref = t.ref),
            (e.return = t),
            (t.child = e)
          );
        }
        function Sl(e, t, n, r, a) {
          if (null !== e) {
            var o = e.memoizedProps;
            if (cr(o, r) && e.ref === t.ref) {
              if (((yl = !1), (t.pendingProps = r = o), 0 === (e.lanes & a)))
                return (t.lanes = e.lanes), Zl(e, t, a);
              0 !== (131072 & e.flags) && (yl = !0);
            }
          }
          return Ol(e, t, n, r, a);
        }
        function Cl(e, t, n) {
          var r = t.pendingProps,
            a = r.children,
            o = null !== e ? e.memoizedState : null;
          if ("hidden" === r.mode)
            if (0 === (1 & t.mode))
              (t.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null,
              }),
                Oa(Dc, Pc),
                (Pc |= n);
            else {
              if (0 === (1073741824 & n))
                return (
                  (e = null !== o ? o.baseLanes | n : n),
                  (t.lanes = t.childLanes = 1073741824),
                  (t.memoizedState = {
                    baseLanes: e,
                    cachePool: null,
                    transitions: null,
                  }),
                  (t.updateQueue = null),
                  Oa(Dc, Pc),
                  (Pc |= e),
                  null
                );
              (t.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null,
              }),
                (r = null !== o ? o.baseLanes : n),
                Oa(Dc, Pc),
                (Pc |= r);
            }
          else
            null !== o
              ? ((r = o.baseLanes | n), (t.memoizedState = null))
              : (r = n),
              Oa(Dc, Pc),
              (Pc |= r);
          return xl(e, t, a, n), t.child;
        }
        function El(e, t) {
          var n = t.ref;
          ((null === e && null !== n) || (null !== e && e.ref !== n)) &&
            ((t.flags |= 512), (t.flags |= 2097152));
        }
        function Ol(e, t, n, r, a) {
          var o = Pa(n) ? Na : ja.current;
          return (
            (o = Ta(t, o)),
            No(t, a),
            (n = gi(e, t, n, r, o, a)),
            (r = vi()),
            null === e || yl
              ? (ao && r && eo(t), (t.flags |= 1), xl(e, t, n, a), t.child)
              : ((t.updateQueue = e.updateQueue),
                (t.flags &= -2053),
                (e.lanes &= ~a),
                Zl(e, t, a))
          );
        }
        function Al(e, t, n, r, a) {
          if (Pa(n)) {
            var o = !0;
            Ia(t);
          } else o = !1;
          if ((No(t, a), null === t.stateNode))
            Wl(e, t), il(t, n, r), cl(t, n, r, a), (r = !0);
          else if (null === e) {
            var i = t.stateNode,
              l = t.memoizedProps;
            i.props = l;
            var c = i.context,
              s = n.contextType;
            "object" === typeof s && null !== s
              ? (s = To(s))
              : (s = Ta(t, (s = Pa(n) ? Na : ja.current)));
            var u = n.getDerivedStateFromProps,
              d =
                "function" === typeof u ||
                "function" === typeof i.getSnapshotBeforeUpdate;
            d ||
              ("function" !== typeof i.UNSAFE_componentWillReceiveProps &&
                "function" !== typeof i.componentWillReceiveProps) ||
              ((l !== r || c !== s) && ll(t, i, r, s)),
              (Io = !1);
            var p = t.memoizedState;
            (i.state = p),
              Wo(t, r, i, a),
              (c = t.memoizedState),
              l !== r || p !== c || La.current || Io
                ? ("function" === typeof u &&
                    (rl(t, n, u, r), (c = t.memoizedState)),
                  (l = Io || ol(t, n, l, r, p, c, s))
                    ? (d ||
                        ("function" !== typeof i.UNSAFE_componentWillMount &&
                          "function" !== typeof i.componentWillMount) ||
                        ("function" === typeof i.componentWillMount &&
                          i.componentWillMount(),
                        "function" === typeof i.UNSAFE_componentWillMount &&
                          i.UNSAFE_componentWillMount()),
                      "function" === typeof i.componentDidMount &&
                        (t.flags |= 4194308))
                    : ("function" === typeof i.componentDidMount &&
                        (t.flags |= 4194308),
                      (t.memoizedProps = r),
                      (t.memoizedState = c)),
                  (i.props = r),
                  (i.state = c),
                  (i.context = s),
                  (r = l))
                : ("function" === typeof i.componentDidMount &&
                    (t.flags |= 4194308),
                  (r = !1));
          } else {
            (i = t.stateNode),
              Fo(e, t),
              (l = t.memoizedProps),
              (s = t.type === t.elementType ? l : nl(t.type, l)),
              (i.props = s),
              (d = t.pendingProps),
              (p = i.context),
              "object" === typeof (c = n.contextType) && null !== c
                ? (c = To(c))
                : (c = Ta(t, (c = Pa(n) ? Na : ja.current)));
            var f = n.getDerivedStateFromProps;
            (u =
              "function" === typeof f ||
              "function" === typeof i.getSnapshotBeforeUpdate) ||
              ("function" !== typeof i.UNSAFE_componentWillReceiveProps &&
                "function" !== typeof i.componentWillReceiveProps) ||
              ((l !== d || p !== c) && ll(t, i, r, c)),
              (Io = !1),
              (p = t.memoizedState),
              (i.state = p),
              Wo(t, r, i, a);
            var m = t.memoizedState;
            l !== d || p !== m || La.current || Io
              ? ("function" === typeof f &&
                  (rl(t, n, f, r), (m = t.memoizedState)),
                (s = Io || ol(t, n, s, r, p, m, c) || !1)
                  ? (u ||
                      ("function" !== typeof i.UNSAFE_componentWillUpdate &&
                        "function" !== typeof i.componentWillUpdate) ||
                      ("function" === typeof i.componentWillUpdate &&
                        i.componentWillUpdate(r, m, c),
                      "function" === typeof i.UNSAFE_componentWillUpdate &&
                        i.UNSAFE_componentWillUpdate(r, m, c)),
                    "function" === typeof i.componentDidUpdate &&
                      (t.flags |= 4),
                    "function" === typeof i.getSnapshotBeforeUpdate &&
                      (t.flags |= 1024))
                  : ("function" !== typeof i.componentDidUpdate ||
                      (l === e.memoizedProps && p === e.memoizedState) ||
                      (t.flags |= 4),
                    "function" !== typeof i.getSnapshotBeforeUpdate ||
                      (l === e.memoizedProps && p === e.memoizedState) ||
                      (t.flags |= 1024),
                    (t.memoizedProps = r),
                    (t.memoizedState = m)),
                (i.props = r),
                (i.state = m),
                (i.context = c),
                (r = s))
              : ("function" !== typeof i.componentDidUpdate ||
                  (l === e.memoizedProps && p === e.memoizedState) ||
                  (t.flags |= 4),
                "function" !== typeof i.getSnapshotBeforeUpdate ||
                  (l === e.memoizedProps && p === e.memoizedState) ||
                  (t.flags |= 1024),
                (r = !1));
          }
          return jl(e, t, n, r, o, a);
        }
        function jl(e, t, n, r, a, o) {
          El(e, t);
          var i = 0 !== (128 & t.flags);
          if (!r && !i) return a && Ra(t, n, !1), Zl(e, t, o);
          (r = t.stateNode), (bl.current = t);
          var l =
            i && "function" !== typeof n.getDerivedStateFromError
              ? null
              : r.render();
          return (
            (t.flags |= 1),
            null !== e && i
              ? ((t.child = wo(t, e.child, null, o)),
                (t.child = wo(t, null, l, o)))
              : xl(e, t, l, o),
            (t.memoizedState = r.state),
            a && Ra(t, n, !0),
            t.child
          );
        }
        function Ll(e) {
          var t = e.stateNode;
          t.pendingContext
            ? za(0, t.pendingContext, t.pendingContext !== t.context)
            : t.context && za(0, t.context, !1),
            Jo(e, t.containerInfo);
        }
        function Nl(e, t, n, r, a) {
          return mo(), ho(a), (t.flags |= 256), xl(e, t, n, r), t.child;
        }
        var Tl,
          Pl,
          Dl,
          zl,
          Ml = { dehydrated: null, treeContext: null, retryLane: 0 };
        function Il(e) {
          return { baseLanes: e, cachePool: null, transitions: null };
        }
        function Rl(e, t, n) {
          var r,
            a = t.pendingProps,
            i = ei.current,
            l = !1,
            c = 0 !== (128 & t.flags);
          if (
            ((r = c) ||
              (r = (null === e || null !== e.memoizedState) && 0 !== (2 & i)),
            r
              ? ((l = !0), (t.flags &= -129))
              : (null !== e && null === e.memoizedState) || (i |= 1),
            Oa(ei, 1 & i),
            null === e)
          )
            return (
              so(t),
              null !== (e = t.memoizedState) && null !== (e = e.dehydrated)
                ? (0 === (1 & t.mode)
                    ? (t.lanes = 1)
                    : "$!" === e.data
                      ? (t.lanes = 8)
                      : (t.lanes = 1073741824),
                  null)
                : ((c = a.children),
                  (e = a.fallback),
                  l
                    ? ((a = t.mode),
                      (l = t.child),
                      (c = { mode: "hidden", children: c }),
                      0 === (1 & a) && null !== l
                        ? ((l.childLanes = 0), (l.pendingProps = c))
                        : (l = Is(c, a, 0, null)),
                      (e = Ms(e, a, n, null)),
                      (l.return = t),
                      (e.return = t),
                      (l.sibling = e),
                      (t.child = l),
                      (t.child.memoizedState = Il(n)),
                      (t.memoizedState = Ml),
                      e)
                    : Fl(t, c))
            );
          if (null !== (i = e.memoizedState) && null !== (r = i.dehydrated))
            return (function (e, t, n, r, a, i, l) {
              if (n)
                return 256 & t.flags
                  ? ((t.flags &= -257), Ul(e, t, l, (r = ul(Error(o(422))))))
                  : null !== t.memoizedState
                    ? ((t.child = e.child), (t.flags |= 128), null)
                    : ((i = r.fallback),
                      (a = t.mode),
                      (r = Is(
                        { mode: "visible", children: r.children },
                        a,
                        0,
                        null,
                      )),
                      ((i = Ms(i, a, l, null)).flags |= 2),
                      (r.return = t),
                      (i.return = t),
                      (r.sibling = i),
                      (t.child = r),
                      0 !== (1 & t.mode) && wo(t, e.child, null, l),
                      (t.child.memoizedState = Il(l)),
                      (t.memoizedState = Ml),
                      i);
              if (0 === (1 & t.mode)) return Ul(e, t, l, null);
              if ("$!" === a.data) {
                if ((r = a.nextSibling && a.nextSibling.dataset))
                  var c = r.dgst;
                return (
                  (r = c), Ul(e, t, l, (r = ul((i = Error(o(419))), r, void 0)))
                );
              }
              if (((c = 0 !== (l & e.childLanes)), yl || c)) {
                if (null !== (r = Lc)) {
                  switch (l & -l) {
                    case 4:
                      a = 2;
                      break;
                    case 16:
                      a = 8;
                      break;
                    case 64:
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                    case 67108864:
                      a = 32;
                      break;
                    case 536870912:
                      a = 268435456;
                      break;
                    default:
                      a = 0;
                  }
                  0 !== (a = 0 !== (a & (r.suspendedLanes | l)) ? 0 : a) &&
                    a !== i.retryLane &&
                    ((i.retryLane = a), Mo(e, a), ns(r, e, a, -1));
                }
                return hs(), Ul(e, t, l, (r = ul(Error(o(421)))));
              }
              return "$?" === a.data
                ? ((t.flags |= 128),
                  (t.child = e.child),
                  (t = As.bind(null, e)),
                  (a._reactRetry = t),
                  null)
                : ((e = i.treeContext),
                  (ro = sa(a.nextSibling)),
                  (no = t),
                  (ao = !0),
                  (oo = null),
                  null !== e &&
                    ((Xa[_a++] = Ja),
                    (Xa[_a++] = Ka),
                    (Xa[_a++] = Ya),
                    (Ja = e.id),
                    (Ka = e.overflow),
                    (Ya = t)),
                  (t = Fl(t, r.children)),
                  (t.flags |= 4096),
                  t);
            })(e, t, c, a, r, i, n);
          if (l) {
            (l = a.fallback), (c = t.mode), (r = (i = e.child).sibling);
            var s = { mode: "hidden", children: a.children };
            return (
              0 === (1 & c) && t.child !== i
                ? (((a = t.child).childLanes = 0),
                  (a.pendingProps = s),
                  (t.deletions = null))
                : ((a = Ds(i, s)).subtreeFlags = 14680064 & i.subtreeFlags),
              null !== r
                ? (l = Ds(r, l))
                : ((l = Ms(l, c, n, null)).flags |= 2),
              (l.return = t),
              (a.return = t),
              (a.sibling = l),
              (t.child = a),
              (a = l),
              (l = t.child),
              (c =
                null === (c = e.child.memoizedState)
                  ? Il(n)
                  : {
                      baseLanes: c.baseLanes | n,
                      cachePool: null,
                      transitions: c.transitions,
                    }),
              (l.memoizedState = c),
              (l.childLanes = e.childLanes & ~n),
              (t.memoizedState = Ml),
              a
            );
          }
          return (
            (e = (l = e.child).sibling),
            (a = Ds(l, { mode: "visible", children: a.children })),
            0 === (1 & t.mode) && (a.lanes = n),
            (a.return = t),
            (a.sibling = null),
            null !== e &&
              (null === (n = t.deletions)
                ? ((t.deletions = [e]), (t.flags |= 16))
                : n.push(e)),
            (t.child = a),
            (t.memoizedState = null),
            a
          );
        }
        function Fl(e, t) {
          return (
            ((t = Is(
              { mode: "visible", children: t },
              e.mode,
              0,
              null,
            )).return = e),
            (e.child = t)
          );
        }
        function Ul(e, t, n, r) {
          return (
            null !== r && ho(r),
            wo(t, e.child, null, n),
            ((e = Fl(t, t.pendingProps.children)).flags |= 2),
            (t.memoizedState = null),
            e
          );
        }
        function Hl(e, t, n) {
          e.lanes |= t;
          var r = e.alternate;
          null !== r && (r.lanes |= t), Lo(e.return, t, n);
        }
        function Bl(e, t, n, r, a) {
          var o = e.memoizedState;
          null === o
            ? (e.memoizedState = {
                isBackwards: t,
                rendering: null,
                renderingStartTime: 0,
                last: r,
                tail: n,
                tailMode: a,
              })
            : ((o.isBackwards = t),
              (o.rendering = null),
              (o.renderingStartTime = 0),
              (o.last = r),
              (o.tail = n),
              (o.tailMode = a));
        }
        function Vl(e, t, n) {
          var r = t.pendingProps,
            a = r.revealOrder,
            o = r.tail;
          if ((xl(e, t, r.children, n), 0 !== (2 & (r = ei.current))))
            (r = (1 & r) | 2), (t.flags |= 128);
          else {
            if (null !== e && 0 !== (128 & e.flags))
              e: for (e = t.child; null !== e; ) {
                if (13 === e.tag) null !== e.memoizedState && Hl(e, n, t);
                else if (19 === e.tag) Hl(e, n, t);
                else if (null !== e.child) {
                  (e.child.return = e), (e = e.child);
                  continue;
                }
                if (e === t) break e;
                for (; null === e.sibling; ) {
                  if (null === e.return || e.return === t) break e;
                  e = e.return;
                }
                (e.sibling.return = e.return), (e = e.sibling);
              }
            r &= 1;
          }
          if ((Oa(ei, r), 0 === (1 & t.mode))) t.memoizedState = null;
          else
            switch (a) {
              case "forwards":
                for (n = t.child, a = null; null !== n; )
                  null !== (e = n.alternate) && null === ti(e) && (a = n),
                    (n = n.sibling);
                null === (n = a)
                  ? ((a = t.child), (t.child = null))
                  : ((a = n.sibling), (n.sibling = null)),
                  Bl(t, !1, a, n, o);
                break;
              case "backwards":
                for (n = null, a = t.child, t.child = null; null !== a; ) {
                  if (null !== (e = a.alternate) && null === ti(e)) {
                    t.child = a;
                    break;
                  }
                  (e = a.sibling), (a.sibling = n), (n = a), (a = e);
                }
                Bl(t, !0, n, null, o);
                break;
              case "together":
                Bl(t, !1, null, null, void 0);
                break;
              default:
                t.memoizedState = null;
            }
          return t.child;
        }
        function Wl(e, t) {
          0 === (1 & t.mode) &&
            null !== e &&
            ((e.alternate = null), (t.alternate = null), (t.flags |= 2));
        }
        function Zl(e, t, n) {
          if (
            (null !== e && (t.dependencies = e.dependencies),
            (Ic |= t.lanes),
            0 === (n & t.childLanes))
          )
            return null;
          if (null !== e && t.child !== e.child) throw Error(o(153));
          if (null !== t.child) {
            for (
              n = Ds((e = t.child), e.pendingProps), t.child = n, n.return = t;
              null !== e.sibling;

            )
              (e = e.sibling),
                ((n = n.sibling = Ds(e, e.pendingProps)).return = t);
            n.sibling = null;
          }
          return t.child;
        }
        function Gl(e, t) {
          if (!ao)
            switch (e.tailMode) {
              case "hidden":
                t = e.tail;
                for (var n = null; null !== t; )
                  null !== t.alternate && (n = t), (t = t.sibling);
                null === n ? (e.tail = null) : (n.sibling = null);
                break;
              case "collapsed":
                n = e.tail;
                for (var r = null; null !== n; )
                  null !== n.alternate && (r = n), (n = n.sibling);
                null === r
                  ? t || null === e.tail
                    ? (e.tail = null)
                    : (e.tail.sibling = null)
                  : (r.sibling = null);
            }
        }
        function ql(e) {
          var t = null !== e.alternate && e.alternate.child === e.child,
            n = 0,
            r = 0;
          if (t)
            for (var a = e.child; null !== a; )
              (n |= a.lanes | a.childLanes),
                (r |= 14680064 & a.subtreeFlags),
                (r |= 14680064 & a.flags),
                (a.return = e),
                (a = a.sibling);
          else
            for (a = e.child; null !== a; )
              (n |= a.lanes | a.childLanes),
                (r |= a.subtreeFlags),
                (r |= a.flags),
                (a.return = e),
                (a = a.sibling);
          return (e.subtreeFlags |= r), (e.childLanes = n), t;
        }
        function Xl(e, t, n) {
          var r = t.pendingProps;
          switch ((to(t), t.tag)) {
            case 2:
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
              return ql(t), null;
            case 1:
            case 17:
              return Pa(t.type) && Da(), ql(t), null;
            case 3:
              return (
                (r = t.stateNode),
                Ko(),
                Ea(La),
                Ea(ja),
                ri(),
                r.pendingContext &&
                  ((r.context = r.pendingContext), (r.pendingContext = null)),
                (null !== e && null !== e.child) ||
                  (po(t)
                    ? (t.flags |= 4)
                    : null === e ||
                      (e.memoizedState.isDehydrated && 0 === (256 & t.flags)) ||
                      ((t.flags |= 1024),
                      null !== oo && (is(oo), (oo = null)))),
                Pl(e, t),
                ql(t),
                null
              );
            case 5:
              $o(t);
              var a = Yo(_o.current);
              if (((n = t.type), null !== e && null != t.stateNode))
                Dl(e, t, n, r, a),
                  e.ref !== t.ref && ((t.flags |= 512), (t.flags |= 2097152));
              else {
                if (!r) {
                  if (null === t.stateNode) throw Error(o(166));
                  return ql(t), null;
                }
                if (((e = Yo(qo.current)), po(t))) {
                  (r = t.stateNode), (n = t.type);
                  var i = t.memoizedProps;
                  switch (
                    ((r[pa] = t), (r[fa] = i), (e = 0 !== (1 & t.mode)), n)
                  ) {
                    case "dialog":
                      Ur("cancel", r), Ur("close", r);
                      break;
                    case "iframe":
                    case "object":
                    case "embed":
                      Ur("load", r);
                      break;
                    case "video":
                    case "audio":
                      for (a = 0; a < Mr.length; a++) Ur(Mr[a], r);
                      break;
                    case "source":
                      Ur("error", r);
                      break;
                    case "img":
                    case "image":
                    case "link":
                      Ur("error", r), Ur("load", r);
                      break;
                    case "details":
                      Ur("toggle", r);
                      break;
                    case "input":
                      J(r, i), Ur("invalid", r);
                      break;
                    case "select":
                      (r._wrapperState = { wasMultiple: !!i.multiple }),
                        Ur("invalid", r);
                      break;
                    case "textarea":
                      ae(r, i), Ur("invalid", r);
                  }
                  for (var c in (be(n, i), (a = null), i))
                    if (i.hasOwnProperty(c)) {
                      var s = i[c];
                      "children" === c
                        ? "string" === typeof s
                          ? r.textContent !== s &&
                            (!0 !== i.suppressHydrationWarning &&
                              Qr(r.textContent, s, e),
                            (a = ["children", s]))
                          : "number" === typeof s &&
                            r.textContent !== "" + s &&
                            (!0 !== i.suppressHydrationWarning &&
                              Qr(r.textContent, s, e),
                            (a = ["children", "" + s]))
                        : l.hasOwnProperty(c) &&
                          null != s &&
                          "onScroll" === c &&
                          Ur("scroll", r);
                    }
                  switch (n) {
                    case "input":
                      q(r), $(r, i, !0);
                      break;
                    case "textarea":
                      q(r), ie(r);
                      break;
                    case "select":
                    case "option":
                      break;
                    default:
                      "function" === typeof i.onClick && (r.onclick = $r);
                  }
                  (r = a), (t.updateQueue = r), null !== r && (t.flags |= 4);
                } else {
                  (c = 9 === a.nodeType ? a : a.ownerDocument),
                    "http://www.w3.org/1999/xhtml" === e && (e = le(n)),
                    "http://www.w3.org/1999/xhtml" === e
                      ? "script" === n
                        ? (((e = c.createElement("div")).innerHTML =
                            "<script><\/script>"),
                          (e = e.removeChild(e.firstChild)))
                        : "string" === typeof r.is
                          ? (e = c.createElement(n, { is: r.is }))
                          : ((e = c.createElement(n)),
                            "select" === n &&
                              ((c = e),
                              r.multiple
                                ? (c.multiple = !0)
                                : r.size && (c.size = r.size)))
                      : (e = c.createElementNS(e, n)),
                    (e[pa] = t),
                    (e[fa] = r),
                    Tl(e, t, !1, !1),
                    (t.stateNode = e);
                  e: {
                    switch (((c = ye(n, r)), n)) {
                      case "dialog":
                        Ur("cancel", e), Ur("close", e), (a = r);
                        break;
                      case "iframe":
                      case "object":
                      case "embed":
                        Ur("load", e), (a = r);
                        break;
                      case "video":
                      case "audio":
                        for (a = 0; a < Mr.length; a++) Ur(Mr[a], e);
                        a = r;
                        break;
                      case "source":
                        Ur("error", e), (a = r);
                        break;
                      case "img":
                      case "image":
                      case "link":
                        Ur("error", e), Ur("load", e), (a = r);
                        break;
                      case "details":
                        Ur("toggle", e), (a = r);
                        break;
                      case "input":
                        J(e, r), (a = Y(e, r)), Ur("invalid", e);
                        break;
                      case "option":
                      default:
                        a = r;
                        break;
                      case "select":
                        (e._wrapperState = { wasMultiple: !!r.multiple }),
                          (a = R({}, r, { value: void 0 })),
                          Ur("invalid", e);
                        break;
                      case "textarea":
                        ae(e, r), (a = re(e, r)), Ur("invalid", e);
                    }
                    for (i in (be(n, a), (s = a)))
                      if (s.hasOwnProperty(i)) {
                        var u = s[i];
                        "style" === i
                          ? ge(e, u)
                          : "dangerouslySetInnerHTML" === i
                            ? null != (u = u ? u.__html : void 0) && de(e, u)
                            : "children" === i
                              ? "string" === typeof u
                                ? ("textarea" !== n || "" !== u) && pe(e, u)
                                : "number" === typeof u && pe(e, "" + u)
                              : "suppressContentEditableWarning" !== i &&
                                "suppressHydrationWarning" !== i &&
                                "autoFocus" !== i &&
                                (l.hasOwnProperty(i)
                                  ? null != u &&
                                    "onScroll" === i &&
                                    Ur("scroll", e)
                                  : null != u && y(e, i, u, c));
                      }
                    switch (n) {
                      case "input":
                        q(e), $(e, r, !1);
                        break;
                      case "textarea":
                        q(e), ie(e);
                        break;
                      case "option":
                        null != r.value &&
                          e.setAttribute("value", "" + Z(r.value));
                        break;
                      case "select":
                        (e.multiple = !!r.multiple),
                          null != (i = r.value)
                            ? ne(e, !!r.multiple, i, !1)
                            : null != r.defaultValue &&
                              ne(e, !!r.multiple, r.defaultValue, !0);
                        break;
                      default:
                        "function" === typeof a.onClick && (e.onclick = $r);
                    }
                    switch (n) {
                      case "button":
                      case "input":
                      case "select":
                      case "textarea":
                        r = !!r.autoFocus;
                        break e;
                      case "img":
                        r = !0;
                        break e;
                      default:
                        r = !1;
                    }
                  }
                  r && (t.flags |= 4);
                }
                null !== t.ref && ((t.flags |= 512), (t.flags |= 2097152));
              }
              return ql(t), null;
            case 6:
              if (e && null != t.stateNode) zl(e, t, e.memoizedProps, r);
              else {
                if ("string" !== typeof r && null === t.stateNode)
                  throw Error(o(166));
                if (((n = Yo(_o.current)), Yo(qo.current), po(t))) {
                  if (
                    ((r = t.stateNode),
                    (n = t.memoizedProps),
                    (r[pa] = t),
                    (i = r.nodeValue !== n) && null !== (e = no))
                  )
                    switch (e.tag) {
                      case 3:
                        Qr(r.nodeValue, n, 0 !== (1 & e.mode));
                        break;
                      case 5:
                        !0 !== e.memoizedProps.suppressHydrationWarning &&
                          Qr(r.nodeValue, n, 0 !== (1 & e.mode));
                    }
                  i && (t.flags |= 4);
                } else
                  ((r = (9 === n.nodeType ? n : n.ownerDocument).createTextNode(
                    r,
                  ))[pa] = t),
                    (t.stateNode = r);
              }
              return ql(t), null;
            case 13:
              if (
                (Ea(ei),
                (r = t.memoizedState),
                null === e ||
                  (null !== e.memoizedState &&
                    null !== e.memoizedState.dehydrated))
              ) {
                if (
                  ao &&
                  null !== ro &&
                  0 !== (1 & t.mode) &&
                  0 === (128 & t.flags)
                )
                  fo(), mo(), (t.flags |= 98560), (i = !1);
                else if (((i = po(t)), null !== r && null !== r.dehydrated)) {
                  if (null === e) {
                    if (!i) throw Error(o(318));
                    if (
                      !(i =
                        null !== (i = t.memoizedState) ? i.dehydrated : null)
                    )
                      throw Error(o(317));
                    i[pa] = t;
                  } else
                    mo(),
                      0 === (128 & t.flags) && (t.memoizedState = null),
                      (t.flags |= 4);
                  ql(t), (i = !1);
                } else null !== oo && (is(oo), (oo = null)), (i = !0);
                if (!i) return 65536 & t.flags ? t : null;
              }
              return 0 !== (128 & t.flags)
                ? ((t.lanes = n), t)
                : ((r = null !== r) !==
                    (null !== e && null !== e.memoizedState) &&
                    r &&
                    ((t.child.flags |= 8192),
                    0 !== (1 & t.mode) &&
                      (null === e || 0 !== (1 & ei.current)
                        ? 0 === zc && (zc = 3)
                        : hs())),
                  null !== t.updateQueue && (t.flags |= 4),
                  ql(t),
                  null);
            case 4:
              return (
                Ko(),
                Pl(e, t),
                null === e && Vr(t.stateNode.containerInfo),
                ql(t),
                null
              );
            case 10:
              return jo(t.type._context), ql(t), null;
            case 19:
              if ((Ea(ei), null === (i = t.memoizedState))) return ql(t), null;
              if (((r = 0 !== (128 & t.flags)), null === (c = i.rendering)))
                if (r) Gl(i, !1);
                else {
                  if (0 !== zc || (null !== e && 0 !== (128 & e.flags)))
                    for (e = t.child; null !== e; ) {
                      if (null !== (c = ti(e))) {
                        for (
                          t.flags |= 128,
                            Gl(i, !1),
                            null !== (r = c.updateQueue) &&
                              ((t.updateQueue = r), (t.flags |= 4)),
                            t.subtreeFlags = 0,
                            r = n,
                            n = t.child;
                          null !== n;

                        )
                          (e = r),
                            ((i = n).flags &= 14680066),
                            null === (c = i.alternate)
                              ? ((i.childLanes = 0),
                                (i.lanes = e),
                                (i.child = null),
                                (i.subtreeFlags = 0),
                                (i.memoizedProps = null),
                                (i.memoizedState = null),
                                (i.updateQueue = null),
                                (i.dependencies = null),
                                (i.stateNode = null))
                              : ((i.childLanes = c.childLanes),
                                (i.lanes = c.lanes),
                                (i.child = c.child),
                                (i.subtreeFlags = 0),
                                (i.deletions = null),
                                (i.memoizedProps = c.memoizedProps),
                                (i.memoizedState = c.memoizedState),
                                (i.updateQueue = c.updateQueue),
                                (i.type = c.type),
                                (e = c.dependencies),
                                (i.dependencies =
                                  null === e
                                    ? null
                                    : {
                                        lanes: e.lanes,
                                        firstContext: e.firstContext,
                                      })),
                            (n = n.sibling);
                        return Oa(ei, (1 & ei.current) | 2), t.child;
                      }
                      e = e.sibling;
                    }
                  null !== i.tail &&
                    Ke() > Vc &&
                    ((t.flags |= 128),
                    (r = !0),
                    Gl(i, !1),
                    (t.lanes = 4194304));
                }
              else {
                if (!r)
                  if (null !== (e = ti(c))) {
                    if (
                      ((t.flags |= 128),
                      (r = !0),
                      null !== (n = e.updateQueue) &&
                        ((t.updateQueue = n), (t.flags |= 4)),
                      Gl(i, !0),
                      null === i.tail &&
                        "hidden" === i.tailMode &&
                        !c.alternate &&
                        !ao)
                    )
                      return ql(t), null;
                  } else
                    2 * Ke() - i.renderingStartTime > Vc &&
                      1073741824 !== n &&
                      ((t.flags |= 128),
                      (r = !0),
                      Gl(i, !1),
                      (t.lanes = 4194304));
                i.isBackwards
                  ? ((c.sibling = t.child), (t.child = c))
                  : (null !== (n = i.last) ? (n.sibling = c) : (t.child = c),
                    (i.last = c));
              }
              return null !== i.tail
                ? ((t = i.tail),
                  (i.rendering = t),
                  (i.tail = t.sibling),
                  (i.renderingStartTime = Ke()),
                  (t.sibling = null),
                  (n = ei.current),
                  Oa(ei, r ? (1 & n) | 2 : 1 & n),
                  t)
                : (ql(t), null);
            case 22:
            case 23:
              return (
                ds(),
                (r = null !== t.memoizedState),
                null !== e &&
                  (null !== e.memoizedState) !== r &&
                  (t.flags |= 8192),
                r && 0 !== (1 & t.mode)
                  ? 0 !== (1073741824 & Pc) &&
                    (ql(t), 6 & t.subtreeFlags && (t.flags |= 8192))
                  : ql(t),
                null
              );
            case 24:
            case 25:
              return null;
          }
          throw Error(o(156, t.tag));
        }
        function _l(e, t) {
          switch ((to(t), t.tag)) {
            case 1:
              return (
                Pa(t.type) && Da(),
                65536 & (e = t.flags)
                  ? ((t.flags = (-65537 & e) | 128), t)
                  : null
              );
            case 3:
              return (
                Ko(),
                Ea(La),
                Ea(ja),
                ri(),
                0 !== (65536 & (e = t.flags)) && 0 === (128 & e)
                  ? ((t.flags = (-65537 & e) | 128), t)
                  : null
              );
            case 5:
              return $o(t), null;
            case 13:
              if (
                (Ea(ei),
                null !== (e = t.memoizedState) && null !== e.dehydrated)
              ) {
                if (null === t.alternate) throw Error(o(340));
                mo();
              }
              return 65536 & (e = t.flags)
                ? ((t.flags = (-65537 & e) | 128), t)
                : null;
            case 19:
              return Ea(ei), null;
            case 4:
              return Ko(), null;
            case 10:
              return jo(t.type._context), null;
            case 22:
            case 23:
              return ds(), null;
            default:
              return null;
          }
        }
        (Tl = function (e, t) {
          for (var n = t.child; null !== n; ) {
            if (5 === n.tag || 6 === n.tag) e.appendChild(n.stateNode);
            else if (4 !== n.tag && null !== n.child) {
              (n.child.return = n), (n = n.child);
              continue;
            }
            if (n === t) break;
            for (; null === n.sibling; ) {
              if (null === n.return || n.return === t) return;
              n = n.return;
            }
            (n.sibling.return = n.return), (n = n.sibling);
          }
        }),
          (Pl = function () {}),
          (Dl = function (e, t, n, r) {
            var a = e.memoizedProps;
            if (a !== r) {
              (e = t.stateNode), Yo(qo.current);
              var o,
                i = null;
              switch (n) {
                case "input":
                  (a = Y(e, a)), (r = Y(e, r)), (i = []);
                  break;
                case "select":
                  (a = R({}, a, { value: void 0 })),
                    (r = R({}, r, { value: void 0 })),
                    (i = []);
                  break;
                case "textarea":
                  (a = re(e, a)), (r = re(e, r)), (i = []);
                  break;
                default:
                  "function" !== typeof a.onClick &&
                    "function" === typeof r.onClick &&
                    (e.onclick = $r);
              }
              for (u in (be(n, r), (n = null), a))
                if (!r.hasOwnProperty(u) && a.hasOwnProperty(u) && null != a[u])
                  if ("style" === u) {
                    var c = a[u];
                    for (o in c)
                      c.hasOwnProperty(o) && (n || (n = {}), (n[o] = ""));
                  } else
                    "dangerouslySetInnerHTML" !== u &&
                      "children" !== u &&
                      "suppressContentEditableWarning" !== u &&
                      "suppressHydrationWarning" !== u &&
                      "autoFocus" !== u &&
                      (l.hasOwnProperty(u)
                        ? i || (i = [])
                        : (i = i || []).push(u, null));
              for (u in r) {
                var s = r[u];
                if (
                  ((c = null != a ? a[u] : void 0),
                  r.hasOwnProperty(u) && s !== c && (null != s || null != c))
                )
                  if ("style" === u)
                    if (c) {
                      for (o in c)
                        !c.hasOwnProperty(o) ||
                          (s && s.hasOwnProperty(o)) ||
                          (n || (n = {}), (n[o] = ""));
                      for (o in s)
                        s.hasOwnProperty(o) &&
                          c[o] !== s[o] &&
                          (n || (n = {}), (n[o] = s[o]));
                    } else n || (i || (i = []), i.push(u, n)), (n = s);
                  else
                    "dangerouslySetInnerHTML" === u
                      ? ((s = s ? s.__html : void 0),
                        (c = c ? c.__html : void 0),
                        null != s && c !== s && (i = i || []).push(u, s))
                      : "children" === u
                        ? ("string" !== typeof s && "number" !== typeof s) ||
                          (i = i || []).push(u, "" + s)
                        : "suppressContentEditableWarning" !== u &&
                          "suppressHydrationWarning" !== u &&
                          (l.hasOwnProperty(u)
                            ? (null != s && "onScroll" === u && Ur("scroll", e),
                              i || c === s || (i = []))
                            : (i = i || []).push(u, s));
              }
              n && (i = i || []).push("style", n);
              var u = i;
              (t.updateQueue = u) && (t.flags |= 4);
            }
          }),
          (zl = function (e, t, n, r) {
            n !== r && (t.flags |= 4);
          });
        var Yl = !1,
          Jl = !1,
          Kl = "function" === typeof WeakSet ? WeakSet : Set,
          Ql = null;
        function $l(e, t) {
          var n = e.ref;
          if (null !== n)
            if ("function" === typeof n)
              try {
                n(null);
              } catch (r) {
                Cs(e, t, r);
              }
            else n.current = null;
        }
        function ec(e, t, n) {
          try {
            n();
          } catch (r) {
            Cs(e, t, r);
          }
        }
        var tc = !1;
        function nc(e, t, n) {
          var r = t.updateQueue;
          if (null !== (r = null !== r ? r.lastEffect : null)) {
            var a = (r = r.next);
            do {
              if ((a.tag & e) === e) {
                var o = a.destroy;
                (a.destroy = void 0), void 0 !== o && ec(t, n, o);
              }
              a = a.next;
            } while (a !== r);
          }
        }
        function rc(e, t) {
          if (
            null !== (t = null !== (t = t.updateQueue) ? t.lastEffect : null)
          ) {
            var n = (t = t.next);
            do {
              if ((n.tag & e) === e) {
                var r = n.create;
                n.destroy = r();
              }
              n = n.next;
            } while (n !== t);
          }
        }
        function ac(e) {
          var t = e.ref;
          if (null !== t) {
            var n = e.stateNode;
            e.tag, (e = n), "function" === typeof t ? t(e) : (t.current = e);
          }
        }
        function oc(e) {
          var t = e.alternate;
          null !== t && ((e.alternate = null), oc(t)),
            (e.child = null),
            (e.deletions = null),
            (e.sibling = null),
            5 === e.tag &&
              null !== (t = e.stateNode) &&
              (delete t[pa],
              delete t[fa],
              delete t[ha],
              delete t[ga],
              delete t[va]),
            (e.stateNode = null),
            (e.return = null),
            (e.dependencies = null),
            (e.memoizedProps = null),
            (e.memoizedState = null),
            (e.pendingProps = null),
            (e.stateNode = null),
            (e.updateQueue = null);
        }
        function ic(e) {
          return 5 === e.tag || 3 === e.tag || 4 === e.tag;
        }
        function lc(e) {
          e: for (;;) {
            for (; null === e.sibling; ) {
              if (null === e.return || ic(e.return)) return null;
              e = e.return;
            }
            for (
              e.sibling.return = e.return, e = e.sibling;
              5 !== e.tag && 6 !== e.tag && 18 !== e.tag;

            ) {
              if (2 & e.flags) continue e;
              if (null === e.child || 4 === e.tag) continue e;
              (e.child.return = e), (e = e.child);
            }
            if (!(2 & e.flags)) return e.stateNode;
          }
        }
        function cc(e, t, n) {
          var r = e.tag;
          if (5 === r || 6 === r)
            (e = e.stateNode),
              t
                ? 8 === n.nodeType
                  ? n.parentNode.insertBefore(e, t)
                  : n.insertBefore(e, t)
                : (8 === n.nodeType
                    ? (t = n.parentNode).insertBefore(e, n)
                    : (t = n).appendChild(e),
                  (null !== (n = n._reactRootContainer) && void 0 !== n) ||
                    null !== t.onclick ||
                    (t.onclick = $r));
          else if (4 !== r && null !== (e = e.child))
            for (cc(e, t, n), e = e.sibling; null !== e; )
              cc(e, t, n), (e = e.sibling);
        }
        function sc(e, t, n) {
          var r = e.tag;
          if (5 === r || 6 === r)
            (e = e.stateNode), t ? n.insertBefore(e, t) : n.appendChild(e);
          else if (4 !== r && null !== (e = e.child))
            for (sc(e, t, n), e = e.sibling; null !== e; )
              sc(e, t, n), (e = e.sibling);
        }
        var uc = null,
          dc = !1;
        function pc(e, t, n) {
          for (n = n.child; null !== n; ) fc(e, t, n), (n = n.sibling);
        }
        function fc(e, t, n) {
          if (ot && "function" === typeof ot.onCommitFiberUnmount)
            try {
              ot.onCommitFiberUnmount(at, n);
            } catch (l) {}
          switch (n.tag) {
            case 5:
              Jl || $l(n, t);
            case 6:
              var r = uc,
                a = dc;
              (uc = null),
                pc(e, t, n),
                (dc = a),
                null !== (uc = r) &&
                  (dc
                    ? ((e = uc),
                      (n = n.stateNode),
                      8 === e.nodeType
                        ? e.parentNode.removeChild(n)
                        : e.removeChild(n))
                    : uc.removeChild(n.stateNode));
              break;
            case 18:
              null !== uc &&
                (dc
                  ? ((e = uc),
                    (n = n.stateNode),
                    8 === e.nodeType
                      ? ca(e.parentNode, n)
                      : 1 === e.nodeType && ca(e, n),
                    Vt(e))
                  : ca(uc, n.stateNode));
              break;
            case 4:
              (r = uc),
                (a = dc),
                (uc = n.stateNode.containerInfo),
                (dc = !0),
                pc(e, t, n),
                (uc = r),
                (dc = a);
              break;
            case 0:
            case 11:
            case 14:
            case 15:
              if (
                !Jl &&
                null !== (r = n.updateQueue) &&
                null !== (r = r.lastEffect)
              ) {
                a = r = r.next;
                do {
                  var o = a,
                    i = o.destroy;
                  (o = o.tag),
                    void 0 !== i &&
                      (0 !== (2 & o) || 0 !== (4 & o)) &&
                      ec(n, t, i),
                    (a = a.next);
                } while (a !== r);
              }
              pc(e, t, n);
              break;
            case 1:
              if (
                !Jl &&
                ($l(n, t),
                "function" === typeof (r = n.stateNode).componentWillUnmount)
              )
                try {
                  (r.props = n.memoizedProps),
                    (r.state = n.memoizedState),
                    r.componentWillUnmount();
                } catch (l) {
                  Cs(n, t, l);
                }
              pc(e, t, n);
              break;
            case 21:
              pc(e, t, n);
              break;
            case 22:
              1 & n.mode
                ? ((Jl = (r = Jl) || null !== n.memoizedState),
                  pc(e, t, n),
                  (Jl = r))
                : pc(e, t, n);
              break;
            default:
              pc(e, t, n);
          }
        }
        function mc(e) {
          var t = e.updateQueue;
          if (null !== t) {
            e.updateQueue = null;
            var n = e.stateNode;
            null === n && (n = e.stateNode = new Kl()),
              t.forEach(function (t) {
                var r = js.bind(null, e, t);
                n.has(t) || (n.add(t), t.then(r, r));
              });
          }
        }
        function hc(e, t) {
          var n = t.deletions;
          if (null !== n)
            for (var r = 0; r < n.length; r++) {
              var a = n[r];
              try {
                var i = e,
                  l = t,
                  c = l;
                e: for (; null !== c; ) {
                  switch (c.tag) {
                    case 5:
                      (uc = c.stateNode), (dc = !1);
                      break e;
                    case 3:
                    case 4:
                      (uc = c.stateNode.containerInfo), (dc = !0);
                      break e;
                  }
                  c = c.return;
                }
                if (null === uc) throw Error(o(160));
                fc(i, l, a), (uc = null), (dc = !1);
                var s = a.alternate;
                null !== s && (s.return = null), (a.return = null);
              } catch (u) {
                Cs(a, t, u);
              }
            }
          if (12854 & t.subtreeFlags)
            for (t = t.child; null !== t; ) gc(t, e), (t = t.sibling);
        }
        function gc(e, t) {
          var n = e.alternate,
            r = e.flags;
          switch (e.tag) {
            case 0:
            case 11:
            case 14:
            case 15:
              if ((hc(t, e), vc(e), 4 & r)) {
                try {
                  nc(3, e, e.return), rc(3, e);
                } catch (g) {
                  Cs(e, e.return, g);
                }
                try {
                  nc(5, e, e.return);
                } catch (g) {
                  Cs(e, e.return, g);
                }
              }
              break;
            case 1:
              hc(t, e), vc(e), 512 & r && null !== n && $l(n, n.return);
              break;
            case 5:
              if (
                (hc(t, e),
                vc(e),
                512 & r && null !== n && $l(n, n.return),
                32 & e.flags)
              ) {
                var a = e.stateNode;
                try {
                  pe(a, "");
                } catch (g) {
                  Cs(e, e.return, g);
                }
              }
              if (4 & r && null != (a = e.stateNode)) {
                var i = e.memoizedProps,
                  l = null !== n ? n.memoizedProps : i,
                  c = e.type,
                  s = e.updateQueue;
                if (((e.updateQueue = null), null !== s))
                  try {
                    "input" === c &&
                      "radio" === i.type &&
                      null != i.name &&
                      K(a, i),
                      ye(c, l);
                    var u = ye(c, i);
                    for (l = 0; l < s.length; l += 2) {
                      var d = s[l],
                        p = s[l + 1];
                      "style" === d
                        ? ge(a, p)
                        : "dangerouslySetInnerHTML" === d
                          ? de(a, p)
                          : "children" === d
                            ? pe(a, p)
                            : y(a, d, p, u);
                    }
                    switch (c) {
                      case "input":
                        Q(a, i);
                        break;
                      case "textarea":
                        oe(a, i);
                        break;
                      case "select":
                        var f = a._wrapperState.wasMultiple;
                        a._wrapperState.wasMultiple = !!i.multiple;
                        var m = i.value;
                        null != m
                          ? ne(a, !!i.multiple, m, !1)
                          : f !== !!i.multiple &&
                            (null != i.defaultValue
                              ? ne(a, !!i.multiple, i.defaultValue, !0)
                              : ne(a, !!i.multiple, i.multiple ? [] : "", !1));
                    }
                    a[fa] = i;
                  } catch (g) {
                    Cs(e, e.return, g);
                  }
              }
              break;
            case 6:
              if ((hc(t, e), vc(e), 4 & r)) {
                if (null === e.stateNode) throw Error(o(162));
                (a = e.stateNode), (i = e.memoizedProps);
                try {
                  a.nodeValue = i;
                } catch (g) {
                  Cs(e, e.return, g);
                }
              }
              break;
            case 3:
              if (
                (hc(t, e),
                vc(e),
                4 & r && null !== n && n.memoizedState.isDehydrated)
              )
                try {
                  Vt(t.containerInfo);
                } catch (g) {
                  Cs(e, e.return, g);
                }
              break;
            case 4:
            default:
              hc(t, e), vc(e);
              break;
            case 13:
              hc(t, e),
                vc(e),
                8192 & (a = e.child).flags &&
                  ((i = null !== a.memoizedState),
                  (a.stateNode.isHidden = i),
                  !i ||
                    (null !== a.alternate &&
                      null !== a.alternate.memoizedState) ||
                    (Bc = Ke())),
                4 & r && mc(e);
              break;
            case 22:
              if (
                ((d = null !== n && null !== n.memoizedState),
                1 & e.mode
                  ? ((Jl = (u = Jl) || d), hc(t, e), (Jl = u))
                  : hc(t, e),
                vc(e),
                8192 & r)
              ) {
                if (
                  ((u = null !== e.memoizedState),
                  (e.stateNode.isHidden = u) && !d && 0 !== (1 & e.mode))
                )
                  for (Ql = e, d = e.child; null !== d; ) {
                    for (p = Ql = d; null !== Ql; ) {
                      switch (((m = (f = Ql).child), f.tag)) {
                        case 0:
                        case 11:
                        case 14:
                        case 15:
                          nc(4, f, f.return);
                          break;
                        case 1:
                          $l(f, f.return);
                          var h = f.stateNode;
                          if ("function" === typeof h.componentWillUnmount) {
                            (r = f), (n = f.return);
                            try {
                              (t = r),
                                (h.props = t.memoizedProps),
                                (h.state = t.memoizedState),
                                h.componentWillUnmount();
                            } catch (g) {
                              Cs(r, n, g);
                            }
                          }
                          break;
                        case 5:
                          $l(f, f.return);
                          break;
                        case 22:
                          if (null !== f.memoizedState) {
                            wc(p);
                            continue;
                          }
                      }
                      null !== m ? ((m.return = f), (Ql = m)) : wc(p);
                    }
                    d = d.sibling;
                  }
                e: for (d = null, p = e; ; ) {
                  if (5 === p.tag) {
                    if (null === d) {
                      d = p;
                      try {
                        (a = p.stateNode),
                          u
                            ? "function" === typeof (i = a.style).setProperty
                              ? i.setProperty("display", "none", "important")
                              : (i.display = "none")
                            : ((c = p.stateNode),
                              (l =
                                void 0 !== (s = p.memoizedProps.style) &&
                                null !== s &&
                                s.hasOwnProperty("display")
                                  ? s.display
                                  : null),
                              (c.style.display = he("display", l)));
                      } catch (g) {
                        Cs(e, e.return, g);
                      }
                    }
                  } else if (6 === p.tag) {
                    if (null === d)
                      try {
                        p.stateNode.nodeValue = u ? "" : p.memoizedProps;
                      } catch (g) {
                        Cs(e, e.return, g);
                      }
                  } else if (
                    ((22 !== p.tag && 23 !== p.tag) ||
                      null === p.memoizedState ||
                      p === e) &&
                    null !== p.child
                  ) {
                    (p.child.return = p), (p = p.child);
                    continue;
                  }
                  if (p === e) break e;
                  for (; null === p.sibling; ) {
                    if (null === p.return || p.return === e) break e;
                    d === p && (d = null), (p = p.return);
                  }
                  d === p && (d = null),
                    (p.sibling.return = p.return),
                    (p = p.sibling);
                }
              }
              break;
            case 19:
              hc(t, e), vc(e), 4 & r && mc(e);
            case 21:
          }
        }
        function vc(e) {
          var t = e.flags;
          if (2 & t) {
            try {
              e: {
                for (var n = e.return; null !== n; ) {
                  if (ic(n)) {
                    var r = n;
                    break e;
                  }
                  n = n.return;
                }
                throw Error(o(160));
              }
              switch (r.tag) {
                case 5:
                  var a = r.stateNode;
                  32 & r.flags && (pe(a, ""), (r.flags &= -33)),
                    sc(e, lc(e), a);
                  break;
                case 3:
                case 4:
                  var i = r.stateNode.containerInfo;
                  cc(e, lc(e), i);
                  break;
                default:
                  throw Error(o(161));
              }
            } catch (l) {
              Cs(e, e.return, l);
            }
            e.flags &= -3;
          }
          4096 & t && (e.flags &= -4097);
        }
        function bc(e, t, n) {
          (Ql = e), yc(e, t, n);
        }
        function yc(e, t, n) {
          for (var r = 0 !== (1 & e.mode); null !== Ql; ) {
            var a = Ql,
              o = a.child;
            if (22 === a.tag && r) {
              var i = null !== a.memoizedState || Yl;
              if (!i) {
                var l = a.alternate,
                  c = (null !== l && null !== l.memoizedState) || Jl;
                l = Yl;
                var s = Jl;
                if (((Yl = i), (Jl = c) && !s))
                  for (Ql = a; null !== Ql; )
                    (c = (i = Ql).child),
                      22 === i.tag && null !== i.memoizedState
                        ? kc(a)
                        : null !== c
                          ? ((c.return = i), (Ql = c))
                          : kc(a);
                for (; null !== o; ) (Ql = o), yc(o, t, n), (o = o.sibling);
                (Ql = a), (Yl = l), (Jl = s);
              }
              xc(e);
            } else
              0 !== (8772 & a.subtreeFlags) && null !== o
                ? ((o.return = a), (Ql = o))
                : xc(e);
          }
        }
        function xc(e) {
          for (; null !== Ql; ) {
            var t = Ql;
            if (0 !== (8772 & t.flags)) {
              var n = t.alternate;
              try {
                if (0 !== (8772 & t.flags))
                  switch (t.tag) {
                    case 0:
                    case 11:
                    case 15:
                      Jl || rc(5, t);
                      break;
                    case 1:
                      var r = t.stateNode;
                      if (4 & t.flags && !Jl)
                        if (null === n) r.componentDidMount();
                        else {
                          var a =
                            t.elementType === t.type
                              ? n.memoizedProps
                              : nl(t.type, n.memoizedProps);
                          r.componentDidUpdate(
                            a,
                            n.memoizedState,
                            r.__reactInternalSnapshotBeforeUpdate,
                          );
                        }
                      var i = t.updateQueue;
                      null !== i && Zo(t, i, r);
                      break;
                    case 3:
                      var l = t.updateQueue;
                      if (null !== l) {
                        if (((n = null), null !== t.child))
                          switch (t.child.tag) {
                            case 5:
                            case 1:
                              n = t.child.stateNode;
                          }
                        Zo(t, l, n);
                      }
                      break;
                    case 5:
                      var c = t.stateNode;
                      if (null === n && 4 & t.flags) {
                        n = c;
                        var s = t.memoizedProps;
                        switch (t.type) {
                          case "button":
                          case "input":
                          case "select":
                          case "textarea":
                            s.autoFocus && n.focus();
                            break;
                          case "img":
                            s.src && (n.src = s.src);
                        }
                      }
                      break;
                    case 6:
                    case 4:
                    case 12:
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                      break;
                    case 13:
                      if (null === t.memoizedState) {
                        var u = t.alternate;
                        if (null !== u) {
                          var d = u.memoizedState;
                          if (null !== d) {
                            var p = d.dehydrated;
                            null !== p && Vt(p);
                          }
                        }
                      }
                      break;
                    default:
                      throw Error(o(163));
                  }
                Jl || (512 & t.flags && ac(t));
              } catch (f) {
                Cs(t, t.return, f);
              }
            }
            if (t === e) {
              Ql = null;
              break;
            }
            if (null !== (n = t.sibling)) {
              (n.return = t.return), (Ql = n);
              break;
            }
            Ql = t.return;
          }
        }
        function wc(e) {
          for (; null !== Ql; ) {
            var t = Ql;
            if (t === e) {
              Ql = null;
              break;
            }
            var n = t.sibling;
            if (null !== n) {
              (n.return = t.return), (Ql = n);
              break;
            }
            Ql = t.return;
          }
        }
        function kc(e) {
          for (; null !== Ql; ) {
            var t = Ql;
            try {
              switch (t.tag) {
                case 0:
                case 11:
                case 15:
                  var n = t.return;
                  try {
                    rc(4, t);
                  } catch (c) {
                    Cs(t, n, c);
                  }
                  break;
                case 1:
                  var r = t.stateNode;
                  if ("function" === typeof r.componentDidMount) {
                    var a = t.return;
                    try {
                      r.componentDidMount();
                    } catch (c) {
                      Cs(t, a, c);
                    }
                  }
                  var o = t.return;
                  try {
                    ac(t);
                  } catch (c) {
                    Cs(t, o, c);
                  }
                  break;
                case 5:
                  var i = t.return;
                  try {
                    ac(t);
                  } catch (c) {
                    Cs(t, i, c);
                  }
              }
            } catch (c) {
              Cs(t, t.return, c);
            }
            if (t === e) {
              Ql = null;
              break;
            }
            var l = t.sibling;
            if (null !== l) {
              (l.return = t.return), (Ql = l);
              break;
            }
            Ql = t.return;
          }
        }
        var Sc,
          Cc = Math.ceil,
          Ec = x.ReactCurrentDispatcher,
          Oc = x.ReactCurrentOwner,
          Ac = x.ReactCurrentBatchConfig,
          jc = 0,
          Lc = null,
          Nc = null,
          Tc = 0,
          Pc = 0,
          Dc = Ca(0),
          zc = 0,
          Mc = null,
          Ic = 0,
          Rc = 0,
          Fc = 0,
          Uc = null,
          Hc = null,
          Bc = 0,
          Vc = 1 / 0,
          Wc = null,
          Zc = !1,
          Gc = null,
          qc = null,
          Xc = !1,
          _c = null,
          Yc = 0,
          Jc = 0,
          Kc = null,
          Qc = -1,
          $c = 0;
        function es() {
          return 0 !== (6 & jc) ? Ke() : -1 !== Qc ? Qc : (Qc = Ke());
        }
        function ts(e) {
          return 0 === (1 & e.mode)
            ? 1
            : 0 !== (2 & jc) && 0 !== Tc
              ? Tc & -Tc
              : null !== go.transition
                ? (0 === $c && ($c = ht()), $c)
                : 0 !== (e = yt)
                  ? e
                  : (e = void 0 === (e = window.event) ? 16 : Jt(e.type));
        }
        function ns(e, t, n, r) {
          if (50 < Jc) throw ((Jc = 0), (Kc = null), Error(o(185)));
          vt(e, n, r),
            (0 !== (2 & jc) && e === Lc) ||
              (e === Lc && (0 === (2 & jc) && (Rc |= n), 4 === zc && ls(e, Tc)),
              rs(e, r),
              1 === n &&
                0 === jc &&
                0 === (1 & t.mode) &&
                ((Vc = Ke() + 500), Ua && Va()));
        }
        function rs(e, t) {
          var n = e.callbackNode;
          !(function (e, t) {
            for (
              var n = e.suspendedLanes,
                r = e.pingedLanes,
                a = e.expirationTimes,
                o = e.pendingLanes;
              0 < o;

            ) {
              var i = 31 - it(o),
                l = 1 << i,
                c = a[i];
              -1 === c
                ? (0 !== (l & n) && 0 === (l & r)) || (a[i] = ft(l, t))
                : c <= t && (e.expiredLanes |= l),
                (o &= ~l);
            }
          })(e, t);
          var r = pt(e, e === Lc ? Tc : 0);
          if (0 === r)
            null !== n && _e(n),
              (e.callbackNode = null),
              (e.callbackPriority = 0);
          else if (((t = r & -r), e.callbackPriority !== t)) {
            if ((null != n && _e(n), 1 === t))
              0 === e.tag
                ? (function (e) {
                    (Ua = !0), Ba(e);
                  })(cs.bind(null, e))
                : Ba(cs.bind(null, e)),
                ia(function () {
                  0 === (6 & jc) && Va();
                }),
                (n = null);
            else {
              switch (xt(r)) {
                case 1:
                  n = $e;
                  break;
                case 4:
                  n = et;
                  break;
                case 16:
                default:
                  n = tt;
                  break;
                case 536870912:
                  n = rt;
              }
              n = Ls(n, as.bind(null, e));
            }
            (e.callbackPriority = t), (e.callbackNode = n);
          }
        }
        function as(e, t) {
          if (((Qc = -1), ($c = 0), 0 !== (6 & jc))) throw Error(o(327));
          var n = e.callbackNode;
          if (ks() && e.callbackNode !== n) return null;
          var r = pt(e, e === Lc ? Tc : 0);
          if (0 === r) return null;
          if (0 !== (30 & r) || 0 !== (r & e.expiredLanes) || t) t = gs(e, r);
          else {
            t = r;
            var a = jc;
            jc |= 2;
            var i = ms();
            for (
              (Lc === e && Tc === t) ||
              ((Wc = null), (Vc = Ke() + 500), ps(e, t));
              ;

            )
              try {
                bs();
                break;
              } catch (c) {
                fs(e, c);
              }
            Ao(),
              (Ec.current = i),
              (jc = a),
              null !== Nc ? (t = 0) : ((Lc = null), (Tc = 0), (t = zc));
          }
          if (0 !== t) {
            if (
              (2 === t && 0 !== (a = mt(e)) && ((r = a), (t = os(e, a))),
              1 === t)
            )
              throw ((n = Mc), ps(e, 0), ls(e, r), rs(e, Ke()), n);
            if (6 === t) ls(e, r);
            else {
              if (
                ((a = e.current.alternate),
                0 === (30 & r) &&
                  !(function (e) {
                    for (var t = e; ; ) {
                      if (16384 & t.flags) {
                        var n = t.updateQueue;
                        if (null !== n && null !== (n = n.stores))
                          for (var r = 0; r < n.length; r++) {
                            var a = n[r],
                              o = a.getSnapshot;
                            a = a.value;
                            try {
                              if (!lr(o(), a)) return !1;
                            } catch (l) {
                              return !1;
                            }
                          }
                      }
                      if (((n = t.child), 16384 & t.subtreeFlags && null !== n))
                        (n.return = t), (t = n);
                      else {
                        if (t === e) break;
                        for (; null === t.sibling; ) {
                          if (null === t.return || t.return === e) return !0;
                          t = t.return;
                        }
                        (t.sibling.return = t.return), (t = t.sibling);
                      }
                    }
                    return !0;
                  })(a) &&
                  (2 === (t = gs(e, r)) &&
                    0 !== (i = mt(e)) &&
                    ((r = i), (t = os(e, i))),
                  1 === t))
              )
                throw ((n = Mc), ps(e, 0), ls(e, r), rs(e, Ke()), n);
              switch (((e.finishedWork = a), (e.finishedLanes = r), t)) {
                case 0:
                case 1:
                  throw Error(o(345));
                case 2:
                case 5:
                  ws(e, Hc, Wc);
                  break;
                case 3:
                  if (
                    (ls(e, r),
                    (130023424 & r) === r && 10 < (t = Bc + 500 - Ke()))
                  ) {
                    if (0 !== pt(e, 0)) break;
                    if (((a = e.suspendedLanes) & r) !== r) {
                      es(), (e.pingedLanes |= e.suspendedLanes & a);
                      break;
                    }
                    e.timeoutHandle = ra(ws.bind(null, e, Hc, Wc), t);
                    break;
                  }
                  ws(e, Hc, Wc);
                  break;
                case 4:
                  if ((ls(e, r), (4194240 & r) === r)) break;
                  for (t = e.eventTimes, a = -1; 0 < r; ) {
                    var l = 31 - it(r);
                    (i = 1 << l), (l = t[l]) > a && (a = l), (r &= ~i);
                  }
                  if (
                    ((r = a),
                    10 <
                      (r =
                        (120 > (r = Ke() - r)
                          ? 120
                          : 480 > r
                            ? 480
                            : 1080 > r
                              ? 1080
                              : 1920 > r
                                ? 1920
                                : 3e3 > r
                                  ? 3e3
                                  : 4320 > r
                                    ? 4320
                                    : 1960 * Cc(r / 1960)) - r))
                  ) {
                    e.timeoutHandle = ra(ws.bind(null, e, Hc, Wc), r);
                    break;
                  }
                  ws(e, Hc, Wc);
                  break;
                default:
                  throw Error(o(329));
              }
            }
          }
          return rs(e, Ke()), e.callbackNode === n ? as.bind(null, e) : null;
        }
        function os(e, t) {
          var n = Uc;
          return (
            e.current.memoizedState.isDehydrated && (ps(e, t).flags |= 256),
            2 !== (e = gs(e, t)) && ((t = Hc), (Hc = n), null !== t && is(t)),
            e
          );
        }
        function is(e) {
          null === Hc ? (Hc = e) : Hc.push.apply(Hc, e);
        }
        function ls(e, t) {
          for (
            t &= ~Fc,
              t &= ~Rc,
              e.suspendedLanes |= t,
              e.pingedLanes &= ~t,
              e = e.expirationTimes;
            0 < t;

          ) {
            var n = 31 - it(t),
              r = 1 << n;
            (e[n] = -1), (t &= ~r);
          }
        }
        function cs(e) {
          if (0 !== (6 & jc)) throw Error(o(327));
          ks();
          var t = pt(e, 0);
          if (0 === (1 & t)) return rs(e, Ke()), null;
          var n = gs(e, t);
          if (0 !== e.tag && 2 === n) {
            var r = mt(e);
            0 !== r && ((t = r), (n = os(e, r)));
          }
          if (1 === n) throw ((n = Mc), ps(e, 0), ls(e, t), rs(e, Ke()), n);
          if (6 === n) throw Error(o(345));
          return (
            (e.finishedWork = e.current.alternate),
            (e.finishedLanes = t),
            ws(e, Hc, Wc),
            rs(e, Ke()),
            null
          );
        }
        function ss(e, t) {
          var n = jc;
          jc |= 1;
          try {
            return e(t);
          } finally {
            0 === (jc = n) && ((Vc = Ke() + 500), Ua && Va());
          }
        }
        function us(e) {
          null !== _c && 0 === _c.tag && 0 === (6 & jc) && ks();
          var t = jc;
          jc |= 1;
          var n = Ac.transition,
            r = yt;
          try {
            if (((Ac.transition = null), (yt = 1), e)) return e();
          } finally {
            (yt = r), (Ac.transition = n), 0 === (6 & (jc = t)) && Va();
          }
        }
        function ds() {
          (Pc = Dc.current), Ea(Dc);
        }
        function ps(e, t) {
          (e.finishedWork = null), (e.finishedLanes = 0);
          var n = e.timeoutHandle;
          if ((-1 !== n && ((e.timeoutHandle = -1), aa(n)), null !== Nc))
            for (n = Nc.return; null !== n; ) {
              var r = n;
              switch ((to(r), r.tag)) {
                case 1:
                  null !== (r = r.type.childContextTypes) &&
                    void 0 !== r &&
                    Da();
                  break;
                case 3:
                  Ko(), Ea(La), Ea(ja), ri();
                  break;
                case 5:
                  $o(r);
                  break;
                case 4:
                  Ko();
                  break;
                case 13:
                case 19:
                  Ea(ei);
                  break;
                case 10:
                  jo(r.type._context);
                  break;
                case 22:
                case 23:
                  ds();
              }
              n = n.return;
            }
          if (
            ((Lc = e),
            (Nc = e = Ds(e.current, null)),
            (Tc = Pc = t),
            (zc = 0),
            (Mc = null),
            (Fc = Rc = Ic = 0),
            (Hc = Uc = null),
            null !== Po)
          ) {
            for (t = 0; t < Po.length; t++)
              if (null !== (r = (n = Po[t]).interleaved)) {
                n.interleaved = null;
                var a = r.next,
                  o = n.pending;
                if (null !== o) {
                  var i = o.next;
                  (o.next = a), (r.next = i);
                }
                n.pending = r;
              }
            Po = null;
          }
          return e;
        }
        function fs(e, t) {
          for (;;) {
            var n = Nc;
            try {
              if ((Ao(), (ai.current = Qi), ui)) {
                for (var r = li.memoizedState; null !== r; ) {
                  var a = r.queue;
                  null !== a && (a.pending = null), (r = r.next);
                }
                ui = !1;
              }
              if (
                ((ii = 0),
                (si = ci = li = null),
                (di = !1),
                (pi = 0),
                (Oc.current = null),
                null === n || null === n.return)
              ) {
                (zc = 1), (Mc = t), (Nc = null);
                break;
              }
              e: {
                var i = e,
                  l = n.return,
                  c = n,
                  s = t;
                if (
                  ((t = Tc),
                  (c.flags |= 32768),
                  null !== s &&
                    "object" === typeof s &&
                    "function" === typeof s.then)
                ) {
                  var u = s,
                    d = c,
                    p = d.tag;
                  if (0 === (1 & d.mode) && (0 === p || 11 === p || 15 === p)) {
                    var f = d.alternate;
                    f
                      ? ((d.updateQueue = f.updateQueue),
                        (d.memoizedState = f.memoizedState),
                        (d.lanes = f.lanes))
                      : ((d.updateQueue = null), (d.memoizedState = null));
                  }
                  var m = gl(l);
                  if (null !== m) {
                    (m.flags &= -257),
                      vl(m, l, c, 0, t),
                      1 & m.mode && hl(i, u, t),
                      (s = u);
                    var h = (t = m).updateQueue;
                    if (null === h) {
                      var g = new Set();
                      g.add(s), (t.updateQueue = g);
                    } else h.add(s);
                    break e;
                  }
                  if (0 === (1 & t)) {
                    hl(i, u, t), hs();
                    break e;
                  }
                  s = Error(o(426));
                } else if (ao && 1 & c.mode) {
                  var v = gl(l);
                  if (null !== v) {
                    0 === (65536 & v.flags) && (v.flags |= 256),
                      vl(v, l, c, 0, t),
                      ho(sl(s, c));
                    break e;
                  }
                }
                (i = s = sl(s, c)),
                  4 !== zc && (zc = 2),
                  null === Uc ? (Uc = [i]) : Uc.push(i),
                  (i = l);
                do {
                  switch (i.tag) {
                    case 3:
                      (i.flags |= 65536),
                        (t &= -t),
                        (i.lanes |= t),
                        Vo(i, fl(0, s, t));
                      break e;
                    case 1:
                      c = s;
                      var b = i.type,
                        y = i.stateNode;
                      if (
                        0 === (128 & i.flags) &&
                        ("function" === typeof b.getDerivedStateFromError ||
                          (null !== y &&
                            "function" === typeof y.componentDidCatch &&
                            (null === qc || !qc.has(y))))
                      ) {
                        (i.flags |= 65536),
                          (t &= -t),
                          (i.lanes |= t),
                          Vo(i, ml(i, c, t));
                        break e;
                      }
                  }
                  i = i.return;
                } while (null !== i);
              }
              xs(n);
            } catch (x) {
              (t = x), Nc === n && null !== n && (Nc = n = n.return);
              continue;
            }
            break;
          }
        }
        function ms() {
          var e = Ec.current;
          return (Ec.current = Qi), null === e ? Qi : e;
        }
        function hs() {
          (0 !== zc && 3 !== zc && 2 !== zc) || (zc = 4),
            null === Lc ||
              (0 === (268435455 & Ic) && 0 === (268435455 & Rc)) ||
              ls(Lc, Tc);
        }
        function gs(e, t) {
          var n = jc;
          jc |= 2;
          var r = ms();
          for ((Lc === e && Tc === t) || ((Wc = null), ps(e, t)); ; )
            try {
              vs();
              break;
            } catch (a) {
              fs(e, a);
            }
          if ((Ao(), (jc = n), (Ec.current = r), null !== Nc))
            throw Error(o(261));
          return (Lc = null), (Tc = 0), zc;
        }
        function vs() {
          for (; null !== Nc; ) ys(Nc);
        }
        function bs() {
          for (; null !== Nc && !Ye(); ) ys(Nc);
        }
        function ys(e) {
          var t = Sc(e.alternate, e, Pc);
          (e.memoizedProps = e.pendingProps),
            null === t ? xs(e) : (Nc = t),
            (Oc.current = null);
        }
        function xs(e) {
          var t = e;
          do {
            var n = t.alternate;
            if (((e = t.return), 0 === (32768 & t.flags))) {
              if (null !== (n = Xl(n, t, Pc))) return void (Nc = n);
            } else {
              if (null !== (n = _l(n, t)))
                return (n.flags &= 32767), void (Nc = n);
              if (null === e) return (zc = 6), void (Nc = null);
              (e.flags |= 32768), (e.subtreeFlags = 0), (e.deletions = null);
            }
            if (null !== (t = t.sibling)) return void (Nc = t);
            Nc = t = e;
          } while (null !== t);
          0 === zc && (zc = 5);
        }
        function ws(e, t, n) {
          var r = yt,
            a = Ac.transition;
          try {
            (Ac.transition = null),
              (yt = 1),
              (function (e, t, n, r) {
                do {
                  ks();
                } while (null !== _c);
                if (0 !== (6 & jc)) throw Error(o(327));
                n = e.finishedWork;
                var a = e.finishedLanes;
                if (null === n) return null;
                if (
                  ((e.finishedWork = null),
                  (e.finishedLanes = 0),
                  n === e.current)
                )
                  throw Error(o(177));
                (e.callbackNode = null), (e.callbackPriority = 0);
                var i = n.lanes | n.childLanes;
                if (
                  ((function (e, t) {
                    var n = e.pendingLanes & ~t;
                    (e.pendingLanes = t),
                      (e.suspendedLanes = 0),
                      (e.pingedLanes = 0),
                      (e.expiredLanes &= t),
                      (e.mutableReadLanes &= t),
                      (e.entangledLanes &= t),
                      (t = e.entanglements);
                    var r = e.eventTimes;
                    for (e = e.expirationTimes; 0 < n; ) {
                      var a = 31 - it(n),
                        o = 1 << a;
                      (t[a] = 0), (r[a] = -1), (e[a] = -1), (n &= ~o);
                    }
                  })(e, i),
                  e === Lc && ((Nc = Lc = null), (Tc = 0)),
                  (0 === (2064 & n.subtreeFlags) && 0 === (2064 & n.flags)) ||
                    Xc ||
                    ((Xc = !0),
                    Ls(tt, function () {
                      return ks(), null;
                    })),
                  (i = 0 !== (15990 & n.flags)),
                  0 !== (15990 & n.subtreeFlags) || i)
                ) {
                  (i = Ac.transition), (Ac.transition = null);
                  var l = yt;
                  yt = 1;
                  var c = jc;
                  (jc |= 4),
                    (Oc.current = null),
                    (function (e, t) {
                      if (((ea = Zt), fr((e = pr())))) {
                        if ("selectionStart" in e)
                          var n = {
                            start: e.selectionStart,
                            end: e.selectionEnd,
                          };
                        else
                          e: {
                            var r =
                              (n =
                                ((n = e.ownerDocument) && n.defaultView) ||
                                window).getSelection && n.getSelection();
                            if (r && 0 !== r.rangeCount) {
                              n = r.anchorNode;
                              var a = r.anchorOffset,
                                i = r.focusNode;
                              r = r.focusOffset;
                              try {
                                n.nodeType, i.nodeType;
                              } catch (w) {
                                n = null;
                                break e;
                              }
                              var l = 0,
                                c = -1,
                                s = -1,
                                u = 0,
                                d = 0,
                                p = e,
                                f = null;
                              t: for (;;) {
                                for (
                                  var m;
                                  p !== n ||
                                    (0 !== a && 3 !== p.nodeType) ||
                                    (c = l + a),
                                    p !== i ||
                                      (0 !== r && 3 !== p.nodeType) ||
                                      (s = l + r),
                                    3 === p.nodeType &&
                                      (l += p.nodeValue.length),
                                    null !== (m = p.firstChild);

                                )
                                  (f = p), (p = m);
                                for (;;) {
                                  if (p === e) break t;
                                  if (
                                    (f === n && ++u === a && (c = l),
                                    f === i && ++d === r && (s = l),
                                    null !== (m = p.nextSibling))
                                  )
                                    break;
                                  f = (p = f).parentNode;
                                }
                                p = m;
                              }
                              n =
                                -1 === c || -1 === s
                                  ? null
                                  : { start: c, end: s };
                            } else n = null;
                          }
                        n = n || { start: 0, end: 0 };
                      } else n = null;
                      for (
                        ta = { focusedElem: e, selectionRange: n },
                          Zt = !1,
                          Ql = t;
                        null !== Ql;

                      )
                        if (
                          ((e = (t = Ql).child),
                          0 !== (1028 & t.subtreeFlags) && null !== e)
                        )
                          (e.return = t), (Ql = e);
                        else
                          for (; null !== Ql; ) {
                            t = Ql;
                            try {
                              var h = t.alternate;
                              if (0 !== (1024 & t.flags))
                                switch (t.tag) {
                                  case 0:
                                  case 11:
                                  case 15:
                                  case 5:
                                  case 6:
                                  case 4:
                                  case 17:
                                    break;
                                  case 1:
                                    if (null !== h) {
                                      var g = h.memoizedProps,
                                        v = h.memoizedState,
                                        b = t.stateNode,
                                        y = b.getSnapshotBeforeUpdate(
                                          t.elementType === t.type
                                            ? g
                                            : nl(t.type, g),
                                          v,
                                        );
                                      b.__reactInternalSnapshotBeforeUpdate = y;
                                    }
                                    break;
                                  case 3:
                                    var x = t.stateNode.containerInfo;
                                    1 === x.nodeType
                                      ? (x.textContent = "")
                                      : 9 === x.nodeType &&
                                        x.documentElement &&
                                        x.removeChild(x.documentElement);
                                    break;
                                  default:
                                    throw Error(o(163));
                                }
                            } catch (w) {
                              Cs(t, t.return, w);
                            }
                            if (null !== (e = t.sibling)) {
                              (e.return = t.return), (Ql = e);
                              break;
                            }
                            Ql = t.return;
                          }
                      (h = tc), (tc = !1);
                    })(e, n),
                    gc(n, e),
                    mr(ta),
                    (Zt = !!ea),
                    (ta = ea = null),
                    (e.current = n),
                    bc(n, e, a),
                    Je(),
                    (jc = c),
                    (yt = l),
                    (Ac.transition = i);
                } else e.current = n;
                if (
                  (Xc && ((Xc = !1), (_c = e), (Yc = a)),
                  (i = e.pendingLanes),
                  0 === i && (qc = null),
                  (function (e) {
                    if (ot && "function" === typeof ot.onCommitFiberRoot)
                      try {
                        ot.onCommitFiberRoot(
                          at,
                          e,
                          void 0,
                          128 === (128 & e.current.flags),
                        );
                      } catch (t) {}
                  })(n.stateNode),
                  rs(e, Ke()),
                  null !== t)
                )
                  for (r = e.onRecoverableError, n = 0; n < t.length; n++)
                    (a = t[n]),
                      r(a.value, { componentStack: a.stack, digest: a.digest });
                if (Zc) throw ((Zc = !1), (e = Gc), (Gc = null), e);
                0 !== (1 & Yc) && 0 !== e.tag && ks(),
                  (i = e.pendingLanes),
                  0 !== (1 & i)
                    ? e === Kc
                      ? Jc++
                      : ((Jc = 0), (Kc = e))
                    : (Jc = 0),
                  Va();
              })(e, t, n, r);
          } finally {
            (Ac.transition = a), (yt = r);
          }
          return null;
        }
        function ks() {
          if (null !== _c) {
            var e = xt(Yc),
              t = Ac.transition,
              n = yt;
            try {
              if (((Ac.transition = null), (yt = 16 > e ? 16 : e), null === _c))
                var r = !1;
              else {
                if (((e = _c), (_c = null), (Yc = 0), 0 !== (6 & jc)))
                  throw Error(o(331));
                var a = jc;
                for (jc |= 4, Ql = e.current; null !== Ql; ) {
                  var i = Ql,
                    l = i.child;
                  if (0 !== (16 & Ql.flags)) {
                    var c = i.deletions;
                    if (null !== c) {
                      for (var s = 0; s < c.length; s++) {
                        var u = c[s];
                        for (Ql = u; null !== Ql; ) {
                          var d = Ql;
                          switch (d.tag) {
                            case 0:
                            case 11:
                            case 15:
                              nc(8, d, i);
                          }
                          var p = d.child;
                          if (null !== p) (p.return = d), (Ql = p);
                          else
                            for (; null !== Ql; ) {
                              var f = (d = Ql).sibling,
                                m = d.return;
                              if ((oc(d), d === u)) {
                                Ql = null;
                                break;
                              }
                              if (null !== f) {
                                (f.return = m), (Ql = f);
                                break;
                              }
                              Ql = m;
                            }
                        }
                      }
                      var h = i.alternate;
                      if (null !== h) {
                        var g = h.child;
                        if (null !== g) {
                          h.child = null;
                          do {
                            var v = g.sibling;
                            (g.sibling = null), (g = v);
                          } while (null !== g);
                        }
                      }
                      Ql = i;
                    }
                  }
                  if (0 !== (2064 & i.subtreeFlags) && null !== l)
                    (l.return = i), (Ql = l);
                  else
                    e: for (; null !== Ql; ) {
                      if (0 !== (2048 & (i = Ql).flags))
                        switch (i.tag) {
                          case 0:
                          case 11:
                          case 15:
                            nc(9, i, i.return);
                        }
                      var b = i.sibling;
                      if (null !== b) {
                        (b.return = i.return), (Ql = b);
                        break e;
                      }
                      Ql = i.return;
                    }
                }
                var y = e.current;
                for (Ql = y; null !== Ql; ) {
                  var x = (l = Ql).child;
                  if (0 !== (2064 & l.subtreeFlags) && null !== x)
                    (x.return = l), (Ql = x);
                  else
                    e: for (l = y; null !== Ql; ) {
                      if (0 !== (2048 & (c = Ql).flags))
                        try {
                          switch (c.tag) {
                            case 0:
                            case 11:
                            case 15:
                              rc(9, c);
                          }
                        } catch (k) {
                          Cs(c, c.return, k);
                        }
                      if (c === l) {
                        Ql = null;
                        break e;
                      }
                      var w = c.sibling;
                      if (null !== w) {
                        (w.return = c.return), (Ql = w);
                        break e;
                      }
                      Ql = c.return;
                    }
                }
                if (
                  ((jc = a),
                  Va(),
                  ot && "function" === typeof ot.onPostCommitFiberRoot)
                )
                  try {
                    ot.onPostCommitFiberRoot(at, e);
                  } catch (k) {}
                r = !0;
              }
              return r;
            } finally {
              (yt = n), (Ac.transition = t);
            }
          }
          return !1;
        }
        function Ss(e, t, n) {
          (e = Ho(e, (t = fl(0, (t = sl(n, t)), 1)), 1)),
            (t = es()),
            null !== e && (vt(e, 1, t), rs(e, t));
        }
        function Cs(e, t, n) {
          if (3 === e.tag) Ss(e, e, n);
          else
            for (; null !== t; ) {
              if (3 === t.tag) {
                Ss(t, e, n);
                break;
              }
              if (1 === t.tag) {
                var r = t.stateNode;
                if (
                  "function" === typeof t.type.getDerivedStateFromError ||
                  ("function" === typeof r.componentDidCatch &&
                    (null === qc || !qc.has(r)))
                ) {
                  (t = Ho(t, (e = ml(t, (e = sl(n, e)), 1)), 1)),
                    (e = es()),
                    null !== t && (vt(t, 1, e), rs(t, e));
                  break;
                }
              }
              t = t.return;
            }
        }
        function Es(e, t, n) {
          var r = e.pingCache;
          null !== r && r.delete(t),
            (t = es()),
            (e.pingedLanes |= e.suspendedLanes & n),
            Lc === e &&
              (Tc & n) === n &&
              (4 === zc ||
              (3 === zc && (130023424 & Tc) === Tc && 500 > Ke() - Bc)
                ? ps(e, 0)
                : (Fc |= n)),
            rs(e, t);
        }
        function Os(e, t) {
          0 === t &&
            (0 === (1 & e.mode)
              ? (t = 1)
              : ((t = ut), 0 === (130023424 & (ut <<= 1)) && (ut = 4194304)));
          var n = es();
          null !== (e = Mo(e, t)) && (vt(e, t, n), rs(e, n));
        }
        function As(e) {
          var t = e.memoizedState,
            n = 0;
          null !== t && (n = t.retryLane), Os(e, n);
        }
        function js(e, t) {
          var n = 0;
          switch (e.tag) {
            case 13:
              var r = e.stateNode,
                a = e.memoizedState;
              null !== a && (n = a.retryLane);
              break;
            case 19:
              r = e.stateNode;
              break;
            default:
              throw Error(o(314));
          }
          null !== r && r.delete(t), Os(e, n);
        }
        function Ls(e, t) {
          return Xe(e, t);
        }
        function Ns(e, t, n, r) {
          (this.tag = e),
            (this.key = n),
            (this.sibling =
              this.child =
              this.return =
              this.stateNode =
              this.type =
              this.elementType =
                null),
            (this.index = 0),
            (this.ref = null),
            (this.pendingProps = t),
            (this.dependencies =
              this.memoizedState =
              this.updateQueue =
              this.memoizedProps =
                null),
            (this.mode = r),
            (this.subtreeFlags = this.flags = 0),
            (this.deletions = null),
            (this.childLanes = this.lanes = 0),
            (this.alternate = null);
        }
        function Ts(e, t, n, r) {
          return new Ns(e, t, n, r);
        }
        function Ps(e) {
          return !(!(e = e.prototype) || !e.isReactComponent);
        }
        function Ds(e, t) {
          var n = e.alternate;
          return (
            null === n
              ? (((n = Ts(e.tag, t, e.key, e.mode)).elementType =
                  e.elementType),
                (n.type = e.type),
                (n.stateNode = e.stateNode),
                (n.alternate = e),
                (e.alternate = n))
              : ((n.pendingProps = t),
                (n.type = e.type),
                (n.flags = 0),
                (n.subtreeFlags = 0),
                (n.deletions = null)),
            (n.flags = 14680064 & e.flags),
            (n.childLanes = e.childLanes),
            (n.lanes = e.lanes),
            (n.child = e.child),
            (n.memoizedProps = e.memoizedProps),
            (n.memoizedState = e.memoizedState),
            (n.updateQueue = e.updateQueue),
            (t = e.dependencies),
            (n.dependencies =
              null === t
                ? null
                : { lanes: t.lanes, firstContext: t.firstContext }),
            (n.sibling = e.sibling),
            (n.index = e.index),
            (n.ref = e.ref),
            n
          );
        }
        function zs(e, t, n, r, a, i) {
          var l = 2;
          if (((r = e), "function" === typeof e)) Ps(e) && (l = 1);
          else if ("string" === typeof e) l = 5;
          else
            e: switch (e) {
              case S:
                return Ms(n.children, a, i, t);
              case C:
                (l = 8), (a |= 8);
                break;
              case E:
                return (
                  ((e = Ts(12, n, t, 2 | a)).elementType = E), (e.lanes = i), e
                );
              case L:
                return (
                  ((e = Ts(13, n, t, a)).elementType = L), (e.lanes = i), e
                );
              case N:
                return (
                  ((e = Ts(19, n, t, a)).elementType = N), (e.lanes = i), e
                );
              case D:
                return Is(n, a, i, t);
              default:
                if ("object" === typeof e && null !== e)
                  switch (e.$$typeof) {
                    case O:
                      l = 10;
                      break e;
                    case A:
                      l = 9;
                      break e;
                    case j:
                      l = 11;
                      break e;
                    case T:
                      l = 14;
                      break e;
                    case P:
                      (l = 16), (r = null);
                      break e;
                  }
                throw Error(o(130, null == e ? e : typeof e, ""));
            }
          return (
            ((t = Ts(l, n, t, a)).elementType = e),
            (t.type = r),
            (t.lanes = i),
            t
          );
        }
        function Ms(e, t, n, r) {
          return ((e = Ts(7, e, r, t)).lanes = n), e;
        }
        function Is(e, t, n, r) {
          return (
            ((e = Ts(22, e, r, t)).elementType = D),
            (e.lanes = n),
            (e.stateNode = { isHidden: !1 }),
            e
          );
        }
        function Rs(e, t, n) {
          return ((e = Ts(6, e, null, t)).lanes = n), e;
        }
        function Fs(e, t, n) {
          return (
            ((t = Ts(
              4,
              null !== e.children ? e.children : [],
              e.key,
              t,
            )).lanes = n),
            (t.stateNode = {
              containerInfo: e.containerInfo,
              pendingChildren: null,
              implementation: e.implementation,
            }),
            t
          );
        }
        function Us(e, t, n, r, a) {
          (this.tag = t),
            (this.containerInfo = e),
            (this.finishedWork =
              this.pingCache =
              this.current =
              this.pendingChildren =
                null),
            (this.timeoutHandle = -1),
            (this.callbackNode = this.pendingContext = this.context = null),
            (this.callbackPriority = 0),
            (this.eventTimes = gt(0)),
            (this.expirationTimes = gt(-1)),
            (this.entangledLanes =
              this.finishedLanes =
              this.mutableReadLanes =
              this.expiredLanes =
              this.pingedLanes =
              this.suspendedLanes =
              this.pendingLanes =
                0),
            (this.entanglements = gt(0)),
            (this.identifierPrefix = r),
            (this.onRecoverableError = a),
            (this.mutableSourceEagerHydrationData = null);
        }
        function Hs(e, t, n, r, a, o, i, l, c) {
          return (
            (e = new Us(e, t, n, l, c)),
            1 === t ? ((t = 1), !0 === o && (t |= 8)) : (t = 0),
            (o = Ts(3, null, null, t)),
            (e.current = o),
            (o.stateNode = e),
            (o.memoizedState = {
              element: r,
              isDehydrated: n,
              cache: null,
              transitions: null,
              pendingSuspenseBoundaries: null,
            }),
            Ro(o),
            e
          );
        }
        function Bs(e) {
          if (!e) return Aa;
          e: {
            if (Ve((e = e._reactInternals)) !== e || 1 !== e.tag)
              throw Error(o(170));
            var t = e;
            do {
              switch (t.tag) {
                case 3:
                  t = t.stateNode.context;
                  break e;
                case 1:
                  if (Pa(t.type)) {
                    t = t.stateNode.__reactInternalMemoizedMergedChildContext;
                    break e;
                  }
              }
              t = t.return;
            } while (null !== t);
            throw Error(o(171));
          }
          if (1 === e.tag) {
            var n = e.type;
            if (Pa(n)) return Ma(e, n, t);
          }
          return t;
        }
        function Vs(e, t, n, r, a, o, i, l, c) {
          return (
            ((e = Hs(n, r, !0, e, 0, o, 0, l, c)).context = Bs(null)),
            (n = e.current),
            ((o = Uo((r = es()), (a = ts(n)))).callback =
              void 0 !== t && null !== t ? t : null),
            Ho(n, o, a),
            (e.current.lanes = a),
            vt(e, a, r),
            rs(e, r),
            e
          );
        }
        function Ws(e, t, n, r) {
          var a = t.current,
            o = es(),
            i = ts(a);
          return (
            (n = Bs(n)),
            null === t.context ? (t.context = n) : (t.pendingContext = n),
            ((t = Uo(o, i)).payload = { element: e }),
            null !== (r = void 0 === r ? null : r) && (t.callback = r),
            null !== (e = Ho(a, t, i)) && (ns(e, a, i, o), Bo(e, a, i)),
            i
          );
        }
        function Zs(e) {
          return (e = e.current).child
            ? (e.child.tag, e.child.stateNode)
            : null;
        }
        function Gs(e, t) {
          if (null !== (e = e.memoizedState) && null !== e.dehydrated) {
            var n = e.retryLane;
            e.retryLane = 0 !== n && n < t ? n : t;
          }
        }
        function qs(e, t) {
          Gs(e, t), (e = e.alternate) && Gs(e, t);
        }
        Sc = function (e, t, n) {
          if (null !== e)
            if (e.memoizedProps !== t.pendingProps || La.current) yl = !0;
            else {
              if (0 === (e.lanes & n) && 0 === (128 & t.flags))
                return (
                  (yl = !1),
                  (function (e, t, n) {
                    switch (t.tag) {
                      case 3:
                        Ll(t), mo();
                        break;
                      case 5:
                        Qo(t);
                        break;
                      case 1:
                        Pa(t.type) && Ia(t);
                        break;
                      case 4:
                        Jo(t, t.stateNode.containerInfo);
                        break;
                      case 10:
                        var r = t.type._context,
                          a = t.memoizedProps.value;
                        Oa(So, r._currentValue), (r._currentValue = a);
                        break;
                      case 13:
                        if (null !== (r = t.memoizedState))
                          return null !== r.dehydrated
                            ? (Oa(ei, 1 & ei.current), (t.flags |= 128), null)
                            : 0 !== (n & t.child.childLanes)
                              ? Rl(e, t, n)
                              : (Oa(ei, 1 & ei.current),
                                null !== (e = Zl(e, t, n)) ? e.sibling : null);
                        Oa(ei, 1 & ei.current);
                        break;
                      case 19:
                        if (
                          ((r = 0 !== (n & t.childLanes)),
                          0 !== (128 & e.flags))
                        ) {
                          if (r) return Vl(e, t, n);
                          t.flags |= 128;
                        }
                        if (
                          (null !== (a = t.memoizedState) &&
                            ((a.rendering = null),
                            (a.tail = null),
                            (a.lastEffect = null)),
                          Oa(ei, ei.current),
                          r)
                        )
                          break;
                        return null;
                      case 22:
                      case 23:
                        return (t.lanes = 0), Cl(e, t, n);
                    }
                    return Zl(e, t, n);
                  })(e, t, n)
                );
              yl = 0 !== (131072 & e.flags);
            }
          else (yl = !1), ao && 0 !== (1048576 & t.flags) && $a(t, qa, t.index);
          switch (((t.lanes = 0), t.tag)) {
            case 2:
              var r = t.type;
              Wl(e, t), (e = t.pendingProps);
              var a = Ta(t, ja.current);
              No(t, n), (a = gi(null, t, r, e, a, n));
              var i = vi();
              return (
                (t.flags |= 1),
                "object" === typeof a &&
                null !== a &&
                "function" === typeof a.render &&
                void 0 === a.$$typeof
                  ? ((t.tag = 1),
                    (t.memoizedState = null),
                    (t.updateQueue = null),
                    Pa(r) ? ((i = !0), Ia(t)) : (i = !1),
                    (t.memoizedState =
                      null !== a.state && void 0 !== a.state ? a.state : null),
                    Ro(t),
                    (a.updater = al),
                    (t.stateNode = a),
                    (a._reactInternals = t),
                    cl(t, r, e, n),
                    (t = jl(null, t, r, !0, i, n)))
                  : ((t.tag = 0),
                    ao && i && eo(t),
                    xl(null, t, a, n),
                    (t = t.child)),
                t
              );
            case 16:
              r = t.elementType;
              e: {
                switch (
                  (Wl(e, t),
                  (e = t.pendingProps),
                  (r = (a = r._init)(r._payload)),
                  (t.type = r),
                  (a = t.tag =
                    (function (e) {
                      if ("function" === typeof e) return Ps(e) ? 1 : 0;
                      if (void 0 !== e && null !== e) {
                        if ((e = e.$$typeof) === j) return 11;
                        if (e === T) return 14;
                      }
                      return 2;
                    })(r)),
                  (e = nl(r, e)),
                  a)
                ) {
                  case 0:
                    t = Ol(null, t, r, e, n);
                    break e;
                  case 1:
                    t = Al(null, t, r, e, n);
                    break e;
                  case 11:
                    t = wl(null, t, r, e, n);
                    break e;
                  case 14:
                    t = kl(null, t, r, nl(r.type, e), n);
                    break e;
                }
                throw Error(o(306, r, ""));
              }
              return t;
            case 0:
              return (
                (r = t.type),
                (a = t.pendingProps),
                Ol(e, t, r, (a = t.elementType === r ? a : nl(r, a)), n)
              );
            case 1:
              return (
                (r = t.type),
                (a = t.pendingProps),
                Al(e, t, r, (a = t.elementType === r ? a : nl(r, a)), n)
              );
            case 3:
              e: {
                if ((Ll(t), null === e)) throw Error(o(387));
                (r = t.pendingProps),
                  (a = (i = t.memoizedState).element),
                  Fo(e, t),
                  Wo(t, r, null, n);
                var l = t.memoizedState;
                if (((r = l.element), i.isDehydrated)) {
                  if (
                    ((i = {
                      element: r,
                      isDehydrated: !1,
                      cache: l.cache,
                      pendingSuspenseBoundaries: l.pendingSuspenseBoundaries,
                      transitions: l.transitions,
                    }),
                    (t.updateQueue.baseState = i),
                    (t.memoizedState = i),
                    256 & t.flags)
                  ) {
                    t = Nl(e, t, r, n, (a = sl(Error(o(423)), t)));
                    break e;
                  }
                  if (r !== a) {
                    t = Nl(e, t, r, n, (a = sl(Error(o(424)), t)));
                    break e;
                  }
                  for (
                    ro = sa(t.stateNode.containerInfo.firstChild),
                      no = t,
                      ao = !0,
                      oo = null,
                      n = ko(t, null, r, n),
                      t.child = n;
                    n;

                  )
                    (n.flags = (-3 & n.flags) | 4096), (n = n.sibling);
                } else {
                  if ((mo(), r === a)) {
                    t = Zl(e, t, n);
                    break e;
                  }
                  xl(e, t, r, n);
                }
                t = t.child;
              }
              return t;
            case 5:
              return (
                Qo(t),
                null === e && so(t),
                (r = t.type),
                (a = t.pendingProps),
                (i = null !== e ? e.memoizedProps : null),
                (l = a.children),
                na(r, a)
                  ? (l = null)
                  : null !== i && na(r, i) && (t.flags |= 32),
                El(e, t),
                xl(e, t, l, n),
                t.child
              );
            case 6:
              return null === e && so(t), null;
            case 13:
              return Rl(e, t, n);
            case 4:
              return (
                Jo(t, t.stateNode.containerInfo),
                (r = t.pendingProps),
                null === e ? (t.child = wo(t, null, r, n)) : xl(e, t, r, n),
                t.child
              );
            case 11:
              return (
                (r = t.type),
                (a = t.pendingProps),
                wl(e, t, r, (a = t.elementType === r ? a : nl(r, a)), n)
              );
            case 7:
              return xl(e, t, t.pendingProps, n), t.child;
            case 8:
            case 12:
              return xl(e, t, t.pendingProps.children, n), t.child;
            case 10:
              e: {
                if (
                  ((r = t.type._context),
                  (a = t.pendingProps),
                  (i = t.memoizedProps),
                  (l = a.value),
                  Oa(So, r._currentValue),
                  (r._currentValue = l),
                  null !== i)
                )
                  if (lr(i.value, l)) {
                    if (i.children === a.children && !La.current) {
                      t = Zl(e, t, n);
                      break e;
                    }
                  } else
                    for (
                      null !== (i = t.child) && (i.return = t);
                      null !== i;

                    ) {
                      var c = i.dependencies;
                      if (null !== c) {
                        l = i.child;
                        for (var s = c.firstContext; null !== s; ) {
                          if (s.context === r) {
                            if (1 === i.tag) {
                              (s = Uo(-1, n & -n)).tag = 2;
                              var u = i.updateQueue;
                              if (null !== u) {
                                var d = (u = u.shared).pending;
                                null === d
                                  ? (s.next = s)
                                  : ((s.next = d.next), (d.next = s)),
                                  (u.pending = s);
                              }
                            }
                            (i.lanes |= n),
                              null !== (s = i.alternate) && (s.lanes |= n),
                              Lo(i.return, n, t),
                              (c.lanes |= n);
                            break;
                          }
                          s = s.next;
                        }
                      } else if (10 === i.tag)
                        l = i.type === t.type ? null : i.child;
                      else if (18 === i.tag) {
                        if (null === (l = i.return)) throw Error(o(341));
                        (l.lanes |= n),
                          null !== (c = l.alternate) && (c.lanes |= n),
                          Lo(l, n, t),
                          (l = i.sibling);
                      } else l = i.child;
                      if (null !== l) l.return = i;
                      else
                        for (l = i; null !== l; ) {
                          if (l === t) {
                            l = null;
                            break;
                          }
                          if (null !== (i = l.sibling)) {
                            (i.return = l.return), (l = i);
                            break;
                          }
                          l = l.return;
                        }
                      i = l;
                    }
                xl(e, t, a.children, n), (t = t.child);
              }
              return t;
            case 9:
              return (
                (a = t.type),
                (r = t.pendingProps.children),
                No(t, n),
                (r = r((a = To(a)))),
                (t.flags |= 1),
                xl(e, t, r, n),
                t.child
              );
            case 14:
              return (
                (a = nl((r = t.type), t.pendingProps)),
                kl(e, t, r, (a = nl(r.type, a)), n)
              );
            case 15:
              return Sl(e, t, t.type, t.pendingProps, n);
            case 17:
              return (
                (r = t.type),
                (a = t.pendingProps),
                (a = t.elementType === r ? a : nl(r, a)),
                Wl(e, t),
                (t.tag = 1),
                Pa(r) ? ((e = !0), Ia(t)) : (e = !1),
                No(t, n),
                il(t, r, a),
                cl(t, r, a, n),
                jl(null, t, r, !0, e, n)
              );
            case 19:
              return Vl(e, t, n);
            case 22:
              return Cl(e, t, n);
          }
          throw Error(o(156, t.tag));
        };
        var Xs =
          "function" === typeof reportError
            ? reportError
            : function (e) {
                console.error(e);
              };
        function _s(e) {
          this._internalRoot = e;
        }
        function Ys(e) {
          this._internalRoot = e;
        }
        function Js(e) {
          return !(
            !e ||
            (1 !== e.nodeType && 9 !== e.nodeType && 11 !== e.nodeType)
          );
        }
        function Ks(e) {
          return !(
            !e ||
            (1 !== e.nodeType &&
              9 !== e.nodeType &&
              11 !== e.nodeType &&
              (8 !== e.nodeType ||
                " react-mount-point-unstable " !== e.nodeValue))
          );
        }
        function Qs() {}
        function $s(e, t, n, r, a) {
          var o = n._reactRootContainer;
          if (o) {
            var i = o;
            if ("function" === typeof a) {
              var l = a;
              a = function () {
                var e = Zs(i);
                l.call(e);
              };
            }
            Ws(t, i, e, a);
          } else
            i = (function (e, t, n, r, a) {
              if (a) {
                if ("function" === typeof r) {
                  var o = r;
                  r = function () {
                    var e = Zs(i);
                    o.call(e);
                  };
                }
                var i = Vs(t, r, e, 0, null, !1, 0, "", Qs);
                return (
                  (e._reactRootContainer = i),
                  (e[ma] = i.current),
                  Vr(8 === e.nodeType ? e.parentNode : e),
                  us(),
                  i
                );
              }
              for (; (a = e.lastChild); ) e.removeChild(a);
              if ("function" === typeof r) {
                var l = r;
                r = function () {
                  var e = Zs(c);
                  l.call(e);
                };
              }
              var c = Hs(e, 0, !1, null, 0, !1, 0, "", Qs);
              return (
                (e._reactRootContainer = c),
                (e[ma] = c.current),
                Vr(8 === e.nodeType ? e.parentNode : e),
                us(function () {
                  Ws(t, c, n, r);
                }),
                c
              );
            })(n, t, e, a, r);
          return Zs(i);
        }
        (Ys.prototype.render = _s.prototype.render =
          function (e) {
            var t = this._internalRoot;
            if (null === t) throw Error(o(409));
            Ws(e, t, null, null);
          }),
          (Ys.prototype.unmount = _s.prototype.unmount =
            function () {
              var e = this._internalRoot;
              if (null !== e) {
                this._internalRoot = null;
                var t = e.containerInfo;
                us(function () {
                  Ws(null, e, null, null);
                }),
                  (t[ma] = null);
              }
            }),
          (Ys.prototype.unstable_scheduleHydration = function (e) {
            if (e) {
              var t = Ct();
              e = { blockedOn: null, target: e, priority: t };
              for (
                var n = 0;
                n < Dt.length && 0 !== t && t < Dt[n].priority;
                n++
              );
              Dt.splice(n, 0, e), 0 === n && Rt(e);
            }
          }),
          (wt = function (e) {
            switch (e.tag) {
              case 3:
                var t = e.stateNode;
                if (t.current.memoizedState.isDehydrated) {
                  var n = dt(t.pendingLanes);
                  0 !== n &&
                    (bt(t, 1 | n),
                    rs(t, Ke()),
                    0 === (6 & jc) && ((Vc = Ke() + 500), Va()));
                }
                break;
              case 13:
                us(function () {
                  var t = Mo(e, 1);
                  if (null !== t) {
                    var n = es();
                    ns(t, e, 1, n);
                  }
                }),
                  qs(e, 1);
            }
          }),
          (kt = function (e) {
            if (13 === e.tag) {
              var t = Mo(e, 134217728);
              if (null !== t) ns(t, e, 134217728, es());
              qs(e, 134217728);
            }
          }),
          (St = function (e) {
            if (13 === e.tag) {
              var t = ts(e),
                n = Mo(e, t);
              if (null !== n) ns(n, e, t, es());
              qs(e, t);
            }
          }),
          (Ct = function () {
            return yt;
          }),
          (Et = function (e, t) {
            var n = yt;
            try {
              return (yt = e), t();
            } finally {
              yt = n;
            }
          }),
          (ke = function (e, t, n) {
            switch (t) {
              case "input":
                if ((Q(e, n), (t = n.name), "radio" === n.type && null != t)) {
                  for (n = e; n.parentNode; ) n = n.parentNode;
                  for (
                    n = n.querySelectorAll(
                      "input[name=" +
                        JSON.stringify("" + t) +
                        '][type="radio"]',
                    ),
                      t = 0;
                    t < n.length;
                    t++
                  ) {
                    var r = n[t];
                    if (r !== e && r.form === e.form) {
                      var a = wa(r);
                      if (!a) throw Error(o(90));
                      X(r), Q(r, a);
                    }
                  }
                }
                break;
              case "textarea":
                oe(e, n);
                break;
              case "select":
                null != (t = n.value) && ne(e, !!n.multiple, t, !1);
            }
          }),
          (je = ss),
          (Le = us);
        var eu = {
            usingClientEntryPoint: !1,
            Events: [ya, xa, wa, Oe, Ae, ss],
          },
          tu = {
            findFiberByHostInstance: ba,
            bundleType: 0,
            version: "18.3.1",
            rendererPackageName: "react-dom",
          },
          nu = {
            bundleType: tu.bundleType,
            version: tu.version,
            rendererPackageName: tu.rendererPackageName,
            rendererConfig: tu.rendererConfig,
            overrideHookState: null,
            overrideHookStateDeletePath: null,
            overrideHookStateRenamePath: null,
            overrideProps: null,
            overridePropsDeletePath: null,
            overridePropsRenamePath: null,
            setErrorHandler: null,
            setSuspenseHandler: null,
            scheduleUpdate: null,
            currentDispatcherRef: x.ReactCurrentDispatcher,
            findHostInstanceByFiber: function (e) {
              return null === (e = Ge(e)) ? null : e.stateNode;
            },
            findFiberByHostInstance:
              tu.findFiberByHostInstance ||
              function () {
                return null;
              },
            findHostInstancesForRefresh: null,
            scheduleRefresh: null,
            scheduleRoot: null,
            setRefreshHandler: null,
            getCurrentFiber: null,
            reconcilerVersion: "18.3.1-next-f1338f8080-20240426",
          };
        if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
          var ru = __REACT_DEVTOOLS_GLOBAL_HOOK__;
          if (!ru.isDisabled && ru.supportsFiber)
            try {
              (at = ru.inject(nu)), (ot = ru);
            } catch (ue) {}
        }
        (t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = eu),
          (t.createPortal = function (e, t) {
            var n =
              2 < arguments.length && void 0 !== arguments[2]
                ? arguments[2]
                : null;
            if (!Js(t)) throw Error(o(200));
            return (function (e, t, n) {
              var r =
                3 < arguments.length && void 0 !== arguments[3]
                  ? arguments[3]
                  : null;
              return {
                $$typeof: k,
                key: null == r ? null : "" + r,
                children: e,
                containerInfo: t,
                implementation: n,
              };
            })(e, t, null, n);
          }),
          (t.createRoot = function (e, t) {
            if (!Js(e)) throw Error(o(299));
            var n = !1,
              r = "",
              a = Xs;
            return (
              null !== t &&
                void 0 !== t &&
                (!0 === t.unstable_strictMode && (n = !0),
                void 0 !== t.identifierPrefix && (r = t.identifierPrefix),
                void 0 !== t.onRecoverableError && (a = t.onRecoverableError)),
              (t = Hs(e, 1, !1, null, 0, n, 0, r, a)),
              (e[ma] = t.current),
              Vr(8 === e.nodeType ? e.parentNode : e),
              new _s(t)
            );
          }),
          (t.findDOMNode = function (e) {
            if (null == e) return null;
            if (1 === e.nodeType) return e;
            var t = e._reactInternals;
            if (void 0 === t) {
              if ("function" === typeof e.render) throw Error(o(188));
              throw ((e = Object.keys(e).join(",")), Error(o(268, e)));
            }
            return (e = null === (e = Ge(t)) ? null : e.stateNode);
          }),
          (t.flushSync = function (e) {
            return us(e);
          }),
          (t.hydrate = function (e, t, n) {
            if (!Ks(t)) throw Error(o(200));
            return $s(null, e, t, !0, n);
          }),
          (t.hydrateRoot = function (e, t, n) {
            if (!Js(e)) throw Error(o(405));
            var r = (null != n && n.hydratedSources) || null,
              a = !1,
              i = "",
              l = Xs;
            if (
              (null !== n &&
                void 0 !== n &&
                (!0 === n.unstable_strictMode && (a = !0),
                void 0 !== n.identifierPrefix && (i = n.identifierPrefix),
                void 0 !== n.onRecoverableError && (l = n.onRecoverableError)),
              (t = Vs(t, null, e, 1, null != n ? n : null, a, 0, i, l)),
              (e[ma] = t.current),
              Vr(e),
              r)
            )
              for (e = 0; e < r.length; e++)
                (a = (a = (n = r[e])._getVersion)(n._source)),
                  null == t.mutableSourceEagerHydrationData
                    ? (t.mutableSourceEagerHydrationData = [n, a])
                    : t.mutableSourceEagerHydrationData.push(n, a);
            return new Ys(t);
          }),
          (t.render = function (e, t, n) {
            if (!Ks(t)) throw Error(o(200));
            return $s(null, e, t, !1, n);
          }),
          (t.unmountComponentAtNode = function (e) {
            if (!Ks(e)) throw Error(o(40));
            return (
              !!e._reactRootContainer &&
              (us(function () {
                $s(null, null, e, !1, function () {
                  (e._reactRootContainer = null), (e[ma] = null);
                });
              }),
              !0)
            );
          }),
          (t.unstable_batchedUpdates = ss),
          (t.unstable_renderSubtreeIntoContainer = function (e, t, n, r) {
            if (!Ks(n)) throw Error(o(200));
            if (null == e || void 0 === e._reactInternals) throw Error(o(38));
            return $s(e, t, n, !1, r);
          }),
          (t.version = "18.3.1-next-f1338f8080-20240426");
      },
      250: function (e, t, n) {
        var r = n(164);
        (t.createRoot = r.createRoot), (t.hydrateRoot = r.hydrateRoot);
      },
      164: function (e, t, n) {
        !(function e() {
          if (
            "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ &&
            "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE
          )
            try {
              __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
            } catch (t) {
              console.error(t);
            }
        })(),
          (e.exports = n(463));
      },
      357: function (e) {
        var t = 65521;
        e.exports = function (e) {
          for (var n = 1, r = 0, a = 0, o = e.length, i = -4 & o; a < i; ) {
            for (var l = Math.min(a + 4096, i); a < l; a += 4)
              r +=
                (n += e.charCodeAt(a)) +
                (n += e.charCodeAt(a + 1)) +
                (n += e.charCodeAt(a + 2)) +
                (n += e.charCodeAt(a + 3));
            (n %= t), (r %= t);
          }
          for (; a < o; a++) r += n += e.charCodeAt(a);
          return (n %= t) | ((r %= t) << 16);
        };
      },
      374: function (e, t, n) {
        var r = n(791),
          a = Symbol.for("react.element"),
          o = Symbol.for("react.fragment"),
          i = Object.prototype.hasOwnProperty,
          l =
            r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED
              .ReactCurrentOwner,
          c = { key: !0, ref: !0, __self: !0, __source: !0 };
        function s(e, t, n) {
          var r,
            o = {},
            s = null,
            u = null;
          for (r in (void 0 !== n && (s = "" + n),
          void 0 !== t.key && (s = "" + t.key),
          void 0 !== t.ref && (u = t.ref),
          t))
            i.call(t, r) && !c.hasOwnProperty(r) && (o[r] = t[r]);
          if (e && e.defaultProps)
            for (r in (t = e.defaultProps)) void 0 === o[r] && (o[r] = t[r]);
          return {
            $$typeof: a,
            type: e,
            key: s,
            ref: u,
            props: o,
            _owner: l.current,
          };
        }
        (t.Fragment = o), (t.jsx = s), (t.jsxs = s);
      },
      117: function (e, t) {
        var n = Symbol.for("react.element"),
          r = Symbol.for("react.portal"),
          a = Symbol.for("react.fragment"),
          o = Symbol.for("react.strict_mode"),
          i = Symbol.for("react.profiler"),
          l = Symbol.for("react.provider"),
          c = Symbol.for("react.context"),
          s = Symbol.for("react.forward_ref"),
          u = Symbol.for("react.suspense"),
          d = Symbol.for("react.memo"),
          p = Symbol.for("react.lazy"),
          f = Symbol.iterator;
        var m = {
            isMounted: function () {
              return !1;
            },
            enqueueForceUpdate: function () {},
            enqueueReplaceState: function () {},
            enqueueSetState: function () {},
          },
          h = Object.assign,
          g = {};
        function v(e, t, n) {
          (this.props = e),
            (this.context = t),
            (this.refs = g),
            (this.updater = n || m);
        }
        function b() {}
        function y(e, t, n) {
          (this.props = e),
            (this.context = t),
            (this.refs = g),
            (this.updater = n || m);
        }
        (v.prototype.isReactComponent = {}),
          (v.prototype.setState = function (e, t) {
            if ("object" !== typeof e && "function" !== typeof e && null != e)
              throw Error(
                "setState(...): takes an object of state variables to update or a function which returns an object of state variables.",
              );
            this.updater.enqueueSetState(this, e, t, "setState");
          }),
          (v.prototype.forceUpdate = function (e) {
            this.updater.enqueueForceUpdate(this, e, "forceUpdate");
          }),
          (b.prototype = v.prototype);
        var x = (y.prototype = new b());
        (x.constructor = y), h(x, v.prototype), (x.isPureReactComponent = !0);
        var w = Array.isArray,
          k = Object.prototype.hasOwnProperty,
          S = { current: null },
          C = { key: !0, ref: !0, __self: !0, __source: !0 };
        function E(e, t, r) {
          var a,
            o = {},
            i = null,
            l = null;
          if (null != t)
            for (a in (void 0 !== t.ref && (l = t.ref),
            void 0 !== t.key && (i = "" + t.key),
            t))
              k.call(t, a) && !C.hasOwnProperty(a) && (o[a] = t[a]);
          var c = arguments.length - 2;
          if (1 === c) o.children = r;
          else if (1 < c) {
            for (var s = Array(c), u = 0; u < c; u++) s[u] = arguments[u + 2];
            o.children = s;
          }
          if (e && e.defaultProps)
            for (a in (c = e.defaultProps)) void 0 === o[a] && (o[a] = c[a]);
          return {
            $$typeof: n,
            type: e,
            key: i,
            ref: l,
            props: o,
            _owner: S.current,
          };
        }
        function O(e) {
          return "object" === typeof e && null !== e && e.$$typeof === n;
        }
        var A = /\/+/g;
        function j(e, t) {
          return "object" === typeof e && null !== e && null != e.key
            ? (function (e) {
                var t = { "=": "=0", ":": "=2" };
                return (
                  "$" +
                  e.replace(/[=:]/g, function (e) {
                    return t[e];
                  })
                );
              })("" + e.key)
            : t.toString(36);
        }
        function L(e, t, a, o, i) {
          var l = typeof e;
          ("undefined" !== l && "boolean" !== l) || (e = null);
          var c = !1;
          if (null === e) c = !0;
          else
            switch (l) {
              case "string":
              case "number":
                c = !0;
                break;
              case "object":
                switch (e.$$typeof) {
                  case n:
                  case r:
                    c = !0;
                }
            }
          if (c)
            return (
              (i = i((c = e))),
              (e = "" === o ? "." + j(c, 0) : o),
              w(i)
                ? ((a = ""),
                  null != e && (a = e.replace(A, "$&/") + "/"),
                  L(i, t, a, "", function (e) {
                    return e;
                  }))
                : null != i &&
                  (O(i) &&
                    (i = (function (e, t) {
                      return {
                        $$typeof: n,
                        type: e.type,
                        key: t,
                        ref: e.ref,
                        props: e.props,
                        _owner: e._owner,
                      };
                    })(
                      i,
                      a +
                        (!i.key || (c && c.key === i.key)
                          ? ""
                          : ("" + i.key).replace(A, "$&/") + "/") +
                        e,
                    )),
                  t.push(i)),
              1
            );
          if (((c = 0), (o = "" === o ? "." : o + ":"), w(e)))
            for (var s = 0; s < e.length; s++) {
              var u = o + j((l = e[s]), s);
              c += L(l, t, a, u, i);
            }
          else if (
            ((u = (function (e) {
              return null === e || "object" !== typeof e
                ? null
                : "function" === typeof (e = (f && e[f]) || e["@@iterator"])
                  ? e
                  : null;
            })(e)),
            "function" === typeof u)
          )
            for (e = u.call(e), s = 0; !(l = e.next()).done; )
              c += L((l = l.value), t, a, (u = o + j(l, s++)), i);
          else if ("object" === l)
            throw (
              ((t = String(e)),
              Error(
                "Objects are not valid as a React child (found: " +
                  ("[object Object]" === t
                    ? "object with keys {" + Object.keys(e).join(", ") + "}"
                    : t) +
                  "). If you meant to render a collection of children, use an array instead.",
              ))
            );
          return c;
        }
        function N(e, t, n) {
          if (null == e) return e;
          var r = [],
            a = 0;
          return (
            L(e, r, "", "", function (e) {
              return t.call(n, e, a++);
            }),
            r
          );
        }
        function T(e) {
          if (-1 === e._status) {
            var t = e._result;
            (t = t()).then(
              function (t) {
                (0 !== e._status && -1 !== e._status) ||
                  ((e._status = 1), (e._result = t));
              },
              function (t) {
                (0 !== e._status && -1 !== e._status) ||
                  ((e._status = 2), (e._result = t));
              },
            ),
              -1 === e._status && ((e._status = 0), (e._result = t));
          }
          if (1 === e._status) return e._result.default;
          throw e._result;
        }
        var P = { current: null },
          D = { transition: null },
          z = {
            ReactCurrentDispatcher: P,
            ReactCurrentBatchConfig: D,
            ReactCurrentOwner: S,
          };
        function M() {
          throw Error(
            "act(...) is not supported in production builds of React.",
          );
        }
        (t.Children = {
          map: N,
          forEach: function (e, t, n) {
            N(
              e,
              function () {
                t.apply(this, arguments);
              },
              n,
            );
          },
          count: function (e) {
            var t = 0;
            return (
              N(e, function () {
                t++;
              }),
              t
            );
          },
          toArray: function (e) {
            return (
              N(e, function (e) {
                return e;
              }) || []
            );
          },
          only: function (e) {
            if (!O(e))
              throw Error(
                "React.Children.only expected to receive a single React element child.",
              );
            return e;
          },
        }),
          (t.Component = v),
          (t.Fragment = a),
          (t.Profiler = i),
          (t.PureComponent = y),
          (t.StrictMode = o),
          (t.Suspense = u),
          (t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = z),
          (t.act = M),
          (t.cloneElement = function (e, t, r) {
            if (null === e || void 0 === e)
              throw Error(
                "React.cloneElement(...): The argument must be a React element, but you passed " +
                  e +
                  ".",
              );
            var a = h({}, e.props),
              o = e.key,
              i = e.ref,
              l = e._owner;
            if (null != t) {
              if (
                (void 0 !== t.ref && ((i = t.ref), (l = S.current)),
                void 0 !== t.key && (o = "" + t.key),
                e.type && e.type.defaultProps)
              )
                var c = e.type.defaultProps;
              for (s in t)
                k.call(t, s) &&
                  !C.hasOwnProperty(s) &&
                  (a[s] = void 0 === t[s] && void 0 !== c ? c[s] : t[s]);
            }
            var s = arguments.length - 2;
            if (1 === s) a.children = r;
            else if (1 < s) {
              c = Array(s);
              for (var u = 0; u < s; u++) c[u] = arguments[u + 2];
              a.children = c;
            }
            return {
              $$typeof: n,
              type: e.type,
              key: o,
              ref: i,
              props: a,
              _owner: l,
            };
          }),
          (t.createContext = function (e) {
            return (
              ((e = {
                $$typeof: c,
                _currentValue: e,
                _currentValue2: e,
                _threadCount: 0,
                Provider: null,
                Consumer: null,
                _defaultValue: null,
                _globalName: null,
              }).Provider = { $$typeof: l, _context: e }),
              (e.Consumer = e)
            );
          }),
          (t.createElement = E),
          (t.createFactory = function (e) {
            var t = E.bind(null, e);
            return (t.type = e), t;
          }),
          (t.createRef = function () {
            return { current: null };
          }),
          (t.forwardRef = function (e) {
            return { $$typeof: s, render: e };
          }),
          (t.isValidElement = O),
          (t.lazy = function (e) {
            return {
              $$typeof: p,
              _payload: { _status: -1, _result: e },
              _init: T,
            };
          }),
          (t.memo = function (e, t) {
            return { $$typeof: d, type: e, compare: void 0 === t ? null : t };
          }),
          (t.startTransition = function (e) {
            var t = D.transition;
            D.transition = {};
            try {
              e();
            } finally {
              D.transition = t;
            }
          }),
          (t.unstable_act = M),
          (t.useCallback = function (e, t) {
            return P.current.useCallback(e, t);
          }),
          (t.useContext = function (e) {
            return P.current.useContext(e);
          }),
          (t.useDebugValue = function () {}),
          (t.useDeferredValue = function (e) {
            return P.current.useDeferredValue(e);
          }),
          (t.useEffect = function (e, t) {
            return P.current.useEffect(e, t);
          }),
          (t.useId = function () {
            return P.current.useId();
          }),
          (t.useImperativeHandle = function (e, t, n) {
            return P.current.useImperativeHandle(e, t, n);
          }),
          (t.useInsertionEffect = function (e, t) {
            return P.current.useInsertionEffect(e, t);
          }),
          (t.useLayoutEffect = function (e, t) {
            return P.current.useLayoutEffect(e, t);
          }),
          (t.useMemo = function (e, t) {
            return P.current.useMemo(e, t);
          }),
          (t.useReducer = function (e, t, n) {
            return P.current.useReducer(e, t, n);
          }),
          (t.useRef = function (e) {
            return P.current.useRef(e);
          }),
          (t.useState = function (e) {
            return P.current.useState(e);
          }),
          (t.useSyncExternalStore = function (e, t, n) {
            return P.current.useSyncExternalStore(e, t, n);
          }),
          (t.useTransition = function () {
            return P.current.useTransition();
          }),
          (t.version = "18.3.1");
      },
      791: function (e, t, n) {
        e.exports = n(117);
      },
      184: function (e, t, n) {
        e.exports = n(374);
      },
      813: function (e, t) {
        function n(e, t) {
          var n = e.length;
          e.push(t);
          e: for (; 0 < n; ) {
            var r = (n - 1) >>> 1,
              a = e[r];
            if (!(0 < o(a, t))) break e;
            (e[r] = t), (e[n] = a), (n = r);
          }
        }
        function r(e) {
          return 0 === e.length ? null : e[0];
        }
        function a(e) {
          if (0 === e.length) return null;
          var t = e[0],
            n = e.pop();
          if (n !== t) {
            e[0] = n;
            e: for (var r = 0, a = e.length, i = a >>> 1; r < i; ) {
              var l = 2 * (r + 1) - 1,
                c = e[l],
                s = l + 1,
                u = e[s];
              if (0 > o(c, n))
                s < a && 0 > o(u, c)
                  ? ((e[r] = u), (e[s] = n), (r = s))
                  : ((e[r] = c), (e[l] = n), (r = l));
              else {
                if (!(s < a && 0 > o(u, n))) break e;
                (e[r] = u), (e[s] = n), (r = s);
              }
            }
          }
          return t;
        }
        function o(e, t) {
          var n = e.sortIndex - t.sortIndex;
          return 0 !== n ? n : e.id - t.id;
        }
        if (
          "object" === typeof performance &&
          "function" === typeof performance.now
        ) {
          var i = performance;
          t.unstable_now = function () {
            return i.now();
          };
        } else {
          var l = Date,
            c = l.now();
          t.unstable_now = function () {
            return l.now() - c;
          };
        }
        var s = [],
          u = [],
          d = 1,
          p = null,
          f = 3,
          m = !1,
          h = !1,
          g = !1,
          v = "function" === typeof setTimeout ? setTimeout : null,
          b = "function" === typeof clearTimeout ? clearTimeout : null,
          y = "undefined" !== typeof setImmediate ? setImmediate : null;
        function x(e) {
          for (var t = r(u); null !== t; ) {
            if (null === t.callback) a(u);
            else {
              if (!(t.startTime <= e)) break;
              a(u), (t.sortIndex = t.expirationTime), n(s, t);
            }
            t = r(u);
          }
        }
        function w(e) {
          if (((g = !1), x(e), !h))
            if (null !== r(s)) (h = !0), D(k);
            else {
              var t = r(u);
              null !== t && z(w, t.startTime - e);
            }
        }
        function k(e, n) {
          (h = !1), g && ((g = !1), b(O), (O = -1)), (m = !0);
          var o = f;
          try {
            for (
              x(n), p = r(s);
              null !== p && (!(p.expirationTime > n) || (e && !L()));

            ) {
              var i = p.callback;
              if ("function" === typeof i) {
                (p.callback = null), (f = p.priorityLevel);
                var l = i(p.expirationTime <= n);
                (n = t.unstable_now()),
                  "function" === typeof l
                    ? (p.callback = l)
                    : p === r(s) && a(s),
                  x(n);
              } else a(s);
              p = r(s);
            }
            if (null !== p) var c = !0;
            else {
              var d = r(u);
              null !== d && z(w, d.startTime - n), (c = !1);
            }
            return c;
          } finally {
            (p = null), (f = o), (m = !1);
          }
        }
        "undefined" !== typeof navigator &&
          void 0 !== navigator.scheduling &&
          void 0 !== navigator.scheduling.isInputPending &&
          navigator.scheduling.isInputPending.bind(navigator.scheduling);
        var S,
          C = !1,
          E = null,
          O = -1,
          A = 5,
          j = -1;
        function L() {
          return !(t.unstable_now() - j < A);
        }
        function N() {
          if (null !== E) {
            var e = t.unstable_now();
            j = e;
            var n = !0;
            try {
              n = E(!0, e);
            } finally {
              n ? S() : ((C = !1), (E = null));
            }
          } else C = !1;
        }
        if ("function" === typeof y)
          S = function () {
            y(N);
          };
        else if ("undefined" !== typeof MessageChannel) {
          var T = new MessageChannel(),
            P = T.port2;
          (T.port1.onmessage = N),
            (S = function () {
              P.postMessage(null);
            });
        } else
          S = function () {
            v(N, 0);
          };
        function D(e) {
          (E = e), C || ((C = !0), S());
        }
        function z(e, n) {
          O = v(function () {
            e(t.unstable_now());
          }, n);
        }
        (t.unstable_IdlePriority = 5),
          (t.unstable_ImmediatePriority = 1),
          (t.unstable_LowPriority = 4),
          (t.unstable_NormalPriority = 3),
          (t.unstable_Profiling = null),
          (t.unstable_UserBlockingPriority = 2),
          (t.unstable_cancelCallback = function (e) {
            e.callback = null;
          }),
          (t.unstable_continueExecution = function () {
            h || m || ((h = !0), D(k));
          }),
          (t.unstable_forceFrameRate = function (e) {
            0 > e || 125 < e
              ? console.error(
                  "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported",
                )
              : (A = 0 < e ? Math.floor(1e3 / e) : 5);
          }),
          (t.unstable_getCurrentPriorityLevel = function () {
            return f;
          }),
          (t.unstable_getFirstCallbackNode = function () {
            return r(s);
          }),
          (t.unstable_next = function (e) {
            switch (f) {
              case 1:
              case 2:
              case 3:
                var t = 3;
                break;
              default:
                t = f;
            }
            var n = f;
            f = t;
            try {
              return e();
            } finally {
              f = n;
            }
          }),
          (t.unstable_pauseExecution = function () {}),
          (t.unstable_requestPaint = function () {}),
          (t.unstable_runWithPriority = function (e, t) {
            switch (e) {
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
                break;
              default:
                e = 3;
            }
            var n = f;
            f = e;
            try {
              return t();
            } finally {
              f = n;
            }
          }),
          (t.unstable_scheduleCallback = function (e, a, o) {
            var i = t.unstable_now();
            switch (
              ("object" === typeof o && null !== o
                ? (o = "number" === typeof (o = o.delay) && 0 < o ? i + o : i)
                : (o = i),
              e)
            ) {
              case 1:
                var l = -1;
                break;
              case 2:
                l = 250;
                break;
              case 5:
                l = 1073741823;
                break;
              case 4:
                l = 1e4;
                break;
              default:
                l = 5e3;
            }
            return (
              (e = {
                id: d++,
                callback: a,
                priorityLevel: e,
                startTime: o,
                expirationTime: (l = o + l),
                sortIndex: -1,
              }),
              o > i
                ? ((e.sortIndex = o),
                  n(u, e),
                  null === r(s) &&
                    e === r(u) &&
                    (g ? (b(O), (O = -1)) : (g = !0), z(w, o - i)))
                : ((e.sortIndex = l), n(s, e), h || m || ((h = !0), D(k))),
              e
            );
          }),
          (t.unstable_shouldYield = L),
          (t.unstable_wrapCallback = function (e) {
            var t = f;
            return function () {
              var n = f;
              f = t;
              try {
                return e.apply(this, arguments);
              } finally {
                f = n;
              }
            };
          });
      },
      296: function (e, t, n) {
        e.exports = n(813);
      },
    },
    t = {};
  function n(r) {
    var a = t[r];
    if (void 0 !== a) return a.exports;
    var o = (t[r] = { exports: {} });
    return e[r](o, o.exports, n), o.exports;
  }
  (n.n = function (e) {
    var t =
      e && e.__esModule
        ? function () {
            return e.default;
          }
        : function () {
            return e;
          };
    return n.d(t, { a: t }), t;
  }),
    (function () {
      var e,
        t = Object.getPrototypeOf
          ? function (e) {
              return Object.getPrototypeOf(e);
            }
          : function (e) {
              return e.__proto__;
            };
      n.t = function (r, a) {
        if ((1 & a && (r = this(r)), 8 & a)) return r;
        if ("object" === typeof r && r) {
          if (4 & a && r.__esModule) return r;
          if (16 & a && "function" === typeof r.then) return r;
        }
        var o = Object.create(null);
        n.r(o);
        var i = {};
        e = e || [null, t({}), t([]), t(t)];
        for (
          var l = 2 & a && r;
          "object" == typeof l && !~e.indexOf(l);
          l = t(l)
        )
          Object.getOwnPropertyNames(l).forEach(function (e) {
            i[e] = function () {
              return r[e];
            };
          });
        return (
          (i.default = function () {
            return r;
          }),
          n.d(o, i),
          o
        );
      };
    })(),
    (n.d = function (e, t) {
      for (var r in t)
        n.o(t, r) &&
          !n.o(e, r) &&
          Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    }),
    (n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (n.r = function (e) {
      "undefined" !== typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
        Object.defineProperty(e, "__esModule", { value: !0 });
    }),
    (n.p = "./latest/"),
    (function () {
      var e = n(791),
        t = n(250),
        r = n.t(t, 2);
      function a(e, t) {
        if (!(e instanceof t))
          throw new TypeError("Cannot call a class as a function");
      }
      function o(e) {
        return (
          (o =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (e) {
                  return typeof e;
                }
              : function (e) {
                  return e &&
                    "function" == typeof Symbol &&
                    e.constructor === Symbol &&
                    e !== Symbol.prototype
                    ? "symbol"
                    : typeof e;
                }),
          o(e)
        );
      }
      function i(e) {
        var t = (function (e, t) {
          if ("object" !== o(e) || null === e) return e;
          var n = e[Symbol.toPrimitive];
          if (void 0 !== n) {
            var r = n.call(e, t || "default");
            if ("object" !== o(r)) return r;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return ("string" === t ? String : Number)(e);
        })(e, "string");
        return "symbol" === o(t) ? t : String(t);
      }
      function l(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          (r.enumerable = r.enumerable || !1),
            (r.configurable = !0),
            "value" in r && (r.writable = !0),
            Object.defineProperty(e, i(r.key), r);
        }
      }
      function c(e, t, n) {
        return (
          t && l(e.prototype, t),
          n && l(e, n),
          Object.defineProperty(e, "prototype", { writable: !1 }),
          e
        );
      }
      function s(e) {
        if (void 0 === e)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called",
          );
        return e;
      }
      function u(e, t) {
        return (
          (u = Object.setPrototypeOf
            ? Object.setPrototypeOf.bind()
            : function (e, t) {
                return (e.__proto__ = t), e;
              }),
          u(e, t)
        );
      }
      function d(e, t) {
        if ("function" !== typeof t && null !== t)
          throw new TypeError(
            "Super expression must either be null or a function",
          );
        (e.prototype = Object.create(t && t.prototype, {
          constructor: { value: e, writable: !0, configurable: !0 },
        })),
          Object.defineProperty(e, "prototype", { writable: !1 }),
          t && u(e, t);
      }
      function p(e) {
        return (
          (p = Object.setPrototypeOf
            ? Object.getPrototypeOf.bind()
            : function (e) {
                return e.__proto__ || Object.getPrototypeOf(e);
              }),
          p(e)
        );
      }
      function f() {
        if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" === typeof Proxy) return !0;
        try {
          return (
            Boolean.prototype.valueOf.call(
              Reflect.construct(Boolean, [], function () {}),
            ),
            !0
          );
        } catch (e) {
          return !1;
        }
      }
      function m(e) {
        var t = f();
        return function () {
          var n,
            r = p(e);
          if (t) {
            var a = p(this).constructor;
            n = Reflect.construct(r, arguments, a);
          } else n = r.apply(this, arguments);
          return (function (e, t) {
            if (t && ("object" === o(t) || "function" === typeof t)) return t;
            if (void 0 !== t)
              throw new TypeError(
                "Derived constructors may only return object or undefined",
              );
            return s(e);
          })(this, n);
        };
      }
      function h(e, t, n) {
        return (
          (h = f()
            ? Reflect.construct.bind()
            : function (e, t, n) {
                var r = [null];
                r.push.apply(r, t);
                var a = new (Function.bind.apply(e, r))();
                return n && u(a, n.prototype), a;
              }),
          h.apply(null, arguments)
        );
      }
      function g(e) {
        var t = "function" === typeof Map ? new Map() : void 0;
        return (
          (g = function (e) {
            if (
              null === e ||
              ((n = e),
              -1 === Function.toString.call(n).indexOf("[native code]"))
            )
              return e;
            var n;
            if ("function" !== typeof e)
              throw new TypeError(
                "Super expression must either be null or a function",
              );
            if ("undefined" !== typeof t) {
              if (t.has(e)) return t.get(e);
              t.set(e, r);
            }
            function r() {
              return h(e, arguments, p(this).constructor);
            }
            return (
              (r.prototype = Object.create(e.prototype, {
                constructor: {
                  value: r,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
              u(r, e)
            );
          }),
          g(e)
        );
      }
      function v(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      function b(e, t) {
        if (e) {
          if ("string" === typeof e) return v(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          return (
            "Object" === n && e.constructor && (n = e.constructor.name),
            "Map" === n || "Set" === n
              ? Array.from(e)
              : "Arguments" === n ||
                  /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
                ? v(e, t)
                : void 0
          );
        }
      }
      function y(e, t) {
        var n =
          ("undefined" !== typeof Symbol && e[Symbol.iterator]) ||
          e["@@iterator"];
        if (!n) {
          if (
            Array.isArray(e) ||
            (n = b(e)) ||
            (t && e && "number" === typeof e.length)
          ) {
            n && (e = n);
            var r = 0,
              a = function () {};
            return {
              s: a,
              n: function () {
                return r >= e.length
                  ? { done: !0 }
                  : { done: !1, value: e[r++] };
              },
              e: function (e) {
                throw e;
              },
              f: a,
            };
          }
          throw new TypeError(
            "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
          );
        }
        var o,
          i = !0,
          l = !1;
        return {
          s: function () {
            n = n.call(e);
          },
          n: function () {
            var e = n.next();
            return (i = e.done), e;
          },
          e: function (e) {
            (l = !0), (o = e);
          },
          f: function () {
            try {
              i || null == n.return || n.return();
            } finally {
              if (l) throw o;
            }
          },
        };
      }
      var x = Object.defineProperty,
        w = function (e, t, n) {
          return (
            (function (e, t, n) {
              t in e
                ? x(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: n,
                  })
                : (e[t] = n);
            })(e, "symbol" != typeof t ? t + "" : t, n),
            n
          );
        },
        k = {
          string: {
            stringify: function (e) {
              return e;
            },
            parse: function (e) {
              return e;
            },
          },
          number: {
            stringify: function (e) {
              return "".concat(e);
            },
            parse: function (e) {
              return parseFloat(e);
            },
          },
          boolean: {
            stringify: function (e) {
              return e ? "true" : "false";
            },
            parse: function (e) {
              return /^[ty1-9]/i.test(e);
            },
          },
          function: {
            stringify: function (e) {
              return e.name;
            },
            parse: function (e, t) {
              var n =
                typeof window < "u" && e in window
                  ? window[e]
                  : typeof global < "u" && e in global
                    ? global[e]
                    : void 0;
              return "function" == typeof n ? n.bind(t) : void 0;
            },
          },
          json: {
            stringify: function (e) {
              return JSON.stringify(e);
            },
            parse: function (e) {
              return JSON.parse(e);
            },
          },
        },
        S = Symbol.for("r2wc.render"),
        C = Symbol.for("r2wc.connected"),
        E = Symbol.for("r2wc.context"),
        O = Symbol.for("r2wc.props");
      function A(e, t, n) {
        var r, o, i;
        t.props || (t.props = e.propTypes ? Object.keys(e.propTypes) : []);
        var l,
          u = (
            Array.isArray(t.props) ? t.props.slice() : Object.keys(t.props)
          ).filter(function (e) {
            return "container" !== e;
          }),
          p = {},
          f = {},
          h = {},
          v = y(u);
        try {
          for (v.s(); !(l = v.n()).done; ) {
            var b = l.value;
            p[b] = Array.isArray(t.props) ? "string" : t.props[b];
            var x = j(b);
            (f[b] = x), (h[x] = b);
          }
        } catch (P) {
          v.e(P);
        } finally {
          v.f();
        }
        var A,
          L = (function (l, g) {
            d(b, l);
            var v = m(b);
            function b() {
              var e;
              a(this, b),
                (e = v.call(this)),
                w(s(e), r, !0),
                w(s(e), o),
                w(s(e), i, {}),
                w(s(e), "container"),
                t.shadow
                  ? (e.container = e.attachShadow({ mode: t.shadow }))
                  : (e.container = s(e)),
                (e[O].container = e.container);
              var n,
                l = y(u);
              try {
                for (l.s(); !(n = l.n()).done; ) {
                  var c = n.value,
                    d = f[c],
                    m = e.getAttribute(d),
                    h = p[c],
                    g = k[h];
                  m && null != g && g.parse && (e[O][c] = g.parse(m, s(e)));
                }
              } catch (P) {
                l.e(P);
              } finally {
                l.f();
              }
              return e;
            }
            return (
              c(
                b,
                [
                  {
                    key: "connectedCallback",
                    value: function () {
                      (this[C] = !0), this[S]();
                    },
                  },
                  {
                    key: "disconnectedCallback",
                    value: function () {
                      (this[C] = !1), this[E] && n.unmount(this[E]);
                    },
                  },
                  {
                    key: "attributeChangedCallback",
                    value: function (e, t, n) {
                      var r = h[e],
                        a = p[r],
                        o = k[a];
                      r in p &&
                        null != o &&
                        o.parse &&
                        ((this[O][r] = o.parse(n, this)), this[S]());
                    },
                  },
                  {
                    key: g,
                    value: function () {
                      this[C] &&
                        (this[E]
                          ? n.update(this[E], this[O])
                          : (this[E] = n.mount(this.container, e, this[O])));
                    },
                  },
                ],
                [
                  {
                    key: "observedAttributes",
                    get: function () {
                      return Object.keys(h);
                    },
                  },
                ],
              ),
              b
            );
          })(g(HTMLElement), ((r = C), (o = E), (i = O), S)),
          N = y(u);
        try {
          var T = function () {
            var e = A.value,
              t = f[e],
              n = p[e];
            Object.defineProperty(L.prototype, e, {
              enumerable: !0,
              configurable: !0,
              get: function () {
                return this[O][e];
              },
              set: function (r) {
                this[O][e] = r;
                var a = k[n];
                if (null != a && a.stringify) {
                  var o = a.stringify(r);
                  this.getAttribute(t) !== o && this.setAttribute(t, o);
                }
              },
            });
          };
          for (N.s(); !(A = N.n()).done; ) T();
        } catch (P) {
          N.e(P);
        } finally {
          N.f();
        }
        return L;
      }
      function j() {
        return (
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ""
        )
          .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
          .toLowerCase();
      }
      var L = (function (e) {
          return (
            (e.SOLO = "SOLO"),
            (e.DUO = "DUO"),
            (e.POWER_PLUG = "POWER_PLUG"),
            (e.STANDARD = "STANDARD"),
            (e.XL = "XL"),
            e
          );
        })({}),
        N = (function (e) {
          return (
            (e.ALL_SEATS_ARE_ALREADY_SELECTED =
              "paoSeatmapUi.errors.TOO_MANY_SELECTED_SEATS_ERROR"),
            (e.ALL_SEATS_ARE_NOT_SELECTED =
              "paoSeatmapUi.errors.NOT_ENOUGH_SELECTED_SEATS_ERROR"),
            (e.SEATS_IN_DIFFERENT_COACH =
              "paoSeatmapUi.errors.NOT_SAME_COACH_ERROR"),
            (e.SEATS_IN_DIFFERENT_DECKS =
              "paoSeatmapUi.errors.NOT_SAME_DECK_ERROR"),
            (e.SEAT_ALREADY_TAKEN = "paoSeatmapUi.warning.SEAT_ALREADY_TAKEN"),
            (e.CHANGING_DECK_WITH_SELECTED_SEAT =
              "paoSeatmapUi.warning.CHANGING_DECK_WITH_SELECTED_SEAT"),
            (e.CHANGING_COACH_WITH_SELECTED_SEAT =
              "paoSeatmapUi.warning.CHANGING_COACH_WITH_SELECTED_SEAT"),
            e
          );
        })({}),
        T = (function (e) {
          return (
            (e.TGV = "TGV"),
            (e.IC = "IC"),
            (e.OUIGO = "OUIGO"),
            (e.OUIGO_ESP = "OUIGO_ESP"),
            (e.OUIGO_LC = "OUIGO_LC"),
            e
          );
        })({}),
        P = (function (e) {
          return (
            (e[(e.TGV_IC = 0)] = "TGV_IC"),
            (e[(e.OUIGO = 1)] = "OUIGO"),
            (e[(e.OUIGO_ESP = 2)] = "OUIGO_ESP"),
            (e[(e.OUIGO_LC = 3)] = "OUIGO_LC"),
            e
          );
        })({}),
        D = (function (e) {
          return (e[(e.MONO = 0)] = "MONO"), (e[(e.DUO = 1)] = "DUO"), e;
        })({}),
        z = (function (e) {
          return (
            (e.EXIT = "EXIT"),
            (e.TRAIN_DIRECTION = "TRAIN_DIRECTION"),
            (e.DELETE_SELECTION = "DELETE_SELECTION"),
            (e.STANDARD_SEAT = "STANDARD_SEAT"),
            (e.XL_SEAT = "XL_SEAT"),
            (e.AVAILABLE_MONO_SEAT = "AVAILABLE_MONO_SEAT"),
            (e.UNAVAILABLE_MONO_SEAT = "UNAVAILABLE_MONO_SEAT"),
            (e.SELECTED_MONO_SEAT = "SELECTED_MONO_SEAT"),
            (e.AVAILABLE_DUO_SEAT = "AVAILABLE_DUO_SEAT"),
            (e.UNAVAILABLE_DUO_SEAT = "UNAVAILABLE_DUO_SEAT"),
            (e.SELECTED_DUO_SEAT = "SELECTED_DUO_SEAT"),
            (e.ELECTRIC_PLUG = "ELECTRIC_PLUG"),
            (e.SOLO_SEAT = "SOLO_SEAT"),
            e
          );
        })({}),
        M = {
          VERTICAL_TRESHOLD: 640,
          COACH_TRAVEL_CLASS: { FIRST: "1", SECOND: "2" },
          COACH_ORIENTATION: { UNKNOWN: "UNKNOWN", EAST: "EAST", WEST: "WEST" },
          DECK_TYPE: { UPPER: "TOP", LOWER: "BOTTOM" },
          COLOR_PRIMARY_BIS_RATIO: 0.73,
          COLOR_SECONDARY_DISABLED_OPACITY: 0.84,
          COLOR_SECONDARY_DISABLED_BORDER_OPACITY: 0.6,
          DEFAULT_COLOR: {
            TGV: {
              primary: "#9B2743",
              secondary: "#7E7F74",
              ternary: "#4e5053",
              quaternary: "#000000",
            },
            IC: {
              primary: "#9B2743",
              secondary: "#7E7F74",
              ternary: "#4e5053",
              quaternary: "#000000",
            },
            OUIGO: {
              primary: "#0088CE",
              secondary: "#7E7F74",
              ternary: "#4e5053",
              quaternary: "#a8023a",
            },
            OUIGO_ESP: {
              primary: "#0088CE",
              secondary: "#7E7F74",
              ternary: "#4e5053",
              quaternary: "#a8023a",
            },
            OUIGO_LC: {
              primary: "#0088CE",
              secondary: "#7E7F74",
              ternary: "#4e5053",
              quaternary: "#a8023a",
            },
          },
          TRAIN_TYPES_WITH_PASSENGER_SEATMAP: [
            T.OUIGO,
            T.OUIGO_ESP,
            T.OUIGO_LC,
          ],
        };
      function I(e, t) {
        return (
          (function (e) {
            if (Array.isArray(e)) return e;
          })(e) ||
          (function (e, t) {
            var n =
              null == e
                ? null
                : ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
                  e["@@iterator"];
            if (null != n) {
              var r,
                a,
                o,
                i,
                l = [],
                c = !0,
                s = !1;
              try {
                if (((o = (n = n.call(e)).next), 0 === t)) {
                  if (Object(n) !== n) return;
                  c = !1;
                } else
                  for (
                    ;
                    !(c = (r = o.call(n)).done) &&
                    (l.push(r.value), l.length !== t);
                    c = !0
                  );
              } catch (u) {
                (s = !0), (a = u);
              } finally {
                try {
                  if (
                    !c &&
                    null != n.return &&
                    ((i = n.return()), Object(i) !== i)
                  )
                    return;
                } finally {
                  if (s) throw a;
                }
              }
              return l;
            }
          })(e, t) ||
          b(e, t) ||
          (function () {
            throw new TypeError(
              "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
            );
          })()
        );
      }
      function R(e, t, n) {
        return (
          (t = i(t)) in e
            ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              })
            : (e[t] = n),
          e
        );
      }
      function F(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t &&
            (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, r);
        }
        return n;
      }
      function U(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? F(Object(n), !0).forEach(function (t) {
                R(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : F(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      function H() {
        return (
          (H =
            "undefined" !== typeof Reflect && Reflect.get
              ? Reflect.get.bind()
              : function (e, t, n) {
                  var r = (function (e, t) {
                    for (
                      ;
                      !Object.prototype.hasOwnProperty.call(e, t) &&
                      null !== (e = p(e));

                    );
                    return e;
                  })(e, t);
                  if (r) {
                    var a = Object.getOwnPropertyDescriptor(r, t);
                    return a.get
                      ? a.get.call(arguments.length < 3 ? e : n)
                      : a.value;
                  }
                }),
          H.apply(this, arguments)
        );
      }
      function B(e, t) {
        return t.some(function (t) {
          return V(e, t.passenger);
        });
      }
      function V(e, t) {
        return null !== t && e.rank === t.rank && e.type === t.type;
      }
      var W = (function () {
          function e() {
            a(this, e);
          }
          return (
            c(e, [
              {
                key: "getNextCurrentPassenger",
                value: function (e, t, n) {
                  if (
                    null === e.app.currentPassenger ||
                    null === e.immutable.passengers
                  )
                    return null;
                  if (null !== n) {
                    var r = e.app.placings.find(function (e) {
                      return e.seat.seatNumber === n.seatNumber;
                    });
                    if (void 0 !== r) return r.passenger;
                  }
                  for (
                    var a = e.immutable.passengers.findIndex(function (t) {
                        return V(t, e.app.currentPassenger);
                      }),
                      o = 1;
                    o < e.immutable.passengers.length;
                    o++
                  ) {
                    var i = (a + o) % e.immutable.passengers.length;
                    if (!B(e.immutable.passengers[i], t))
                      return e.immutable.passengers[i];
                  }
                  return e.immutable.passengers[a];
                },
              },
            ]),
            e
          );
        })(),
        Z = (function () {
          function e() {
            a(this, e);
          }
          return (
            c(e, null, [
              {
                key: "noError",
                value: function () {
                  return {
                    displayError: !1,
                    errorId: void 0,
                    confirmEvent: null,
                  };
                },
              },
              {
                key: "noFocusableSeats",
                value: function () {
                  return {
                    currentFocusSeatIndexOnCurrentGrid: -1,
                    seatWithFocus: void 0,
                    focusableSeats: [],
                  };
                },
              },
              {
                key: "noTrainDirection",
                value: function () {
                  return {
                    displayTrainDirection: !1,
                    trainDirectionCode: M.COACH_ORIENTATION.UNKNOWN,
                  };
                },
              },
              {
                key: "defaultImmutableData",
                value: function () {
                  return {
                    terms: {},
                    carriages: [],
                    coaches: [],
                    displayableElementsForCoachSelector: void 0,
                    numberOfPassengers: 0,
                    managerType: P.TGV_IC,
                    passengers: [],
                    trainType: T.TGV,
                    trainDirection: e.noTrainDirection(),
                    legendContent: [],
                  };
                },
              },
              {
                key: "defaultDisplayData",
                value: function () {
                  return {
                    isHorizontalDisplay: !0,
                    errorDisplayHandler: e.noError(),
                    seatFocusHolder: e.noFocusableSeats(),
                    displayPassenger: !1,
                    displayAncillaryServices: !1,
                  };
                },
              },
              {
                key: "defaultApplicationData",
                value: function () {
                  return {
                    placings: [],
                    currentDeck: void 0,
                    currentCoach: void 0,
                    currentPassenger: void 0,
                  };
                },
              },
            ]),
            e
          );
        })(),
        G = (function () {
          function e() {
            a(this, e),
              (this.updateFocusableSeatsWithDisplayedDeck =
                this.updateFocusableSeatsWithDisplayedDeck.bind(this)),
              (this.seatGetFocusByClick = this.seatGetFocusByClick.bind(this)),
              (this.moveFocusToNextSeat = this.moveFocusToNextSeat.bind(this)),
              (this.moveFocusToPreviousSeat =
                this.moveFocusToPreviousSeat.bind(this)),
              (this.updateSeatHandlerFromNewIndex =
                this.updateSeatHandlerFromNewIndex.bind(this));
          }
          return (
            c(e, [
              {
                key: "updateFocusableSeatsWithDisplayedDeck",
                value: function (e, t) {
                  return U(
                    U({}, e),
                    {},
                    {
                      seatWithFocus: void 0,
                      currentFocusSeatIndexOnCurrentGrid: -1,
                      focusableSeats: t.deckGrid.deckCells
                        .filter(function (e) {
                          return void 0 !== e.seat && e.seat.available;
                        })
                        .sort(this.seatGraphicalOrderComparator)
                        .map(function (e) {
                          return e.seat;
                        }),
                    },
                  );
                },
              },
              {
                key: "seatGraphicalOrderComparator",
                value: function (e, t) {
                  return e.rowRank === t.rowRank
                    ? e.columnRank - t.columnRank
                    : e.rowRank - t.rowRank;
                },
              },
              {
                key: "seatGetFocusByClick",
                value: function (e, t) {
                  return U(
                    U({}, e),
                    {},
                    {
                      seatWithFocus: t,
                      currentFocusSeatIndexOnCurrentGrid:
                        e.focusableSeats.findIndex(function (e) {
                          return e.seatNumber === t.seatNumber;
                        }),
                    },
                  );
                },
              },
              {
                key: "moveFocusToNextSeat",
                value: function (e) {
                  var t = e.currentFocusSeatIndexOnCurrentGrid + 1;
                  return (
                    t > e.focusableSeats.length - 1 && (t = 0),
                    this.updateSeatHandlerFromNewIndex(e, t)
                  );
                },
              },
              {
                key: "moveFocusToPreviousSeat",
                value: function (e) {
                  var t = e.currentFocusSeatIndexOnCurrentGrid - 1;
                  return (
                    t < 0 && (t = e.focusableSeats.length - 1),
                    this.updateSeatHandlerFromNewIndex(e, t)
                  );
                },
              },
              {
                key: "updateSeatHandlerFromNewIndex",
                value: function (e, t) {
                  return U(
                    U({}, e),
                    {},
                    {
                      currentFocusSeatIndexOnCurrentGrid: t,
                      seatWithFocus: e.focusableSeats[t],
                    },
                  );
                },
              },
            ]),
            e
          );
        })(),
        q = (function () {
          function e() {
            a(this, e),
              (this.defaultTerms = [
                { termCode: "paoSeatmapUi.currency.EUR", termLabel: "\u20ac" },
              ]);
          }
          return (
            c(e, [
              {
                key: "computeTermsAndAddDefaultValues",
                value: function (e) {
                  var t = this.defaultTerms.filter(function (t) {
                    var n = t.termCode;
                    return !e.some(function (e) {
                      return e.termCode === n;
                    });
                  });
                  return e.concat(t).reduce(function (e, t) {
                    return U(U({}, e), {}, R({}, t.termCode, t.termLabel));
                  }, {});
                },
              },
            ]),
            e
          );
        })(),
        X = (function () {
          function e(t, n, r) {
            a(this, e),
              (this.seatSelectionService = t),
              (this.deckCoachManager = n),
              (this.managerType = r),
              (this.seatFocusManager = new G()),
              (this.passengerManager = new W()),
              (this.termsManager = new q()),
              (this.changeOrientation = this.changeOrientation.bind(this)),
              (this.initializeState = this.initializeState.bind(this)),
              (this.filterCoachesForCoachSelector =
                this.filterCoachesForCoachSelector.bind(this)),
              (this.selectCoach = this.selectCoach.bind(this)),
              (this.selectDeck = this.selectDeck.bind(this)),
              (this.closeErrorDialog = this.closeErrorDialog.bind(this)),
              (this.seatGetFocusByClick = this.seatGetFocusByClick.bind(this)),
              (this.moveFocusToNextSeat = this.moveFocusToNextSeat.bind(this)),
              (this.moveFocusToPreviousSeat =
                this.moveFocusToPreviousSeat.bind(this)),
              (this.moveFocusWithKeyBoard =
                this.moveFocusWithKeyBoard.bind(this)),
              (this.calculateTrainDirection =
                this.calculateTrainDirection.bind(this)),
              (this.calculateCoachAndDeckAvailability =
                this.calculateCoachAndDeckAvailability.bind(this)),
              (this.seatSelectionService = t),
              (this.deckCoachManager = n);
          }
          return (
            c(e, [
              {
                key: "changeOrientation",
                value: function (e, t) {
                  return e.display.isHorizontalDisplay === t
                    ? e
                    : (console.log(
                        "CONTEXT - changement d'affichage vers un affichage ".concat(
                          t ? "horizontale" : "verticale",
                          ".",
                        ),
                      ),
                      U(
                        U({}, e),
                        {},
                        {
                          display: U(
                            U({}, e.display),
                            {},
                            { isHorizontalDisplay: t },
                          ),
                        },
                      ));
                },
              },
              {
                key: "calculateCoachAndDeckAvailability",
                value: function (e) {
                  var t = function (e) {
                      return (
                        void 0 !== e.deckGrid &&
                        null !== e.deckGrid &&
                        void 0 !== e.deckGrid.deckCells &&
                        null !== e.deckGrid.deckCells &&
                        !e.full
                      );
                    },
                    n = function (e) {
                      return U(
                        U({}, e),
                        {},
                        {
                          decks: e.decks.map(function (e) {
                            return U(U({}, e), {}, { available: t(e) });
                          }),
                          full: e.decks.every(function (e) {
                            return !t(e);
                          }),
                        },
                      );
                    };
                  return U(
                    U({}, e),
                    {},
                    {
                      carriages: e.carriages.map(function (e) {
                        return U(U({}, e), {}, { coaches: e.coaches.map(n) });
                      }),
                    },
                  );
                },
              },
              {
                key: "initializeState",
                value: function (e, t, n) {
                  var r = this.calculateCoachAndDeckAvailability(t),
                    a = function (e) {
                      return e["@id"] === r.defaultDeck["@id"];
                    },
                    o = r.carriages.flatMap(function (e) {
                      return e.coaches;
                    }),
                    i = o.find(function (e) {
                      return void 0 !== e.decks.find(a);
                    }),
                    l = o[0];
                  void 0 !== i && (l = i);
                  var c = l.decks.find(a),
                    s = l.decks[0];
                  void 0 !== c && (s = c);
                  var u = null,
                    d = null,
                    p = n;
                  void 0 !== r.passengers &&
                    r.passengers.length > 0 &&
                    ((d = (u = r.passengers)[0]), (p = u.length));
                  var f = !1,
                    m = !1;
                  M.TRAIN_TYPES_WITH_PASSENGER_SEATMAP.includes(
                    r.trainCategory,
                  ) && ((f = !0), (m = !0));
                  var h = U(
                    U({}, e),
                    {},
                    {
                      immutable: U(
                        U({}, e.immutable),
                        {},
                        {
                          passengers: u,
                          trainType: r.trainCategory,
                          managerType: this.managerType,
                          terms:
                            this.termsManager.computeTermsAndAddDefaultValues(
                              r.terms,
                            ),
                          carriages: r.carriages,
                          coaches: r.coaches,
                          displayableElementsForCoachSelector:
                            this.filterCoachesForCoachSelector(r.carriages),
                          numberOfPassengers: p,
                          trainDirection: this.calculateTrainDirection(
                            r.carriages,
                          ),
                        },
                      ),
                      app: U(
                        U({}, e.app),
                        {},
                        {
                          currentCoach: l,
                          currentDeck: s,
                          currentPassenger: d,
                        },
                      ),
                      display: U(
                        U({}, e.display),
                        {},
                        {
                          seatFocusHolder:
                            this.seatFocusManager.updateFocusableSeatsWithDisplayedDeck(
                              e.display.seatFocusHolder,
                              s,
                            ),
                          displayPassenger: f,
                          displayAncillaryServices: m,
                        },
                      ),
                    },
                  );
                  return (
                    console.log("CONTEXT - chargement des donn\xe9es."),
                    console.debug("CONTEXT - newState : ", h),
                    h
                  );
                },
              },
              {
                key: "selectCoach",
                value: function (e, t) {
                  if (e.app.currentCoach === t) return e;
                  var n = this.deckCoachManager.validateCoachSelection(e, t);
                  if (null !== n)
                    return (
                      console.log(
                        "CONTEXT - la s\xe9lection du deck ".concat(
                          t.number,
                          " \xe0 rencontr\xe9 un probl\xe8me.",
                        ),
                      ),
                      console.debug("CONTEXT - error : ", n),
                      U(
                        U({}, e),
                        {},
                        {
                          display: U(
                            U({}, e.display),
                            {},
                            { errorDisplayHandler: n },
                          ),
                        },
                      )
                    );
                  var r = this.deckCoachManager.getNewDeck(e, t);
                  return (
                    console.log(
                      "CONTEXT - le coach ".concat(
                        t.number,
                        " a \xe9t\xe9 s\xe9lectionn\xe9.",
                      ),
                    ),
                    console.debug("CONTEXT - newSelectedCoach : ", t),
                    console.debug("CONTEXT - newSelectedDeck : ", r),
                    U(
                      U({}, e),
                      {},
                      {
                        app: U(
                          U({}, e.app),
                          {},
                          { currentDeck: r, currentCoach: t },
                        ),
                        display: U(
                          U({}, e.display),
                          {},
                          {
                            seatFocusHolder:
                              this.seatFocusManager.updateFocusableSeatsWithDisplayedDeck(
                                e.display.seatFocusHolder,
                                r,
                              ),
                          },
                        ),
                      },
                    )
                  );
                },
              },
              {
                key: "forceSelectCoach",
                value: function (e, t) {
                  var n = this.deckCoachManager.getNewDeck(e, t);
                  return (
                    console.log(
                      "CONTEXT - le coach ".concat(
                        t.number,
                        " a \xe9t\xe9 s\xe9lectionn\xe9.",
                      ),
                    ),
                    console.debug("CONTEXT - newSelectedCoach : ", t),
                    console.debug("CONTEXT - newSelectedDeck : ", n),
                    U(
                      U({}, e),
                      {},
                      {
                        app: U(
                          U({}, e.app),
                          {},
                          { currentDeck: n, currentCoach: t, placings: [] },
                        ),
                        display: U(
                          U({}, e.display),
                          {},
                          {
                            errorDisplayHandler: Z.noError(),
                            seatFocusHolder:
                              this.seatFocusManager.updateFocusableSeatsWithDisplayedDeck(
                                e.display.seatFocusHolder,
                                n,
                              ),
                          },
                        ),
                      },
                    )
                  );
                },
              },
              {
                key: "selectDeck",
                value: function (e, t) {
                  if (e.app.currentDeck === t) return e;
                  var n = this.deckCoachManager.validateDeckSelection(e, t);
                  return null !== n
                    ? (console.log(
                        "CONTEXT - la s\xe9lection du deck ".concat(
                          t["@id"],
                          " \xe0 rencontr\xe9 un probl\xe8me.",
                        ),
                      ),
                      console.debug("CONTEXT - error : ", n),
                      U(
                        U({}, e),
                        {},
                        {
                          display: U(
                            U({}, e.display),
                            {},
                            { errorDisplayHandler: n },
                          ),
                        },
                      ))
                    : (console.log(
                        "CONTEXT - le deck ".concat(
                          t.deckType,
                          " a \xe9t\xe9 s\xe9lectionn\xe9.",
                        ),
                      ),
                      console.debug("CONTEXT - newSelectedDeck : ", t),
                      U(
                        U({}, e),
                        {},
                        {
                          app: U(U({}, e.app), {}, { currentDeck: t }),
                          display: U(
                            U({}, e.display),
                            {},
                            {
                              seatFocusHolder:
                                this.seatFocusManager.updateFocusableSeatsWithDisplayedDeck(
                                  e.display.seatFocusHolder,
                                  t,
                                ),
                            },
                          ),
                        },
                      ));
                },
              },
              {
                key: "forceSelectDeck",
                value: function (e, t) {
                  return (
                    console.log(
                      "CONTEXT - le deck ".concat(
                        t.deckType,
                        " a \xe9t\xe9 s\xe9lectionn\xe9.",
                      ),
                    ),
                    console.debug("CONTEXT - newSelectedDeck : ", t),
                    U(
                      U({}, e),
                      {},
                      {
                        app: U(
                          U({}, e.app),
                          {},
                          { currentDeck: t, placings: [] },
                        ),
                        display: U(
                          U({}, e.display),
                          {},
                          {
                            errorDisplayHandler: Z.noError(),
                            seatFocusHolder:
                              this.seatFocusManager.updateFocusableSeatsWithDisplayedDeck(
                                e.display.seatFocusHolder,
                                t,
                              ),
                          },
                        ),
                      },
                    )
                  );
                },
              },
              {
                key: "closeErrorDialog",
                value: function (e) {
                  var t = U({}, e.app.currentDeck),
                    n = U({}, e.app.currentCoach);
                  return (
                    (e.display.errorDisplayHandler.errorId !==
                      N.SEATS_IN_DIFFERENT_DECKS &&
                      e.display.errorDisplayHandler.errorId !==
                        N.SEATS_IN_DIFFERENT_COACH) ||
                      ((n = e.app.placings[0].coach),
                      (t = e.app.placings[0].deck)),
                    console.log('CONTEXT - fermeture de "errorDialog".'),
                    console.debug(
                      "CONTEXT - seatFocusHolder",
                      e.display.seatFocusHolder,
                    ),
                    console.debug("CONTEXT - currentDeck", t),
                    console.debug("CONTEXT - currentCoach", n),
                    U(
                      U({}, e),
                      {},
                      {
                        display: U(
                          U({}, e.display),
                          {},
                          {
                            errorDisplayHandler: Z.noError(),
                            seatFocusHolder: U(
                              U({}, e.display.seatFocusHolder),
                              {},
                              {
                                seatWithFocus:
                                  e.display.seatFocusHolder.seatWithFocus,
                              },
                            ),
                          },
                        ),
                        app: U(
                          U({}, e.app),
                          {},
                          { currentCoach: n, currentDeck: t },
                        ),
                      },
                    )
                  );
                },
              },
              {
                key: "seatGetFocusByClick",
                value: function (e, t) {
                  if (null !== t)
                    return U(
                      U({}, e),
                      {},
                      {
                        display: U(
                          U({}, e.display),
                          {},
                          {
                            seatFocusHolder:
                              this.seatFocusManager.seatGetFocusByClick(
                                e.display.seatFocusHolder,
                                t,
                              ),
                          },
                        ),
                      },
                    );
                  var n = e.app.currentDeck.deckGrid.deckCells.find(
                    function (e) {
                      return !(!e.seat || !e.seat.available) && e.seat;
                    },
                  );
                  return void 0 === n
                    ? e
                    : U(
                        U({}, e),
                        {},
                        {
                          display: U(
                            U({}, e.display),
                            {},
                            {
                              seatFocusHolder:
                                this.seatFocusManager.seatGetFocusByClick(
                                  e.display.seatFocusHolder,
                                  n.seat,
                                ),
                            },
                          ),
                        },
                      );
                },
              },
              {
                key: "moveFocusToNextSeat",
                value: function (e) {
                  return this.moveFocusWithKeyBoard(
                    e,
                    this.seatFocusManager.moveFocusToNextSeat,
                  );
                },
              },
              {
                key: "moveFocusToPreviousSeat",
                value: function (e) {
                  return this.moveFocusWithKeyBoard(
                    e,
                    this.seatFocusManager.moveFocusToPreviousSeat,
                  );
                },
              },
              {
                key: "moveFocusWithKeyBoard",
                value: function (e, t) {
                  var n = t(e.display.seatFocusHolder),
                    r = this.seatSelectionService.autoSelectSeatOnFocus(
                      e,
                      n.seatWithFocus,
                    );
                  return U(
                    U({}, e),
                    {},
                    {
                      app: U(U({}, e.app), {}, { placings: r }),
                      display: U(U({}, e.display), {}, { seatFocusHolder: n }),
                    },
                  );
                },
              },
              {
                key: "selectSeat",
                value: function (e, t) {
                  var n = this.seatSelectionService.validateSeatSelection(e, t);
                  if (null !== n)
                    return (
                      console.log(
                        "CONTEXT - la s\xe9lection du seat ".concat(
                          t.seatNumber,
                          " \xe0 rencontr\xe9 un probl\xe8me.",
                        ),
                      ),
                      console.debug("CONTEXT - error : ", n),
                      U(
                        U({}, e),
                        {},
                        {
                          display: U(
                            U({}, e.display),
                            {},
                            {
                              errorDisplayHandler: n,
                              seatFocusHolder: U(
                                U({}, e.display.seatFocusHolder),
                                {},
                                {
                                  currentFocusSeatIndexOnCurrentGrid: -1,
                                  seatWithFocus: void 0,
                                },
                              ),
                            },
                          ),
                        },
                      )
                    );
                  var r = this.seatSelectionService.selectSeat(e, t),
                    a = e.app.currentPassenger;
                  return (
                    r.length >= e.app.placings.length &&
                      ((a = this.passengerManager.getNextCurrentPassenger(
                        e,
                        r,
                        t,
                      )),
                      console.log(
                        "CONTEXT - le seat ".concat(
                          t.seatNumber,
                          " a \xe9t\xe9 s\xe9lectionn\xe9.",
                        ),
                      )),
                    U(
                      U({}, e),
                      {},
                      {
                        app: U(
                          U({}, e.app),
                          {},
                          { placings: r, currentPassenger: a },
                        ),
                      },
                    )
                  );
                },
              },
              {
                key: "forceSelectSeat",
                value: function (e, t) {
                  var n = this.seatSelectionService.selectSeat(e, t),
                    r = this.passengerManager.getNextCurrentPassenger(e, n, t);
                  return (
                    console.log(
                      "CONTEXT - le seat ".concat(
                        t.seatNumber,
                        " a \xe9t\xe9 s\xe9lectionn\xe9.",
                      ),
                    ),
                    console.debug("CONTEXT - placings : ", n),
                    U(
                      U({}, e),
                      {},
                      {
                        app: U(
                          U({}, e.app),
                          {},
                          { placings: n, currentPassenger: r },
                        ),
                        display: U(
                          U({}, e.display),
                          {},
                          { errorDisplayHandler: Z.noError() },
                        ),
                      },
                    )
                  );
                },
              },
              {
                key: "selectCurrentPassenger",
                value: function (e, t) {
                  return U(
                    U({}, e),
                    {},
                    { app: U(U({}, e.app), {}, { currentPassenger: t }) },
                  );
                },
              },
              {
                key: "removeAllPlacings",
                value: function (e) {
                  return U(
                    U({}, e),
                    {},
                    { app: U(U({}, e.app), {}, { placings: [] }) },
                  );
                },
              },
              {
                key: "removePlacing",
                value: function (e, t) {
                  return U(
                    U({}, e),
                    {},
                    {
                      app: U(
                        U({}, e.app),
                        {},
                        {
                          placings:
                            this.seatSelectionService.removePlacingOfPassenger(
                              e.app.placings,
                              t,
                            ),
                        },
                      ),
                    },
                  );
                },
              },
            ]),
            e
          );
        })();
      function _(e) {
        return (
          (function (e) {
            if (Array.isArray(e)) return v(e);
          })(e) ||
          (function (e) {
            if (
              ("undefined" !== typeof Symbol && null != e[Symbol.iterator]) ||
              null != e["@@iterator"]
            )
              return Array.from(e);
          })(e) ||
          b(e) ||
          (function () {
            throw new TypeError(
              "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
            );
          })()
        );
      }
      var Y = (function () {
          function e(t) {
            a(this, e), (this.action = t);
          }
          return (
            c(e, [
              {
                key: "applyToState",
                value: function (e, t) {
                  return this.action(e, t);
                },
              },
            ]),
            e
          );
        })(),
        J = (function () {
          function e() {
            a(this, e);
          }
          return (
            c(e, null, [
              {
                key: "changeOrientation",
                value: function (e) {
                  return new Y(function (t, n) {
                    return t.changeOrientation(n, e);
                  });
                },
              },
              {
                key: "initState",
                value: function (e, t) {
                  return new Y(function (n, r) {
                    return n.initializeState(r, e, t);
                  });
                },
              },
              {
                key: "changeSelectedSeat",
                value: function (e) {
                  return new Y(function (t, n) {
                    return t.selectSeat(n, e);
                  });
                },
              },
              {
                key: "forceChangeSelectedSeat",
                value: function (e) {
                  return new Y(function (t, n) {
                    return t.forceSelectSeat(n, e);
                  });
                },
              },
              {
                key: "changeSelectedCoach",
                value: function (e) {
                  return new Y(function (t, n) {
                    return t.selectCoach(n, e);
                  });
                },
              },
              {
                key: "forceChangeSelectedCoach",
                value: function (e) {
                  return new Y(function (t, n) {
                    return t.forceSelectCoach(n, e);
                  });
                },
              },
              {
                key: "changeSelectedDeck",
                value: function (e) {
                  return new Y(function (t, n) {
                    return t.selectDeck(n, e);
                  });
                },
              },
              {
                key: "forceChangeSelectedDeck",
                value: function (e) {
                  return new Y(function (t, n) {
                    return t.forceSelectDeck(n, e);
                  });
                },
              },
              {
                key: "seatGetFocusBySystem",
                value: function (e) {
                  return new Y(function (t, n) {
                    return t.seatGetFocusByClick(n, e);
                  });
                },
              },
              {
                key: "changeFocusToPreviousSeat",
                value: function () {
                  return new Y(function (e, t) {
                    return e.moveFocusToPreviousSeat(t);
                  });
                },
              },
              {
                key: "changeFocusToNextSeat",
                value: function () {
                  return new Y(function (e, t) {
                    return e.moveFocusToNextSeat(t);
                  });
                },
              },
              {
                key: "closeErrorDialog",
                value: function () {
                  return new Y(function (e, t) {
                    return e.closeErrorDialog(t);
                  });
                },
              },
              {
                key: "selectCurrentPassenger",
                value: function (e) {
                  return new Y(function (t, n) {
                    return t.selectCurrentPassenger(n, e);
                  });
                },
              },
              {
                key: "removeAllPlacings",
                value: function () {
                  return new Y(function (e, t) {
                    return e.removeAllPlacings(t);
                  });
                },
              },
              {
                key: "removePlacing",
                value: function (e) {
                  return new Y(function (t, n) {
                    return t.removePlacing(n, e);
                  });
                },
              },
            ]),
            e
          );
        })(),
        K = (function () {
          function e() {
            a(this, e);
          }
          return (
            c(e, [
              {
                key: "selectSeat",
                value: function (e, t) {
                  var n,
                    r = {
                      passenger: e.app.currentPassenger,
                      seat: t,
                      deck: e.app.currentDeck,
                      coach: e.app.currentCoach,
                    },
                    a = _(e.app.placings);
                  if (1 === e.immutable.numberOfPassengers)
                    return 1 ===
                      (null === (n = e.app.placings) || void 0 === n
                        ? void 0
                        : n.length) &&
                      this.areEqualPlacings(r, e.app.placings[0])
                      ? []
                      : [r];
                  if (
                    null === e.immutable.passengers ||
                    null === e.app.currentPassenger
                  )
                    this.isSeatAlreadySelected(a, r)
                      ? (a = this.removePlacingOfSeat(a, r))
                      : a.push(r);
                  else {
                    var o,
                      i = this.getPlacingOnSameSeat(a, r);
                    if (void 0 !== i)
                      (a = this.removePlacingOfSeat(a, i)),
                        (null === (o = i.passenger) || void 0 === o
                          ? void 0
                          : o.rank) !== e.app.currentPassenger.rank &&
                          (a = this.removePlacingOfPassenger(
                            a,
                            e.app.currentPassenger,
                          )).push(r);
                    else
                      (a = this.removePlacingOfPassenger(
                        a,
                        e.app.currentPassenger,
                      )).push(r);
                  }
                  return a;
                },
              },
              {
                key: "isSeatAvailable",
                value: function (e, t) {
                  var n = this,
                    r = {
                      passenger: e.app.currentPassenger,
                      seat: t,
                      deck: e.app.currentDeck,
                      coach: e.app.currentCoach,
                    };
                  return !e.app.placings.some(function (e) {
                    return n.areEqualPlacings(e, r);
                  });
                },
              },
              {
                key: "autoSelectSeatOnFocus",
                value: function (e, t) {
                  return 1 === e.immutable.numberOfPassengers
                    ? this.selectSeat(e, t)
                    : e.app.placings;
                },
              },
              {
                key: "passengerPlacementIsAllowed",
                value: function (e, t) {
                  return e.length < t;
                },
              },
              {
                key: "isSeatAlreadySelected",
                value: function (e, t) {
                  var n = this;
                  return e.some(function (e) {
                    return n.areEqualPlacings(e, t);
                  });
                },
              },
              {
                key: "getPlacingOnSameSeat",
                value: function (e, t) {
                  var n = this;
                  return e.find(function (e) {
                    return n.areEqualPlacings(e, t);
                  });
                },
              },
              {
                key: "areEqualPlacings",
                value: function (e, t) {
                  return (
                    e.seat.id === t.seat.id && e.deck["@id"] === t.deck["@id"]
                  );
                },
              },
              {
                key: "removePlacingOfSeat",
                value: function (e, t) {
                  var n = this;
                  return e.filter(function (e) {
                    return !n.areEqualPlacings(e, t);
                  });
                },
              },
              {
                key: "removePlacingOfPassenger",
                value: function (e, t) {
                  return e.filter(function (e) {
                    return null !== e.passenger && e.passenger.rank !== t.rank;
                  });
                },
              },
              {
                key: "isSeatInAnotherDeck",
                value: function (e, t) {
                  return (
                    !!e.app.placings.length &&
                    !e.app.placings
                      .map(function (e) {
                        return e.deck;
                      })
                      .some(function (e) {
                        return e["@id"] === t.deck["@id"];
                      })
                  );
                },
              },
              {
                key: "isSeatInAnotherCoach",
                value: function (e, t) {
                  return (
                    !!e.app.placings.length &&
                    !e.app.placings
                      .map(function (e) {
                        return e.coach;
                      })
                      .some(function (e) {
                        return e.number === t.coach.number;
                      })
                  );
                },
              },
              {
                key: "validateSeatSelection",
                value: function (e, t) {
                  var n = {
                    passenger: e.app.currentPassenger,
                    seat: t,
                    deck: e.app.currentDeck,
                    coach: e.app.currentCoach,
                  };
                  if (1 === e.immutable.numberOfPassengers) return null;
                  var r,
                    a,
                    o = this.getPlacingOnSameSeat(e.app.placings, n);
                  return void 0 !== o
                    ? (null === (r = o.passenger) || void 0 === r
                        ? void 0
                        : r.rank) ===
                      (null === (a = n.passenger) || void 0 === a
                        ? void 0
                        : a.rank)
                      ? null
                      : {
                          displayError: !0,
                          errorId: N.SEAT_ALREADY_TAKEN,
                          confirmEvent: J.forceChangeSelectedSeat(t),
                        }
                    : this.isSeatInAnotherCoach(e, n)
                      ? {
                          displayError: !0,
                          errorId: N.SEATS_IN_DIFFERENT_COACH,
                          confirmEvent: null,
                        }
                      : this.isSeatInAnotherDeck(e, n)
                        ? {
                            displayError: !0,
                            errorId: N.SEATS_IN_DIFFERENT_DECKS,
                            confirmEvent: null,
                          }
                        : this.passengerPlacementIsAllowed(
                              e.app.placings,
                              e.immutable.numberOfPassengers,
                            )
                          ? null
                          : {
                              displayError: !0,
                              errorId: N.ALL_SEATS_ARE_ALREADY_SELECTED,
                              confirmEvent: null,
                            };
                },
              },
            ]),
            e
          );
        })(),
        Q = (function () {
          function e() {
            a(this, e);
          }
          return (
            c(e, [
              {
                key: "validateDeckSelection",
                value: function (e, t) {
                  return null;
                },
              },
              {
                key: "validateCoachSelection",
                value: function (e, t) {
                  return null;
                },
              },
              {
                key: "getNewDeck",
                value: function (e, t) {
                  var n = e.app.currentDeck.deckType,
                    r =
                      t.decks.find(function (e) {
                        return e.available;
                      }) || t.decks[0];
                  return (
                    t.decks.find(function (e) {
                      return e.deckType === n && e.available;
                    }) || r
                  );
                },
              },
            ]),
            e
          );
        })();
      function $(e, t, n, r, a) {
        var o, i;
        switch (t) {
          case D.DUO:
            o = (function (e) {
              return [
                {
                  style: "legendAvailable",
                  svg: z.STANDARD_SEAT,
                  legend: e["paoSeatmapUi.paoLegend.seat.STANDARD"],
                },
                {
                  style: "legendAvailable",
                  svg: z.XL_SEAT,
                  legend: e["paoSeatmapUi.paoLegend.seat.XL"],
                },
                {
                  style: "legendAvailable",
                  svg: z.AVAILABLE_DUO_SEAT,
                  legend: e["paoSeatmapUi.paoLegend.available"],
                },
                {
                  style: "legendUnvailable",
                  svg: z.UNAVAILABLE_DUO_SEAT,
                  legend: e["paoSeatmapUi.paoLegend.unavailable"],
                },
                {
                  style: "legendSelected",
                  svg: z.SELECTED_DUO_SEAT,
                  legend: e["paoSeatmapUi.paoLegend.selected"],
                },
              ];
            })(e);
            break;
          case D.MONO:
          default:
            o = (function (e) {
              return [
                {
                  style: "legendAvailable",
                  svg: z.AVAILABLE_MONO_SEAT,
                  legend: e["paoSeatmapUi.paoLegend.available"],
                },
                {
                  style: "legendUnvailable",
                  svg: z.UNAVAILABLE_MONO_SEAT,
                  legend: e["paoSeatmapUi.paoLegend.unavailable"],
                },
                {
                  style: "legendSelected",
                  svg: z.SELECTED_MONO_SEAT,
                  legend: e["paoSeatmapUi.paoLegend.selected"],
                },
              ];
            })(e);
        }
        (o.push({
          style: "legendExit",
          svg: z.EXIT,
          legend: e["paoSeatmapUi.paoLegend.exit"],
        }),
        n &&
          o.push({
            style: "",
            svg: z.TRAIN_DIRECTION,
            legend: ""
              .concat(e["paoSeatmapUi.paoLegend.trainDirection"], "<br><small>")
              .concat(
                e["paoSeatmapUi.paoLegend.trainDirectionTerms"],
                "</small>",
              ),
          }),
        a) && (i = o).push.apply(i, _(a));
        return (
          r &&
            o.push({
              style: "delete",
              svg: z.DELETE_SELECTION,
              legend: e["paoSeatmapUi.paoLegend.deleteSeat"],
            }),
          o
        );
      }
      var ee = (function (e) {
          d(n, e);
          var t = m(n);
          function n() {
            return a(this, n), t.call(this, new K(), new Q(), P.TGV_IC);
          }
          return (
            c(
              n,
              [
                {
                  key: "initializeState",
                  value: function (e, t, r) {
                    var a = H(p(n.prototype), "initializeState", this).call(
                      this,
                      e,
                      t,
                      r,
                    );
                    return (
                      (a.immutable.legendContent = $(
                        a.immutable.terms,
                        D.MONO,
                        a.immutable.trainDirection.displayTrainDirection,
                        a.display.displayPassenger,
                      )),
                      a
                    );
                  },
                },
                {
                  key: "calculateTrainDirection",
                  value: function (e) {
                    var t = e
                      .flatMap(function (e) {
                        return e.coaches;
                      })
                      .filter(n.filterCoachOnFirstClass())
                      .find(function (e) {
                        return e.coachDirection !== M.COACH_ORIENTATION.EAST;
                      })
                      ? M.COACH_ORIENTATION.UNKNOWN
                      : M.COACH_ORIENTATION.EAST;
                    return {
                      displayTrainDirection: t === M.COACH_ORIENTATION.EAST,
                      trainDirectionCode: t,
                    };
                  },
                },
                {
                  key: "filterCoachesForCoachSelector",
                  value: function (e) {
                    return e.map(function (e) {
                      return U(
                        U({}, e),
                        {},
                        {
                          coaches: e.coaches.filter(
                            n.filterCoachOnFirstClass(),
                          ),
                        },
                      );
                    });
                  },
                },
                {
                  key: "calculateCoachAndDeckAvailability",
                  value: function (e) {
                    var t = H(
                        p(n.prototype),
                        "calculateCoachAndDeckAvailability",
                        this,
                      ).call(this, e),
                      r = function (e) {
                        return e.travelClass === M.COACH_TRAVEL_CLASS.FIRST
                          ? U({}, e)
                          : U(
                              U({}, e),
                              {},
                              {
                                full: !0,
                                decks: e.decks.map(function (e) {
                                  return U(U({}, e), {}, { available: !1 });
                                }),
                              },
                            );
                      };
                    return U(
                      U({}, t),
                      {},
                      {
                        carriages: t.carriages.map(function (e) {
                          return U(U({}, e), {}, { coaches: e.coaches.map(r) });
                        }),
                      },
                    );
                  },
                },
              ],
              [
                {
                  key: "filterCoachOnFirstClass",
                  value: function () {
                    return function (e) {
                      return e.travelClass === M.COACH_TRAVEL_CLASS.FIRST;
                    };
                  },
                },
              ],
            ),
            n
          );
        })(X),
        te = (function (e) {
          d(n, e);
          var t = m(n);
          function n() {
            return a(this, n), t.apply(this, arguments);
          }
          return (
            c(n, [
              {
                key: "passengerPlacementIsAllowed",
                value: function (e, t) {
                  return !0;
                },
              },
            ]),
            n
          );
        })(K),
        ne = (function (e) {
          d(n, e);
          var t = m(n);
          function n() {
            return a(this, n), t.apply(this, arguments);
          }
          return (
            c(n, [
              {
                key: "validateDeckSelection",
                value: function (e, t) {
                  var n;
                  return e.app.placings.length > 0 &&
                    1 !==
                      (null === (n = e.immutable.passengers) || void 0 === n
                        ? void 0
                        : n.length)
                    ? {
                        displayError: !0,
                        errorId: N.CHANGING_DECK_WITH_SELECTED_SEAT,
                        confirmEvent: J.forceChangeSelectedDeck(t),
                      }
                    : null;
                },
              },
              {
                key: "validateCoachSelection",
                value: function (e, t) {
                  var n;
                  return e.app.placings.length > 0 &&
                    1 !==
                      (null === (n = e.immutable.passengers) || void 0 === n
                        ? void 0
                        : n.length)
                    ? {
                        displayError: !0,
                        errorId: N.CHANGING_COACH_WITH_SELECTED_SEAT,
                        confirmEvent: J.forceChangeSelectedCoach(t),
                      }
                    : null;
                },
              },
            ]),
            n
          );
        })(Q),
        re = ne,
        ae = (function (e) {
          d(n, e);
          var t = m(n);
          function n(e) {
            return a(this, n), t.call(this, new te(), new re(), e);
          }
          return (
            c(n, [
              {
                key: "calculateTrainDirection",
                value: function () {
                  return Z.noTrainDirection();
                },
              },
              {
                key: "filterCoachesForCoachSelector",
                value: function (e) {
                  return e;
                },
              },
              {
                key: "initializeState",
                value: function (e, t, r) {
                  var a = H(p(n.prototype), "initializeState", this).call(
                      this,
                      e,
                      t,
                      r,
                    ),
                    o = a.immutable.terms;
                  return (
                    (a.immutable.legendContent = $(
                      o,
                      D.MONO,
                      a.immutable.trainDirection.displayTrainDirection,
                      a.display.displayPassenger,
                      [
                        {
                          style: "electric-plug",
                          svg: z.ELECTRIC_PLUG,
                          legend: o["paoSeatmapUi.paoLegend.seat.POWER_PLUG"],
                        },
                        {
                          style: "solo-seat",
                          svg: z.SOLO_SEAT,
                          legend: o["paoSeatmapUi.paoLegend.seat.SOLO"],
                        },
                      ],
                    )),
                    a
                  );
                },
              },
            ]),
            n
          );
        })(X),
        oe = (function (e) {
          d(n, e);
          var t = m(n);
          function n() {
            return a(this, n), t.call(this, new te(), new re(), P.OUIGO_ESP);
          }
          return (
            c(n, [
              {
                key: "calculateTrainDirection",
                value: function () {
                  return Z.noTrainDirection();
                },
              },
              {
                key: "filterCoachesForCoachSelector",
                value: function (e) {
                  return e;
                },
              },
              {
                key: "initializeState",
                value: function (e, t, r) {
                  var a = H(p(n.prototype), "initializeState", this).call(
                    this,
                    e,
                    t,
                    r,
                  );
                  return (
                    (a.immutable.legendContent = $(
                      a.immutable.terms,
                      D.DUO,
                      a.immutable.trainDirection.displayTrainDirection,
                      a.display.displayPassenger,
                    )),
                    a
                  );
                },
              },
            ]),
            n
          );
        })(X),
        ie = (function (e) {
          d(n, e);
          var t = m(n);
          function n(e) {
            return a(this, n), t.call(this, new te(), new re(), e);
          }
          return (
            c(n, [
              {
                key: "calculateTrainDirection",
                value: function () {
                  return Z.noTrainDirection();
                },
              },
              {
                key: "filterCoachesForCoachSelector",
                value: function (e) {
                  return e;
                },
              },
              {
                key: "initializeState",
                value: function (e, t, r) {
                  var a = H(p(n.prototype), "initializeState", this).call(
                      this,
                      e,
                      t,
                      r,
                    ),
                    o = a.immutable.terms;
                  return (
                    (a.immutable.legendContent = $(
                      o,
                      D.MONO,
                      a.immutable.trainDirection.displayTrainDirection,
                      a.display.displayPassenger,
                      [],
                    )),
                    a
                  );
                },
              },
            ]),
            n
          );
        })(X),
        le = (function () {
          function e() {
            a(this, e);
          }
          return (
            c(e, null, [
              {
                key: "getStateManager",
                value: function (e) {
                  switch (e) {
                    case "TGV":
                    case "IC":
                      return new ee();
                    case "OUIGO":
                      return new ae(P.OUIGO);
                    case "OUIGO_ESP":
                      return new oe();
                    case "OUIGO_LC":
                      return new ie(P.OUIGO_LC);
                    default:
                      throw new Error(
                        "Can't resolve state manager for ".concat(e),
                      );
                  }
                },
              },
            ]),
            e
          );
        })(),
        ce = n(184),
        se = {
          immutable: Z.defaultImmutableData(),
          display: Z.defaultDisplayData(),
          app: Z.defaultApplicationData(),
        };
      var ue,
        de = (0, e.createContext)(se),
        pe = (0, e.createContext)(function () {
          return null;
        }),
        fe = function (t) {
          var n = (0, e.useReducer)(
              (function (e) {
                var t = le.getStateManager(e);
                return function (e, n) {
                  return n.applyToState(t, e);
                };
              })(t.trainType),
              se,
            ),
            r = I(n, 2),
            a = r[0],
            o = r[1];
          return (0, ce.jsx)(pe.Provider, {
            value: o,
            children: (0, ce.jsx)(de.Provider, {
              value: a,
              children: t.children,
            }),
          });
        },
        me = function () {
          return (0, e.useContext)(pe);
        },
        he = function () {
          return (0, e.useContext)(de);
        },
        ge = function () {
          return he().immutable;
        },
        ve = function () {
          return he().display;
        },
        be = function () {
          return he().app;
        },
        ye = function (e) {
          var t = e.id,
            n = e.text,
            r = e.separator,
            a = void 0 === r ? " " : r,
            o = Array.isArray(n)
              ? n
                  .filter(function (e) {
                    return void 0 !== e;
                  })
                  .join(a)
              : n;
          return (0, ce.jsx)("div", {
            id: t,
            style: { display: "none" },
            "aria-hidden": "false",
            children: o,
          });
        },
        xe = function (e) {
          var t = e.id,
            n = e.label,
            r = e.description,
            a = void 0 === r ? "" : r,
            o = e.separator,
            i = void 0 === o ? " " : o,
            l = Array.isArray(n)
              ? n
                  .filter(function (e) {
                    return void 0 !== e;
                  })
                  .join(i)
              : n,
            c = Array.isArray(a)
              ? a
                  .filter(function (e) {
                    return void 0 !== e;
                  })
                  .join(i)
              : a;
          return (0, ce.jsxs)(ce.Fragment, {
            children: [
              (0, ce.jsx)(ye, { id: we.getLabel(t), text: l, separator: i }),
              !!a &&
                (0, ce.jsx)(ye, {
                  id: we.getDescription(t),
                  text: c,
                  separator: i,
                }),
            ],
          });
        },
        we = (function () {
          function e() {
            a(this, e);
          }
          return (
            c(e, null, [
              {
                key: "getLabel",
                value: function (t) {
                  return e.sanitizeId(t) + "Label";
                },
              },
              {
                key: "getDescription",
                value: function (t) {
                  return e.sanitizeId(t) + "Description";
                },
              },
              {
                key: "sanitizeId",
                value: function (e) {
                  return e.replace(/(Description|Label)$/i, "");
                },
              },
            ]),
            e
          );
        })(),
        ke = ["title", "titleId"];
      function Se() {
        return (
          (Se = Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }),
          Se.apply(this, arguments)
        );
      }
      function Ce(e, t) {
        if (null == e) return {};
        var n,
          r,
          a = (function (e, t) {
            if (null == e) return {};
            var n,
              r,
              a = {},
              o = Object.keys(e);
            for (r = 0; r < o.length; r++)
              (n = o[r]), t.indexOf(n) >= 0 || (a[n] = e[n]);
            return a;
          })(e, t);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          for (r = 0; r < o.length; r++)
            (n = o[r]),
              t.indexOf(n) >= 0 ||
                (Object.prototype.propertyIsEnumerable.call(e, n) &&
                  (a[n] = e[n]));
        }
        return a;
      }
      function Ee(t, n) {
        var r = t.title,
          a = t.titleId,
          o = Ce(t, ke);
        return e.createElement(
          "svg",
          Se({ viewBox: "0 0 40 80", ref: n, "aria-labelledby": a }, o),
          r ? e.createElement("title", { id: a }, r) : null,
          ue ||
            (ue = e.createElement("path", {
              stroke: "none",
              d: "M23.247302 5.63131l-3.239023-3.2183-3.254323 3.309158c-.15175.152068-.234957.35387-.234957.568742 0 .214872.08384.416992.234637.567147.15175.152707.353232.23687.568105.23687h.000318c.213278 0 .41476-.083205.570335-.237826 0 0 .663745-.682553 1.305173-1.338964v4.091177c0 .443134.359927.803698.802742.803698.442815 0 .802742-.36088.802742-.803697V5.477648c.639515.631864 1.306448 1.288275 1.306448 1.288595.302224.304455.831116.306686 1.13589.00322.31306-.312744.314656-.82187.0019-1.13812zM16.752722 75.812767l3.23902 3.2183 3.254324-3.30916c.15175-.152066.234956-.353868.234956-.56874s-.08384-.416993-.234638-.567148c-.15175-.152706-.35323-.23687-.568104-.23687h-.000318c-.213278 0-.41476.0832-.570336.237826 0 0-.663744.682554-1.305172 1.338966v-4.091178c0-.443133-.359927-.803698-.802743-.803698-.442813 0-.80274.360883-.80274.803698v4.131665c-.639515-.631865-1.306447-1.288277-1.306447-1.288596-.302223-.304455-.831115-.306686-1.135888-.0032-.313063.312743-.314658.82187-.0019 1.13812z",
            })),
        );
      }
      var Oe,
        Ae = e.forwardRef(Ee),
        je = (n.p, ["title", "titleId"]);
      function Le() {
        return (
          (Le = Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }),
          Le.apply(this, arguments)
        );
      }
      function Ne(e, t) {
        if (null == e) return {};
        var n,
          r,
          a = (function (e, t) {
            if (null == e) return {};
            var n,
              r,
              a = {},
              o = Object.keys(e);
            for (r = 0; r < o.length; r++)
              (n = o[r]), t.indexOf(n) >= 0 || (a[n] = e[n]);
            return a;
          })(e, t);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          for (r = 0; r < o.length; r++)
            (n = o[r]),
              t.indexOf(n) >= 0 ||
                (Object.prototype.propertyIsEnumerable.call(e, n) &&
                  (a[n] = e[n]));
        }
        return a;
      }
      function Te(t, n) {
        var r = t.title,
          a = t.titleId,
          o = Ne(t, je);
        return e.createElement(
          "svg",
          Le({ viewBox: "0 0 40 40", ref: n, "aria-labelledby": a }, o),
          r ? e.createElement("title", { id: a }, r) : null,
          Oe ||
            (Oe = e.createElement("path", {
              stroke: "none",
              d: "M36.23651 16.091493L20.041395-.000002 3.769785 16.545783c-.75875.76034-1.174785 1.769345-1.174785 2.84371 0 1.07436.4192 2.08496 1.173185 2.835735.75875.763535 1.76616 1.18435 2.840525 1.18435h.00159c1.06639 0 2.073805-.416 2.851675-1.189125 0 0 3.318725-3.412775 6.525865-6.69483v20.455885c0 2.21567 1.799635 4.01849 4.01371 4.01849 2.214075 0 4.01371-1.80441 4.01371-4.01849V15.323183c3.197575 3.15932 6.53224 6.441375 6.53224 6.442975 1.51112 1.522275 4.15558 1.53343 5.679445.016 1.56531-1.56372 1.573285-4.10935.0095-5.690605z",
            })),
        );
      }
      var Pe,
        De = e.forwardRef(Te),
        ze = (n.p, ["title", "titleId"]);
      function Me() {
        return (
          (Me = Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }),
          Me.apply(this, arguments)
        );
      }
      function Ie(e, t) {
        if (null == e) return {};
        var n,
          r,
          a = (function (e, t) {
            if (null == e) return {};
            var n,
              r,
              a = {},
              o = Object.keys(e);
            for (r = 0; r < o.length; r++)
              (n = o[r]), t.indexOf(n) >= 0 || (a[n] = e[n]);
            return a;
          })(e, t);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          for (r = 0; r < o.length; r++)
            (n = o[r]),
              t.indexOf(n) >= 0 ||
                (Object.prototype.propertyIsEnumerable.call(e, n) &&
                  (a[n] = e[n]));
        }
        return a;
      }
      function Re(t, n) {
        var r = t.title,
          a = t.titleId,
          o = Ie(t, ze);
        return e.createElement(
          "svg",
          Me({ viewBox: "0 0 80 80", ref: n, "aria-labelledby": a }, o),
          r ? e.createElement("title", { id: a }, r) : null,
          Pe ||
            (Pe = e.createElement("path", {
              stroke: "none",
              d: "M15.6 72.1H63c5.7 0 10.3-4.6 10.3-10.3v-27.6c0-5.7-4.6-10.3-10.3-10.3h-6.8c-0.5-8.9-7.9-16-16.9-16-9 0-16.4 7.1-16.9 16H15.6c-5.7 0-10.3 4.6-10.3 10.3v27.6c0 5.7 4.6 10.3 10.3 10.3zm23.7-59.5c6.4 0 11.7 5 12.1 11.2H27.2c0.5-6.3 5.7-11.2 12.1-11.2z",
            })),
        );
      }
      var Fe,
        Ue = e.forwardRef(Re),
        He = (n.p, ["title", "titleId"]);
      function Be() {
        return (
          (Be = Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }),
          Be.apply(this, arguments)
        );
      }
      function Ve(e, t) {
        if (null == e) return {};
        var n,
          r,
          a = (function (e, t) {
            if (null == e) return {};
            var n,
              r,
              a = {},
              o = Object.keys(e);
            for (r = 0; r < o.length; r++)
              (n = o[r]), t.indexOf(n) >= 0 || (a[n] = e[n]);
            return a;
          })(e, t);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          for (r = 0; r < o.length; r++)
            (n = o[r]),
              t.indexOf(n) >= 0 ||
                (Object.prototype.propertyIsEnumerable.call(e, n) &&
                  (a[n] = e[n]));
        }
        return a;
      }
      function We(t, n) {
        var r = t.title,
          a = t.titleId,
          o = Ve(t, He);
        return e.createElement(
          "svg",
          Be({ viewBox: "0 0 80 80", ref: n, "aria-labelledby": a }, o),
          r ? e.createElement("title", { id: a }, r) : null,
          Fe ||
            (Fe = e.createElement("path", {
              stroke: "none",
              d: "M13.858752 20.844365c2.467347 0 4.476897-1.999146 4.476897-4.472438 0-2.467346-2.00955-4.47095-4.4769-4.47095-2.47329 0-4.47095 2.003604-4.47095 4.47095.00148 2.471806 1.99766 4.472438 4.47095 4.472438zM2.113588 63.869837c-1.16976 0-2.113595.946807-2.113595 2.113594 0 1.16531.943835 2.11657 2.113595 2.11657h21.60712c1.166787 0 2.11062-.95126 2.11062-2.11656 0-.10999-.043103-.20363-.06094-.30619h.046078v-6.1431h8.394924c1.91591 0 3.36213-1.46703 3.36213-3.41267v-5.17846h8.29088c1.872805 0 3.2893-1.43135 3.2893-3.32943v-5.20967h8.390465c1.91591 0 3.362132-1.46703 3.362132-3.41266V33.8128h8.29088c1.843077 0 3.286326-1.4596 3.286326-3.329433l-.002972-6.361592H80v-5.69422H66.78483v9.691024H55.20762v8.59261H43.45948v5.07441h-.008918l.005946 3.4632H31.8793v8.58964h-4.191516c.026755-2.26966-.237816-6.26052-2.199803-8.86907-1.63201-2.17157-4.61364-3.32349-7.45852-4.34164l.02081-.00446-.02081-5.36425c2.05563 2.08981 4.75188 3.57171 7.84052 4.08896 1.12666.19025 2.19535-.56928 2.38114-1.69445.19174-1.12517-.56927-2.1894-1.6989-2.38114-4.82173-.810063-8.339924-4.885644-8.52275-9.735615l-.057964-.486037c-.066886-.985453-.801144-1.797-1.791056-1.91591-3.8229-.469687-7.59378.57968-10.624455 2.95933-3.030687 2.369252-4.96146 5.77746-5.42223 9.59739-.17985 1.440274-.133772 2.88501.115936 4.30002.20066 1.12071 1.27381 1.863885 2.39749 1.66174 1.0018-.17985 1.70188-1.046392 1.70188-2.02887 0-.123368-.01189-.242277-.031215-.36713-.10999-.597514-.15904-1.20246-.15904-1.81038 0-.41915.026756-.841275.075805-1.260427.331456-2.721512 1.70336-5.148727 3.870463-6.840197.47266-.377534.98991-.698586 1.51608-.972075L9.61819 63.86984h-7.5046zM14.8665 45.02139c3.124315.918565 5.373168 1.594856 6.479015 3.0604.90816 1.208406 1.160842 3.748584 1.160842 5.575312 0 .063914-.005946.11891-.005946.17985h-2.38113v10.032885h-5.32709c-.00594-4.692418-.01486-17.815432-.01486-18.64779.02824-.057968.05797-.12634.08918-.200658z",
            })),
        );
      }
      var Ze,
        Ge = e.forwardRef(We),
        qe = (n.p, ["title", "titleId"]);
      function Xe() {
        return (
          (Xe = Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }),
          Xe.apply(this, arguments)
        );
      }
      function _e(e, t) {
        if (null == e) return {};
        var n,
          r,
          a = (function (e, t) {
            if (null == e) return {};
            var n,
              r,
              a = {},
              o = Object.keys(e);
            for (r = 0; r < o.length; r++)
              (n = o[r]), t.indexOf(n) >= 0 || (a[n] = e[n]);
            return a;
          })(e, t);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          for (r = 0; r < o.length; r++)
            (n = o[r]),
              t.indexOf(n) >= 0 ||
                (Object.prototype.propertyIsEnumerable.call(e, n) &&
                  (a[n] = e[n]));
        }
        return a;
      }
      function Ye(t, n) {
        var r = t.title,
          a = t.titleId,
          o = _e(t, qe);
        return e.createElement(
          "svg",
          Xe({ viewBox: "0 0 80 80", ref: n, "aria-labelledby": a }, o),
          r ? e.createElement("title", { id: a }, r) : null,
          Ze ||
            (Ze = e.createElement("path", {
              stroke: "none",
              d: "M66.136292 20.84309c2.473384 0 4.47409-1.997733 4.47409-4.471117 0-2.467438-2.000706-4.471117-4.47409-4.471117-2.46744 0-4.47409 2.00368-4.47409 4.471117.001486 2.473384 2.00665 4.471118 4.47409 4.471118zM7.51382 30.48245c0 1.869903 1.446275 3.329557 3.28645 3.329557h8.29416v5.178648c0 1.947195 1.446275 3.412794 3.359283 3.412794h8.390777v5.21134c0 1.898144 1.416548 3.329555 3.289423 3.329555H42.4251V56.123c0 1.94571 1.446276 3.41131 3.362257 3.41131h8.395236v6.143326h.04608c-.017838.10405-.063917.197693-.063917.304714 0 1.16683.946842 2.116646 2.113673 2.116646h21.60792c1.16683 0 2.11367-.949815 2.11367-2.116646 0-1.16683-.946846-2.1107-2.113676-2.1107h-7.49893l-.005946-35.49544c.527675.2735 1.044945.59159 1.517623.96914 2.162726 1.693018 3.536168 4.118837 3.867637 6.843424.052024.41768.07878.838335.07878 1.257502 0 .609428-.052025 1.21291-.159046 1.814905-.02081.12189-.031214.2408-.031214.36566 0 .98103.697125 1.849098 1.698964 2.02895 1.126698.20364 2.199885-.539563 2.40055-1.66329.246744-1.413573.292823-2.85985.112967-4.30018-.4593-3.82007-2.388657-7.228404-5.419445-9.59774-3.03079-2.381226-6.80478-3.429144-10.62485-2.957953-.99292.118913-1.724236.929006-1.791125 1.91598l-.05797.48457c-.1858 4.851638-3.701154 8.92737-8.523064 9.737464-1.12967.191747-1.889226 1.25453-1.698966 2.381227.1858 1.123726 1.25453 1.884767 2.381226 1.69302 3.085784-.51727 5.78659-1.997733 7.840805-4.090597l-.02081 5.36445.02081.005943c-2.844983 1.01819-5.82969 2.167185-7.46177 4.3418-1.959085 2.60716-2.22367 6.59817-2.1984 8.8694H48.1225V45.24993H36.54784l.002973-3.463334h-.008918V36.70902H24.790347v-8.58996H13.215683v-9.691383H.000023v5.692945h7.519742l-.005946 6.36183zm51.138404 17.60354c1.102915-1.468572 3.35631-2.141916 6.479256-3.06349.029728.07878.060942.14567.087698.200666 0 .833876-.011892 13.955892-.014864 18.64997h-5.330262v-10.03326h-2.381227c0-.06094-.002973-.115938-.002973-.179854.001487-1.826796.254176-4.36707 1.162372-5.574033z",
            })),
        );
      }
      var Je,
        Ke = e.forwardRef(Ye),
        Qe = (n.p, ["title", "titleId"]);
      function $e() {
        return (
          ($e = Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }),
          $e.apply(this, arguments)
        );
      }
      function et(e, t) {
        if (null == e) return {};
        var n,
          r,
          a = (function (e, t) {
            if (null == e) return {};
            var n,
              r,
              a = {},
              o = Object.keys(e);
            for (r = 0; r < o.length; r++)
              (n = o[r]), t.indexOf(n) >= 0 || (a[n] = e[n]);
            return a;
          })(e, t);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          for (r = 0; r < o.length; r++)
            (n = o[r]),
              t.indexOf(n) >= 0 ||
                (Object.prototype.propertyIsEnumerable.call(e, n) &&
                  (a[n] = e[n]));
        }
        return a;
      }
      function tt(t, n) {
        var r = t.title,
          a = t.titleId,
          o = et(t, Qe);
        return e.createElement(
          "svg",
          $e({ viewBox: "0 0 80 80", ref: n, "aria-labelledby": a }, o),
          r ? e.createElement("title", { id: a }, r) : null,
          Je ||
            (Je = e.createElement("path", {
              stroke: "none",
              d: "M40.202268 8.640724c2.384096 0 4.324673-1.93053 4.324673-4.321802 0-2.38266-1.94057-4.318932-4.32467-4.318932-2.39127 0-4.32037 1.93627-4.32037 4.318932 0 2.391273 1.9291 4.321802 4.32037 4.321802zM3.41312 36.085822h15.74135l-.00574 7.588632c0 1.799914 1.396584 3.212287 3.176403 3.212287h8.01062v5.00359c0 1.88173 1.39802 3.29697 3.24817 3.29697h8.105355v5.02943c0 1.83293 1.365006 3.21516 3.176403 3.21516h8.00919v5.00359c0 1.87886 1.39946 3.2941 3.24961 3.2941h8.10679v5.00646c0 1.34348.86407 2.5506 2.20037 3.07306l.48228.1909h11.71235v-5.50022h-8.89192v-8.27042H58.377958V57.9288h-11.18272l.002872-3.34434h-.008613v-4.897373H43.95137c.165064-.32008.27989-.670303.27989-1.053538l.030143-18.9034-.020094-3.30415v-.42056h-.00575l-.01148-3.43907c1.98507 2.01808 4.59451 3.45055 7.57715 3.94861 1.08798.18659 2.11999-.5483 2.29941-1.63485.18516-1.08655-.54687-2.117128-1.64346-2.30085-4.65624-.78226-8.05368-4.71652-8.2331-9.40577l-.05311-.469358c-.06459-.95163-.77365-1.735323-1.73246-1.851586-3.690253-.450694-7.337447.56122-10.2641 2.85776-2.926654 2.2908-4.79403 5.58203-5.236113 9.272284-.173677 1.39228-.12918 2.78886.109085 4.155303.195205 1.08368 1.23152 1.79848 2.31807 1.606143.968853-.173676 1.643462-1.01335 1.643462-1.959237 0-.119135-.011484-.235397-.030143-.35453-.10478-.57844-.15358-1.162624-.15358-1.751113 0-.401894.025838-.810966.07464-1.217166.32008-2.628103 1.646333-4.97201 3.736185-6.608296.45931-.36314.958805-.67317 1.46548-.937272 0 0-.004307 14.074924-.004307 14.37491 0 1.182718-.48945 2.0999-1.187028 2.803215-2.432897 2.4329-6.977177 4.74379-7.027414 4.76245-1.181285.5239-1.72384 1.909-1.202815 3.09746.076075.167937.202385.288506.30573.43204h-2.32955v-9.35984h-2.64389c-.038756-.00574-.070334-.025836-.10909-.025836H3.414556c-1.12674 0-2.04105.920056-2.04105 2.043926-.001434 1.12961.912876 2.04105 2.039616 2.04105zm34.818428.330128c.538252-.538252.95737-1.168365 1.326253-1.827185-.01004 5.362423-.02583 14.04191-.02583 14.04191 0 .384672.11483.732024.27989 1.05641h-3.97589v-8.30056h-4.60313c1.80135-.99756 4.88733-2.856322 6.99871-4.970575z",
            })),
        );
      }
      var nt,
        rt = e.forwardRef(tt),
        at = (n.p, ["title", "titleId"]);
      function ot() {
        return (
          (ot = Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }),
          ot.apply(this, arguments)
        );
      }
      function it(e, t) {
        if (null == e) return {};
        var n,
          r,
          a = (function (e, t) {
            if (null == e) return {};
            var n,
              r,
              a = {},
              o = Object.keys(e);
            for (r = 0; r < o.length; r++)
              (n = o[r]), t.indexOf(n) >= 0 || (a[n] = e[n]);
            return a;
          })(e, t);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          for (r = 0; r < o.length; r++)
            (n = o[r]),
              t.indexOf(n) >= 0 ||
                (Object.prototype.propertyIsEnumerable.call(e, n) &&
                  (a[n] = e[n]));
        }
        return a;
      }
      function lt(t, n) {
        var r = t.title,
          a = t.titleId,
          o = it(t, at);
        return e.createElement(
          "svg",
          ot({ viewBox: "0 0 80 80", ref: n, "aria-labelledby": a }, o),
          r ? e.createElement("title", { id: a }, r) : null,
          nt ||
            (nt = e.createElement("path", {
              stroke: "none",
              d: "M39.79924 8.640106c2.38249 0 4.314317-1.928956 4.314317-4.320057 0-2.38249-1.931826-4.32006-4.314316-4.32006-2.3911 0-4.32292 1.93756-4.32292 4.32005 0 2.3911 1.93183 4.32005 4.32293 4.32005zM13.568886 79.80767c1.33764-.523862 2.200215-1.72946 2.200215-3.07284v-5.0061h8.10334c1.85576 0 3.25224-1.41514 3.25224-3.296734v-5.000358h8.00287c1.81127 0 3.17905-1.382132 3.17905-3.217797v-5.02619h8.10334c1.85002 0 3.2465-1.41801 3.2465-3.2996v-5.00323h8.01435c1.77969 0 3.17044-1.41227 3.17044-3.21205v-7.58809h15.74309c1.12379 0 2.03804-.91137 2.03804-2.0409 0-1.12379-.91424-2.04378-2.03803-2.04378H58.09418c-.03875 0-.073196.0201-.111947.02584H55.33566l.00574 9.35917h-2.335127c.106208-.14352.229638-.26408.305705-.432.52386-1.188373-.014352-2.573374-1.199856-3.097235-.047363-.02009-4.594187-2.329384-7.025476-4.76211-.700394-.703263-1.191245-1.62038-1.191245-2.803012v-14.3739c.50808.266954 1.00036.574095 1.46538.938644 2.08827 1.637606 3.4173 3.97991 3.73735 6.607824.05024.406173.0732.815215.0732 1.21708 0 .588447-.04736 1.17115-.15357 1.752423-.02583.11769-.0287.23537-.0287.35306 0 .94725.67313 1.78543 1.64048 1.95909 1.08791.19375 2.11984-.52099 2.31504-1.60603.24399-1.36491.28274-2.76139.11195-4.15501-.44779-3.688558-2.30642-6.97955-5.235734-9.270187-2.926447-2.299246-6.57051-3.311087-10.267674-2.858988-.952995.11769-1.662.89989-1.73233 1.852886l-.0531.46789c-.173665 4.69035-3.567996 8.62289-8.23251 9.405097-1.08791.185145-1.819877 1.21421-1.637603 2.302117.179405 1.08504 1.21421 1.81988 2.302117 1.634735 2.97955-.49946 5.590248-1.931825 7.568-3.949765l-.00861 3.438826-.00574.420525-.01722 3.30391.028706 18.902048c0 .384646.11195.73484.277 1.053465h-3.23789v4.89989h-.00287l.00287 3.3441H21.62486v8.299964H10.26928v8.269825H1.378v5.49982h11.702906l.48798-.19232zm26.891998-31.18048s-.014352-8.678867-.020093-14.040905c.36455.658772.78508 1.28884 1.32903 1.827054 2.10836 2.1141 5.18838 3.97273 6.9939 4.97021h-4.60567v8.29996h-3.9756c.16649-.32437.27844-.67169.27844-1.05634z",
            })),
        );
      }
      var ct,
        st = e.forwardRef(lt),
        ut = (n.p, ["title", "titleId"]);
      function dt() {
        return (
          (dt = Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }),
          dt.apply(this, arguments)
        );
      }
      function pt(e, t) {
        if (null == e) return {};
        var n,
          r,
          a = (function (e, t) {
            if (null == e) return {};
            var n,
              r,
              a = {},
              o = Object.keys(e);
            for (r = 0; r < o.length; r++)
              (n = o[r]), t.indexOf(n) >= 0 || (a[n] = e[n]);
            return a;
          })(e, t);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          for (r = 0; r < o.length; r++)
            (n = o[r]),
              t.indexOf(n) >= 0 ||
                (Object.prototype.propertyIsEnumerable.call(e, n) &&
                  (a[n] = e[n]));
        }
        return a;
      }
      function ft(t, n) {
        var r = t.title,
          a = t.titleId,
          o = pt(t, ut);
        return e.createElement(
          "svg",
          dt({ viewBox: "0 0 80 80", ref: n, "aria-labelledby": a }, o),
          r ? e.createElement("title", { id: a }, r) : null,
          ct ||
            (ct = e.createElement(
              "g",
              {
                transform:
                  "matrix(0 0.56060606 -0.4966443 0 154.47651 0.19696889)",
              },
              e.createElement("path", {
                stroke: "none",
                strokeWidth: 0.7,
                d: "M87.4 303.2 71.7 292.3c-0.2-0.2-0.5-0.3-0.7-0.5-0.2 0.2-0.4 0.4-0.7 0.6L54.5 303.2C53.3 304 51.7 304.6 50 305h42c-1.9-0.4-3.4-1-4.6-1.8z",
              }),
              e.createElement("path", {
                stroke: "none",
                strokeWidth: 0.7,
                d: "m95.4 158c-2.3 0-4.4 0.5-5.6 1.4L74.3 170.4C73.5 171 73 171.7 73 172.4V230.5 288.6c0 0.7 0.5 1.4 1.3 2l15.5 10.9C91 302.5 93.1 303 95.4 303h34.9c1.9 0 3.7-0.4 4.9-1 0.9-0.4 1.6-1.1 1.9-1.7V300 230.5 161 160.8c-0.3-0.6-1-1.3-1.9-1.7C133.9 158.4 132.1 158 130.3 158Z",
              }),
              e.createElement("path", {
                stroke: "none",
                strokeWidth: 0.7,
                d: "m11.7 158c-1.9 0-3.7 0.4-4.9 1C6 159.5 5.3 160.1 5 160.8v0.2 69.5 69.5 0.2c0.3 0.6 1 1.3 1.9 1.7C8.1 302.6 9.9 303 11.7 303h34.9c2.3 0 4.4-0.5 5.6-1.4L67.7 290.6C68.5 290 69 289.3 69 288.6V230.5 172.4c0-0.7-0.5-1.4-1.3-2L52.3 159.4C51 158.5 48.9 158 46.6 158Z",
              }),
              e.createElement("path", {
                stroke: "none",
                strokeWidth: 0.7,
                d: "m87.4 157.8-15.8 11c-0.2 0.2-0.5 0.4-0.7 0.6-0.2-0.2-0.4-0.3-0.7-0.5L54.5 157.8C53.3 157 51.7 156.4 50 156h42c-1.9 0.4-3.4 1-4.6 1.8z",
              }),
            )),
        );
      }
      var mt,
        ht = e.forwardRef(ft),
        gt = (n.p, ["title", "titleId"]);
      function vt() {
        return (
          (vt = Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }),
          vt.apply(this, arguments)
        );
      }
      function bt(e, t) {
        if (null == e) return {};
        var n,
          r,
          a = (function (e, t) {
            if (null == e) return {};
            var n,
              r,
              a = {},
              o = Object.keys(e);
            for (r = 0; r < o.length; r++)
              (n = o[r]), t.indexOf(n) >= 0 || (a[n] = e[n]);
            return a;
          })(e, t);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          for (r = 0; r < o.length; r++)
            (n = o[r]),
              t.indexOf(n) >= 0 ||
                (Object.prototype.propertyIsEnumerable.call(e, n) &&
                  (a[n] = e[n]));
        }
        return a;
      }
      function yt(t, n) {
        var r = t.title,
          a = t.titleId,
          o = bt(t, gt);
        return e.createElement(
          "svg",
          vt({ viewBox: "0 0 80 80", ref: n, "aria-labelledby": a }, o),
          r ? e.createElement("title", { id: a }, r) : null,
          mt ||
            (mt = e.createElement("path", {
              stroke: "none",
              className: "wc",
              d: "m30.8 14.8 2.7-9.3 0 0 2.9 9.3 2.3 0 4-13.2-2.4 0-2.7 9.8 0 0-2.9-9.8-2.2 0-2.8 9.8 0 0-2.8-9.8-2.6 0 4.1 13.2 2.4 0zm15.2-1.4c0.6 0.6 1.3 1 2.1 1.2 0.8 0.3 1.6 0.4 2.5 0.4 0.5 0 0.9 0 1.3-0.1 0.4 0 0.8-0.1 1.1-0.2 0.4-0.1 0.7-0.2 1.1-0.3 0.4-0.1 0.7-0.3 1.1-0.5l-0.9-1.9c-0.5 0.3-1 0.5-1.5 0.7-0.5 0.2-1.2 0.3-1.9 0.3-0.8 0-1.4-0.1-2-0.4-0.5-0.3-1-0.6-1.3-1.1-0.3-0.4-0.5-1-0.7-1.6-0.1-0.6-0.2-1.2-0.2-1.9 0-0.6 0.1-1.3 0.2-1.8 0.1-0.6 0.4-1.1 0.7-1.6 0.3-0.5 0.7-0.8 1.2-1.1 0.5-0.3 1.1-0.4 1.8-0.4 0.7 0 1.3 0.2 1.7 0.5 0.4 0.3 0.8 0.8 1.1 1.4L55.7 4C55.4 3.4 55.1 3 54.7 2.7 54.3 2.4 53.9 2.1 53.5 1.9 53 1.7 52.6 1.6 52.1 1.5 51.7 1.4 51.2 1.4 50.7 1.4c-1 0-2 0.2-2.8 0.5-0.8 0.3-1.5 0.8-2.1 1.4-0.6 0.6-1 1.3-1.3 2.2-0.3 0.9-0.5 1.8-0.5 2.9 0 1.1 0.2 2.1 0.5 3 0.3 0.8 0.8 1.5 1.4 2.1zm19.9 19.2c-8.6-1.1-16.5 5.1-17.6 13.8-0.2 1.6-0.1 3.2 0.1 4.7 0.2 1.2 1.4 2 2.6 1.8 1.1-0.2 1.9-1.2 1.9-2.2 0-0.1 0-0.3 0-0.4-0.1-0.6-0.2-1.3-0.2-2 0-0.5 0-0.9 0.1-1.4 0.4-3.2 2.1-6 4.6-7.7 0.1 1.2 0.3 3.2 0.4 4.7l0 2.9c-0.8 3.5-5.6 17-5.1 17.6 0.2 0.2 2.3 0.3 5.1 0.3l0 11.1c0 1.6 1.3 2.9 2.9 2.9l0 0c1.6 0 2.9-1.3 2.9-2.9 0 0 0-5.4 0-11.2 1.4 0 2.7 0 4-0.1 1.2 3 1.5 5.7 1.5 7.7 0 1.8-0.2 2.9-0.2 2.9-0.1 0.2-0.1 0.4-0.1 0.6 0 1.3 0.9 2.6 2.3 2.9 1.6 0.4 3.1-0.6 3.5-2.2 0.1-0.3 1.3-5.7-0.9-12.6-1.2-4-6.6-17.5-6.6-18.6l0-0.1c2.5 3 6.2 5 10.3 5.5 1.2 0.1 2.4-0.8 2.5-2 0.1-1.2-0.8-2.4-2-2.5-5.7-0.6-10.1-5.4-10.1-11.2 0-1.1-0.9-2.1-2-2.2zM53.2 24.1c-0.3 0.9 0.1 1.9 1 2.2 0.9 0.3 1.9-0.1 2.2-1 0.1-0.4 0.4-0.7 0.8-0.9 0.3-0.1 0.6-0.2 0.9-0.1-0.2 0.5-0.2 1-0.2 1.5 0 2.7 2.2 4.9 4.9 4.9 2.7 0 4.9-2.2 4.9-4.9 0-2.7-2.2-4.9-4.9-4.9-0.9 0-1.8 0.3-2.5 0.7-0.2-0.2-0.4-0.3-0.6-0.4-1.3-0.5-2.6-0.4-3.8 0.2-1.2 0.6-2.1 1.6-2.6 2.8zM2.9 52.8c1.1-0.2 1.9-1.2 1.9-2.2 0-0.1 0-0.3 0-0.4-0.1-0.7-0.2-1.3-0.2-2 0-0.4 0-0.9 0.1-1.3 0.4-3 1.8-5.7 4.2-7.5 0.1-0.1 0.3-0.2 0.4-0.3l0 36.5c0 1.6 1.3 2.9 2.9 2.9 1.6 0 2.9-1.3 2.9-2.9 0 0 0-10.5 0-18 1.3 1.7 2.6 3.6 3.6 5.7 1.6 3.4 1.9 6.5 1.9 8.7 0 1.8-0.2 2.9-0.2 2.9 0 0.2-0.1 0.4-0.1 0.6 0 1.3 0.9 2.6 2.3 2.9 1.6 0.4 3.1-0.6 3.5-2.2 0.1-0.3 1.7-7.3-2-15.4-1.5-3.3-3.7-6.3-5.6-8.6l0-8.1c2.5 3.2 6.2 5.5 10.5 6.1 1.2 0.2 2.4-0.7 2.5-2 0.2-1.2-0.7-2.4-2-2.5-5.6-0.7-9.8-5.5-9.8-11.1 0-1.1-0.9-2.1-2-2.2-4.2-0.5-8.3 0.7-11.6 3.3-3.3 2.6-5.4 6.4-5.9 10.5-0.2 1.6-0.1 3.2 0.1 4.7 0.2 1.2 1.4 2 2.6 1.8zM14.1 30.5c2.7 0 4.9-2.2 4.9-4.9 0-2.7-2.2-4.9-4.9-4.9-2.7 0-4.9 2.2-4.9 4.9 0 2.7 2.2 4.9 4.9 4.9zm23.1-10 0 56.4c0 0.9 0.8 1.7 1.7 1.7 0.9 0 1.7-0.8 1.7-1.7l0-56.4c0-0.9-0.8-1.7-1.7-1.7-0.9 0-1.7 0.8-1.7 1.7z",
            })),
        );
      }
      var xt,
        wt = e.forwardRef(yt),
        kt = (n.p, ["title", "titleId"]);
      function St() {
        return (
          (St = Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }),
          St.apply(this, arguments)
        );
      }
      function Ct(e, t) {
        if (null == e) return {};
        var n,
          r,
          a = (function (e, t) {
            if (null == e) return {};
            var n,
              r,
              a = {},
              o = Object.keys(e);
            for (r = 0; r < o.length; r++)
              (n = o[r]), t.indexOf(n) >= 0 || (a[n] = e[n]);
            return a;
          })(e, t);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          for (r = 0; r < o.length; r++)
            (n = o[r]),
              t.indexOf(n) >= 0 ||
                (Object.prototype.propertyIsEnumerable.call(e, n) &&
                  (a[n] = e[n]));
        }
        return a;
      }
      function Et(t, n) {
        var r = t.title,
          a = t.titleId,
          o = Ct(t, kt);
        return e.createElement(
          "svg",
          St(
            {
              viewBox: "0 0 80.000000 80.000000",
              ref: n,
              "aria-labelledby": a,
            },
            o,
          ),
          r ? e.createElement("title", { id: a }, r) : null,
          xt ||
            (xt = e.createElement(
              "g",
              {
                transform:
                  "translate(0.000000,80.000000) scale(0.100000,-0.100000)",
                stroke: "none",
              },
              e.createElement("path", {
                d: "M232 606 c-10 -23 -9 -25 16 -28 30 -3 41 -30 21 -54 -9 -11 -23 -13 -49 -9 -40 7 -99 -12 -133 -43 -55 -50 -66 -147 -24 -211 34 -51 86 -75 149 -69 64 7 97 31 128 95 18 39 29 51 47 51 12 0 32 10 43 23 l19 24 1 -30 c0 -45 40 -117 80 -143 45 -30 130 -28 177 6 64 45 84 157 40 223 -30 46 -101 82 -148 75 -36 -6 -36 -5 -62 54 l-26 60 -50 0 c-39 0 -51 -4 -51 -15 0 -10 11 -15 35 -15 24 0 37 -6 45 -20 10 -19 7 -20 -47 -21 -101 -2 -150 6 -115 18 6 3 12 16 12 29 0 22 -4 24 -48 24 -42 0 -50 -3 -60 -24z m258 -91 c0 -10 -82 -115 -89 -115 -7 0 -51 98 -51 113 0 4 32 7 70 7 39 0 70 -2 70 -5z m-165 -53 c-8 -9 -35 20 -28 31 4 6 11 3 19 -8 8 -10 12 -21 9 -23z m-95 7 c0 -7 -16 -34 -36 -62 -40 -56 -37 -85 7 -79 58 8 109 9 113 3 9 -14 -25 -67 -53 -84 -16 -9 -48 -17 -71 -17 -34 0 -48 6 -75 33 -64 64 -51 160 26 199 38 20 89 24 89 7z m437 -6 c50 -23 80 -91 64 -144 -31 -102 -163 -122 -222 -33 -31 47 -24 108 19 157 15 17 17 16 34 -15 9 -18 17 -48 18 -66 0 -36 22 -52 48 -35 22 14 25 28 9 45 -20 19 -47 74 -47 93 0 20 33 19 77 -2z m-362 -52 c18 -35 12 -41 -37 -41 -43 0 -47 10 -17 51 23 33 32 31 54 -10z",
              }),
            )),
        );
      }
      var Ot,
        At,
        jt,
        Lt,
        Nt,
        Tt,
        Pt,
        Dt,
        zt,
        Mt,
        It = e.forwardRef(Et),
        Rt = (n.p, ["title", "titleId"]);
      function Ft() {
        return (
          (Ft = Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }),
          Ft.apply(this, arguments)
        );
      }
      function Ut(e, t) {
        if (null == e) return {};
        var n,
          r,
          a = (function (e, t) {
            if (null == e) return {};
            var n,
              r,
              a = {},
              o = Object.keys(e);
            for (r = 0; r < o.length; r++)
              (n = o[r]), t.indexOf(n) >= 0 || (a[n] = e[n]);
            return a;
          })(e, t);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          for (r = 0; r < o.length; r++)
            (n = o[r]),
              t.indexOf(n) >= 0 ||
                (Object.prototype.propertyIsEnumerable.call(e, n) &&
                  (a[n] = e[n]));
        }
        return a;
      }
      function Ht(t, n) {
        var r = t.title,
          a = t.titleId,
          o = Ut(t, Rt);
        return e.createElement(
          "svg",
          Ft(
            {
              viewBox: "0 0 500 500",
              xmlns: "http://www.w3.org/2000/svg",
              ref: n,
              "aria-labelledby": a,
            },
            o,
          ),
          r ? e.createElement("title", { id: a }, r) : null,
          e.createElement(
            "g",
            {
              style: {},
              transform:
                "matrix(0.4449630081653595, 0, 0, 0.4449630081653595, 95.96953582763672, 71.29066467285159)",
            },
            Ot ||
              (Ot = e.createElement("circle", {
                r: 43.5,
                transform: "matrix(1, 0, 0, -1, 0, 0)",
                cx: 812.396,
                cy: -169.192,
              })),
            At ||
              (At = e.createElement("path", {
                d: "M 673.016 166.186 C 639.016 181.586 615.216 196.986 587.816 221.286 C 575.716 231.986 575.816 231.786 576.516 241.486 C 577.016 248.686 584.216 256.986 591.716 259.086 C 599.416 261.086 602.916 259.786 611.916 251.286 C 623.016 240.786 632.816 233.086 647.016 223.686 C 659.216 215.686 673.916 207.586 675.616 208.186 C 677.216 208.686 703.416 229.486 703.516 230.186 C 703.516 230.586 695.816 240.486 686.516 252.186 L 669.416 273.386 L 675.616 274.686 C 711.316 281.986 743.616 306.986 760.216 340.486 C 763.216 346.286 768.016 359.386 768.716 363.486 C 769.016 365.386 770.016 365.486 782.916 365.986 L 796.816 366.486 L 798.216 370.486 C 801.216 378.986 806.516 400.986 808.416 412.486 C 811.016 428.186 812.916 454.286 812.216 464.886 C 811.416 475.186 812.916 478.986 818.916 482.486 C 829.416 488.586 845.716 485.386 850.416 476.286 C 852.816 471.686 851.116 434.186 847.416 409.486 C 844.816 391.986 839.116 369.386 833.016 352.486 C 830.416 345.286 827.216 336.386 825.916 332.486 C 824.516 328.686 822.316 324.086 820.916 322.286 C 816.216 316.086 814.116 315.586 791.816 314.986 L 771.716 314.486 L 787.616 294.486 C 805.516 272.186 807.316 268.486 806.116 258.086 C 804.916 247.886 801.916 244.186 779.916 226.286 C 755.316 206.186 705.216 166.286 700.616 162.986 C 698.416 161.486 695.416 160.486 692.116 160.286 C 687.616 159.986 685.416 160.686 673.016 166.186 Z",
              })),
            jt ||
              (jt = e.createElement("circle", {
                r: 97.5,
                transform: "matrix(1, 0, 0, -1, 0, 0)",
                cx: 653.911,
                cy: -392.837,
              })),
          ),
          e.createElement("path", {
            d: "M 250.543 350.654 C 247.977 351.177 246.266 352.128 244.318 353.981 C 242.322 356.024 241.752 357.973 242.703 360.159 C 243.083 361.062 244.081 363.533 244.936 365.624 C 245.791 367.715 247.787 372.135 249.355 375.461 L 252.254 381.544 L 247.169 381.544 L 242.084 381.497 L 240.611 379.5 C 222.22 354.742 222.506 355.074 220.129 353.933 C 217.848 352.793 217.705 352.793 199.219 352.651 C 186.341 352.555 179.925 352.697 178.547 353.078 C 176.029 353.743 173.225 356.499 172.512 358.971 C 171.847 361.394 171.847 367.952 172.512 370.376 C 173.177 372.8 175.981 375.604 178.405 376.269 C 179.593 376.602 185.58 376.792 194.372 376.792 L 208.391 376.792 L 217.42 388.958 C 226.83 401.741 229.777 404.83 233.34 405.78 C 234.576 406.113 241.752 406.256 253.87 406.161 L 272.546 406.018 L 274.495 404.735 C 277.726 402.597 278.629 400.6 278.82 395.088 C 279.057 388.625 278.534 386.771 275.35 383.73 C 271.833 380.356 266.083 369.663 261.474 358.021 C 260.524 355.644 259.24 353.173 258.623 352.46 C 257.624 351.415 254.203 350.037 252.92 350.227 C 252.73 350.274 251.636 350.464 250.543 350.654 Z",
            style: {},
          }),
          e.createElement("circle", {
            r: 18.771,
            transform: "matrix(1, 0, 0, -1, 0, 0)",
            cx: 304.759,
            cy: -388.927,
            style: {},
          }),
          e.createElement(
            "g",
            {
              transform:
                "matrix(0.5280269980430603, 0, 0, 0.5280269980430603, 59.26472473144531, 47.0289001464844)",
              style: {},
            },
            Lt ||
              (Lt = e.createElement("path", {
                d: "M 285.921 69.616 L 303.012 10.747 L 321.369 69.616 L 335.928 69.616 L 361.248 -13.94 L 346.056 -13.94 L 328.965 48.094 L 310.608 -13.94 L 296.682 -13.94 L 278.958 48.094 L 261.234 -13.94 L 244.776 -13.94 L 270.729 69.616 L 285.921 69.616 Z",
              })),
            Nt ||
              (Nt = e.createElement("path", {
                d: "M 382.137 60.754 C 385.935 64.552 390.366 67.084 395.43 68.35 C 400.494 70.249 405.558 70.882 411.255 70.882 C 414.42 70.882 416.952 70.882 419.484 70.249 C 422.016 70.249 424.548 69.616 426.447 68.983 C 428.979 68.35 430.878 67.717 433.41 67.084 C 435.942 66.451 437.841 65.185 440.373 63.919 L 434.676 51.892 C 431.511 53.791 428.346 55.057 425.181 56.323 C 422.016 57.589 417.585 58.222 413.154 58.222 C 408.09 58.222 404.292 57.589 400.494 55.69 C 397.329 53.791 394.164 51.892 392.265 48.727 C 390.366 46.195 389.1 42.397 387.834 38.599 C 387.201 34.801 386.568 31.003 386.568 26.572 C 386.568 22.774 387.201 18.343 387.834 15.178 C 388.467 11.38 390.366 8.215 392.265 5.05 C 394.164 1.885 396.696 -0.014 399.861 -1.913 C 403.026 -3.812 406.824 -4.445 411.255 -4.445 C 415.686 -4.445 419.484 -3.179 422.016 -1.28 C 424.548 0.619 427.08 3.784 428.979 7.582 L 443.538 1.252 C 441.639 -2.546 439.74 -5.078 437.208 -6.977 C 434.676 -8.876 432.144 -10.775 429.612 -12.041 C 426.447 -13.307 423.915 -13.94 420.75 -14.573 C 418.218 -15.206 415.053 -15.206 411.888 -15.206 C 405.558 -15.206 399.228 -13.94 394.164 -12.041 C 389.1 -10.142 384.669 -6.977 380.871 -3.179 C 377.073 0.619 374.541 5.05 372.642 10.747 C 370.743 16.444 369.477 22.141 369.477 29.104 C 369.477 36.067 370.743 42.397 372.642 48.094 C 374.541 53.158 377.706 57.589 381.504 61.387 L 382.137 60.754 Z",
              })),
          ),
          e.createElement("path", {
            d: "M 147.591 108.412 L 147.591 296.924 C 147.591 299.932 150.265 302.606 153.273 302.606 C 156.282 302.606 158.955 299.932 158.955 296.924 L 158.955 108.412 C 158.955 105.404 156.282 102.73 153.273 102.73 C 150.265 102.73 147.591 105.404 147.591 108.412 Z",
            style: {},
          }),
          e.createElement(
            "g",
            {
              transform:
                "matrix(0.5280269980430603, 0, 0, 0.5280269980430603, 59.26472473144531, 47.0289001464844)",
              style: {},
            },
            Tt ||
              (Tt = e.createElement("path", {
                d: "M 21.054 179.549 C 38.145 179.549 52.071 165.623 52.071 148.532 C 52.071 131.441 38.145 117.515 21.054 117.515 C 3.963 117.515 -9.963 131.441 -9.963 148.532 C -9.963 165.623 3.963 179.549 21.054 179.549 Z",
              })),
            Pt ||
              (Pt = e.createElement("path", {
                d: "M -49.842 320.708 C -42.879 319.442 -37.815 313.112 -37.815 306.782 L -37.815 304.25 C -38.448 299.819 -39.081 296.021 -39.081 291.59 C -39.081 289.058 -39.081 285.893 -38.448 283.361 C -35.916 264.371 -27.054 247.28 -11.862 235.886 C -11.229 235.253 -9.963 234.62 -9.33 233.987 L -9.33 465.032 C -9.33 475.16 -1.101 483.389 9.027 483.389 C 19.155 483.389 27.384 475.16 27.384 465.032 L 27.384 351.092 C 35.613 361.853 43.842 373.88 50.172 387.173 C 60.3 408.695 62.199 428.318 62.199 442.244 C 62.199 453.638 60.933 460.601 60.933 460.601 C 60.933 461.867 60.3 463.133 60.3 464.399 C 60.3 472.628 65.997 480.857 74.859 482.756 C 84.987 485.288 94.482 478.958 97.014 468.83 C 97.647 466.931 107.775 422.621 84.354 371.348 C 74.859 350.459 60.933 331.469 48.906 316.91 L 48.906 265.637 C 64.731 285.893 88.152 300.452 115.371 304.25 C 122.967 305.516 130.563 299.819 131.196 291.59 C 132.462 283.994 126.765 276.398 118.536 275.765 C 83.088 271.334 56.502 240.95 56.502 205.502 C 56.502 198.539 50.805 192.209 43.842 191.576 C 17.256 188.411 -8.697 196.007 -29.586 212.465 C -50.475 228.923 -63.768 252.977 -66.933 278.93 C -68.199 289.058 -67.566 299.186 -66.3 308.681 C -65.034 316.277 -57.438 321.341 -49.842 320.075 L -49.842 320.708 Z",
              })),
          ),
          e.createElement(
            "g",
            {
              transform:
                "matrix(0.5280269980430603, 0, 0, 0.5280269980430603, 59.26472473144531, 47.0289001464844)",
              style: {},
            },
            Dt ||
              (Dt = e.createElement("path", {
                d: "M 268.557 139.037 C 266.658 144.734 269.19 151.064 274.887 152.963 C 280.584 154.862 286.914 152.33 288.813 146.633 C 289.446 144.101 291.345 142.202 293.877 140.936 C 295.776 140.303 297.675 139.67 299.574 140.303 C 298.308 143.468 298.308 146.633 298.308 149.798 C 298.308 166.889 312.234 180.815 329.325 180.815 C 346.416 180.815 360.342 166.889 360.342 149.798 C 360.342 132.707 346.416 118.781 329.325 118.781 C 323.628 118.781 317.931 120.68 313.5 123.212 C 312.234 121.946 310.968 121.313 309.702 120.68 C 301.473 117.515 293.244 118.148 285.648 121.946 C 278.052 125.744 272.355 132.074 269.19 139.67 L 268.557 139.037 Z",
              })),
            zt ||
              (zt = e.createElement("path", {
                d: "M 348.948 192.842 C 294.51 185.879 244.503 225.125 237.54 280.196 C 236.274 290.324 236.907 300.452 238.173 309.947 C 239.439 317.543 247.035 322.607 254.631 321.341 C 261.594 320.075 266.658 313.745 266.658 307.415 L 266.658 304.883 C 266.025 301.085 265.392 296.654 265.392 292.223 C 265.392 289.058 265.392 286.526 266.025 283.361 C 268.557 263.105 279.318 245.381 295.143 234.62 C 295.776 242.216 297.042 254.876 297.675 264.371 L 297.675 282.728 C 292.611 304.883 262.227 390.338 265.392 394.136 C 266.658 395.402 279.951 396.035 297.675 396.035 L 297.675 466.298 C 297.675 476.426 305.904 484.655 316.032 484.655 C 326.16 484.655 334.389 476.426 334.389 466.298 L 334.389 395.402 C 343.251 395.402 351.48 395.402 359.709 394.769 C 367.305 413.759 369.204 430.85 369.204 443.51 C 369.204 454.904 367.938 461.867 367.938 461.867 C 367.305 463.133 367.305 464.399 367.305 465.665 C 367.305 473.894 373.002 482.123 381.864 484.022 C 391.992 486.554 401.487 480.224 404.019 470.096 C 404.652 468.197 412.248 434.015 398.322 390.338 C 390.726 365.018 356.544 279.563 356.544 272.6 L 356.544 271.967 C 372.369 290.957 395.79 303.617 421.743 306.782 C 429.339 307.415 436.935 301.718 437.568 294.122 C 438.201 286.526 432.504 278.93 424.908 278.297 C 388.827 274.499 360.975 244.115 360.975 207.401 C 360.975 200.438 355.278 194.108 348.315 193.475 L 348.948 192.842 Z",
              })),
          ),
          e.createElement("path", {
            d: "M 314.097 112.853 L 314.097 301.365 C 314.097 304.373 316.771 307.047 319.779 307.047 C 322.787 307.047 325.461 304.373 325.461 301.365 L 325.461 112.853 C 325.461 109.845 322.787 107.171 319.779 107.171 C 316.771 107.171 314.097 109.845 314.097 112.853 Z",
            style: {},
          }),
          Mt ||
            (Mt = e.createElement("rect", {
              x: 158.726,
              y: -449.454,
              rx: 120,
              ry: 120,
              width: 1950,
              height: 320,
              transform: "matrix(.09 0 0 -.09 140 410)",
            })),
        );
      }
      var Bt,
        Vt = e.forwardRef(Ht),
        Wt = (n.p, ["title", "titleId"]);
      function Zt() {
        return (
          (Zt = Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }),
          Zt.apply(this, arguments)
        );
      }
      function Gt(e, t) {
        if (null == e) return {};
        var n,
          r,
          a = (function (e, t) {
            if (null == e) return {};
            var n,
              r,
              a = {},
              o = Object.keys(e);
            for (r = 0; r < o.length; r++)
              (n = o[r]), t.indexOf(n) >= 0 || (a[n] = e[n]);
            return a;
          })(e, t);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          for (r = 0; r < o.length; r++)
            (n = o[r]),
              t.indexOf(n) >= 0 ||
                (Object.prototype.propertyIsEnumerable.call(e, n) &&
                  (a[n] = e[n]));
        }
        return a;
      }
      function qt(t, n) {
        var r = t.title,
          a = t.titleId,
          o = Gt(t, Wt);
        return e.createElement(
          "svg",
          Zt(
            {
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 410 238",
              ref: n,
              "aria-labelledby": a,
            },
            o,
          ),
          r ? e.createElement("title", { id: a }, r) : null,
          Bt ||
            (Bt = e.createElement(
              "g",
              { transform: "matrix(.1 0 0 -.1 0 238)" },
              e.createElement("path", {
                d: "M2263 2290c-54-11-90-31-131-70-42-43-54-84-34-130 8-19 29-71 47-115s60-137 93-207l61-128h-107l-107 1-31 42c-387 521-381 514-431 538-48 24-51 24-440 27-271 2-406-1-435-9-53-14-112-72-127-124-14-51-14-189 0-240s73-110 124-124c25-7 151-11 336-11h295l190-256c198-269 260-334 335-354 26-7 177-10 432-8l393 3 41 27c68 45 87 87 91 203 5 136-6 175-73 239-74 71-195 296-292 541-20 50-47 102-60 117-21 22-93 51-120 47-4-1-27-5-50-9z",
              }),
              e.createElement("circle", { cx: 3355, cy: 1500, r: 395 }),
              e.createElement("rect", {
                x: 110,
                y: 185,
                width: 3720,
                height: 590,
                rx: 200,
              }),
            )),
        );
      }
      var Xt = e.forwardRef(qt);
      n.p;
      var _t,
        Yt = n(357),
        Jt = n.n(Yt),
        Kt = (function (t) {
          d(r, t);
          var n = m(r);
          function r() {
            var t;
            a(this, r);
            for (var o = arguments.length, i = new Array(o), l = 0; l < o; l++)
              i[l] = arguments[l];
            return (
              ((t = n.call.apply(n, [this].concat(i))).scopeClassNameCache =
                {}),
              (t.scopedCSSTextCache = {}),
              (t.scoped = t.props.scoped || !0),
              (t.pepper = ""),
              (t.getStyleString = function () {
                if (t.props.children instanceof Array) {
                  var n = t.props.children.filter(function (t) {
                    return !(0, e.isValidElement)(t) && "string" === typeof t;
                  });
                  if (n.length > 1)
                    throw new Error(
                      "Multiple style objects as direct descedents of a Style component are not supported ("
                        .concat(
                          n.length,
                          "\n          style objects detected): ",
                        )
                        .concat(n[0]),
                    );
                  return n[0];
                }
                return "string" !== typeof t.props.children ||
                  (0, e.isValidElement)(t.props.children)
                  ? null
                  : t.props.children;
              }),
              (t.getRootElement = function () {
                if (t.props.children instanceof Array) {
                  var n = t.props.children.filter(function (t) {
                    return (0, e.isValidElement)(t);
                  });
                  return n[0];
                }
                return (0, e.isValidElement)(t.props.children)
                  ? t.props.children
                  : null;
              }),
              (t.getRootSelectors = function (e) {
                var t = [];
                return (
                  e.props.id && t.push("#".concat(e.props.id)),
                  e.props.className &&
                    e.props.className
                      .trim()
                      .split(/\s+/g)
                      .forEach(function (e) {
                        return t.push(e);
                      }),
                  t.length || "function" === typeof e.type || t.push(e.type),
                  t
                );
              }),
              (t.processCSSText = function (e, n, r) {
                return e
                  .replace(/\s*\/\/(?![^(]*\)).*|\s*\/\*.*\*\//g, "")
                  .replace(/\s\s+/g, " ")
                  .split("}")
                  .map(function (e) {
                    var a = /.*:.*;/g,
                      o = /.*:.*(;|$|\s+)/g,
                      i = /\s*@/g,
                      l = /\s*(([0-9][0-9]?|100)\s*%)|\s*(to|from)\s*$/g;
                    return e
                      .split("{")
                      .map(function (e, c, s) {
                        if (!e.trim().length) return "";
                        var u = s.length - 1 === c && e.match(o);
                        if (e.match(a) || u)
                          return t.escapeTextContentForBrowser(e);
                        var d = e;
                        return !n ||
                          /:target/gi.test(d) ||
                          d.match(i) ||
                          d.match(l)
                          ? d
                          : t.scopeSelector(n, d, r);
                      })
                      .join("{\n");
                  })
                  .join("}\n");
              }),
              (t.escapeTextContentForBrowser = function (e) {
                var t = { ">": "&gt;", "<": "&lt;" };
                return "".concat(e).replace(/[><]/g, function (e) {
                  return t[e];
                });
              }),
              (t.scopeSelector = function (e, n, r) {
                var a = [];
                return (
                  n.split(/,(?![^(|[]*\)|\])/g).forEach(function (n) {
                    if (
                      null !== r &&
                      void 0 !== r &&
                      r.length &&
                      r.some(function (e) {
                        return n.match(e);
                      })
                    ) {
                      var o =
                          null === r || void 0 === r
                            ? void 0
                            : r.map(function (e) {
                                return e.replace(
                                  /[-/\\^$*+?.()|[\]{}]/g,
                                  "\\$&",
                                );
                              }),
                        i = n.replace(
                          new RegExp(
                            "(".concat(
                              null === o || void 0 === o ? void 0 : o.join("|"),
                              ")",
                            ),
                          ),
                          "$1".concat(e),
                        );
                      a.push(i, t.scoped ? "".concat(e, " ").concat(n) : n);
                    } else a.push(t.scoped ? "".concat(e, " ").concat(n) : n);
                  }),
                  !t.scoped && a.length > 1 ? a[1] : a.join(", ")
                );
              }),
              (t.getScopeClassName = function (e, n) {
                var r = e;
                return (
                  n &&
                    ((t.pepper = ""),
                    t.traverseObjectToGeneratePepper(n),
                    (r += t.pepper)),
                  "s" + Jt()(r)
                );
              }),
              (t.traverseObjectToGeneratePepper = function (e) {
                var n =
                  arguments.length > 1 && void 0 !== arguments[1]
                    ? arguments[1]
                    : 0;
                n > 32 ||
                  t.pepper.length > 1e4 ||
                  Object.keys(e).forEach(function (r) {
                    var a = /^[_$]|type|ref|^value$/.test(r);
                    e[r] && "object" === typeof e[r] && !a
                      ? t.traverseObjectToGeneratePepper(e[r], n + 1)
                      : e[r] &&
                        !a &&
                        "function" !== typeof e[r] &&
                        (t.pepper += e[r]);
                  });
              }),
              (t.isVoidElement = function (e) {
                return [
                  "area",
                  "base",
                  "br",
                  "col",
                  "command",
                  "embed",
                  "hr",
                  "img",
                  "input",
                  "keygen",
                  "link",
                  "meta",
                  "param",
                  "source",
                  "track",
                  "wbr",
                ].some(function (t) {
                  return e === t;
                });
              }),
              (t.createStyleElement = function (e, t) {
                return (0, ce.jsx)(
                  "style",
                  {
                    id: "seatmap_styles",
                    type: "text/css",
                    dangerouslySetInnerHTML: { __html: e || "" },
                  },
                  t,
                );
              }),
              (t.getNewChildrenForCloneElement = function (e, n, r) {
                return [t.createStyleElement(e, r)].concat(n.props.children);
              }),
              t
            );
          }
          return (
            c(r, [
              {
                key: "render",
                value: function () {
                  var t = this.getStyleString(),
                    n = this.getRootElement();
                  if (!t && n) return n.props.children;
                  if (t && !n)
                    return this.createStyleElement(
                      this.processCSSText(t),
                      this.getScopeClassName(t, n),
                    );
                  var r,
                    a,
                    o = n.props.id ? n.props.id : "",
                    i = n.props.className
                      ? "".concat(n.props.className, " ")
                      : "",
                    l = i + o + t;
                  this.scopeClassNameCache[l]
                    ? ((r = this.scopeClassNameCache[l]),
                      (a = this.scopedCSSTextCache[r]))
                    : ((r = this.getScopeClassName(t, n)),
                      (a = this.processCSSText(
                        t,
                        ".".concat(r),
                        this.getRootSelectors(n),
                      )),
                      (this.scopeClassNameCache[l] = r),
                      (this.scopedCSSTextCache[r] = a));
                  var c = this.scoped ? "".concat(i).concat(r) : i;
                  return (0, e.cloneElement)(
                    n,
                    U(U({}, n.props), {}, { className: c.trim() }),
                    this.getNewChildrenForCloneElement(a, n, r),
                  );
                },
              },
            ]),
            r
          );
        })(e.Component),
        Qt = function (e) {
          var t;
          return (
            "string" === typeof e.styles
              ? (t = e.styles.toString())
              : Array.isArray(t) &&
                (t = e.styles.reduce(function (e, t) {
                  return "".concat(e, " ").concat(t);
                })),
            (0, ce.jsxs)(Kt, { scoped: e.scoped, children: [t, e.children] })
          );
        },
        $t = {
          exit_hall: function (e) {
            return (0, ce.jsx)(Ae, U({}, e));
          },
          key_exit: function (e) {
            return (0, ce.jsx)(De, U({}, e));
          },
          luggage_rack: function (e) {
            return (0, ce.jsx)(Ue, U({}, e));
          },
          stairs_bottom_east: function (e) {
            return (0, ce.jsx)(Ge, U({}, e));
          },
          stairs_bottom_west: function (e) {
            return (0, ce.jsx)(Ke, U({}, e));
          },
          stairs_top_east: function (e) {
            return (0, ce.jsx)(rt, U({}, e));
          },
          stairs_top_west: function (e) {
            return (0, ce.jsx)(st, U({}, e));
          },
          table: function (e) {
            return (0, ce.jsx)(ht, U({}, e));
          },
          wc: function (e) {
            return (0, ce.jsx)(wt, U({}, e));
          },
          bike: function (e) {
            return (0, ce.jsx)(It, U({}, e));
          },
          disabled_wc_nursery: function (e) {
            return (0, ce.jsx)(Vt, U({}, e));
          },
          nursery: function (e) {
            return (0, ce.jsx)(Xt, U({}, e));
          },
          hallway: function () {
            return (0, ce.jsx)(ce.Fragment, {});
          },
          empty_area: function () {
            return (0, ce.jsx)(ce.Fragment, {});
          },
        },
        en = [
          "wc",
          "bike",
          "luggage_rack",
          "luggage_rack_no_icon",
          "stairs",
          "stairs_up",
          "stairs_down",
          "disabled_wc_nursery",
          "nursery",
        ],
        tn = function (e) {
          var t = be().currentDeck,
            n = ge().terms,
            r = e.cell.type.toLowerCase(),
            a = r;
          "stairs" === r &&
            (a = ""
              .concat(r, "_")
              .concat(t.deckType, "_")
              .concat(e.cell.orientationAngle)
              .toLowerCase());
          var o = $t[a],
            i = void 0 === o || en.includes(r),
            l =
              n["paoSeatmapUi.paoDeckgrid.paoSeparating.".concat(e.cell.type)],
            c = "pao-deck-separating-".concat(r);
          return (0, ce.jsx)(Qt, {
            styles:
              ".pao-deck-separating{width:100%;height:100%;-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center}.pao-deck-separating.tech_room,.pao-deck-separating.luggage_room{background-color:rgba(var(--ternary-color-rgb), 0.6) !important}.pao-deck-separating.with-background{background-color:rgba(var(--ternary-color-rgb), 0.2)}.pao-deck-separating svg{fill:var(--ternary-color)}.pao-deck-separating.luggage_rack svg{height:80%;width:80%;max-height:2.8em;max-width:2.8em}.pao-deck-separating.stairs svg{height:50%;width:50%}.pao-deck-separating.wc svg{height:50%;width:50%}.pao-deck-separating.disabled_wc_nursery svg{height:100%;width:100%}.pao-deck-separating.nursery svg{opacity:.9;height:80%;width:80%;max-height:2.8em;max-width:2.8em}.pao-deck-separating.table svg{opacity:.4;height:100%;width:100%}@media(min-width: 640px){.pao-deck-separating.table svg{-webkit-transform:rotate(90deg);transform:rotate(90deg);-webkit-transform-origin:50% 50%;transform-origin:50% 50%}}.pao-deck-separating.exit_hall{background-size:100% 100%}@media(min-width: 640px){.pao-deck-separating.exit_hall svg{height:100%;width:100%}}@media(max-width: 639px){.pao-deck-separating.exit_hall svg{width:50%;height:auto;-webkit-transform:rotate(90deg);transform:rotate(90deg)}}",
            children: (0, ce.jsxs)("div", {
              className: "pao-deck-separating "
                .concat(r, " ")
                .concat(i ? "with-background" : "", " ")
                .concat(r),
              "aria-labelledby": we.getLabel(c),
              children: [
                o
                  ? o({ role: "presentation", title: l })
                  : (0, ce.jsx)(ce.Fragment, {}),
                (0, ce.jsx)(xe, { id: c, label: l }),
              ],
            }),
          });
        },
        nn = {
          ArrowLeft: "ArrowLeft",
          ArrowRight: "ArrowRight",
          ArrowDown: "ArrowDown",
          ArrowUp: "ArrowUp",
          Enter: "Enter",
          Space: " ",
          Tab: "Tab",
          Escape: "Escape",
          Delete: "Delete",
          Backspace: "Backspace",
        },
        rn = ["title", "titleId"];
      function an() {
        return (
          (an = Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }),
          an.apply(this, arguments)
        );
      }
      function on(e, t) {
        if (null == e) return {};
        var n,
          r,
          a = (function (e, t) {
            if (null == e) return {};
            var n,
              r,
              a = {},
              o = Object.keys(e);
            for (r = 0; r < o.length; r++)
              (n = o[r]), t.indexOf(n) >= 0 || (a[n] = e[n]);
            return a;
          })(e, t);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          for (r = 0; r < o.length; r++)
            (n = o[r]),
              t.indexOf(n) >= 0 ||
                (Object.prototype.propertyIsEnumerable.call(e, n) &&
                  (a[n] = e[n]));
        }
        return a;
      }
      function ln(t, n) {
        var r = t.title,
          a = t.titleId,
          o = on(t, rn);
        return e.createElement(
          "svg",
          an(
            {
              viewBox: "0 0 19 19",
              xmlns: "http://www.w3.org/2000/svg",
              xmlnsXlink: "http://www.w3.org/1999/xlink",
              ref: n,
              "aria-labelledby": a,
            },
            o,
          ),
          void 0 === r
            ? e.createElement("title", { id: a }, "bubble of auxiliary service")
            : r
              ? e.createElement("title", { id: a }, r)
              : null,
          _t ||
            (_t = e.createElement(
              "g",
              null,
              e.createElement("path", {
                className: "background",
                d: "M13.6128603,11.7805674 C14.9324452,10.7882799 17.9592697,8.3909351 17.9592697,8.3909351 C17.9592697,8.3909351 18.2122728,6.71388717 17.4617677,5.37101871 C16.5872415,3.80604733 15.1776527,2.55475362 13.484587,1.84949141 C6.61948539,-1.01119426 0.000299999999,3.76572711 0.000299999999,10.03313 C0.000299999999,14.6767896 3.63659981,18.4914927 8.31113373,19.0001047 C8.33593796,19.0026712 8.35082049,18.971235 8.33522926,18.9521 C8.33522926,18.9521 9.10416033,16.0319591 9.79655263,15.2658749 C11.0636943,13.8628678 12.4910005,12.6238752 13.6128603,11.7805674",
              }),
              e.createElement("path", {
                className: "border",
                d: "M6.29913333,17.9067259 C3.03465185,16.6675037 0.703985185,13.5156148 0.703985185,9.82187407 C0.703985185,5.05076296 4.58561481,1.16842963 9.35672593,1.16842963 C13.5296889,1.16842963 17.0221704,4.13805926 17.832837,8.07528148 L18.5449852,8.07528148 C17.7258741,3.74328148 13.9265778,0.464725926 9.35672593,0.464725926 C4.18942963,0.464725926 0.000281481481,4.65387407 0.000281481481,9.82187407 C0.000281481481,13.9174296 2.63494815,17.3895037 6.29913333,18.6575778 L6.29913333,17.9067259 Z",
              }),
            )),
        );
      }
      var cn,
        sn,
        un,
        dn,
        pn = e.forwardRef(ln),
        fn = (n.p, ["title", "titleId"]);
      function mn() {
        return (
          (mn = Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }),
          mn.apply(this, arguments)
        );
      }
      function hn(e, t) {
        if (null == e) return {};
        var n,
          r,
          a = (function (e, t) {
            if (null == e) return {};
            var n,
              r,
              a = {},
              o = Object.keys(e);
            for (r = 0; r < o.length; r++)
              (n = o[r]), t.indexOf(n) >= 0 || (a[n] = e[n]);
            return a;
          })(e, t);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          for (r = 0; r < o.length; r++)
            (n = o[r]),
              t.indexOf(n) >= 0 ||
                (Object.prototype.propertyIsEnumerable.call(e, n) &&
                  (a[n] = e[n]));
        }
        return a;
      }
      function gn(t, n) {
        var r = t.title,
          a = t.titleId,
          o = hn(t, fn);
        return e.createElement(
          "svg",
          mn(
            {
              viewBox: "0 0 7 10",
              xmlns: "http://www.w3.org/2000/svg",
              xmlnsXlink: "http://www.w3.org/1999/xlink",
              ref: n,
              "aria-labelledby": a,
            },
            o,
          ),
          r ? e.createElement("title", { id: a }, r) : null,
          cn ||
            (cn = e.createElement("path", {
              d: "M0,2.90287818 L0,4.48416672 C0,6.41164928 1.33647818,8.13298753 3.15624719,8.3159932 C5.24375281,8.52601241 7,6.80057784 7,4.64281591 L7,2.90287818 C7,2.6803486 6.82896355,2.5 6.6179241,2.5 L0.382075896,2.5 C0.171141443,2.5 0,2.6803486 0,2.90287818",
            })),
          sn ||
            (sn = e.createElement("polygon", {
              points:
                "2.72222222 10 4.27777778 10 4.27777778 7.5 2.72222222 7.5",
            })),
          un ||
            (un = e.createElement("path", {
              d: "M2.33333333,4.16666667 C2.11845432,4.16666667 1.94444444,3.91752726 1.94444444,3.61041203 L1.94444444,0.55625464 C1.94444444,0.249139402 2.11845432,0 2.33333333,0 C2.54812808,0 2.72222222,0.249139402 2.72222222,0.55625464 L2.72222222,3.61041203 C2.72222222,3.91752726 2.54812808,4.16666667 2.33333333,4.16666667",
            })),
          dn ||
            (dn = e.createElement("path", {
              d: "M4.66666667,4.16666667 C4.45187192,4.16666667 4.27777778,3.91752726 4.27777778,3.61041203 L4.27777778,0.55625464 C4.27777778,0.249139402 4.45187192,0 4.66666667,0 C4.88154568,0 5.05555556,0.249139402 5.05555556,0.55625464 L5.05555556,3.61041203 C5.05555556,3.91752726 4.88154568,4.16666667 4.66666667,4.16666667",
            })),
        );
      }
      var vn,
        bn = e.forwardRef(gn),
        yn = (n.p, ["title", "titleId"]);
      function xn() {
        return (
          (xn = Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }),
          xn.apply(this, arguments)
        );
      }
      function wn(e, t) {
        if (null == e) return {};
        var n,
          r,
          a = (function (e, t) {
            if (null == e) return {};
            var n,
              r,
              a = {},
              o = Object.keys(e);
            for (r = 0; r < o.length; r++)
              (n = o[r]), t.indexOf(n) >= 0 || (a[n] = e[n]);
            return a;
          })(e, t);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          for (r = 0; r < o.length; r++)
            (n = o[r]),
              t.indexOf(n) >= 0 ||
                (Object.prototype.propertyIsEnumerable.call(e, n) &&
                  (a[n] = e[n]));
        }
        return a;
      }
      function kn(t, n) {
        var r = t.title,
          a = t.titleId,
          o = wn(t, yn);
        return e.createElement(
          "svg",
          xn(
            {
              viewBox: "0 0 7 10",
              xmlns: "http://www.w3.org/2000/svg",
              xmlnsXlink: "http://www.w3.org/1999/xlink",
              ref: n,
              "aria-labelledby": a,
            },
            o,
          ),
          r ? e.createElement("title", { id: a }, r) : null,
          vn ||
            (vn = e.createElement(
              "g",
              null,
              e.createElement(
                "g",
                { transform: "translate(1.500000, 0.000000)" },
                e.createElement("path", {
                  d: "M3.9619907,1.9863814 C3.9619907,3.07810233 3.07696744,3.96312558 1.98524651,3.96312558 C0.893618605,3.96312558 0.00850232558,3.07810233 0.00850232558,1.9863814 C0.00850232558,0.894660465 0.893618605,0.0096372093 1.98524651,0.0096372093 C3.07696744,0.0096372093 3.9619907,0.894660465 3.9619907,1.9863814",
                }),
              ),
              e.createElement(
                "g",
                { transform: "translate(0.000000, 4.000000)" },
                e.createElement("path", {
                  d: "M5.42006164,0.0600206897 C4.92440411,0.593606897 4.24032192,0.923503448 3.48480137,0.923503448 C2.72928082,0.923503448 2.04529452,0.593606897 1.54963699,0.0600206897 C0.242938356,1.43795172 0.0337054795,4.10826207 0.000335616438,4.92695172 C-0.00580136986,5.07850345 0.0755136986,5.21722759 0.20419863,5.27815862 C0.676554795,5.50191724 1.90510274,6.00002069 3.48480137,6.00002069 C5.0645,6.00002069 6.29304795,5.50191724 6.76540411,5.27815862 C6.89408904,5.21722759 6.9755,5.07850345 6.96926712,4.92695172 C6.93589726,4.10826207 6.72676027,1.43795172 5.42006164,0.0600206897",
                }),
              ),
            )),
        );
      }
      var Sn = e.forwardRef(kn);
      n.p;
      var Cn,
        En = new Map(
          Object.entries(
            (R((Cn = {}), L.POWER_PLUG, bn), R(Cn, L.SOLO, Sn), Cn),
          ),
        ),
        On = function (t) {
          var n = (0, e.useRef)(null);
          function r() {
            if (null !== n.current) {
              (n.current.style.height = ""), (n.current.style.width = "");
              var e = Math.min(n.current.offsetHeight, n.current.offsetWidth);
              (n.current.style.height = e + "px"),
                (n.current.style.width = e + "px");
            }
          }
          if (
            ((0, e.useEffect)(function () {
              r();
              var e = ["orientationchange", "resize"];
              return (
                e.forEach(function (e) {
                  return window.addEventListener(e, r);
                }),
                function () {
                  e.forEach(function (e) {
                    return window.removeEventListener(e, r);
                  });
                }
              );
            }),
            !t.seat.ancillaryServices || 0 === t.seat.ancillaryServices.length)
          )
            return (0, ce.jsx)(ce.Fragment, {});
          var a = t.seat.ancillaryServices
            .map(function (e) {
              return En.get(e.type);
            })
            .find(function (e) {
              return void 0 !== e;
            });
          return void 0 === a
            ? (0, ce.jsx)(ce.Fragment, {})
            : (0, ce.jsx)(Qt, {
                styles:
                  ".pao-ancillary-services-container{height:100%;width:100%;position:absolute}.pao-ancillary-services-container .pao-ancillary-services{height:100%;width:100%;position:relative;z-index:10}.pao-ancillary-services-container .pao-ancillary-services .bulle svg,.pao-ancillary-services-container .pao-ancillary-services .icon svg{position:absolute;top:0;left:0}.pao-ancillary-services-container .pao-ancillary-services .bulle svg{height:60%;width:60%;transform:translate(-24%, -34%)}.pao-ancillary-services-container .pao-ancillary-services .bulle svg .background{fill:#fff}.pao-ancillary-services-container .pao-ancillary-services .bulle svg .border{fill:var(--primary-color)}.pao-ancillary-services-container .pao-ancillary-services .icon svg{fill:var(--primary-color);height:30%;width:30%;transform:translate(-3%, -25%)}.pao-ancillary-services-container.disabled .bulle svg .background{fill:var(--secondary-color-disabled)}.pao-ancillary-services-container.disabled .bulle svg .border{fill:var(--secondary-color-disabled-border)}.pao-ancillary-services-container.disabled .icon svg{fill:var(--ternary-color);opacity:.5}.pao-ancillary-services-container.selected .bulle svg .background{fill:var(--primary-color)}.pao-ancillary-services-container.selected .bulle svg .border{fill:#fff}.pao-ancillary-services-container.selected .icon svg{fill:#fff}.pao-ancillary-services-container.current .bulle svg .background{fill:var(--primary-highlighted-color)}.pao-ancillary-services-container.current .bulle svg .border{fill:#fff}.pao-ancillary-services-container.current .icon svg{fill:#fff}",
                children: (0, ce.jsx)("div", {
                  className: "pao-ancillary-services-container ".concat(
                    t.state,
                  ),
                  ref: n,
                  children: (0, ce.jsxs)("div", {
                    className: "pao-ancillary-services",
                    "aria-hidden": "true",
                    children: [
                      (0, ce.jsx)("div", {
                        className: "bulle",
                        children: (0, ce.jsx)(pn, {}),
                      }),
                      (0, ce.jsx)("div", {
                        className: "icon",
                        children: (0, ce.jsx)(a, {}),
                      }),
                    ],
                  }),
                }),
              });
        },
        An = (function (e) {
          return (
            (e.DISABLED = "disabled"),
            (e.ENABLE = "enable"),
            (e.SELECTED = "selected"),
            (e.CURRENT = "current"),
            e
          );
        })({});
      function jn() {
        return (0, ce.jsx)("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 80 80",
          children: (0, ce.jsxs)("g", {
            transform: "matrix(1.71546 0 0 -1.85463 -2047.77 1005.312)",
            children: [
              (0, ce.jsx)("path", {
                fill: "white",
                stroke: "none",
                d: "M1230.2109 537.3271h-28.416c-6.18 0-6.885-4.027-6.885-7.131v-19.642c0-3.104.705-7.133 6.885-7.133h28.416z",
              }),
              (0, ce.jsx)("path", {
                fill: "white",
                strokeMiterlimit: "10",
                d: "M1202.926333 537.3271h-1.131433c-6.18 0-6.885-4.027-6.885-7.131v-19.642c0-3.104.705-7.133 6.885-7.133h1.18348",
              }),
              (0, ce.jsx)("path", {
                fill: "white",
                stroke: "none",
                d: "M1204.4746 535.3857c-.794 0-1.437.645-1.437 1.436v2.42c0 .795.643 1.437 1.437 1.437h22.348c.795 0 1.437-.642 1.437-1.437v-2.42c0-.791-.642-1.436-1.437-1.436z",
              }),
              (0, ce.jsx)("path", {
                fill: "white",
                strokeMiterlimit: "10",
                d: "M1221.610757 535.3857H1204.4746c-.794 0-1.437.645-1.437 1.436v2.42c0 .795.643 1.437 1.437 1.437h16.68582",
              }),
              (0, ce.jsx)("path", {
                fill: "white",
                stroke: "none",
                d: "M1204.4746 500.0713c-.794 0-1.437.643-1.437 1.437v2.42c0 .793.643 1.438 1.437 1.438h22.348c.795 0 1.437-.645 1.437-1.438v-2.42c0-.794-.642-1.437-1.436-1.437z",
              }),
              (0, ce.jsx)("path", {
                fill: "white",
                strokeMiterlimit: "10",
                d: "M1221.64756 500.0713h-17.17296c-.794 0-1.437.643-1.437 1.437v2.42c0 .793.643 1.438 1.437 1.438h17.209763",
              }),
              (0, ce.jsx)("path", {
                fill: "white",
                stroke: "none",
                d: "M1231.998 500.0732c3.068 0 7.102 5.064 7.102 20.303 0 15.238-4.034 20.303-7.102 20.303h-10.172c-.686 0-2.105-.117-2.105-1.334v-2.51c0-1.41 7.879-2.617 7.879-4.422v-23.555c0-1.805-7.879-3.533-7.879-4.943v-2.508c0-1.219 1.419-1.336 2.105-1.336.53.002 7.102.002 10.172.002",
              }),
              (0, ce.jsx)("path", {
                fill: "white",
                strokeMiterlimit: "10",
                d: "M1231.998 500.0732c3.068 0 7.102 5.064 7.102 20.303 0 15.238-4.034 20.303-7.102 20.303h-10.172c-.686 0-2.105-.117-2.105-1.334v-2.51c0-1.41 7.879-2.617 7.879-4.422v-23.555c0-1.805-7.879-3.533-7.879-4.943v-2.508c0-1.219 1.419-1.336 2.105-1.336.53.002 7.102.002 10.172.002z",
              }),
              (0, ce.jsx)("g", {
                opacity: ".300003",
                children: (0, ce.jsx)("path", {
                  stroke: "none",
                  d: "M1227.6152 530.1377h5.336c1.223 0 2.213-.992 2.213-2.215v-15.096c0-1.222-.99-2.214-2.213-2.214h-5.336z",
                }),
              }),
            ],
          }),
        });
      }
      function Ln() {
        return (0, ce.jsx)("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 80 80",
          children: (0, ce.jsxs)("g", {
            transform: "matrix(1.71546 0 0 -1.85463 -2047.77 1005.312)",
            children: [
              (0, ce.jsx)("path", {
                fill: "none",
                stroke: "white",
                d: "M1230.2109 537.3271h-28.416c-6.18 0-6.885-4.027-6.885-7.131v-19.642c0-3.104.705-7.133 6.885-7.133h28.416z",
              }),
              (0, ce.jsx)("path", {
                fill: "none",
                stroke: "white",
                d: "M1204.4746 535.3857c-.794 0-1.437.645-1.437 1.436v2.42c0 .795.643 1.437 1.437 1.437h22.348c.795 0 1.437-.642 1.437-1.437v-2.42c0-.791-.642-1.436-1.437-1.436zm0-35.3144c-.794 0-1.437.643-1.437 1.437v2.42c0 .793.643 1.438 1.437 1.438h22.348c.795 0 1.437-.645 1.437-1.438v-2.42c0-.794-.642-1.437-1.436-1.437z",
              }),
              (0, ce.jsx)("path", {
                fill: "none",
                stroke: "white",
                d: "M1221.64756 500.0713h-17.17296c-.794 0-1.437.643-1.437 1.437v2.42c0 .793.643 1.438 1.437 1.438h17.209763m-.07361 30.0194H1204.4746c-.794 0-1.437.645-1.437 1.436v2.42c0 .795.643 1.437 1.437 1.437h16.68582m-18.234087-3.3516h-1.131433c-6.18 0-6.885-4.027-6.885-7.131v-19.642c0-3.104.705-7.133 6.885-7.133h1.18348",
              }),
              (0, ce.jsx)("path", {
                fill: "none",
                stroke: "white",
                d: "M1231.998 500.0732c3.068 0 7.102 5.064 7.102 20.303 0 15.238-4.034 20.303-7.102 20.303h-10.172c-.686 0-2.105-.117-2.105-1.334v-2.51c0-1.41 7.879-2.617 7.879-4.422v-23.555c0-1.805-7.879-3.533-7.879-4.943v-2.508c0-1.219 1.419-1.336 2.105-1.336.53.002 7.102.002 10.172.002",
              }),
              (0, ce.jsx)("path", {
                fill: "none",
                stroke: "white",
                d: "M1231.998 500.0732c3.068 0 7.102 5.064 7.102 20.303 0 15.238-4.034 20.303-7.102 20.303h-10.172c-.686 0-2.105-.117-2.105-1.334v-2.51c0-1.41 7.879-2.617 7.879-4.422v-23.555c0-1.805-7.879-3.533-7.879-4.943v-2.508c0-1.219 1.419-1.336 2.105-1.336.53.002 7.102.002 10.172.002z",
              }),
              (0, ce.jsx)("g", {
                opacity: ".300003",
                children: (0, ce.jsx)("path", {
                  fill: "none",
                  d: "M1228.107086 530.13568l4.844114.00202c1.223.00051 2.213-.992 2.213-2.215v-15.096c0-1.222-.99-2.214-2.213-2.214l-4.838598.01965z",
                }),
              }),
              (0, ce.jsx)("path", {
                fill: "none",
                stroke: "white",
                d: "M1200.625933 503.996464c-1.639124.171715-2.743783.633274-3.647424 1.524002-.77286.761807-1.19487 1.717893-1.4606 3.309036-.08542.511416-.13036 21.34984-.04834 22.410147.17415 2.25136.82514 3.62191 2.16006 4.54764.52838.36642 1.42403.70734 2.2719.86478.44294.08224 1.58438.17176 2.19239.17194l.40101.00011.03049-.18053c.13316-.78843.52986-1.31709 1.21292-1.6164l.34875-.15283 8.7376-.01286c5.25721-.00774 8.76088.00474 8.79605.03138.03755.02842.28174-.03728.68302-.18377.34351-.125406 1.05787-.385287 1.58745-.577515 1.65881-.602115 2.47689-.994415 2.9537-1.416416l.2212-.195773v-23.7643l-.22048-.22124c-.49461-.496325-1.21583-.877565-3.60224-1.90416l-1.768955-.760973h-8.67413c-9.61212 0-8.85678.02571-9.40273-.32002-.449347-.28455-.754076-.7837-.87004-1.42513l-.03264-.18053-.73932.00624c-.406626.00345-.91498.024648-1.129677.04714z",
              }),
              (0, ce.jsx)("path", {
                fill: "none",
                stroke: "white",
                d: "M1200.625933 503.996464c-1.639124.171715-2.743783.633274-3.647424 1.524002-.77286.761807-1.19487 1.717893-1.4606 3.309036-.08542.511416-.13036 21.34984-.04834 22.410147.17415 2.25136.82514 3.62191 2.16006 4.54764.52838.36642 1.42403.70734 2.2719.86478.44294.08224 1.58438.17176 2.19239.17194l.40101.00011.03049-.18053c.13316-.78843.52986-1.31709 1.21292-1.6164l.34875-.15283 8.7376-.01286c5.25721-.00774 8.76088.00474 8.79605.03138.03755.02842.28174-.03728.68302-.18377.34351-.125406 1.05787-.385287 1.58745-.577515 1.65881-.602115 2.47689-.994415 2.9537-1.416416l.2212-.195773v-23.7643l-.22048-.22124c-.49461-.496325-1.21583-.877565-3.60224-1.90416l-1.768955-.760973h-8.67413c-9.61212 0-8.85678.02571-9.40273-.32002-.449347-.28455-.754076-.7837-.87004-1.42513l-.03264-.18053-.73932.00624c-.406626.00345-.91498.024648-1.129677.04714z",
              }),
              (0, ce.jsx)("path", {
                fill: "none",
                stroke: "white",
                d: "M1200.625933 503.996464c-1.639124.171715-2.743783.633274-3.647424 1.524002-.77286.761807-1.19487 1.717893-1.4606 3.309036-.08542.511416-.13036 21.34984-.04834 22.410147.17415 2.25136.82514 3.62191 2.16006 4.54764.52838.36642 1.42403.70734 2.2719.86478.44294.08224 1.58438.17176 2.19239.17194l.40101.00011.03049-.18053c.13316-.78843.52986-1.31709 1.21292-1.6164l.34875-.15283 8.7376-.01286c5.25721-.00774 8.76088.00474 8.79605.03138.03755.02842.28174-.03728.68302-.18377.34351-.125406 1.05787-.385287 1.58745-.577515 1.65881-.602115 2.47689-.994415 2.9537-1.416416l.2212-.195773v-23.7643l-.22048-.22124c-.49461-.496325-1.21583-.877565-3.60224-1.90416l-1.768955-.760973h-8.67413c-9.61212 0-8.85678.02571-9.40273-.32002-.449347-.28455-.754076-.7837-.87004-1.42513l-.03264-.18053-.73932.00624c-.406626.00345-.91498.024648-1.129677.04714z",
              }),
              (0, ce.jsx)("path", {
                fill: "none",
                stroke: "white",
                d: "M1200.625933 503.996464c-1.639124.171715-2.743783.633274-3.647424 1.524002-.77286.761807-1.19487 1.717893-1.4606 3.309036-.08542.511416-.13036 21.34984-.04834 22.410147.17415 2.25136.82514 3.62191 2.16006 4.54764.52838.36642 1.42403.70734 2.2719.86478.44294.08224 1.58438.17176 2.19239.17194l.40101.00011.03049-.18053c.13316-.78843.52986-1.31709 1.21292-1.6164l.34875-.15283 8.7376-.01286c5.25721-.00774 8.76088.00474 8.79605.03138.03755.02842.28174-.03728.68302-.18377.34351-.125406 1.05787-.385287 1.58745-.577515 1.65881-.602115 2.47689-.994415 2.9537-1.416416l.2212-.195773v-23.7643l-.22048-.22124c-.49461-.496325-1.21583-.877565-3.60224-1.90416l-1.768955-.760973h-8.67413c-9.61212 0-8.85678.02571-9.40273-.32002-.449347-.28455-.754076-.7837-.87004-1.42513l-.03264-.18053-.73932.00624c-.406626.00345-.91498.024648-1.129677.04714z",
              }),
              (0, ce.jsx)("path", {
                fillOpacity: ".7",
                d: "M1200.625933 503.996464c-1.639124.171715-2.743783.633274-3.647424 1.524002-.77286.761807-1.19487 1.717893-1.4606 3.309036-.08542.511416-.13036 21.34984-.04834 22.410147.17415 2.25136.82514 3.62191 2.16006 4.54764.52838.36642 1.42403.70734 2.2719.86478.44294.08224 1.58438.17176 2.19239.17194l.40101.00011.03049-.18053c.13316-.78843.52986-1.31709 1.21292-1.6164l.34875-.15283 8.7376-.01286c5.25721-.00774 8.76088.00474 8.79605.03138.03755.02842.28174-.03728.68302-.18377.34351-.125406 1.05787-.385287 1.58745-.577515 1.65881-.602115 2.47689-.994415 2.9537-1.416416l.2212-.195773v-23.7643l-.22048-.22124c-.49461-.496325-1.21583-.877565-3.60224-1.90416l-1.768955-.760973h-8.67413c-9.61212 0-8.85678.02571-9.40273-.32002-.449347-.28455-.754076-.7837-.87004-1.42513l-.03264-.18053-.73932.00624c-.406626.00345-.91498.024648-1.129677.04714z",
              }),
              (0, ce.jsx)("path", {
                fillOpacity: ".7",
                d: "M1204.19834 500.64365c-.294078.09697-.493442.297928-.5852.589878-.121086.385267-.086637 2.906546.0427 3.12506.120282.203217.368573.389312.602763.451772.133938.03572 2.518718.04714 7.808285.037387l7.61545-.01404-.178675-.21664c-.09827-.119152-.205235-.29028-.237698-.380285-.039103-.108413-.05845-.668984-.057326-1.660902.00151-1.318353.01298-1.527457.09609-1.750003l.0944-.252746-7.49988.00211c-6.23253.00177-7.53385.01333-7.70092.06842zm-.12565 35.367776c-.151542.069383-.267846.173106-.364333.32492l-.141732.223005v1.46834c0 1.42618.003322 1.47409.11593 1.66889.06376.1103.192577.25112.28626.31293l.170334.11238 7.61196.01251c4.18658.00688 7.61171.00688 7.6114 0-.00031-.00688-.03545-.11885-.07807-.24883-.06174-.18824-.07728-.54577-.07637-1.757184.00128-1.689245.01021-1.740593.35934-2.063525l.168-.155395-7.72007.00004-7.72007.00004z",
              }),
              (0, ce.jsx)("path", {
                d: "M1221.304018 500.624243c-.390224.046977-.724312.1789-.89998.355385l-.13012.13072v2.852472l.308902.230242c.337753.251747 1.507993.817312 2.9701 1.435418 1.38813.586832 2.608682 1.166483 3.15725 1.499406.57239.347378 1.069074.797415 1.24504 1.128105.11986.22526.126605.28748.141624 1.30644l.015768 1.06993 2.716732.01328 2.71673.01328.29257.1329c.5607.2547.95965.67471 1.203573 1.26711l.117334.28497.01537 7.75088c.01025 5.16473-.00268 7.87939-.03872 8.13602-.10647.7582-.58604 1.39758-1.28811 1.71736l-.35167.16018-2.69465.01369-2.69465.013687-.00052 1.28615c-.00052 1.269597-.00215 1.289475-.13033 1.5441-.38197.75898-1.42357 1.320596-4.50139 2.427108-1.96277.70564-2.67803 1.012428-3.06793 1.315888l-.15902.123768.000197 1.355738c.00023 1.588688-.00134 1.583218.508635 1.80429l.29791.12915 5.64717.013616 5.64717.013615.36172-.10699c1.02104-.30202 2.10534-1.364548 2.94257-2.883496 1.92902-3.499735 2.914823-9.1743 2.914204-16.775-.000577-7.08544-.85375-12.49274-2.53312-16.054634-1.02223-2.16811-2.36439-3.508154-3.7114-3.70554-.40471-.059305-10.525755-.05856-11.018927.00081z",
              }),
              (0, ce.jsx)("path", {
                fill: "none",
                stroke: "white",
                d: "M1228.107087 520.383858v9.745723l2.641418-.02746c1.45278-.01511 2.725418-.04685 2.828085-.07055.257205-.05936.774804-.37726.968942-.59511.23254-.26094.416824-.59401.508203-.91851.070107-.24896.079784-1.23851.079784-8.1584 0-6.96199-.00937-7.90834-.08078-8.162-.21367-.75896-.97225-1.44488-1.65097-1.4928-.14965-.01056-1.40218-.02987-2.78339-.0429l-2.5113-.02368z",
              }),
            ],
          }),
        });
      }
      function Nn(e, t) {
        var n = void 0 === t && void 0 === e ? "0.33" : void 0;
        return (0, ce.jsxs)("svg", {
          viewBox: "0 0 29 29",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            (0, ce.jsx)("rect", {
              fill: t,
              opacity: n,
              x: "0.8",
              y: "0.5",
              width: "28",
              height: "28",
              rx: "3",
            }),
            (0, ce.jsx)("g", {
              transform:
                "scale(0.75, 0.75) translate(38.5000,-0.000000) rotate(90)",
              fill: e,
              stroke: "none",
              children: (0, ce.jsx)("path", {
                d: "M38.14,3.2c0-.25,0-.42,0-.45h0A3.42,3.42,0,0,0,34.75,0H3.41A3.42,3.42,0,0,0,.07,2.75h0A4.13,4.13,0,0,0,0,3.2c0,.07,0,.14,0,.21V34.75a3.41,3.41,0,0,0,3.41,3.41H34.75a3.41,3.41,0,0,0,3.41-3.41V3.41C38.16,3.34,38.14,3.27,38.14,3.2Zm-36.83,0c0-.07,0-.14,0-.2V3A2.12,2.12,0,0,1,3.41,1.29H34.75A2.12,2.12,0,0,1,36.82,3V3c0,.06,0,.13,0,.2.07,1,0,4.53-4.82,7.4a1.82,1.82,0,0,1-1,.26h-24a1.84,1.84,0,0,1-1-.26C1.35,7.75,1.24,4.18,1.31,3.22ZM36.87,29.48h0v5.27a2.12,2.12,0,0,1-2.12,2.12H3.41a2.12,2.12,0,0,1-2.12-2.12v-27a12,12,0,0,0,4.18,4,3.27,3.27,0,0,0,.33.14,2.47,2.47,0,0,0,1.29.3c3,.15,12,0,12,0s9,.18,12,0h0a3.31,3.31,0,0,0,1.29-.29h0c.11,0,.23-.08.34-.14a11.92,11.92,0,0,0,4.17-3.95V27.23h0Z",
              }),
            }),
          ],
        });
      }
      var Tn = function (e) {
        var t = ge().managerType;
        return (function (e, t, n) {
          if (t === P.TGV_IC)
            switch (e) {
              case An.DISABLED:
                return Ln();
              case An.ENABLE:
                return jn();
              case An.SELECTED:
              case An.CURRENT:
                return Ln();
            }
          if (t === P.OUIGO || t === P.OUIGO_LC)
            switch (e) {
              case An.DISABLED:
                return Nn(void 0, void 0);
              case An.ENABLE:
                return Nn(void 0, "white");
              case An.SELECTED:
              case An.CURRENT:
                return Nn("white", void 0);
            }
          if (t === P.OUIGO_ESP) {
            var r = n === L.STANDARD;
            switch (e) {
              case An.DISABLED:
                return r ? Nn(void 0, void 0) : Ln();
              case An.ENABLE:
                return r ? Nn(void 0, "white") : jn();
              case An.SELECTED:
              case An.CURRENT:
                return r ? Nn("white", void 0) : Ln();
            }
          }
          throw new Error(
            "Le managerType ".concat(t, " n'est pas reconnu par PaoSeat."),
          );
        })(e.state, t, e.type || L.STANDARD);
      };
      function Pn(e, t) {
        t.seat.available && e(J.changeSelectedSeat(t.seat));
      }
      function Dn(e, t, n) {
        var r = (function (e, t) {
            var n;
            return (
              (null === (n = t.ancillaryServices) || void 0 === n
                ? void 0
                : n
                    .map(function (t) {
                      return e["paoSeatmapUi.paoLegend.seat." + t.type] || "";
                    })
                    .join(" ")) ||
              e["paoSeatmapUi.paoDeckgrid.paoSeat.seatLabels"]
            );
          })(e, t),
          a = e["paoSeatmapUi.paoDeckgrid.paoSeat.selectedLabels.true"],
          o = n ? " " + a : "",
          i =
            e[
              "paoSeatmapUi.paoDeckgrid.paoSeat.availableLabels." +
                (t.available ? "true" : "false")
            ];
        return [r + " " + t.seatNumber, o, i].filter(function (e) {
          return !!e;
        });
      }
      function zn(e, t) {
        return [
          e[
            "paoSeatmapUi.paoDeckgrid.paoSeat.orientationLabels." +
              t.orientationAngle
          ],
          e[
            "paoSeatmapUi.paoDeckgrid.paoSeat.positionLabels." + t.seat.position
          ],
          e[
            "paoSeatmapUi.paoDeckgrid.paoSeat.shelfLabels." +
              ("SHELF" === t.seat.type.toUpperCase() ? "true" : "false")
          ],
        ].filter(function (e) {
          return !!e;
        });
      }
      var Mn = function (t) {
        var n,
          r,
          a = me(),
          o = be(),
          i = o.placings,
          l = o.currentDeck,
          c = o.currentPassenger,
          s = ve().seatFocusHolder,
          u = ge(),
          d = u.terms,
          p = u.managerType,
          f = u.trainType,
          m = M.TRAIN_TYPES_WITH_PASSENGER_SEATMAP.includes(f),
          h = (0, e.useRef)(null),
          g = t.orientationAngle.toLowerCase(),
          v = (function (e, t, n) {
            return e.some(function (e) {
              return e.seat.id === n.id && e.deck["@id"] === t["@id"];
            });
          })(i, l, t.seat),
          b = !1,
          y = t.seat.available ? An.ENABLE : An.DISABLED;
        v &&
          ((y = An.SELECTED),
          (b = (function (e, t, n, r) {
            if (null === n) return !1;
            return e.some(function (e) {
              return (
                e.seat.id === r.id &&
                e.deck["@id"] === t["@id"] &&
                null !== e.passenger &&
                e.passenger.rank === n.rank &&
                e.passenger.type === n.type
              );
            });
          })(i, l, c, t.seat)),
          b && (y = An.CURRENT));
        var x,
          w = v ? "selected" : "unselected",
          k = t.seat.available ? "enabled" : "disabled",
          S = b ? "current" : "",
          C = p === P.TGV_IC ? "tgv-ic" : void 0,
          E =
            void 0 === s.seatWithFocus &&
            void 0 !== s.focusableSeats &&
            s.focusableSeats.length > 0 &&
            s.focusableSeats[0].seatNumber === t.seat.seatNumber,
          O =
            void 0 !== s.seatWithFocus &&
            s.seatWithFocus.seatNumber === t.seat.seatNumber,
          A = E || O ? 0 : -1,
          j =
            null === (n = t.seat.ancillaryServices) ||
            void 0 === n ||
            null ===
              (r = n.find(function (e) {
                return ["STANDARD", "XL"].includes(e.type);
              })) ||
            void 0 === r
              ? void 0
              : r.type,
          L = function () {
            O || a(J.seatGetFocusBySystem(t.seat));
          };
        ((0, e.useEffect)(
          function () {
            var e;
            O && (null === (e = h.current) || void 0 === e || e.focus());
          },
          [O, s],
        ),
        b && O) &&
          (null === (x = h.current) || void 0 === x || x.focus());
        var N = function () {
            b && v && O && Pn(a, t);
          },
          T = "seat".concat(t.seat.seatNumber);
        return (0, ce.jsx)(Qt, {
          styles:
            ".seat-wrapper{width:100%;height:100%;box-sizing:border-box;padding:.1em}.seat-wrapper .pao-seat{cursor:pointer;-webkit-box-align:center;align-items:center;color:#fff;display:-webkit-box;display:flex;height:100%;-webkit-box-pack:center;justify-content:center}.seat-wrapper .pao-seat .seat-svg{height:100%;width:100%}.seat-wrapper .pao-seat .seat-svg svg{height:100%;width:100%;box-sizing:inherit;stroke:var(--primary-color);fill:var(--primary-color)}@media(max-width: 639px){.seat-wrapper .pao-seat .seat-svg svg{-webkit-transform:rotate(90deg);transform:rotate(90deg);-webkit-transform-origin:50% 50%;transform-origin:50% 50%}}.seat-wrapper .pao-seat .seat-number{height:100%;width:100%;pointer-events:none;text-align:center;position:absolute;left:0;top:0}.seat-wrapper .pao-seat .seat-number span{font-size:10px;font-weight:bold;z-index:20}.seat-wrapper .pao-seat .seat-number span.unselected.enabled{color:var(--ternary-color);background-color:rgba(255,255,255,.6)}.seat-wrapper .pao-seat .seat-number span.selected{color:#fff;text-shadow:-1px 0 var(--primary-highlighted-color),0 1px var(--primary-highlighted-color),1px 0 var(--primary-highlighted-color),0 -1px var(--primary-highlighted-color)}.seat-wrapper .pao-seat .seat-number span.disabled{color:var(--secondary-color);background-color:rgba(0,0,0,0)}.seat-wrapper .pao-seat .seat-number span.tgv-ic{color:var(--ternary-color);font-size:13px;background-color:rgba(0,0,0,0);text-shadow:none}@media(min-width: 640px){.seat-wrapper .pao-seat .seat-number span{position:absolute;top:50%;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)}}@media(max-width: 639px){.seat-wrapper .pao-seat .seat-number span{position:absolute;top:calc(50% + .3em);left:50%;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)}}.seat-wrapper .pao-seat .ancillary-services{height:100%;width:100%;position:absolute}.seat-wrapper .pao-seat .ancillary-services .bulle svg,.seat-wrapper .pao-seat .ancillary-services .icon svg{position:absolute;top:9%;left:21%;transform:translate(-50%, -50%)}.seat-wrapper .pao-seat .ancillary-services .bulle svg{fill:var(--primary-color);height:60%;width:60%}.seat-wrapper .pao-seat .ancillary-services .icon svg{fill:var(--primary-color);height:30%;width:30%}.seat-wrapper .pao-seat:focus{outline-color:var(--primary-color);outline-width:2px;outline-style:dashed}.seat-wrapper .pao-seat.disabled{cursor:not-allowed}.seat-wrapper .pao-seat.disabled:focus{outline-color:rgba(var(--secondary-color-rgb), 0.4)}.seat-wrapper .pao-seat.disabled .seat-svg svg{fill:var(--secondary-color);stroke:#fff;opacity:.4}.seat-wrapper .pao-seat.disabled .ancillary-services .bulle svg{fill:var(--secondary-color)}.seat-wrapper .pao-seat.selected .seat-svg svg{fill:var(--primary-color);stroke:none}.seat-wrapper .pao-seat.selected .seat-number span{color:#fff}.seat-wrapper .pao-seat.current .seat-svg svg{fill:var(--primary-highlighted-color);stroke:none}.seat-wrapper .pao-seat.current .seat-number span{color:#fff}.seat-wrapper .pao-seat.east .seat-svg svg{transform:rotate(180deg)}@media(max-width: 639px){.seat-wrapper .pao-seat.east .seat-svg svg{-webkit-transform:rotate(-90deg);transform:rotate(-90deg);-webkit-transform-origin:50% 50%;transform-origin:50% 50%}}@media(min-width: 640px){.seat-wrapper .pao-seat.east .seat-number span{left:calc(50% + .4em)}}@media(min-width: 640px){.seat-wrapper .pao-seat.west .seat-number span{left:calc(50% - .4em)}}@media(max-width: 639px){.seat-wrapper .pao-seat.west .seat-number span{top:calc(50% - .3em)}}.seat-wrapper .pao-seat.south .seat-svg svg{transform:rotate(-90deg)}@media(max-width: 639px){.seat-wrapper .pao-seat.south .seat-svg svg{transform:rotate(0deg);transform-origin:50% 50%}}@media(min-width: 640px){.seat-wrapper .pao-seat.south .seat-number span{top:calc(50% + .3em);left:50%}}@media(max-width: 639px){.seat-wrapper .pao-seat.south .seat-number span{top:50%;left:calc(50% - .4em)}}.seat-wrapper .pao-seat.north .seat-svg svg{transform:rotate(90deg)}@media(max-width: 639px){.seat-wrapper .pao-seat.north .seat-svg svg{transform:rotate(180deg);transform-origin:50% 50%}}@media(min-width: 640px){.seat-wrapper .pao-seat.north .seat-number span{top:calc(50% - .3em);left:50%}}@media(max-width: 639px){.seat-wrapper .pao-seat.north .seat-number span{top:50%;left:calc(50% + .4em)}}",
          children: (0, ce.jsx)("div", {
            className: "seat-wrapper",
            children: (0, ce.jsxs)("div", {
              tabIndex: A,
              role: "checkbox",
              "aria-checked": v,
              "aria-disabled": !t.seat.available,
              "aria-labelledby": we.getLabel(T),
              "aria-describedby": we.getDescription(T),
              className: "pao-seat "
                .concat(g, " ")
                .concat(S, " ")
                .concat(w, " ")
                .concat(k),
              onClick: function () {
                L(), Pn(a, t);
              },
              onKeyDown: function (e) {
                return (function (e, t, n, r, a) {
                  if (!a && (e.key === nn.ArrowUp || e.key === nn.ArrowDown))
                    return;
                  switch (e.key) {
                    case nn.ArrowUp:
                    case nn.ArrowLeft:
                      t(J.changeFocusToPreviousSeat()), e.preventDefault();
                      break;
                    case nn.ArrowDown:
                    case nn.ArrowRight:
                      t(J.changeFocusToNextSeat()), e.preventDefault();
                      break;
                    case nn.Enter:
                    case nn.Space:
                      Pn(t, n), e.preventDefault();
                      break;
                    case nn.Delete:
                    case nn.Backspace:
                      r();
                  }
                })(e, a, t, N, m);
              },
              onFocus: L,
              ref: h,
              children: [
                (0, ce.jsx)("div", {
                  className: "seat-svg",
                  "aria-hidden": "true",
                  children: (0, ce.jsx)(Tn, { state: y, type: j }),
                }),
                (0, ce.jsx)(On, { seat: t.seat, state: y }),
                (0, ce.jsx)("div", {
                  className: "seat-number",
                  "aria-hidden": "true",
                  children: (0, ce.jsx)("span", {
                    className: "".concat(k, " ").concat(w, " ").concat(C),
                    children: t.seat.seatNumber,
                  }),
                }),
                (0, ce.jsx)(xe, {
                  id: T,
                  label: Dn(d, t.seat, v),
                  description: zn(d, t),
                  separator: ", ",
                }),
              ],
            }),
          }),
        });
      };
      var In = function (e) {
        return (0, ce.jsx)(Qt, {
          styles:
            ".pao-deck-cell{width:100%;height:100%}.pao-deck-seat{background-color:salmon;width:100%;height:100%}",
          children: (0, ce.jsx)("div", {
            className: "pao-deck-cell",
            children: e.deckCell.seat
              ? (0, ce.jsx)(Mn, {
                  orientationAngle: e.deckCell.orientationAngle,
                  seat: e.deckCell.seat,
                })
              : (0, ce.jsx)(tn, { cell: e.deckCell }),
          }),
        });
      };
      var Rn = function () {
        var t = be().currentDeck,
          n = ve(),
          r = n.isHorizontalDisplay,
          a = n.displayPassenger,
          o = ge().trainType,
          i = I(
            (0, e.useState)({
              nbRow: 4,
              nbColumn: 30,
              rowSize: 25,
              columnSize: 100 / 30,
            }),
            2,
          ),
          l = i[0],
          c = i[1],
          s = (0, e.useRef)(null);
        (0, e.useEffect)(
          function () {
            t &&
              c({
                nbRow: t.deckGrid.rowSize,
                nbColumn: t.deckGrid.columnSize,
                rowSize: 100 / t.deckGrid.rowSize,
                columnSize: 100 / t.deckGrid.columnSize,
              });
          },
          [t],
        ),
          (0, e.useEffect)(
            function () {
              var e = function () {
                if (null !== s.current) {
                  var e = null;
                  r
                    ? o === T.IC &&
                      (e =
                        0.1501103752759382 *
                        s.current.getBoundingClientRect().width)
                    : a &&
                      (e =
                        (t.deckGrid.columnSize / t.deckGrid.rowSize) *
                        s.current.getBoundingClientRect().width),
                    (s.current.style.minHeight =
                      null === e ? "" : "".concat(e, "px"));
                }
              };
              e();
              var n = ["orientationchange", "resize"];
              return (
                n.forEach(function (t) {
                  return window.addEventListener(t, e);
                }),
                function () {
                  n.forEach(function (t) {
                    return window.removeEventListener(t, e);
                  });
                }
              );
            },
            [o, s, r, t, a],
          );
        var u = function (e) {
          return r
            ? {
                top: "".concat((e.rowRank / l.nbRow) * 100, "%"),
                left: "".concat((e.columnRank / l.nbColumn) * 100, "%"),
                width: "".concat((e.columnStretch || 1) * l.columnSize, "%"),
                height: "".concat((e.rowStretch || 1) * l.rowSize, "%"),
              }
            : {
                top: "".concat((e.columnRank / l.nbColumn) * 100, "%"),
                left: "".concat(
                  ((l.nbRow - e.rowRank - e.rowStretch) / l.nbRow) * 100,
                  "%",
                ),
                width: "".concat((e.rowStretch || 1) * l.rowSize, "%"),
                height: "".concat((e.columnStretch || 1) * l.columnSize, "%"),
              };
        };
        return void 0 === t
          ? (0, ce.jsx)(ce.Fragment, {})
          : (0, ce.jsx)(Qt, {
              styles:
                ".pao-deck-grid{display:flex;width:100%}@media(max-width: 639px){.pao-deck-grid{height:90.6em}}.pao-deck-grid .deck-grid-container{height:calc(100% - .6em);width:calc(100% - .6em);position:relative;border:.3em solid var(--ternary-color);padding:0}.pao-deck-grid .deck-grid-container .deck-cell-container{position:absolute}",
              children: (0, ce.jsx)("div", {
                className: "pao-deck-grid",
                children: (0, ce.jsx)("div", {
                  className: "deck-grid-container",
                  role: "group",
                  ref: s,
                  children: t.deckGrid.deckCells.map(function (e) {
                    return (0, ce.jsx)(
                      "div",
                      {
                        className: "deck-cell-container",
                        style: u(e),
                        children: (0, ce.jsx)(In, { deckCell: e }),
                      },
                      "".concat(e.columnRank).concat(e.rowRank),
                    );
                  }),
                }),
              }),
            });
      };
      var Fn = function (e, t) {
          switch (e.key) {
            case nn.ArrowLeft:
              !(function (e) {
                var t,
                  n =
                    e.previousElementSibling ||
                    (null === (t = e.parentElement) || void 0 === t
                      ? void 0
                      : t.lastElementChild);
                null !== n && void 0 !== n && n.focus();
              })(e.target);
              break;
            case nn.ArrowRight:
              !(function (e) {
                var t,
                  n =
                    e.nextElementSibling ||
                    (null === (t = e.parentElement) || void 0 === t
                      ? void 0
                      : t.firstElementChild);
                n && n.focus();
              })(e.target);
              break;
            case nn.Enter:
            case nn.Space:
              t(), e.preventDefault();
          }
        },
        Un = (function () {
          function e() {
            a(this, e);
          }
          return (
            c(e, null, [
              {
                key: "comparatorByStrongestDeckType",
                value: function (e) {
                  return function (t, n) {
                    return t.deckType !== n.deckType
                      ? t.deckType === e
                        ? -1
                        : 1
                      : 0;
                  };
                },
              },
              {
                key: "topFirst",
                value: function () {
                  return e.comparatorByStrongestDeckType("TOP");
                },
              },
              {
                key: "bottomFirst",
                value: function () {
                  return e.comparatorByStrongestDeckType("BOTTOM");
                },
              },
            ]),
            e
          );
        })();
      function Hn(e, t) {
        e(J.changeSelectedDeck(t));
      }
      var Bn = function () {
        var e = be(),
          t = e.currentCoach,
          n = e.currentDeck,
          r = ge().terms,
          a = me(),
          o = "deckSelector";
        return (0, ce.jsx)(Qt, {
          styles:
            ".tablist{list-style-type:none;margin:.5em 1em;padding:0}.tab{font-size:1.6em;opacity:.9;outline:none;padding:0;position:relative}@media(min-width: 640px){.tab{float:left;margin:0 5px 0 0}}@media(max-width: 639px){.tab{display:block;margin:.25em}}.tab span{border-radius:.25em;cursor:pointer;display:block;font-weight:normal;padding:.3125em;position:relative;text-align:center;text-transform:lowercase;z-index:1;border:solid var(--secondary-color) .08em;color:var(--primary-color)}.tab:focus span{outline:2px dashed currentColor;outline-offset:-0.4em}.tab.full span{background-color:rgba(var(--secondary-color-rgb), 0.2)}.tab.selected span{background-color:var(--primary-color);color:#fff}.tab div{display:none}.deck-selector{display:flex;align-items:center}@media(max-width: 639px){.deck-selector{flex-direction:column-reverse}}.deck-selector .deck-nav-label{opacity:.9;text-transform:uppercase;color:var(--ternary-color)}@media(min-width: 640px){.deck-selector .deck-nav-label{font-size:1.4em;margin-right:1em}}@media(max-width: 639px){.deck-selector .deck-nav-label{font-size:1.2em;line-height:1.2;-webkit-box-ordinal-group:100;order:99}}@media(max-width: 639px){.deck-selector ul.tablist{display:flex;flex-direction:column}}.deck-selector ul.tablist .tab-medium{min-height:2em;min-width:3.25em}",
          children: (0, ce.jsxs)("div", {
            className: "deck-selector",
            children: [
              (0, ce.jsx)("div", {
                className: "deck-nav-label",
                id: "deckSelectorLabel",
                children: r["paoSeatmapUi.paoCoachSelector.deckSelectorLabel"],
              }),
              (0, ce.jsx)("ul", {
                role: "tablist",
                className: "tablist",
                "aria-labelledby": we.getLabel(o),
                children: t.decks.sort(Un.bottomFirst()).map(function (e, t) {
                  var o = n && n["@id"] === e["@id"],
                    i = o ? "selected" : "",
                    l = e.full ? "full" : "",
                    c = [
                      r["paoSeatmapUi.paoCoachSelector.deckSelectorLabel"],
                      r[
                        "paoSeatmapUi.deckTypeDescriptionLabels.".concat(
                          e.deckType.toUpperCase(),
                        )
                      ],
                      r[
                        "paoSeatmapUi.paoCoachSelector.fullLabels.".concat(
                          e.full.toString().toLowerCase(),
                        )
                      ],
                    ],
                    s = "deck-desc-".concat(e.deckType);
                  return (0, ce.jsxs)(
                    "li",
                    {
                      role: "tab",
                      "aria-selected": o,
                      "aria-labelledby": we.getLabel(s),
                      tabIndex: o ? 0 : -1,
                      onClick: function () {
                        return Hn(a, e);
                      },
                      onKeyDown: function (t) {
                        return (function (e, t, n) {
                          Fn(e, function () {
                            return Hn(t, n);
                          });
                        })(t, a, e);
                      },
                      className: "tab tab-medium ".concat(i, " ").concat(l),
                      children: [
                        (0, ce.jsx)("span", {
                          children:
                            r[
                              "paoSeatmapUi.paoCoachSelector.deckTypelabels.".concat(
                                e.deckType,
                              )
                            ],
                        }),
                        (0, ce.jsx)(xe, { id: s, label: c }),
                      ],
                    },
                    t,
                  );
                }),
              }),
              (0, ce.jsx)(xe, {
                id: o,
                label: r["paoSeatmapUi.paoCoachSelector.deckSelectorLabel"],
              }),
            ],
          }),
        });
      };
      var Vn = function () {
        var t = ge().trainDirection,
          n = I(
            (0, e.useState)(
              "linearGradientId_" + Math.random().toString().replace(".", ""),
            ),
            1,
          )[0];
        return t.displayTrainDirection
          ? (0, ce.jsx)(Qt, {
              styles:
                ".pao-train-direction svg{color:var(--secondary-color, currentColor);opacity:.7;height:100%;width:100%}",
              children: (0, ce.jsx)("div", {
                className: "pao-train-direction",
                children: (0, ce.jsxs)("svg", {
                  viewBox: "85 -195 334 811",
                  children: [
                    (0, ce.jsx)("defs", {
                      children: (0, ce.jsxs)("linearGradient", {
                        id: n,
                        x1: "0%",
                        y1: "0%",
                        x2: "100%",
                        y2: "0%",
                        children: [
                          (0, ce.jsx)("stop", {
                            offset: "0%",
                            stopColor: "currentColor",
                            stopOpacity: "0.6",
                          }),
                          (0, ce.jsx)("stop", {
                            offset: "100%",
                            stopColor: "currentColor",
                            stopOpacity: "0.3",
                          }),
                        ],
                      }),
                    }),
                    (0, ce.jsx)("path", {
                      fill: "url(#" + n + ")",
                      d: "M541 251l-235 -240q-12 -11 -30 -11t-32 11v0q-11 12 -11 31.5t11 30.5l174 178l-175 173q-11 14 -11 32t11 30l8 7q14 9 30 6.5t28 -13.5zM309 251l-235 -240q-12 -11 -30 -11t-32 11v0q-11 12 -11 31.5t11 30.5l174 178l-175 173q-11 14 -11 32t11 30l8 7q14 9 30 6.5t28 -13.5z",
                    }),
                  ],
                }),
              }),
            })
          : (0, ce.jsx)(ce.Fragment, {});
      };
      function Wn(e, t) {
        e(J.changeSelectedCoach(t));
      }
      var Zn = function () {
          var e = be().currentCoach,
            t = ge(),
            n = t.terms,
            r = t.displayableElementsForCoachSelector,
            a = me(),
            o = void 0 !== e && void 0 !== e.decks && e.decks.length > 1;
          if (!r) return (0, ce.jsx)(ce.Fragment, {});
          var i = "coachSelector";
          return (0, ce.jsx)(Qt, {
            styles:
              ".tablist{list-style-type:none;margin:.5em 1em;padding:0}.tab{font-size:1.6em;opacity:.9;outline:none;padding:0;position:relative}@media(min-width: 640px){.tab{float:left;margin:0 5px 0 0}}@media(max-width: 639px){.tab{display:block;margin:.25em}}.tab span{border-radius:.25em;cursor:pointer;display:block;font-weight:normal;padding:.3125em;position:relative;text-align:center;text-transform:lowercase;z-index:1;border:solid var(--secondary-color) .08em;color:var(--primary-color)}.tab:focus span{outline:2px dashed currentColor;outline-offset:-0.4em}.tab.full span{background-color:rgba(var(--secondary-color-rgb), 0.2)}.tab.selected span{background-color:var(--primary-color);color:#fff}.tab div{display:none}.pao-coach-selector{display:-webkit-box;display:flex;align-items:center;-webkit-box-align:center;-webkit-box-pack:center;justify-content:center;line-height:1.5}@media(min-width: 640px){.pao-coach-selector{padding:0;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row}}@media(max-width: 639px){.pao-coach-selector{padding:.8em 0 0;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}}@media(max-height: 599px){.pao-coach-selector{-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row}}@media(min-width: 640px){.pao-coach-selector .pao-train-direction{display:none}}@media(max-width: 639px){.pao-coach-selector .pao-train-direction{display:block;width:4em;height:4em;transform:rotate(90deg)}}.pao-coach-selector .coach-nav{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center;margin:0}@media(min-width: 640px){.pao-coach-selector .coach-nav{-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row}}@media(min-width: 640px){.pao-coach-selector .coach-nav{padding:0 2em 0 0}}@media(max-width: 639px){.pao-coach-selector .coach-nav{-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}}.pao-coach-selector .coach-nav .coach-nav-label{opacity:.9;text-transform:uppercase;color:var(--ternary-color)}@media(min-width: 640px){.pao-coach-selector .coach-nav .coach-nav-label{font-size:1.4em;margin-right:1em}}@media(max-width: 639px){.pao-coach-selector .coach-nav .coach-nav-label{font-size:1.2em;line-height:1.2}}.pao-coach-selector .coach-nav ul.tablist li.tab-small{min-height:2em;min-width:2em}",
            children: (0, ce.jsxs)("div", {
              className: "pao-coach-selector",
              children: [
                (0, ce.jsxs)("div", {
                  className: "coach-nav",
                  children: [
                    (0, ce.jsx)("div", {
                      className: "coach-nav-label",
                      id: "coachSelectorLabel",
                      children:
                        n["paoSeatmapUi.paoCoachSelector.coachSelectorLabel"],
                    }),
                    (0, ce.jsx)("ul", {
                      className: "tablist",
                      role: "tablist",
                      "aria-labelledby": we.getLabel(i),
                      children: r
                        .flatMap(function (e) {
                          return e.coaches;
                        })
                        .map(function (t, r) {
                          var o = e && e.number === t.number,
                            i = o ? "selected" : "",
                            l = t.full ? "full" : "",
                            c = [
                              n[
                                "paoSeatmapUi.paoCoachSelector.coachSelectorLabel"
                              ],
                              t.number,
                              n[
                                "paoSeatmapUi.paoCoachSelector.fullLabels.".concat(
                                  t.full ? "true" : "false",
                                )
                              ],
                            ],
                            s = "coach-desc-".concat(t.number);
                          return (0, ce.jsxs)(
                            "li",
                            {
                              role: "tab",
                              "aria-selected": o,
                              "aria-labelledby": we.getLabel(s),
                              tabIndex: o ? 0 : -1,
                              onClick: function () {
                                return Wn(a, t);
                              },
                              onKeyDown: function (e) {
                                return (function (e, t, n) {
                                  Fn(e, function () {
                                    return Wn(t, n);
                                  });
                                })(e, a, t);
                              },
                              className: "tab tab-small "
                                .concat(i, " ")
                                .concat(l),
                              children: [
                                (0, ce.jsx)("span", { children: t.number }),
                                (0, ce.jsx)(xe, {
                                  id: "coach-desc-".concat(t.number),
                                  label: c,
                                }),
                              ],
                            },
                            r,
                          );
                        }),
                    }),
                    (0, ce.jsx)(xe, {
                      id: i,
                      label:
                        n["paoSeatmapUi.paoCoachSelector.coachSelectorLabel"],
                    }),
                  ],
                }),
                (0, ce.jsx)("div", {
                  className: "deck-nav",
                  id: "pao-deck-selector",
                  children: o
                    ? (0, ce.jsx)(Bn, {})
                    : (0, ce.jsx)(ce.Fragment, {}),
                }),
                (0, ce.jsx)(Vn, {}),
              ],
            }),
          });
        },
        Gn = (function () {
          function e() {
            a(this, e);
          }
          return (
            c(e, null, [
              {
                key: "sumExtrasFromPlacing",
                value: function (e) {
                  return void 0 === e ||
                    void 0 === e.seat ||
                    void 0 === e.seat.extras ||
                    void 0 === e.passenger
                    ? 0
                    : e.seat.extras
                        .filter(function (t) {
                          var n;
                          return (
                            t.passengerType ===
                            (null === (n = e.passenger) || void 0 === n
                              ? void 0
                              : n.type)
                          );
                        })
                        .map(function (e) {
                          return e.amount.amount;
                        })
                        .reduce(function (e, t) {
                          return e + t;
                        }, 0);
                },
              },
              {
                key: "extractFirstCurrency",
                value: function (e) {
                  return void 0 === e ||
                    void 0 === e.seat ||
                    void 0 === e.seat.extras ||
                    0 === e.seat.extras.length
                    ? "EUR"
                    : e.seat.extras[0].amount.currency;
                },
              },
              {
                key: "sumExtrasFromPlacings",
                value: function (t) {
                  return t.map(e.sumExtrasFromPlacing).reduce(function (e, t) {
                    return e + t;
                  }, 0);
                },
              },
            ]),
            e
          );
        })();
      var qn = function (t) {
        var n = be().placings,
          r = ge(),
          a = r.terms,
          o = r.numberOfPassengers,
          i = I((0, e.useState)([]), 2),
          l = i[0],
          c = i[1];
        return (
          (0, e.useEffect)(
            function () {
              if (0 !== n.length) {
                var e = n.some(function (e) {
                    return void 0 !== e.coach.decks && e.coach.decks.length > 1;
                  }),
                  r = e ? n[0].deck.deckType : void 0,
                  i =
                    a[
                      1 === n.length
                        ? "paoSeatmapUi.seatLabel"
                        : "paoSeatmapUi.seatsLabel"
                    ],
                  l = n
                    .map(function (e) {
                      return e.seat.seatNumber;
                    })
                    .sort()
                    .join(", "),
                  s = e ? a["paoSeatmapUi.deckLabel"] : void 0,
                  u = e
                    ? a["paoSeatmapUi.deckTypeDescriptionLabels.".concat(r)]
                    : void 0,
                  d = t.displayPassengerStats
                    ? "("
                        .concat(n.length, " ")
                        .concat(a["paoSeatmapUi.totalLAbel"], " ")
                        .concat(o, ")")
                    : void 0,
                  p = (function (e) {
                    if (
                      e &&
                      e.length > 0 &&
                      e.some(function (e) {
                        return e.seat.extras && e.seat.extras.length > 0;
                      })
                    )
                      return (
                        ", " +
                        Gn.sumExtrasFromPlacings(e) +
                        " " +
                        Gn.extractFirstCurrency(e[0])
                      );
                    return "";
                  })(n),
                  f = [
                    a["paoSeatmapUi.textLabel"],
                    i,
                    l,
                    a["paoSeatmapUi.carLabel"],
                    n[0].coach.number,
                    s,
                    u,
                    d,
                    p,
                  ];
                c(f);
              } else c([""]);
            },
            [n, a, o, t.displayPassengerStats],
          ),
          (0, ce.jsx)(ye, { id: t.id, text: l })
        );
      };
      function Xn(e) {
        return null === e.seat.ancillaryServices ||
          void 0 === e.seat.ancillaryServices
          ? null
          : e.seat.ancillaryServices.map(function (e) {
              return e.type;
            });
      }
      var _n,
        Yn = function (e) {
          var t = be().placings,
            n = ge(),
            r = n.terms,
            a = n.numberOfPassengers,
            o = ve().displayAncillaryServices,
            i = t.length === a,
            l = r["paoSeatmapUi.currency.EUR"],
            c = null;
          t.length > 0 && (c = t[0].coach);
          var s = "";
          if (o)
            if (0 === t.length) s = "(- ".concat(l, ")");
            else {
              var u = Gn.sumExtrasFromPlacings(t);
              s = "(+".concat(u, " ").concat(l, ")");
            }
          return (0, ce.jsx)(Qt, {
            styles:
              ".pao-action-buttons{align-items:center;display:flex;flex-direction:row;height:100%}@media(max-width: 639px){.pao-action-buttons{border-top:solid rgba(78,80,83,.2) .1em;justify-content:space-around}}@media(min-width: 640px){.pao-action-buttons{margin-left:auto;justify-content:center}}.action-validate.disabled,.action-validate.enabled,.action-abandon{-webkit-transition:background-color .5s ease;transition:background-color .5s ease;max-height:4em;min-height:2em;padding:0 .625em;border:0;border-radius:.1875em;color:var(--primary-color);font-size:1.6em;margin:.1875em;opacity:.9;outline:none;cursor:pointer}.action-abandon{background-color:rgba(var(--ternary-color-rgb), 0.2);color:var(--ternary-color)}.action-abandon.dark{background-color:var(--ternary-color);color:#fff}.action-validate.enabled{background-color:var(--primary-color);color:#fff}.action-validate.disabled{background-color:rgba(var(--secondary-color-rgb), 0.1);color:rgba(var(--secondary-color-rgb), 0.6);cursor:auto}.action-abandon:focus,.action-validate.enabled:focus,.action-validate.disabled:focus{border:solid #7e7f74 .1em;background-color:var(--primary-color);color:#fff}",
            children: (0, ce.jsxs)("div", {
              className: "pao-action-buttons",
              children: [
                (0, ce.jsx)("button", {
                  tabIndex: 0,
                  className:
                    "action-abandon " + (e.darkNegativeButton ? "dark" : ""),
                  onClick: function () {
                    return e.cancelSelection();
                  },
                  children: r["paoSeatmapUi.closeLabel"],
                }),
                (0, ce.jsxs)("button", {
                  tabIndex: 0,
                  className: "action-validate ".concat(
                    i ? "enabled" : "disabled",
                  ),
                  "aria-label":
                    r["paoSeatmapUi.validateLabel"] + (s ? ", " + s : ""),
                  "aria-describedby": "describeActionValider",
                  disabled: !i || void 0,
                  onClick: function () {
                    return (function (e, t, n, r) {
                      if (!e || null === t) return;
                      var a = {
                        coach: t.number,
                        placings: n.map(function (e) {
                          var t;
                          return {
                            seatNumber: e.seat.seatNumber,
                            passengerRank: e.passenger
                              ? e.passenger.rank
                              : null,
                            passengerType:
                              null !== (t = e.passenger) &&
                              void 0 !== t &&
                              t.type
                                ? e.passenger.type
                                : null,
                            ancillaryServices: Xn(e),
                            extraPrice: e.seat.extras
                              ? Gn.sumExtrasFromPlacing(e)
                              : null,
                          };
                        }),
                      };
                      r(a);
                    })(i, c, t, e.validateSelection);
                  },
                  children: [
                    (0, ce.jsxs)("span", {
                      children: [r["paoSeatmapUi.validateLabel"], " ", s],
                    }),
                    (0, ce.jsx)(qn, {
                      id: "describeActionValider",
                      displayPassengerStats: !1,
                    }),
                  ],
                }),
              ],
            }),
          });
        },
        Jn = ["title", "titleId"];
      function Kn() {
        return (
          (Kn = Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }),
          Kn.apply(this, arguments)
        );
      }
      function Qn(e, t) {
        if (null == e) return {};
        var n,
          r,
          a = (function (e, t) {
            if (null == e) return {};
            var n,
              r,
              a = {},
              o = Object.keys(e);
            for (r = 0; r < o.length; r++)
              (n = o[r]), t.indexOf(n) >= 0 || (a[n] = e[n]);
            return a;
          })(e, t);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          for (r = 0; r < o.length; r++)
            (n = o[r]),
              t.indexOf(n) >= 0 ||
                (Object.prototype.propertyIsEnumerable.call(e, n) &&
                  (a[n] = e[n]));
        }
        return a;
      }
      function $n(t, n) {
        var r = t.title,
          a = t.titleId,
          o = Qn(t, Jn);
        return e.createElement(
          "svg",
          Kn(
            {
              viewBox: "0 0 7 11",
              xmlns: "http://www.w3.org/2000/svg",
              xmlnsXlink: "http://www.w3.org/1999/xlink",
              ref: n,
              "aria-labelledby": a,
            },
            o,
          ),
          r ? e.createElement("title", { id: a }, r) : null,
          _n ||
            (_n = e.createElement(
              "g",
              { transform: "translate(0, -0.25)" },
              e.createElement("path", {
                d: "M1.64705882,4.69931418 C1.64705882,4.49721601 1.83139379,4.33333333 2.05882353,4.33333333 C2.28625327,4.33333333 2.47058824,4.49721601 2.47058824,4.69931418 L2.47058824,8.85632066 C2.47058824,9.05841884 2.28625327,9.22222222 2.05882353,9.22222222 C1.83139379,9.22222222 1.64705882,9.05841884 1.64705882,8.85632066 L1.64705882,4.69931418 Z M3.1,4.69931418 C3.1,4.49721601 3.28433497,4.33333333 3.51176471,4.33333333 C3.73919444,4.33333333 3.92352941,4.49721601 3.92352941,4.69931418 L3.92352941,8.85632066 C3.92352941,9.05841884 3.73919444,9.22222222 3.51176471,9.22222222 C3.28433497,9.22222222 3.1,9.05841884 3.1,8.85632066 L3.1,4.69931418 Z M4.52941176,4.69931418 C4.52941176,4.49721601 4.71374673,4.33333333 4.94117647,4.33333333 C5.16860621,4.33333333 5.35294118,4.49721601 5.35294118,4.69931418 L5.35294118,8.85632066 C5.35294118,9.05841884 5.16860621,9.22222222 4.94117647,9.22222222 C4.71374673,9.22222222 4.52941176,9.05841884 4.52941176,8.85632066 L4.52941176,4.69931418 Z M0.586312324,11 L6.41368768,11 C6.73745688,11 7,10.7283239 7,10.3931107 L7,3 L8.8817842e-16,3 L8.8817842e-16,10.3931107 C8.8817842e-16,10.7283239 0.262543117,11 0.586312324,11 L0.586312324,11 Z",
              }),
              e.createElement("path", {
                d: "M4.94117647,1.83333333 L2.05882353,1.83333333 L2.05882353,1.28521557 C2.05882353,1.03598457 2.28482156,0.833333333 2.56276566,0.833333333 L4.43723434,0.833333333 C4.71517844,0.833333333 4.94117647,1.03598457 4.94117647,1.28521557 L4.94117647,1.83333333 Z M7,2.39042802 C7,2.13324514 6.7385782,1.92474708 6.41611374,1.92474708 L5.59539448,1.92474708 L5.59539448,1.45881712 C5.59539448,0.930132296 5.05608029,0.5 4.39319766,0.5 L2.60172846,0.5 C1.93892389,0.5 1.39953164,0.930132296 1.39953164,1.45881712 L1.39953164,1.92474708 L0.583886256,1.92474708 C0.261421801,1.92474708 0,2.13324514 0,2.39042802 L0,2.5 L7,2.5 L7,2.39042802 L7,2.39042802 Z",
              }),
            )),
        );
      }
      var er = e.forwardRef($n);
      n.p;
      var tr,
        nr = new Map(
          Object.entries(
            (R((tr = {}), z.EXIT, (0, ce.jsx)(De, {})),
            R(tr, z.TRAIN_DIRECTION, (0, ce.jsx)(Vn, {})),
            R(tr, z.DELETE_SELECTION, (0, ce.jsx)(er, {})),
            R(
              tr,
              z.STANDARD_SEAT,
              (0, ce.jsx)(Tn, { state: An.ENABLE, type: L.STANDARD }),
            ),
            R(tr, z.XL_SEAT, (0, ce.jsx)(Tn, { state: An.ENABLE, type: L.XL })),
            R(tr, z.AVAILABLE_MONO_SEAT, (0, ce.jsx)(Tn, { state: An.ENABLE })),
            R(
              tr,
              z.UNAVAILABLE_MONO_SEAT,
              (0, ce.jsx)(Tn, { state: An.DISABLED }),
            ),
            R(
              tr,
              z.SELECTED_MONO_SEAT,
              (0, ce.jsx)(Tn, { state: An.SELECTED }),
            ),
            R(
              tr,
              z.AVAILABLE_DUO_SEAT,
              (0, ce.jsxs)(ce.Fragment, {
                children: [
                  (0, ce.jsx)(Tn, { state: An.ENABLE, type: L.STANDARD }),
                  "\xa0",
                  (0, ce.jsx)(Tn, { state: An.ENABLE, type: L.XL }),
                ],
              }),
            ),
            R(
              tr,
              z.UNAVAILABLE_DUO_SEAT,
              (0, ce.jsxs)(ce.Fragment, {
                children: [
                  (0, ce.jsx)(Tn, { state: An.DISABLED, type: L.STANDARD }),
                  "\xa0",
                  (0, ce.jsx)(Tn, { state: An.DISABLED, type: L.XL }),
                ],
              }),
            ),
            R(
              tr,
              z.SELECTED_DUO_SEAT,
              (0, ce.jsxs)(ce.Fragment, {
                children: [
                  (0, ce.jsx)(Tn, { state: An.SELECTED, type: L.STANDARD }),
                  "\xa0",
                  (0, ce.jsx)(Tn, { state: An.SELECTED, type: L.XL }),
                ],
              }),
            ),
            R(tr, z.ELECTRIC_PLUG, (0, ce.jsx)(bn, {})),
            R(tr, z.SOLO_SEAT, (0, ce.jsx)(Sn, {})),
            R(tr, "default", (0, ce.jsx)("div", {})),
            tr),
          ),
        ),
        rr = function (e) {
          var t = e.isVerticalDisplay,
            n = void 0 === t || t,
            r = ge().legendContent;
          return (0, ce.jsx)(Qt, {
            styles:
              ".legend{max-height:100%}.legend ul{color:var(--ternary-color);list-style:none;padding:0}.legend ul li .legend-item-container{display:inline-flex;font-size:1.4em;margin-left:.3em}.legend ul li .legend-item-container svg{height:1.8em;line-height:100%;opacity:.9;width:1.8em}.legend ul li .legend-item-container .legend-label{line-height:100%;margin-bottom:auto;margin-top:auto;opacity:.9;padding-left:.2em}.legend ul li .legend-item-container.legendAvailable svg{fill:var(--primary-color);stroke:var(--primary-color)}.legend ul li .legend-item-container.legendUnvailable svg{fill:var(--secondary-color);opacity:.4}.legend ul li .legend-item-container.legendSelected svg{fill:var(--primary-color)}.legend ul li .legend-item-container.legendExit svg{fill:var(--ternary-color)}.legend ul li .legend-item-container.electric-plug svg{fill:var(--primary-color)}.legend ul li .legend-item-container.solo-seat svg{fill:var(--primary-color)}.legend ul li .legend-item-container.delete svg{fill:var(--ternary-color)}.legend{border:0;display:flex}.legend ul{display:inline-flex;margin:auto}.legend ul li{display:flex;flex-direction:column;justify-content:center}.legend.is-vertical{background-color:#fff;border:0;border-radius:.3em;display:table;padding:1em}.legend.is-vertical ul{display:block}.legend.is-vertical ul li{display:flex;flex-direction:column;justify-content:center;padding:.3em 0}",
            children: (0, ce.jsx)("div", {
              className: n ? "legend is-vertical" : "legend",
              "aria-hidden": "true",
              children: (0, ce.jsx)("ul", {
                children: r.map(function (e, t) {
                  return (0, ce.jsx)(
                    "li",
                    {
                      children: (0, ce.jsxs)("div", {
                        className: "legend-item-container " + e.style,
                        children: [
                          nr.get(e.svg),
                          (0, ce.jsx)("div", {
                            className: "legend-label",
                            children: (0, ce.jsx)("div", {
                              dangerouslySetInnerHTML: { __html: e.legend },
                            }),
                          }),
                        ],
                      }),
                    },
                    t,
                  );
                }),
              }),
            }),
          });
        };
      var ar = function (e) {
          var t = void 0 === e.disableTab || e.disableTab,
            n = void 0 !== e.onPopupKeyDown ? e.onPopupKeyDown : function () {};
          return function (e) {
            t && e.key === nn.Tab && e.preventDefault(), n(e);
          };
        },
        or = function (t) {
          var n = me(),
            r = ge().terms,
            a = (0, e.useRef)(null),
            o = void 0 === t.displayCloseButton || t.displayCloseButton,
            i =
              void 0 !== t.buttonTitleCode
                ? t.buttonTitleCode
                : "paoSeatmapUi.paoErrorDialog.closeLabel",
            l = void 0 !== t.onPopupClick ? t.onPopupClick : function () {},
            c = ar(t);
          (0, e.useEffect)(
            function () {
              var e;
              if (t.show)
                return (
                  o &&
                    a.current &&
                    a.current !==
                      (null === (e = a.current.shadowRoot) || void 0 === e
                        ? void 0
                        : e.activeElement) &&
                    a.current.focus(),
                  window.addEventListener("keydown", c),
                  function () {
                    return window.removeEventListener("keydown", c);
                  }
                );
            },
            [t.show, o, c],
          );
          var s = o
            ? (0, ce.jsx)("div", {
                className: "action-area",
                children: (0, ce.jsx)("button", {
                  onClick: function () {
                    void 0 !== t.actionToDispatchOnClose &&
                      n(t.actionToDispatchOnClose);
                  },
                  ref: a,
                  children: r[i],
                }),
              })
            : (0, ce.jsx)(ce.Fragment, {});
          return (0, ce.jsx)(Qt, {
            styles:
              "#pao-popup{display:none}#pao-popup.show{display:flex;position:fixed;top:0;left:0;width:100%;height:100%;justify-content:center;z-index:99;align-items:center}#pao-popup.show #pop-up{max-width:90%;background-color:#fff;border-radius:.3em;z-index:100;height:max-content;box-shadow:0 16px 24px 2px rgba(0,0,0,.14),0 6px 30px 5px rgba(0,0,0,.12),0 8px 10px -5px rgba(0,0,0,.4)}#pao-popup.show #overlay{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.5)}.action-area{text-align:right;padding:10px}.action-area button{-webkit-transition:background-color .5s ease;transition:background-color .5s ease;max-height:4em;min-height:2em;padding:0 .625em;border:0;border-radius:.1875em;font-size:1.6em;margin:.1875em;opacity:.9;outline:none;cursor:pointer;background-color:var(--primary-color);color:#fff}",
            children: (0, ce.jsxs)("div", {
              id: "pao-popup",
              className: t.show ? "show" : "",
              onClick: function () {
                return l();
              },
              children: [
                (0, ce.jsx)("div", {
                  id: "overlay",
                  onClick: function () {
                    void 0 !== t.onBackgroundClick && t.onBackgroundClick(),
                      l();
                  },
                  role: "button",
                }),
                (0, ce.jsxs)("div", {
                  id: "pop-up",
                  children: [t.children, s],
                }),
              ],
            }),
          });
        };
      var ir = function (t) {
        var n = t.iconDisplay,
          r = ge().terms,
          a = I(e.useState(!1), 2),
          o = a[0],
          i = a[1];
        return (0, ce.jsx)(Qt, {
          styles:
            ".pao-legend-button:focus{outline:2px currentColor dashed;outline-offset:.2em}.pao-legend-button .show-legend-btn{background:none;border:none;color:var(--primary-color);font-size:1.4em;font-weight:bold;margin:auto auto .8em auto;text-decoration-line:none}.pao-legend-button .show-legend-btn:focus{outline:2px currentColor dashed;outline-offset:.2em}.pao-legend-button .show-legend-btn .btn-icon{height:20px;width:20px;border-radius:50%;border:1px solid var(--ternary-color);color:var(--quaternary-color);cursor:pointer;position:relative}.pao-legend-button .show-legend-btn .btn-icon span{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)}",
          children: (0, ce.jsxs)("div", {
            className: "pao-legend-button",
            children: [
              (0, ce.jsx)(or, {
                show: o,
                onPopupClick: function () {
                  return i(!1);
                },
                displayCloseButton: !1,
                onPopupKeyDown: function (e) {
                  return (function (e) {
                    e.preventDefault();
                    var t = e;
                    void 0 !== t &&
                      [nn.Enter, nn.Space, nn.Escape].includes(t.key) &&
                      i(!1);
                  })(e);
                },
                children: (0, ce.jsx)(rr, {}),
              }),
              (0, ce.jsx)("button", {
                className: "show-legend-btn",
                onClick: function () {
                  return i(!0);
                },
                "aria-label": r["paoSeatmapUi.paoLegend.legendLabel"],
                children: n
                  ? (0, ce.jsx)("div", {
                      className: "btn-icon",
                      children: (0, ce.jsx)("span", { children: "?" }),
                    })
                  : r["paoSeatmapUi.paoLegend.legendLabel"],
              }),
            ],
          }),
        });
      };
      var lr = function () {
        var e = be().currentDeck,
          t = null === e || void 0 === e ? void 0 : e.travelSpaceColorCode,
          n = null === e || void 0 === e ? void 0 : e.travelSpaceFontColorCode,
          r = null === e || void 0 === e ? void 0 : e.travelSpaceLabel;
        return (0, ce.jsx)(Qt, {
          styles:
            ".travel-space{display:flex;align-items:center}@media(max-width: 639px){.travel-space{height:4.2em}}@media(min-width: 640px){.travel-space{padding:.5em 1em}}.travel-space .travel-space-label{font-size:1.4em;font-weight:bold;text-shadow:0 0 2px rgba(0,0,0,.5);width:100%;word-break:break-word;line-height:1.5}@media(max-width: 639px){.travel-space .travel-space-label{text-align:center;padding:.5em 1em}}",
          children: (0, ce.jsx)("div", {
            children: r
              ? (0, ce.jsx)("div", {
                  className: "travel-space",
                  style: { backgroundColor: t, color: n },
                  children: (0, ce.jsx)("div", {
                    className: "travel-space-label",
                    children: r,
                  }),
                })
              : (0, ce.jsx)(ce.Fragment, {}),
          }),
        });
      };
      var cr,
        sr = function (e) {
          var t = be(),
            n = t.placings,
            r = t.currentDeck,
            a = e.deck.available && "2" !== e.travelClass,
            o = r["@id"] === e.deck["@id"] ? "selected" : "",
            i = a ? "" : "unavailable",
            l = n.some(function (t) {
              return t.deck["@id"] === e.deck["@id"];
            })
              ? "has-selected-seats"
              : "";
          return (0, ce.jsx)(Qt, {
            styles:
              ".deck{margin:.1em 0;display:flex;flex:1;background-color:#fff;border-width:.1em;border-style:solid;border-radius:2px;border-color:var(--primary-color);opacity:1}.deck.unavailable{border-color:var(--secondary-color);background-color:var(--secondary-color);opacity:.4}.deck.selected{border-color:var(--primary-color);background-color:var(--primary-color);opacity:1}.deck.has-selected-seats{border-width:.2em}",
            children: (0, ce.jsx)("div", {
              className: "deck ".concat(i, " ").concat(o, " ").concat(l),
            }),
          });
        },
        ur = ["title", "titleId"];
      function dr() {
        return (
          (dr = Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }),
          dr.apply(this, arguments)
        );
      }
      function pr(e, t) {
        if (null == e) return {};
        var n,
          r,
          a = (function (e, t) {
            if (null == e) return {};
            var n,
              r,
              a = {},
              o = Object.keys(e);
            for (r = 0; r < o.length; r++)
              (n = o[r]), t.indexOf(n) >= 0 || (a[n] = e[n]);
            return a;
          })(e, t);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          for (r = 0; r < o.length; r++)
            (n = o[r]),
              t.indexOf(n) >= 0 ||
                (Object.prototype.propertyIsEnumerable.call(e, n) &&
                  (a[n] = e[n]));
        }
        return a;
      }
      function fr(t, n) {
        var r = t.title,
          a = t.titleId,
          o = pr(t, ur);
        return e.createElement(
          "svg",
          dr({ viewBox: "0 0 472 465", ref: n, "aria-labelledby": a }, o),
          r ? e.createElement("title", { id: a }, r) : null,
          cr ||
            (cr = e.createElement("path", {
              stroke: "none",
              d: "M453 9v444H9V9h444zM203 138c-9.65-.02-8.11-.39-17.32-15l-16.87-27-9.57-14.61c-5.69-5.88-12.31-1.45-12.05 4.61.17 4.05 5.49 11.39 7.76 15l9.37 15L178 138h-18c-8.28.01-21.26 2.31-17.01 14l19.32 31 36.02 56 14.09 22c1.7 2.72 4.94 7.18 5.88 10 .83 2.47.7 5.41.7 8v73h-37c-3.32.02-6.85-.09-9.66 2.01-4.78 3.57-4.14 10.96.72 14.25 2.95 2 6.54 1.73 9.94 1.74h90c3.85-.01 7.67.33 10.77-2.43 5.32-4.72 4.54-15.38-8.77-15.57h-37.86v-73c-.14-2.09-.22-5.01 0-7 1.33-4.27 10.01-16.68 12.86-21l26.58-41 15.03-22.58c2.91-2.55 6.28-.21 9.39.88 7.06 2.48 11.64 2.78 19 2.7 23-.27 43.35-17.35 47.54-40 1.4-7.6 1.33-16.51-.7-24-1.51-5.57-5-12.44-8.52-17-28.27-36.67-88.16-18.87-90.32 28h-65zm84.18-24c7.56-8.53 18.4-13.73 29.82-13.99 6.75-.15 12.84 1.05 19 3.89 33.72 15.52 29.21 67.23-7 76.2-3.24.8-8.73 1.83-12 1.58-7.27-.56-11.36-1.88-18-4.68 2.22-9.31 13.41-19.91 14.26-27 .59-4.97-4.02-9.19-8.26-10.85-4.78-1.88-20.99-1.15-27-1.15.2-9.09 3.1-17.13 9.18-24zm35.23 4c.34-2.01 1.41-7 .82-8.77-1.66-5.04-15.12-4.12-16.12 1.82-.9 5.39 8 18.23 7.89 25.95-1.71-4.04-11.82-19.22-15.17-21.36-5.22-3.33-11.46 4.44-11.47 9.32-.02 4.18 4.48 5.39 7.64 6.76 3.68 1.6 15.99 7.37 19 7.5 1.84.44 4.14.01 6 0l-1 1.78 1 1c-1.39.78-1.99.78-2.99 2.29-1.26 1.91-3.9 18.34-4.42 21.71-.4 2.62-1.12 6.17 1.01 8.26 3.12 3.06 15.28 2.29 14.73-5.26-.43-5.92-7.44-15.26-7.33-23 2.29 5.39 6.28 10.25 9.71 15 1.28 1.78 3.44 4.99 5.46 5.87 5.21 2.27 12.89-7.52 9.8-12.48-1.4-2.26-5.57-3.61-7.97-4.69l-17-7.7 20 3.54c2.23.24 6.56 1.23 8.57 0 3.86-2.03 3.46-15.11-2.67-15.78-4.64-.51-18.42 7.77-25.9 8.24 5.14-2.52 11.27-7 16-10.43 1.85-1.34 4.98-3.53 5.87-5.66 2.26-5.37-7.46-13.16-12.38-9.88-1.71 1.14-3.32 5.06-4.19 6.97l-7.3 16 2.41-17zm-133.62 38.6l5.53 6.4 9.68 17-20.68-.57-5.65-6.43L167 156l21.79.6zM289 156l-8.81 15-6.37 7.98L268 180h-39l-7.79-1.02-5.53-6.98-9.68-16h83z",
            })),
        );
      }
      var mr = e.forwardRef(fr);
      n.p;
      var hr,
        gr = function (e) {
          var t,
            n = ge().trainType,
            r = (function (e, t) {
              return (
                "1" === e.travelClass ||
                "BAR" === e["@type"] ||
                ("2" === e.travelClass && t === T.IC)
              );
            })(e.coach, n)
              ? ""
              : "hide-coach-number";
          switch (e.coach["@type"]) {
            case "PASSENGER":
              t = e.coach.decks.sort(Un.topFirst()).map(function (t, n) {
                return (0, ce.jsx)(
                  "div",
                  {
                    className: "deck-container",
                    children: (0, ce.jsx)(sr, {
                      deck: t,
                      travelClass: e.coach.travelClass,
                    }),
                  },
                  n,
                );
              });
              break;
            case "BAR":
              t = (0, ce.jsx)("div", {
                className: "bar-coach",
                children: (0, ce.jsx)(mr, {}),
              });
              break;
            default:
              t = (0, ce.jsx)(ce.Fragment, {});
          }
          return (0, ce.jsx)(Qt, {
            styles:
              ".coach-wrapper{display:flex;flex-direction:column;-webkit-box-orient:vertical;-webkit-box-direction:normal;padding:0 .1em;height:4em;width:2.8em}.coach-wrapper .coach-number{text-align:center;color:var(--ternary-color)}.coach-wrapper .coach-number.hide-coach-number{opacity:0}.coach-wrapper .coach-content{display:flex;flex:1;flex-direction:column;height:calc(100% - 1em);line-height:1}.coach-wrapper .coach-content .bar-coach{overflow:hidden;height:2.5em;width:100%;text-align:center}.coach-wrapper .coach-content .bar-coach svg{fill:var(--ternary-color);opacity:.7;max-height:100%;max-width:100%}.coach-wrapper .coach-content .deck-container{display:flex;flex-direction:column;flex:1}",
            children: (0, ce.jsxs)("div", {
              className: "coach-wrapper",
              children: [
                (0, ce.jsx)("div", {
                  className: "coach-number ".concat(r),
                  "aria-hidden": "true",
                  children: e.coach.number,
                }),
                (0, ce.jsx)("div", { className: "coach-content", children: t }),
              ],
            }),
          });
        },
        vr = ["title", "titleId"];
      function br() {
        return (
          (br = Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }),
          br.apply(this, arguments)
        );
      }
      function yr(e, t) {
        if (null == e) return {};
        var n,
          r,
          a = (function (e, t) {
            if (null == e) return {};
            var n,
              r,
              a = {},
              o = Object.keys(e);
            for (r = 0; r < o.length; r++)
              (n = o[r]), t.indexOf(n) >= 0 || (a[n] = e[n]);
            return a;
          })(e, t);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          for (r = 0; r < o.length; r++)
            (n = o[r]),
              t.indexOf(n) >= 0 ||
                (Object.prototype.propertyIsEnumerable.call(e, n) &&
                  (a[n] = e[n]));
        }
        return a;
      }
      function xr(t, n) {
        var r = t.title,
          a = t.titleId,
          o = yr(t, vr);
        return e.createElement(
          "svg",
          br({ viewBox: "0 0 196 146", ref: n, "aria-labelledby": a }, o),
          r ? e.createElement("title", { id: a }, r) : null,
          hr ||
            (hr = e.createElement("path", {
              stroke: "none",
              d: "M55 4c14.12.02 23.29 6.09 35 13.2 20.09 12.2 46.74 33.81 64 49.89 10.46 9.75 31.37 30.88 36.52 43.91 1.8 4.55 1.73 8.31.58 13-3.37 13.81-14.05 17.98-27.1 18H4V4h51zm44 62.86c1.74.13 4.34.17 5.98 0 2.09-.88 3.81-2.01 4.83-3.97 2.88-5.54-4.13-11.05-7.81-14.14-6.17-5.16-22.6-16.84-30-18.96-3.75-1.08-9.02-.79-13-.79v37.86h40z",
            })),
        );
      }
      var wr = e.forwardRef(xr);
      n.p;
      var kr = function () {
          var e = ge().carriages,
            t =
              e.length && e[0].motorCoachNumber > 1
                ? (0, ce.jsx)("div", {
                    className: "engine-wrapper left",
                    children: (0, ce.jsx)(wr, {}),
                  })
                : (0, ce.jsx)(ce.Fragment, {});
          return (0, ce.jsx)(Qt, {
            styles:
              ".train-composition{display:flex;flex:1;justify-content:center;line-height:1.5em}.train-composition .content{display:flex}.train-composition .content .pao-train-direction{margin-top:1.5em;height:2.7em;width:3.8em}.train-composition .content .carriage-wrapper{-webkit-box-flex:1;flex:1;-webkit-box-pack:center;justify-content:center;-webkit-transition-delay:.25s;transition-delay:.25s;-webkit-transition-duration:4s;transition-duration:4s;-webkit-transition-property:margin-left;transition-property:margin-left;-webkit-transition-timing-function:ease-out;transition-timing-function:ease-out;display:flex}.train-composition .content .carriage-wrapper .engine-wrapper{margin-top:1.5em;height:2.7em;width:3.8em}.train-composition .content .carriage-wrapper .engine-wrapper svg{opacity:.4;fill:var(--ternary-color);height:2.5em;width:100%}.train-composition .content .carriage-wrapper .engine-wrapper.left svg{transform:scaleX(-1)}",
            children: (0, ce.jsx)("div", {
              className: "train-composition",
              children: (0, ce.jsxs)("div", {
                className: "content",
                children: [
                  e.map(function (e, n) {
                    return (0, ce.jsxs)(
                      "div",
                      {
                        className: "carriage-wrapper",
                        children: [
                          t,
                          e.coaches
                            .sort(function (e, t) {
                              return e.number - t.number;
                            })
                            .map(function (e, t) {
                              return (0, ce.jsx)(gr, { coach: e }, t);
                            }),
                          (0, ce.jsx)("div", {
                            className: "engine-wrapper",
                            children: (0, ce.jsx)(wr, {}),
                          }),
                        ],
                      },
                      n,
                    );
                  }),
                  (0, ce.jsx)(Vn, {}),
                ],
              }),
            }),
          });
        },
        Sr = function () {
          var e = ge().terms;
          return (0, ce.jsxs)(ce.Fragment, {
            children: [
              (0, ce.jsx)(ye, {
                id: "summaryLabel",
                text: e["paoSeatmapUi.summary"],
              }),
              (0, ce.jsx)(qn, {
                id: "summaryDescription",
                displayPassengerStats: !0,
              }),
            ],
          });
        },
        Cr = function () {
          var e = ge().terms;
          return (0, ce.jsx)(ye, {
            id: "PaoMainAriaDescriptor",
            text: e["paoSeatmapUi.choosePhrase"],
          });
        };
      var Er = function (e) {
          var t = ge().trainType;
          return (0, ce.jsx)(Qt, {
            styles:
              ".pao-layout-classic{height:100%;width:100%;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}@media(max-width: 639px){.summary{display:none}}@media(max-height: 360px){.summary{display:none}}.seatmap-content{display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center}.seatmap-content header{display:flex;flex-direction:column}@media(max-width: 639px){.seatmap-content header{flex-direction:column-reverse;min-width:7em}}.seatmap-content header .button-legend{margin:auto auto .8em auto}@media(min-width: 640px){.seatmap-content header .button-legend{display:none}}@media(max-width: 639px){.seatmap-content header .travel-space-wrapper{height:4.2em;padding:0;display:flex}}@media(min-width: 640px){.seatmap-content{-webkit-box-flex:1;flex:1;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-pack:center;justify-content:center;max-height:31.5em;height:calc(100% - 5.2em)}}@media(max-height: 360px){.seatmap-content{height:calc(100% - 5.2em)}}@media(max-width: 639px){.seatmap-content{-webkit-box-flex:1;flex:1;-webkit-box-orient:horizontal;-webkit-box-direction:reverse;flex-direction:row-reverse;max-height:calc(100% - 4.6em)}}.seatmap-footer{display:-webkit-box;display:flex}@media(max-width: 639px){.seatmap-footer{-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;height:4.6em}}@media(min-width: 640px){.seatmap-footer{-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row}}@media(min-width: 640px){.seatmap-footer{height:5.2em}}@media(max-height: 360px){.seatmap-footer{height:5.2em}}.action-buttons{height:100%}@media(min-width: 640px){.action-buttons{margin-left:auto}}@media(max-width: 639px){.action-buttons{width:100%}}.seat-selector{background-color:#fff}@media(min-width: 640px){.seat-selector{-webkit-box-flex:1;flex:1;max-height:18.6em;height:calc(100% - 12.9em)}.seat-selector.long-and-narrow{max-height:13.6em}}@media(max-width: 639px){.seat-selector{overflow-x:hidden;overflow-y:scroll;width:18.6em}.seat-selector.long-and-narrow{width:13.6em}}.pao-deck-grid-container{height:100%;display:-webkit-box;display:flex}@media(min-width: 640px){.pao-deck-grid-container{max-height:18.6em}}@media(max-width: 639px){.pao-deck-grid-container{height:90.6em}}@media(max-width: 639px){.pao-legend{display:none}}@media(min-width: 640px){.pao-legend{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center}}@media screen and (min-width: 640px)and (min-width: 640px)and (max-width: 43em){.pao-legend{font-size:.9em}}",
            scoped: !1,
            children: (0, ce.jsxs)("div", {
              className: "pao-layout-classic",
              children: [
                (0, ce.jsx)(Cr, {}),
                (0, ce.jsxs)("section", {
                  className: "summary",
                  "aria-describedby": "summaryDescription",
                  children: [(0, ce.jsx)(Sr, {}), (0, ce.jsx)(kr, {})],
                }),
                (0, ce.jsxs)("div", {
                  className: "seatmap-content",
                  children: [
                    (0, ce.jsxs)("header", {
                      children: [
                        (0, ce.jsx)("div", {
                          className: "button-legend",
                          children: (0, ce.jsx)(ir, { iconDisplay: !1 }),
                        }),
                        (0, ce.jsx)(Zn, {}),
                        (0, ce.jsx)("section", {
                          className: "travel-space-wrapper",
                          children: (0, ce.jsx)(lr, {}),
                        }),
                      ],
                    }),
                    (0, ce.jsx)("section", {
                      className: "seat-selector ".concat(
                        t === T.IC ? "long-and-narrow" : "",
                      ),
                      children: (0, ce.jsx)("div", {
                        className: "pao-deck-grid-container",
                        children: (0, ce.jsx)(Rn, {}),
                      }),
                    }),
                  ],
                }),
                (0, ce.jsxs)("div", {
                  className: "seatmap-footer",
                  children: [
                    (0, ce.jsx)("section", {
                      className: "pao-legend",
                      children: (0, ce.jsx)(rr, { isVerticalDisplay: !1 }),
                    }),
                    (0, ce.jsx)("section", {
                      className: "action-buttons",
                      children: (0, ce.jsx)(Yn, {
                        cancelSelection: e.cancelSelection,
                        validateSelection: e.validateSelection,
                        darkNegativeButton: !1,
                      }),
                    }),
                  ],
                }),
              ],
            }),
          });
        },
        Or = {
          POWER_PLUG: (0, ce.jsx)(bn, {}),
          SOLO: (0, ce.jsx)(Sn, {}),
          default: (0, ce.jsx)(ce.Fragment, {}),
        },
        Ar = Object.keys(Or),
        jr = function (e) {
          var t = e.placing;
          if (
            void 0 === t ||
            void 0 === t.seat ||
            void 0 === t.seat.ancillaryServices ||
            0 === t.seat.ancillaryServices.length
          )
            return (0, ce.jsx)(ce.Fragment, {});
          var n = t.seat.ancillaryServices.find(function (e) {
            return Ar.includes(e.type);
          });
          return (void 0 !== n && Or[n.type]) || (0, ce.jsx)(ce.Fragment, {});
        };
      function Lr(e) {
        var t =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Nr,
          n = arguments.length > 2 ? arguments[2] : void 0,
          r = arguments.length > 3 ? arguments[3] : void 0;
        switch (e.key) {
          case nn.ArrowLeft:
          case nn.ArrowUp:
            e.stopPropagation(), e.preventDefault(), t(e.currentTarget, !1);
            break;
          case nn.ArrowDown:
          case nn.ArrowRight:
            e.stopPropagation(), e.preventDefault(), t(e.currentTarget, !0);
            break;
          case nn.Enter:
          case nn.Space:
            e.stopPropagation(), e.preventDefault(), n();
            break;
          case nn.Delete:
          case nn.Backspace:
            e.stopPropagation(), e.preventDefault(), r();
        }
      }
      function Nr(e, t) {
        var n;
        null !== (n = e.getAttribute("class")) &&
        void 0 !== n &&
        n.includes("delete-button-enabled")
          ? Pr(e, t)
          : Tr(e, t);
      }
      function Tr(e, t) {
        var n = e;
        t || (n = Dr(e, !1));
        var r = n.querySelector(".delete-button-enabled");
        if (r) r.focus();
        else {
          var a = Dr(e, t);
          a && a.focus();
        }
      }
      function Pr(e, t) {
        var n = e.closest(".pao-pax-item"),
          r = n;
        t && (r = Dr(n, !0)), r && r.focus();
      }
      function Dr(e, t) {
        var n,
          r,
          a,
          o,
          i = e.parentElement,
          l = t ? i.nextElementSibling : i.previousElementSibling;
        return l
          ? l.firstElementChild
          : t
            ? null === (a = i.parentNode) ||
              void 0 === a ||
              null === (o = a.firstElementChild) ||
              void 0 === o
              ? void 0
              : o.firstElementChild
            : null === (n = i.parentNode) ||
                void 0 === n ||
                null === (r = n.lastElementChild) ||
                void 0 === r
              ? void 0
              : r.firstElementChild;
      }
      var zr,
        Mr = ["title", "titleId"];
      function Ir() {
        return (
          (Ir = Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }),
          Ir.apply(this, arguments)
        );
      }
      function Rr(e, t) {
        if (null == e) return {};
        var n,
          r,
          a = (function (e, t) {
            if (null == e) return {};
            var n,
              r,
              a = {},
              o = Object.keys(e);
            for (r = 0; r < o.length; r++)
              (n = o[r]), t.indexOf(n) >= 0 || (a[n] = e[n]);
            return a;
          })(e, t);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          for (r = 0; r < o.length; r++)
            (n = o[r]),
              t.indexOf(n) >= 0 ||
                (Object.prototype.propertyIsEnumerable.call(e, n) &&
                  (a[n] = e[n]));
        }
        return a;
      }
      function Fr(t, n) {
        var r = t.title,
          a = t.titleId,
          o = Rr(t, Mr);
        return e.createElement(
          "svg",
          Ir(
            {
              viewBox: "0 0 13 13",
              xmlns: "http://www.w3.org/2000/svg",
              xmlnsXlink: "http://www.w3.org/1999/xlink",
              ref: n,
              "aria-labelledby": a,
            },
            o,
          ),
          r ? e.createElement("title", { id: a }, r) : null,
          zr ||
            (zr = e.createElement(
              "g",
              { transform: "translate(-11, -36)" },
              e.createElement("path", {
                d: "M15.6680526,39.0069082 C15.6133599,39.0057392 15.5572493,39.0086617 15.5017464,39.0228841 C14.948743,39.1598482 14.6353744,39.2126465 14.1891229,39.5502834 C13.9952678,39.7156923 13.9810883,39.8618133 14.0134987,39.9831911 C14.0157269,39.9931273 14.0260578,40.0315084 14.0402373,40.0845016 L14.0380091,40.0856706 L15.0554949,43.8748795 L15.0603565,43.8737106 C15.0895259,44.2641458 15.4219357,44.5758705 15.8373972,44.5815205 L17.4159891,44.6043154 C18.2768919,44.6010033 19.2358363,44.7184846 19.4779019,44.8535003 C19.6559569,45.0666421 19.9717563,45.9764887 20.1623703,46.8327575 C20.1686498,46.8635404 20.4512285,48.3715087 20.4512285,48.3715087 C20.5280007,48.7859078 20.942652,49.0621738 21.374724,48.9879444 C21.8074036,48.912546 22.0946413,48.5152918 22.016451,48.0999186 L21.7259723,46.5461656 C21.7243518,46.5393466 21.721921,46.5313587 21.7211107,46.5233708 C21.6808002,46.3429601 21.6200306,46.0894889 21.5416378,45.8064039 C22.02111,46.1477425 22.4744513,46.49025 22.7047681,46.6683228 C23.0464959,46.9330939 23.54744,46.8818542 23.8229289,46.5529846 C24.0998358,46.2243098 24.0459534,45.7436693 23.7034154,45.4787033 C23.6329226,45.4239566 21.9562891,44.1260128 21.0208423,43.6293963 C20.3159148,43.254937 18.5995785,43.1123229 18.0893164,43.0780332 C18.0751368,43.0764746 18.0591341,43.0764746 18.0449545,43.0756952 L17.4103173,43.0667332 L16.9245655,41.259509 C17.9714233,41.7185237 19.2026156,41.7526186 20.3118635,41.2727573 C20.6205731,41.1393002 20.7583176,40.7923116 20.6197629,40.4953938 C20.4820184,40.1998398 20.1188187,40.0673568 19.8111219,40.2010088 C18.5473166,40.746527 17.0550176,40.3471297 16.2646076,39.2514173 C16.1260529,39.0604859 15.8918873,38.9737875 15.6680526,39.0069082 Z M14.8755294,38.9527198 C15.6774953,38.7452407 16.1590882,37.9270294 15.9519366,37.1260315 C15.7447851,36.3231976 14.9274321,35.8416808 14.1245475,36.0475533 C13.3225816,36.2545734 12.840759,37.0714076 13.0481402,37.8724055 C13.2552918,38.6752394 14.0733338,39.1581333 14.8755294,38.9527198 Z M15.2410721,46.5734413 C15.914759,46.8257387 16.6132454,46.969002 17.3176986,46.9993854 C17.6796212,47.015154 17.9841135,46.7255505 17.9994034,46.3536426 C18.0146932,45.9807732 17.7342545,45.666363 17.3723319,45.6517482 C16.8019449,45.6269415 16.2360329,45.5109847 15.6896995,45.3058008 C12.1426343,43.9739321 12.1935384,39.5746887 12.3807462,37.7449558 C12.418598,37.3742017 12.1579242,37.0428691 11.7980527,37.0038322 C11.438927,36.9644108 11.1163479,37.2336305 11.0784961,37.604 C10.6216644,42.0697791 12.1782485,45.4229114 15.2410721,46.5734413 Z",
              }),
            )),
        );
      }
      var Ur = e.forwardRef(Fr);
      n.p;
      var Hr,
        Br = function (e) {
          var t = e.pax,
            n = ge(),
            r = n.terms,
            a = n.passengers,
            o = be(),
            i = o.placings,
            l = o.currentPassenger,
            c = me(),
            s = (null === l || void 0 === l ? void 0 : l.rank) === t.rank,
            u = l ? s : null !== a && t.rank === a[0].rank,
            d = i.find(function (e) {
              var n;
              return (
                (null === (n = e.passenger) || void 0 === n
                  ? void 0
                  : n.rank) === t.rank
              );
            }),
            p = void 0 !== d,
            f = Gn.sumExtrasFromPlacing(d),
            m = Gn.extractFirstCurrency(d),
            h = function () {
              s ||
                (c(J.selectCurrentPassenger(t)),
                p
                  ? (console.log(d), c(J.seatGetFocusBySystem(d.seat)))
                  : c(J.seatGetFocusBySystem(null)));
            },
            g = function () {
              p && (c(J.selectCurrentPassenger(t)), c(J.removePlacing(t)));
            };
          var v,
            b,
            y = "aria_label_delete_".concat(t.rank),
            x = "aria_label_pax_".concat(t.rank);
          return (0, ce.jsx)(Qt, {
            styles:
              ".pao-pax-item{cursor:pointer;border-radius:5px;border-color:var(--primary-color);border-width:1px;border-style:solid;margin-top:0;background-color:#fff;color:var(--ternary-color);font-size:1.4em;box-shadow:3px 3px 3px 0 rgba(0,0,0,.14);padding:2px 10px;margin-left:10px;margin-right:10px;margin-bottom:5px;min-width:10em}@media(max-width: 639px){.pao-pax-item{min-height:64px}}@media(max-width: 420px){.pao-pax-item{box-shadow:5px 5px 3px 0 rgba(0,0,0,.14);padding:3px 10px;margin-left:0;margin-right:0;margin-bottom:18px;width:7em}}.pao-pax-item:focus{outline-offset:-0.4em;outline:2px dashed var(--primary-color)}.pao-pax-item:focus.selected{outline-color:currentColor}.pao-pax-item:focus.with-placing{outline-color:currentColor}.pao-pax-item svg{fill:var(--primary-color)}.pao-pax-item .pao-pax-item-header{width:100%;margin-bottom:5px;flex:auto;display:flex;flex-direction:row}@media(max-width: 420px){.pao-pax-item .pao-pax-item-header{text-align:center;display:flex;flex-direction:column}}.pao-pax-item .pao-pax-item-header span{padding-right:5px}.pao-pax-item .pao-pax-item-header .pax-title{display:flex;flex-direction:row}@media(max-width: 420px){.pao-pax-item .pao-pax-item-header .pax-title{justify-content:center}}.pao-pax-item .pao-pax-item-header .pax-title .pax-rank{color:var(--primary-color)}@media(max-width: 420px){.pao-pax-item .pao-pax-item-header .pax-dash{display:none}}.pao-pax-item .pao-pax-item-placing{flex:auto;display:flex;justify-content:center;flex-direction:row;line-height:1.5}.pao-pax-item .pao-pax-item-placing .icon-with-text{display:flex;justify-content:left;flex-direction:row;color:var(--primary-color)}.pao-pax-item .pao-pax-item-placing .icon-with-text-icon{margin-right:.2em;margin-left:.1em}@media(max-width: 420px){.pao-pax-item .pao-pax-item-placing .icon-with-text-icon{margin-left:0}}.pao-pax-item .pao-pax-item-placing .icon-with-text-icon svg{width:1.5em;height:1.5em}.pao-pax-item .pao-pax-item-placing .pao-pax-item-icons{width:85%;display:flex;flex-direction:row}@media(max-width: 420px){.pao-pax-item .pao-pax-item-placing .pao-pax-item-icons{flex-direction:column}}@media(min-width: 640px){.pao-pax-item .pao-pax-item-placing .pao-pax-item-icons .seat-number{width:47%}}.pao-pax-item .pao-pax-item-placing .pao-pax-item-icons .seat-number .absent-seat-dash{margin-left:.5em}.pao-pax-item .pao-pax-item-placing .pao-pax-item-icons .seat-number .seat-icon{width:30%}.pao-pax-item .pao-pax-item-placing .pao-pax-item-icons .seat-number .seat-selected-number{width:70%;padding-left:.3em}@media(max-width: 420px){.pao-pax-item .pao-pax-item-placing .pao-pax-item-icons .seat-number .seat-selected-number{padding-left:0}}@media(min-width: 640px){.pao-pax-item .pao-pax-item-placing .pao-pax-item-icons .ancillary-services{width:53%}}.pao-pax-item .pao-pax-item-placing .remove-placing{width:15%;text-align:right}@media(max-width: 639px){.pao-pax-item .pao-pax-item-placing .remove-placing{display:flex;align-items:center}}.pao-pax-item .pao-pax-item-placing .remove-placing svg{width:1.5em;height:1.5em}.pao-pax-item .pao-pax-item-placing .remove-placing .delete-button-disabled{cursor:not-allowed}.pao-pax-item .pao-pax-item-placing .remove-placing .delete-button-disabled svg{fill:var(--secondary-color)}.pao-pax-item .pao-pax-item-placing .remove-placing .delete-button-enabled{cursor:pointer}.pao-pax-item .pao-pax-item-placing .remove-placing .delete-button-enabled:focus{outline-offset:.1em;outline:2px dashed currentColor}.pao-pax-item.selected{background-color:var(--primary-highlighted-color);border-color:var(--primary-highlighted-color);color:#fff}@media(max-width: 639px){.pao-pax-item.selected{display:flex;flex-direction:column}}.pao-pax-item.selected svg{fill:#fff}.pao-pax-item.selected .pax-title{display:flex;flex-direction:row}@media(max-width: 639px){.pao-pax-item.selected .pax-title{justify-content:center}}.pao-pax-item.selected .pax-title .pax-rank{color:#fff}.pao-pax-item.selected .icon-with-text{color:#fff}.pao-pax-item.selected .delete-button-disabled svg{fill:var(--secondary-color-disabled-border)}.pao-pax-item.with-placing{background-color:var(--primary-color);border-color:var(--primary-color);color:#fff}@media(max-width: 639px){.pao-pax-item.with-placing{display:flex;flex-direction:column}}.pao-pax-item.with-placing svg{fill:#fff}.pao-pax-item.with-placing .pax-title{display:flex;flex-direction:row}@media(max-width: 639px){.pao-pax-item.with-placing .pax-title{justify-content:center}}.pao-pax-item.with-placing .pax-title .pax-rank{color:#fff}.pao-pax-item.with-placing .icon-with-text{color:#fff}",
            children: (0, ce.jsxs)("div", {
              className: "pao-pax-item "
                .concat(s ? "selected" : "", " ")
                .concat(p && !s ? "with-placing" : ""),
              "data-idx":
                ((v = a),
                (b = t),
                null === v || void 0 === v
                  ? void 0
                  : v.findIndex(function (e) {
                      return e.rank === b.rank;
                    })),
              tabIndex: u ? 0 : -1,
              role: "checkbox",
              "aria-hidden": !1,
              "aria-checked": s,
              "aria-labelledby": we.getLabel(x),
              onKeyDown: function (e) {
                !(function (e, t, n) {
                  Lr(e, Tr, t, n);
                })(e, h, g);
              },
              onClick: h,
              children: [
                (0, ce.jsx)(xe, {
                  id: x,
                  label:
                    r["paoSeatmapUi.paoPaxSelector.passengerLabel"] +
                    " " +
                    t.rank +
                    ", " +
                    r["paoSeatmapUi.paoPaxSelector.paxType." + t.type] +
                    (d
                      ? ", " +
                        r["paoSeatmapUi.paoDeckgrid.paoSeat.seatLabels"] +
                        " " +
                        d.seat.seatNumber
                      : "") +
                    (p ? ", " + f + " " + m : "") +
                    ". ",
                }),
                (0, ce.jsxs)("div", {
                  className: "pao-pax-item-header",
                  "aria-hidden": !0,
                  children: [
                    (0, ce.jsxs)("div", {
                      className: "pax-title",
                      children: [
                        (0, ce.jsx)("span", {
                          children:
                            r["paoSeatmapUi.paoPaxSelector.passengerLabel"],
                        }),
                        (0, ce.jsx)("span", {
                          className: "pax-rank",
                          children: t.rank,
                        }),
                      ],
                    }),
                    (0, ce.jsx)("span", {
                      className: "pax-dash",
                      children: "-",
                    }),
                    (0, ce.jsx)("span", {
                      children:
                        r[
                          "paoSeatmapUi.paoPaxSelector.paxType.".concat(t.type)
                        ],
                    }),
                  ],
                }),
                (0, ce.jsxs)("div", {
                  className: "pao-pax-item-placing",
                  "aria-hidden": !0,
                  children: [
                    (0, ce.jsxs)("div", {
                      className: "pao-pax-item-icons",
                      "aria-hidden": !0,
                      children: [
                        (0, ce.jsxs)("div", {
                          className: "seat-number icon-with-text",
                          children: [
                            (0, ce.jsx)("div", {
                              className: "seat-icon icon-with-text-icon",
                              children: (0, ce.jsx)(Ur, {}),
                            }),
                            p
                              ? (0, ce.jsx)("div", {
                                  className: "seat-selected-number",
                                  children:
                                    null === d || void 0 === d
                                      ? void 0
                                      : d.seat.seatNumber,
                                })
                              : (0, ce.jsx)("div", {
                                  className: "absent-seat-dash",
                                  children: "-",
                                }),
                          ],
                        }),
                        (0, ce.jsxs)("div", {
                          className: "ancillary-services icon-with-text",
                          children: [
                            (0, ce.jsx)("div", {
                              className: "icon-with-text-icon",
                              children: (0, ce.jsx)(jr, { placing: d }),
                            }),
                            (0, ce.jsx)("div", {
                              children: p
                                ? "+"
                                    .concat(f, " ")
                                    .concat(
                                      r["paoSeatmapUi.currency.".concat(m)],
                                    )
                                : "",
                            }),
                          ],
                        }),
                      ],
                    }),
                    (0, ce.jsx)("div", {
                      className: "remove-placing",
                      children: (0, ce.jsxs)("div", {
                        tabIndex: -1,
                        role: "button",
                        onClick: function (e) {
                          p &&
                            (c(J.selectCurrentPassenger(t)),
                            c(J.removePlacing(t)),
                            e.preventDefault());
                        },
                        onKeyDown: function (e) {
                          !(function (e, t, n) {
                            Lr(e, Pr, t, n);
                          })(e, g, g);
                        },
                        className: "delete-button".concat(
                          p ? "-enabled" : "-disabled",
                        ),
                        "aria-labelledby": we.getLabel(y),
                        children: [
                          (0, ce.jsx)(xe, {
                            id: y,
                            label: r["paoSeatmapUi.paoLegend.deleteSeat"],
                          }),
                          (0, ce.jsx)(er, {}),
                        ],
                      }),
                    }),
                  ],
                }),
              ],
            }),
          });
        },
        Vr = ["title", "titleId"];
      function Wr() {
        return (
          (Wr = Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }),
          Wr.apply(this, arguments)
        );
      }
      function Zr(e, t) {
        if (null == e) return {};
        var n,
          r,
          a = (function (e, t) {
            if (null == e) return {};
            var n,
              r,
              a = {},
              o = Object.keys(e);
            for (r = 0; r < o.length; r++)
              (n = o[r]), t.indexOf(n) >= 0 || (a[n] = e[n]);
            return a;
          })(e, t);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          for (r = 0; r < o.length; r++)
            (n = o[r]),
              t.indexOf(n) >= 0 ||
                (Object.prototype.propertyIsEnumerable.call(e, n) &&
                  (a[n] = e[n]));
        }
        return a;
      }
      function Gr(t, n) {
        var r = t.title,
          a = t.titleId,
          o = Zr(t, Vr);
        return e.createElement(
          "svg",
          Wr(
            {
              viewBox: "0 0 11 17",
              xmlns: "http://www.w3.org/2000/svg",
              xmlnsXlink: "http://www.w3.org/1999/xlink",
              ref: n,
              "aria-labelledby": a,
            },
            o,
          ),
          void 0 === r
            ? e.createElement("title", { id: a }, "fleche")
            : r
              ? e.createElement("title", { id: a }, r)
              : null,
          Hr ||
            (Hr = e.createElement(
              "g",
              {
                transform:
                  "translate(-11, -11) rotate(90) translate(0.33,-34.66)",
              },
              e.createElement("path", {
                d: "M20.739728,12.6197633 L27.8174034,21.4238515 C28.1634376,21.8542917 28.0950131,22.4837486 27.6645729,22.8297828 C27.4869619,22.9725657 27.2659098,23.0504019 27.0380225,23.0504019 L12.1070361,23.0504019 C11.5547513,23.0504019 11.1070361,22.6026867 11.1070361,22.0504019 C11.1070361,21.8048884 11.1973542,21.5679542 11.3607834,21.3847391 L19.2140945,12.5806509 C19.5817299,12.1685069 20.213866,12.1324256 20.6260099,12.500061 C20.6671507,12.5367589 20.7051864,12.5767961 20.739728,12.6197633 Z",
              }),
            )),
        );
      }
      var qr = e.forwardRef(Gr);
      n.p;
      function Xr(e, t, n, r) {
        var a = e.current,
          o = t.current,
          i = n.current;
        if (null !== a && null !== o && null !== i) {
          var l = a.scrollHeight > a.scrollWidth;
          _r(a, o, i, a.scrollLeft + 350 * r, l);
        }
      }
      function _r(e, t, n, r, a) {
        var o =
          (a ? e.scrollHeight : e.scrollWidth) -
          (a ? e.clientHeight : e.clientWidth);
        o < 0 && (o = 0);
        var i = Math.max(0, Math.min(o, r));
        a
          ? e.scrollTo({ left: 0, top: i, behavior: "smooth" })
          : e.scrollTo({ left: i, top: 0, behavior: "smooth" }),
          t.classList.toggle("disable", 0 === i),
          n.classList.toggle("disable", i === o);
      }
      var Yr = function () {
        var t = ge(),
          n = t.passengers,
          r = t.terms,
          a = be().currentPassenger,
          o = (0, e.useRef)(null),
          i = (0, e.useRef)(null),
          l = (0, e.useRef)(null);
        return (
          (0, e.useEffect)(
            function () {
              return Xr(o, i, l, 0);
            },
            [n],
          ),
          (0, e.useEffect)(
            function () {
              return (function (e, t, n) {
                var r = e.current,
                  a = t.current,
                  o = n.current;
                if (null === r || null === a || null === o) return;
                var i = r.querySelector("*[aria-checked=true]");
                if (null === i) return;
                var l = i.getAttribute("data-idx");
                if (null === l) return;
                var c = r.scrollHeight > r.scrollWidth,
                  s = c ? i.clientHeight : i.clientWidth,
                  u = s * parseInt(l) - s;
                _r(r, a, o, u, c);
              })(o, i, l);
            },
            [a],
          ),
          (0, ce.jsx)(Qt, {
            styles:
              ".pao-pax-selector{width:100%;height:100%}.pao-pax-selector .pao-pax-selector-header{display:flex;flex-direction:row;color:var(--quaternary-color);align-items:center}@media(min-width: 640px){.pao-pax-selector .pao-pax-selector-header{margin-left:4.5em}}@media(max-width: 639px){.pao-pax-selector .pao-pax-selector-header{height:60px}}.pao-pax-selector .pao-pax-selector-header div{padding-left:5px;font-size:2.2em}.pao-pax-selector .pao-pax-selector-header div.nbPax{font-size:4.2em}@media(max-width: 639px){.pao-pax-selector .pax-selector-passenger{height:calc(100% - 60px)}}.pao-pax-selector .pax-selector-passenger .pax-selector-list-container{scrollbar-width:none}@media(min-width: 640px){.pao-pax-selector .pax-selector-passenger .pax-selector-list-container{overflow-x:scroll;overflow-y:hidden}}@media(max-width: 639px){.pao-pax-selector .pax-selector-passenger .pax-selector-list-container{overflow-x:hidden;overflow-y:scroll}}.pao-pax-selector .pax-selector-passenger .pax-selector-list-container::-webkit-scrollbar{display:none}.pao-pax-selector .pax-selector-passenger .pax-selector-list-container .pax-selector-list{list-style-type:none;display:flex;align-items:center;justify-content:center;line-height:1.5;margin:0}@media(min-width: 640px){.pao-pax-selector .pax-selector-passenger .pax-selector-list-container .pax-selector-list{padding:0;flex-direction:row}}@media(max-width: 639px){.pao-pax-selector .pax-selector-passenger .pax-selector-list-container .pax-selector-list{padding:.8em 0 0;flex-direction:column}}.pao-pax-selector .button-before-container{box-shadow:4px 0px 4px -5px}.pao-pax-selector .button-after-container{box-shadow:-4px 0px 4px -5px}.pao-pax-selector .button-before-container,.pao-pax-selector .button-after-container{position:relative;user-select:none}.pao-pax-selector .button-before-container .button-before,.pao-pax-selector .button-before-container .button-after,.pao-pax-selector .button-after-container .button-before,.pao-pax-selector .button-after-container .button-after{cursor:pointer;position:absolute;top:50%;left:50%;transform:translate(-50%, -65%);height:3.2em;width:3.2em;border-radius:50%;box-shadow:-2px 0 4px}.pao-pax-selector .button-before-container .button-before svg,.pao-pax-selector .button-before-container .button-after svg,.pao-pax-selector .button-after-container .button-before svg,.pao-pax-selector .button-after-container .button-after svg{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);height:50%;width:50%;fill:var(--primary-color)}.pao-pax-selector .button-before-container .button-before svg,.pao-pax-selector .button-after-container .button-before svg{transform:rotate(180deg) translate(50%, 50%)}.pao-pax-selector .button-before-container.disable,.pao-pax-selector .button-after-container.disable{box-shadow:none}.pao-pax-selector .button-before-container.disable .button-before,.pao-pax-selector .button-before-container.disable .button-after,.pao-pax-selector .button-after-container.disable .button-before,.pao-pax-selector .button-after-container.disable .button-after{cursor:not-allowed}.pao-pax-selector .button-before-container.disable .button-before svg,.pao-pax-selector .button-before-container.disable .button-after svg,.pao-pax-selector .button-after-container.disable .button-before svg,.pao-pax-selector .button-after-container.disable .button-after svg{fill:var(--secondary-color)}@media(max-width: 639px){.pax-selector-passenger .button-before-container,.pax-selector-passenger .button-after-container{display:none}.pax-selector-passenger .pax-selector-list-container{height:100%}}@media(min-width: 640px){.pax-selector-passenger{display:flex;flex-direction:row}.pax-selector-passenger .button-before-container{width:4.5em}.pax-selector-passenger .pax-selector-list-container{width:calc(100% - 9em);display:flex}.pax-selector-passenger .button-after-container{width:4.5em}}",
            "aria-hidden": !0,
            children: (0, ce.jsxs)("div", {
              className: "pao-pax-selector",
              children: [
                (0, ce.jsxs)("div", {
                  className: "pao-pax-selector-header",
                  children: [
                    (0, ce.jsx)("div", {
                      className: "nbPax",
                      children: null === n || void 0 === n ? void 0 : n.length,
                    }),
                    (0, ce.jsx)("div", {
                      children:
                        r["paoSeatmapUi.paoPaxSelector.passengersHeaderLabel"],
                    }),
                  ],
                }),
                (0, ce.jsxs)("div", {
                  className: "pax-selector-passenger",
                  children: [
                    (0, ce.jsx)("div", {
                      className: "button-before-container disable",
                      ref: i,
                      children: (0, ce.jsx)("div", {
                        className: "button-before",
                        onClick: function () {
                          return Xr(o, i, l, -1);
                        },
                        children: (0, ce.jsx)(qr, {}),
                      }),
                    }),
                    (0, ce.jsx)("div", {
                      className: "pax-selector-list-container",
                      ref: o,
                      children: (0, ce.jsx)("ul", {
                        className: "pax-selector-list",
                        role: "group",
                        children:
                          null === n || void 0 === n
                            ? void 0
                            : n
                                .sort(function (e, t) {
                                  return e.rank - t.rank;
                                })
                                .map(function (e, t) {
                                  return (0, ce.jsx)(
                                    "li",
                                    {
                                      "data-idx": t,
                                      children: (0, ce.jsx)(Br, { pax: e }),
                                    },
                                    t,
                                  );
                                }),
                      }),
                    }),
                    (0, ce.jsx)("div", {
                      className: "button-after-container disable",
                      ref: l,
                      children: (0, ce.jsx)("div", {
                        className: "button-after",
                        onClick: function () {
                          return Xr(o, i, l, 1);
                        },
                        children: (0, ce.jsx)(qr, {}),
                      }),
                    }),
                  ],
                }),
              ],
            }),
          })
        );
      };
      function Jr(e, t) {
        var n,
          r = (function (e, t) {
            var n,
              r,
              a,
              o = t ? e.nextElementSibling : e.previousElementSibling;
            if (o) return o;
            var i = (function (e, t) {
                var n,
                  r,
                  a = t ? e.nextElementSibling : e.previousElementSibling;
                if (a && !a.className.includes("engine-list-item")) return a;
                var o = e.parentElement,
                  i = (function (e, t) {
                    var n = t ? e.nextElementSibling : e.previousElementSibling;
                    if (n) return n;
                    var r = e.parentElement;
                    return t ? r.firstChild : r.lastChild;
                  })(o, t);
                return t
                  ? null === (n = i.firstChild) || void 0 === n
                    ? void 0
                    : n.nextSibling
                  : null === (r = i.lastChild) || void 0 === r
                    ? void 0
                    : r.previousSibling;
              })(
                null === (n = e.parentElement) ||
                  void 0 === n ||
                  null === (r = n.parentElement) ||
                  void 0 === r
                  ? void 0
                  : r.parentElement,
                t,
              ),
              l =
                null === (a = i.firstElementChild) || void 0 === a
                  ? void 0
                  : a.getElementsByClassName("coach-decks")[0];
            return t ? l.firstElementChild : l.lastChild;
          })(e.parentElement, t),
          a = r.firstChild;
        !(n = a) ||
        (!n.className.includes("coach-button") &&
          !n.className.includes("coach-selected")) ||
        n.className.includes("unavailable") ||
        n.className.includes("full")
          ? Jr(a, t)
          : a.focus();
      }
      var Kr,
        Qr = function (e, t) {
          switch (e.key) {
            case nn.ArrowLeft:
            case nn.ArrowUp:
              Jr(e.target, !1), e.preventDefault();
              break;
            case nn.ArrowRight:
            case nn.ArrowDown:
              !(function (e) {
                Jr(e, !0);
              })(e.target),
                e.preventDefault();
              break;
            case nn.Enter:
            case nn.Space:
              t(), e.preventDefault();
          }
        },
        $r = ["title", "titleId"];
      function ea() {
        return (
          (ea = Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }),
          ea.apply(this, arguments)
        );
      }
      function ta(e, t) {
        if (null == e) return {};
        var n,
          r,
          a = (function (e, t) {
            if (null == e) return {};
            var n,
              r,
              a = {},
              o = Object.keys(e);
            for (r = 0; r < o.length; r++)
              (n = o[r]), t.indexOf(n) >= 0 || (a[n] = e[n]);
            return a;
          })(e, t);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          for (r = 0; r < o.length; r++)
            (n = o[r]),
              t.indexOf(n) >= 0 ||
                (Object.prototype.propertyIsEnumerable.call(e, n) &&
                  (a[n] = e[n]));
        }
        return a;
      }
      function na(t, n) {
        var r = t.title,
          a = t.titleId,
          o = ta(t, $r);
        return e.createElement(
          "svg",
          ea(
            {
              viewBox: "0 0 22 22",
              xmlns: "http://www.w3.org/2000/svg",
              xmlnsXlink: "http://www.w3.org/1999/xlink",
              ref: n,
              "aria-labelledby": a,
            },
            o,
          ),
          void 0 === r
            ? e.createElement("title", { id: a }, "Upper Deck")
            : r
              ? e.createElement("title", { id: a }, r)
              : null,
          Kr ||
            (Kr = e.createElement(
              "g",
              { transform: "translate(-1.0, 1)" },
              e.createElement(
                "g",
                { transform: "translate(1.000000, 3.000000)" },
                e.createElement("path", {
                  d: "M21.5760127,0.0942666667 L16.2862658,0.0942666667 C16.0556835,0.0942666667 15.8685443,0.273466667 15.8685443,0.494266667 L15.8685443,4.57746667 C15.8685443,4.8492 15.6382405,5.06973333 15.3541899,5.06973333 L10.9967975,5.06973333 C10.7662152,5.06973333 10.5790759,5.24893333 10.5790759,5.46973333 L10.5790759,9.64253333 C10.5790759,9.91426667 10.3487722,10.1348 10.0647215,10.1348 L5.70732911,10.1348 C5.47646835,10.1348 5.28960759,10.314 5.28960759,10.5348 L5.28960759,14.7076 C5.28960759,14.9793333 5.0593038,15.1998667 4.77525316,15.1998667 L0.417582278,15.1998667 C0.187,15.1998667 -0.000139240506,15.3790667 -0.000139240506,15.5998667 C-0.000139240506,15.8209333 0.187,15.9998667 0.417582278,15.9998667 L5.70732911,15.9998667 C5.93818987,15.9998667 6.12505063,15.8209333 6.12505063,15.5998667 L6.12505063,11.4273333 C6.12505063,11.1553333 6.35535443,10.9348 6.63940506,10.9348 L10.9967975,10.9348 C11.2276582,10.9348 11.414519,10.7556 11.414519,10.5348 L11.414519,6.36226667 C11.414519,6.09026667 11.6448228,5.86973333 11.9288734,5.86973333 L16.2862658,5.86973333 C16.5171266,5.86973333 16.7039873,5.69053333 16.7039873,5.46973333 L16.7039873,1.3868 C16.7039873,1.1148 16.9345696,0.894266667 17.2186203,0.894266667 L21.5760127,0.894266667 C21.8068734,0.894266667 21.9937342,0.715066667 21.9937342,0.494266667 C21.9937342,0.273466667 21.8068734,0.0942666667 21.5760127,0.0942666667",
                }),
              ),
              e.createElement(
                "g",
                { transform: "translate(3.000000, 1.000000)" },
                e.createElement("path", {
                  d: "M1.12438148,6.67765 L5.16545556,2.48115 C5.23338148,2.41061154 5.34927037,2.45638077 5.35497407,2.55572692 L5.55875185,6.07780385 C5.55304815,6.40276538 5.81023333,6.66849615 6.12678889,6.65745769 C6.42338148,6.64695769 6.65023333,6.37503462 6.65567778,6.06676538 L6.75212222,0.611880769 C6.75393704,0.532188462 6.73993704,0.45115 6.70856667,0.374957692 C6.67123333,0.283419231 6.61238148,0.20615 6.54030741,0.147996154 C6.54030741,0.147726923 6.54030741,0.147457692 6.53978889,0.147457692 C6.51438148,0.126996154 6.4869,0.108957692 6.45864074,0.0933423077 C6.45838148,0.0930730769 6.45812222,0.0930730769 6.45812222,0.0930730769 C6.37904815,0.0502653846 6.2896037,0.0268423077 6.19652963,0.0281334826 C6.19652963,0.0284576923 6.19601111,0.0284576923 6.19575185,0.0281334826 L6.19523333,0.0281334826 C6.19471481,0.0284576923 6.19445556,0.0284576923 6.19393704,0.0281334826 L0.906603704,0.12915 C0.758566667,0.132111538 0.625566667,0.195111538 0.528862963,0.295803846 C0.427492593,0.401342308 0.36552963,0.547803846 0.368381481,0.708803846 C0.373825926,1.02272692 0.624011111,1.27338077 0.926566667,1.26745769 L4.3181963,1.47907308 C4.41386296,1.48526538 4.45793704,1.60561154 4.39027037,1.67588077 L0.365788889,5.85515 C0.163307407,6.06568846 0.130640741,6.40680385 0.3129,6.63618846 C0.521862963,6.89922692 0.89752963,6.91295769 1.12438148,6.67765",
                }),
              ),
            )),
        );
      }
      var ra,
        aa = e.forwardRef(na),
        oa = (n.p, ["title", "titleId"]);
      function ia() {
        return (
          (ia = Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }),
          ia.apply(this, arguments)
        );
      }
      function la(e, t) {
        if (null == e) return {};
        var n,
          r,
          a = (function (e, t) {
            if (null == e) return {};
            var n,
              r,
              a = {},
              o = Object.keys(e);
            for (r = 0; r < o.length; r++)
              (n = o[r]), t.indexOf(n) >= 0 || (a[n] = e[n]);
            return a;
          })(e, t);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          for (r = 0; r < o.length; r++)
            (n = o[r]),
              t.indexOf(n) >= 0 ||
                (Object.prototype.propertyIsEnumerable.call(e, n) &&
                  (a[n] = e[n]));
        }
        return a;
      }
      function ca(t, n) {
        var r = t.title,
          a = t.titleId,
          o = la(t, oa);
        return e.createElement(
          "svg",
          ia(
            {
              viewBox: "0 0 22 22",
              xmlns: "http://www.w3.org/2000/svg",
              xmlnsXlink: "http://www.w3.org/1999/xlink",
              ref: n,
              "aria-labelledby": a,
            },
            o,
          ),
          void 0 === r
            ? e.createElement("title", { id: a }, "Lower Deck")
            : r
              ? e.createElement("title", { id: a }, r)
              : null,
          ra ||
            (ra = e.createElement(
              "g",
              { transform: "translate(21.0, 2) rotate(-270.000000)  " },
              e.createElement(
                "g",
                {
                  transform:
                    "translate(10.000000, 10.000000) scale(-1, 1) rotate(-90.000000) translate(-9.000000, -11.000000) translate(-2.000000, 3.000000)",
                },
                e.createElement("path", {
                  d: "M21.5760127,0.0942666667 L16.2862658,0.0942666667 C16.0556835,0.0942666667 15.8685443,0.273466667 15.8685443,0.494266667 L15.8685443,4.57746667 C15.8685443,4.8492 15.6382405,5.06973333 15.3541899,5.06973333 L10.9967975,5.06973333 C10.7662152,5.06973333 10.5790759,5.24893333 10.5790759,5.46973333 L10.5790759,9.64253333 C10.5790759,9.91426667 10.3487722,10.1348 10.0647215,10.1348 L5.70732911,10.1348 C5.47646835,10.1348 5.28960759,10.314 5.28960759,10.5348 L5.28960759,14.7076 C5.28960759,14.9793333 5.0593038,15.1998667 4.77525316,15.1998667 L0.417582278,15.1998667 C0.187,15.1998667 -0.000139240506,15.3790667 -0.000139240506,15.5998667 C-0.000139240506,15.8209333 0.187,15.9998667 0.417582278,15.9998667 L5.70732911,15.9998667 C5.93818987,15.9998667 6.12505063,15.8209333 6.12505063,15.5998667 L6.12505063,11.4273333 C6.12505063,11.1553333 6.35535443,10.9348 6.63940506,10.9348 L10.9967975,10.9348 C11.2276582,10.9348 11.414519,10.7556 11.414519,10.5348 L11.414519,6.36226667 C11.414519,6.09026667 11.6448228,5.86973333 11.9288734,5.86973333 L16.2862658,5.86973333 C16.5171266,5.86973333 16.7039873,5.69053333 16.7039873,5.46973333 L16.7039873,1.3868 C16.7039873,1.1148 16.9345696,0.894266667 17.2186203,0.894266667 L21.5760127,0.894266667 C21.8068734,0.894266667 21.9937342,0.715066667 21.9937342,0.494266667 C21.9937342,0.273466667 21.8068734,0.0942666667 21.5760127,0.0942666667",
                }),
              ),
              e.createElement(
                "g",
                { transform: "translate(0.000000, 1.000000)" },
                e.createElement("path", {
                  d: "M1.12438148,6.67765 L5.16545556,2.48115 C5.23338148,2.41061154 5.34927037,2.45638077 5.35497407,2.55572692 L5.55875185,6.07780385 C5.55304815,6.40276538 5.81023333,6.66849615 6.12678889,6.65745769 C6.42338148,6.64695769 6.65023333,6.37503462 6.65567778,6.06676538 L6.75212222,0.611880769 C6.75393704,0.532188462 6.73993704,0.45115 6.70856667,0.374957692 C6.67123333,0.283419231 6.61238148,0.20615 6.54030741,0.147996154 C6.54030741,0.147726923 6.54030741,0.147457692 6.53978889,0.147457692 C6.51438148,0.126996154 6.4869,0.108957692 6.45864074,0.0933423077 C6.45838148,0.0930730769 6.45812222,0.0930730769 6.45812222,0.0930730769 C6.37904815,0.0502653846 6.2896037,0.0268423077 6.19652963,0.0281334826 C6.19652963,0.0284576923 6.19601111,0.0284576923 6.19575185,0.0281334826 L6.19523333,0.0281334826 C6.19471481,0.0284576923 6.19445556,0.0284576923 6.19393704,0.0281334826 L0.906603704,0.12915 C0.758566667,0.132111538 0.625566667,0.195111538 0.528862963,0.295803846 C0.427492593,0.401342308 0.36552963,0.547803846 0.368381481,0.708803846 C0.373825926,1.02272692 0.624011111,1.27338077 0.926566667,1.26745769 L4.3181963,1.47907308 C4.41386296,1.48526538 4.45793704,1.60561154 4.39027037,1.67588077 L0.365788889,5.85515 C0.163307407,6.06568846 0.130640741,6.40680385 0.3129,6.63618846 C0.521862963,6.89922692 0.89752963,6.91295769 1.12438148,6.67765",
                }),
              ),
            )),
        );
      }
      var sa = e.forwardRef(ca);
      n.p;
      function ua(e, t, n, r, a, o, i) {
        var l = i ? M.DECK_TYPE.UPPER : M.DECK_TYPE.LOWER,
          c = r.decks.find(function (e) {
            return e.deckType === l;
          });
        if (
          !(function (e, t) {
            if (2 === e.decks.length) return !0;
            if (0 === e.decks.length) return !1;
            var n = function (t) {
                return t.coaches.some(function (t) {
                  return t.number === e.number;
                });
              },
              r = t.find(n) || t[0],
              a = e.decks[0];
            return r.coaches
              .flatMap(function (e) {
                return e.decks;
              })
              .some(function (e) {
                return e.deckType !== a.deckType;
              });
          })(r, t)
        )
          return (0, ce.jsx)(ce.Fragment, {});
        var s = i ? "first" : "second",
          u = o ? "coach-selected" : "";
        if (void 0 === c)
          return (0, ce.jsx)("div", {
            className: "deck-button unavailable ".concat(s, " ").concat(u),
            children: i ? (0, ce.jsx)(aa, {}) : (0, ce.jsx)(sa, {}),
          });
        var d = c.available ? "" : "unavailable",
          p = c["@id"] === a["@id"],
          f = p ? "selected" : "",
          m = "deck-".concat(r.number, "-").concat(c.deckType);
        return (0, ce.jsxs)("div", {
          className: "deck-button "
            .concat(d, " ")
            .concat(f, " ")
            .concat(s, " ")
            .concat(u),
          onKeyDown: function (t) {
            return Qr(t, function () {
              return pa(e, a, c);
            });
          },
          tabIndex: -1,
          "aria-hidden": !o,
          role: "checkbox",
          "aria-checked": p,
          "aria-labelledby": we.getLabel(m),
          onClick: function () {
            return pa(e, a, c);
          },
          children: [
            i ? (0, ce.jsx)(aa, {}) : (0, ce.jsx)(sa, {}),
            (0, ce.jsx)(xe, { id: m, label: ma(n, r, c) }),
          ],
        });
      }
      var da = function (e, t, n) {
        n || t.full || e(J.changeSelectedCoach(t));
      };
      function pa(e, t, n) {
        t.deckType !== n.deckType && n.available && e(J.changeSelectedDeck(n));
      }
      function fa(e, t) {
        return (
          e["paoSeatmapUi.paoCoachSelector.coachSelectorLabel"] + " " + t.number
        );
      }
      function ma(e, t, n) {
        return (
          e["paoSeatmapUi.paoCoachSelector.coachSelectorLabel"] +
          " " +
          t.number +
          ", " +
          e["paoSeatmapUi.paoCoachSelector.deckSelectorLabel"] +
          " " +
          e["paoSeatmapUi.paoCoachSelector.deckTypelabels." + n.deckType]
        );
      }
      var ha,
        ga = function (e) {
          var t = e.coach,
            n = be(),
            r = n.currentCoach,
            a = n.currentDeck,
            o = ge(),
            i = o.carriages,
            l = o.terms,
            c = me(),
            s = (null === r || void 0 === r ? void 0 : r.number) === t.number,
            u = "coach".concat(t.number);
          return (0, ce.jsx)(Qt, {
            styles:
              ".coach-decks{list-style-type:none;display:-webkit-box;padding:0;position:relative;z-index:1}@media(min-width: 640px){.coach-decks{-webkit-box-orient:horizontal}}@media(max-width: 639px){.coach-decks{-webkit-box-orient:vertical}}.coach-decks .coach-button{font-size:1.6em;height:2em;width:2em;z-index:10;position:relative}@media screen and (min-width: 640px)and (max-width: 57em){.coach-decks .coach-button{font-size:1.1em}}@media(min-width: 640px){.coach-decks .coach-button{margin:0 1px 0 1px}}@media(max-width: 639px){.coach-decks .coach-button{margin:1px auto 1px auto}}.coach-decks .coach-button span{border-radius:.3em;cursor:pointer;display:block;text-align:center;vertical-align:middle;line-height:calc(2em - 2px);width:calc(2em - 2px);height:calc(2em - 2px);background-color:#fff;border:solid var(--primary-color) 1px;color:var(--primary-color)}.coach-decks .coach-button.full span{cursor:not-allowed;background-color:rgba(var(--secondary-color-rgb), 0.15);border-color:rgba(var(--secondary-color-rgb), 0.4);color:var(--secondary-color);margin:auto}.coach-decks .coach-button.selected span{background-color:var(--primary-color);color:#fff}.coach-decks .coach-button:focus{outline:0}.coach-decks .coach-button:focus span{outline:2px dashed currentColor;outline-offset:-0.3em}@media screen and (min-width: 640px)and (max-width: 57em){.coach-decks .coach-button:focus span{outline:1px dashed currentColor}}.coach-decks .deck-button{height:2.6em;width:2.6em;border-radius:.4em;border:solid var(--primary-color) 1px;cursor:pointer;color:var(--primary-color);padding:.2em;position:relative;z-index:2;visibility:hidden;opacity:0;transition:visibility 0s .75s,opacity .75s linear,margin .5s;--animation-distance: -3.3em}@media screen and (min-width: 640px)and (max-width: 57em){.coach-decks .deck-button{height:1.7em;width:1.7em;padding:.13em;--animation-distance: -2.2em}}@media(min-width: 640px){.coach-decks .deck-button.first{margin:auto var(--animation-distance) auto 0}}@media(max-width: 639px){.coach-decks .deck-button.first{margin:0 auto var(--animation-distance) auto}}@media(min-width: 640px){.coach-decks .deck-button.second{margin:auto 0 auto var(--animation-distance)}}@media(max-width: 639px){.coach-decks .deck-button.second{margin:var(--animation-distance) auto 0 auto}}.coach-decks .deck-button svg{fill:var(--primary-color)}.coach-decks .deck-button.unavailable{cursor:not-allowed;background-color:rgba(var(--secondary-color-rgb), 0.15);border-color:rgba(var(--secondary-color-rgb), 0.4)}.coach-decks .deck-button.unavailable svg{fill:var(--secondary-color)}.coach-decks .deck-button.coach-selected{visibility:visible;opacity:1;transition:opacity .5s linear,margin .5s}@media(min-width: 640px){.coach-decks .deck-button.coach-selected.first{margin-left:.5em;margin-right:0}.coach-decks .deck-button.coach-selected.second{margin-left:0;margin-right:.5em}}@media(max-width: 639px){.coach-decks .deck-button.coach-selected.first{margin-top:.5em;margin-bottom:0}.coach-decks .deck-button.coach-selected.second{margin-top:0;margin-bottom:.5em}}.coach-decks .deck-button.selected{background-color:var(--primary-color)}.coach-decks .deck-button.selected svg{fill:#fff}.coach-decks .deck-button:focus{outline-offset:-0.4em;outline:2px dashed var(--primary-color)}@media screen and (min-width: 640px)and (max-width: 57em){.coach-decks .deck-button:focus{outline-offset:-0.3em;outline:1px dashed var(--primary-color)}}.coach-decks .deck-button:focus.selected{outline-color:#fff}.coach-decks .deck-button:focus.unavailable{outline-color:var(--secondary-color)}",
            children: (0, ce.jsx)("div", {
              children: (0, ce.jsxs)("ul", {
                className: "coach-decks",
                children: [
                  (0, ce.jsx)("li", {
                    className: "coach-list-item",
                    children: ua(c, i, l, t, a, s, !0),
                  }),
                  (0, ce.jsx)("li", {
                    className: "coach-list-item",
                    children: (0, ce.jsxs)("div", {
                      className: "coach-button "
                        .concat(s ? "selected" : "", " ")
                        .concat(t.full ? "full" : ""),
                      tabIndex: s ? 0 : -1,
                      role: "tab",
                      "aria-labelledby": we.getLabel(u),
                      onKeyDown: function (e) {
                        return Qr(e, function () {
                          return da(c, t, s);
                        });
                      },
                      onClick: function () {
                        return da(c, t, s);
                      },
                      children: [
                        (0, ce.jsx)("span", {
                          "aria-hidden": "true",
                          children: t.number,
                        }),
                        (0, ce.jsx)(xe, { id: u, label: fa(l, t) }),
                      ],
                    }),
                  }),
                  (0, ce.jsx)("li", {
                    className: "coach-list-item",
                    children: ua(c, i, l, t, a, s, !1),
                  }),
                ],
              }),
            }),
          });
        },
        va = ["title", "titleId"];
      function ba() {
        return (
          (ba = Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }),
          ba.apply(this, arguments)
        );
      }
      function ya(e, t) {
        if (null == e) return {};
        var n,
          r,
          a = (function (e, t) {
            if (null == e) return {};
            var n,
              r,
              a = {},
              o = Object.keys(e);
            for (r = 0; r < o.length; r++)
              (n = o[r]), t.indexOf(n) >= 0 || (a[n] = e[n]);
            return a;
          })(e, t);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          for (r = 0; r < o.length; r++)
            (n = o[r]),
              t.indexOf(n) >= 0 ||
                (Object.prototype.propertyIsEnumerable.call(e, n) &&
                  (a[n] = e[n]));
        }
        return a;
      }
      function xa(t, n) {
        var r = t.title,
          a = t.titleId,
          o = ya(t, va);
        return e.createElement(
          "svg",
          ba(
            {
              viewBox: "0 0 51 30",
              xmlns: "http://www.w3.org/2000/svg",
              ref: n,
              "aria-labelledby": a,
            },
            o,
          ),
          void 0 === r
            ? e.createElement("title", { id: a }, "Voiture Motrice")
            : r
              ? e.createElement("title", { id: a }, r)
              : null,
          ha ||
            (ha = e.createElement(
              "g",
              {
                fillRule: "evenodd",
                transform: "rotate(-90) translate(-29, 1)",
              },
              e.createElement(
                "g",
                { transform: "translate(7.922156, 0.180449)" },
                e.createElement("path", {
                  d: "M11.9723725,2.35106108 C10.0249892,1.01456407 7.88776766,0.112905389 6.06332455,0.112905389 C4.23448024,0.112905389 2.09139042,1.01896527 0.140486228,2.36074371 C0.769270659,2.49483353 5.83358204,3.49507904 11.9723725,2.35106108",
                }),
              ),
              e.createElement(
                "g",
                { transform: "translate(0.000000, 2.527754)" },
                e.createElement("path", {
                  d: "M16.6098263,32.9322251 L22.3005749,21.7790036 L23.5123713,33.7259078 C23.5123713,33.7259078 20.2276108,33.1540455 16.6098263,32.9322251 L16.6098263,32.9322251 Z M11.0446587,37.0056802 L16.8741916,37.0056802 L16.8741916,35.1785964 L11.0446587,35.1785964 L11.0446587,37.0056802 Z M4.57988623,32.5296623 L13.2998323,15.4386383 C13.532509,15.4310096 13.7619581,15.4266084 13.9855389,15.4266084 C14.0007964,15.4266084 14.0166407,15.4269018 14.0321916,15.4269018 L14.5130958,15.4342371 C14.6433713,15.4377581 14.7757006,15.4430395 14.9086168,15.4486144 L5.68165269,33.5328419 C4.9178982,33.6452192 4.45841317,33.7259078 4.45841317,33.7259078 L4.57988623,32.5296623 Z M6.22534731,16.3068479 C6.22534731,16.3068479 7.79598802,15.9975904 9.76068263,15.7458419 L5.4190479,24.254824 L6.22534731,16.3068479 Z M7.65133533,14.1813629 C7.65133533,14.3327641 7.52868862,14.4554108 7.37728743,14.4554108 C7.22588623,14.4554108 7.10294611,14.3327641 7.10294611,14.1813629 C7.10294611,14.0299617 7.22588623,13.9070216 7.37728743,13.9070216 C7.52868862,13.9070216 7.65133533,14.0299617 7.65133533,14.1813629 L7.65133533,14.1813629 Z M5.97447904,5.44821317 C6.31513174,4.61433293 7.39430539,4.43300359 7.82591617,4.39896766 C8.25723353,4.36493174 10.090479,4.39896766 10.090479,4.39896766 L10.090479,6.4977521 C10.090479,6.4977521 8.03981437,6.54029701 7.35792216,6.4977521 C6.9245509,6.47075808 5.63382635,6.28209341 5.97447904,5.44821317 L5.97447904,5.44821317 Z M10.6582335,13.9070216 C10.6714371,13.9070216 10.6822934,13.9125964 10.6949102,13.9146503 L10.4619401,14.3714946 C10.4141138,14.3222012 10.3838922,14.255303 10.3838922,14.1813629 C10.3838922,14.0299617 10.5068323,13.9070216 10.6582335,13.9070216 L10.6582335,13.9070216 Z M11.4621856,6.49951257 L11.7555988,6.49951257 L11.7555988,4.40072814 L11.4621856,4.40072814 L11.4621856,6.49951257 Z M12.6502156,6.49951257 L12.9436287,6.49951257 L12.9436287,4.40072814 L12.6502156,4.40072814 L12.6502156,6.49951257 Z M13.8388323,6.49951257 L14.1322455,6.49951257 L14.1322455,4.40072814 L13.8388323,4.40072814 L13.8388323,6.49951257 Z M14.3872216,14.1813629 C14.3872216,14.3327641 14.2642814,14.4554108 14.1128802,14.4554108 C14.0093054,14.4554108 13.9221617,14.3955545 13.875509,14.3107581 L14.0776707,13.9140635 C14.0897006,13.9125964 14.1005569,13.9070216 14.1128802,13.9070216 C14.2642814,13.9070216 14.3872216,14.0299617 14.3872216,14.1813629 L14.3872216,14.1813629 Z M14.9796228,6.49951257 L15.2730359,6.49951257 L15.2730359,4.40072814 L14.9796228,4.40072814 L14.9796228,6.49951257 Z M16.1204132,6.49951257 L16.4138263,6.49951257 L16.4138263,4.40072814 L16.1204132,4.40072814 L16.1204132,6.49951257 Z M17.4137784,13.9070216 C17.5651796,13.9070216 17.6881198,14.0299617 17.6881198,14.1813629 C17.6881198,14.3327641 17.5651796,14.4554108 17.4137784,14.4554108 C17.2623772,14.4554108 17.1397305,14.3327641 17.1397305,14.1813629 C17.1397305,14.0299617 17.2623772,13.9070216 17.4137784,13.9070216 L17.4137784,13.9070216 Z M17.6881198,4.40072814 C17.6881198,4.40072814 19.5216587,4.36669222 19.952976,4.40072814 C20.3842934,4.43476407 21.4634671,4.61638683 21.8044132,5.45026707 C22.1450659,6.28414731 20.8540479,6.47251856 20.4206766,6.49951257 C19.7390778,6.54205749 17.6881198,6.49951257 17.6881198,6.49951257 L17.6881198,4.40072814 Z M20.4206766,14.1813629 C20.4206766,14.0299617 20.5436168,13.9070216 20.695018,13.9070216 C20.8464192,13.9070216 20.9690659,14.0299617 20.9690659,14.1813629 C20.9690659,14.3327641 20.8464192,14.4554108 20.695018,14.4554108 C20.5436168,14.4554108 20.4206766,14.3327641 20.4206766,14.1813629 L20.4206766,14.1813629 Z M13.9855389,32.8456683 C11.3213473,32.8456683 8.49343114,33.150818 6.61676048,33.4016862 L15.7521796,15.4970275 C18.6537425,15.7053509 21.7454371,16.3068479 21.7454371,16.3068479 L22.0461856,19.2726683 L15.1122455,32.8635665 C14.7346228,32.8524168 14.3578802,32.8456683 13.9855389,32.8456683 L13.9855389,32.8456683 Z M27.6292515,16.9728958 C27.3405329,14.2303629 26.3487964,8.74705749 25.3332934,6.18262635 C24.4932515,4.06154251 22.3639521,1.70807545 19.9318503,0.030045509 L19.952976,0.142422754 C17.7509102,0.55525509 15.6846946,0.692865868 13.9086647,0.692865868 C10.3815449,0.692865868 7.99844311,0.149758084 7.96294012,0.141835928 L7.97907784,0.0717101796 C5.57220958,1.7470994 3.47078443,4.07914731 2.63749102,6.18262635 C1.62169461,8.74705749 0.630251497,14.2303629 0.341532934,16.9728958 C-0.426916168,24.2791772 0.341532934,46.3593988 0.341532934,46.3593988 L13.9855389,46.3593988 L27.6292515,46.3593988 C27.6292515,46.3593988 28.397994,24.2791772 27.6292515,16.9728958 L27.6292515,16.9728958 Z",
                }),
              ),
            )),
        );
      }
      var wa = e.forwardRef(xa);
      n.p;
      var ka = function () {
        var e = ge().carriages;
        return void 0 === e
          ? (0, ce.jsx)(ce.Fragment, {})
          : (0, ce.jsx)(Qt, {
              styles:
                ".pao-coach-deck-selector{overflow-x:hidden;height:100%;margin:auto}@media(min-width: 640px){.pao-coach-deck-selector{padding-bottom:.5em}}@media(max-width: 639px){.pao-coach-deck-selector{overflow-y:scroll;padding-right:.5em;padding-left:.5em;scrollbar-width:none}.pao-coach-deck-selector::-webkit-scrollbar{display:none}}.pao-coach-deck-selector .carriage-list{list-style-type:none;display:-webkit-box;padding:0;--engineCoachLength:5.4em;--engineCoachWidth:3.2em}@media screen and (min-width: 640px)and (max-width: 57em){.pao-coach-deck-selector .carriage-list{--engineCoachLength: 3.6em;--engineCoachWidth: 2.13em}}@media(min-width: 640px){.pao-coach-deck-selector .carriage-list{-webkit-box-orient:horizontal}}@media(max-width: 639px){.pao-coach-deck-selector .carriage-list{-webkit-box-orient:vertical}}@media(min-width: 640px){.pao-coach-deck-selector .carriage-list .engine-list-item{height:var(--engineCoachWidth);width:var(--engineCoachLength)}}@media(max-width: 639px){.pao-coach-deck-selector .carriage-list .engine-list-item{margin:auto;height:var(--engineCoachLength);width:var(--engineCoachWidth)}}.pao-coach-deck-selector .carriage-list .engine-list-item .train-engine-svg{margin-right:.2em;position:relative}@media(min-width: 640px){.pao-coach-deck-selector .carriage-list .engine-list-item .train-engine-svg{height:var(--engineCoachWidth);width:var(--engineCoachLength)}}@media(max-width: 639px){.pao-coach-deck-selector .carriage-list .engine-list-item .train-engine-svg{height:var(--engineCoachLength);width:var(--engineCoachWidth)}}.pao-coach-deck-selector .carriage-list .engine-list-item .train-engine-svg svg{position:absolute;fill:var(--ternary-color);opacity:.3}@media(min-width: 640px){.pao-coach-deck-selector .carriage-list .engine-list-item .train-engine-svg svg{top:0;left:0;height:var(--engineCoachWidth);width:var(--engineCoachLength)}}@media(max-width: 639px){.pao-coach-deck-selector .carriage-list .engine-list-item .train-engine-svg svg{top:50%;left:50%;width:var(--engineCoachLength);height:var(--engineCoachWidth)}}@media(min-width: 640px){.pao-coach-deck-selector .carriage-list .engine-list-item .train-engine-left svg{transform:rotate(0)}}@media(max-width: 639px){.pao-coach-deck-selector .carriage-list .engine-list-item .train-engine-left svg{transform:translate(-50%, -50%) rotate(90deg)}}@media(min-width: 640px){.pao-coach-deck-selector .carriage-list .engine-list-item .train-engine-right svg{transform:rotate(180deg)}}@media(max-width: 639px){.pao-coach-deck-selector .carriage-list .engine-list-item .train-engine-right svg{transform:translate(-50%, -50%) rotate(270deg)}}.pao-coach-deck-selector .carriage-list .carriage{list-style-type:none;display:-webkit-box;padding:0;position:relative}@media(min-width: 640px){.pao-coach-deck-selector .carriage-list .carriage{-webkit-box-orient:horizontal}}@media(max-width: 639px){.pao-coach-deck-selector .carriage-list .carriage{-webkit-box-orient:vertical}}",
              children: (0, ce.jsx)("div", {
                className: "pao-coach-deck-selector",
                children: (0, ce.jsx)("ul", {
                  className: "carriage-list",
                  role: "tablist",
                  children: e.map(function (e, t) {
                    return (0, ce.jsxs)(
                      "ul",
                      {
                        className: "carriage",
                        children: [
                          (0, ce.jsx)("li", {
                            className: "engine-list-item train-engine-left",
                            children: (0, ce.jsx)("div", {
                              className: "train-engine-svg train-engine-left",
                              children: (0, ce.jsx)(wa, {}),
                            }),
                          }),
                          e.coaches.map(function (e) {
                            return (0, ce.jsx)(
                              "li",
                              { children: (0, ce.jsx)(ga, { coach: e }) },
                              e.number,
                            );
                          }),
                          (0, ce.jsx)("li", {
                            className: "engine-list-item",
                            children: (0, ce.jsx)("div", {
                              className: "train-engine-svg train-engine-right",
                              children: (0, ce.jsx)(wa, {}),
                            }),
                          }),
                        ],
                      },
                      t,
                    );
                  }),
                }),
              }),
            });
      };
      var Sa = function () {
        var e = be(),
          t = e.currentCoach,
          n = e.currentDeck,
          r = ge(),
          a = r.terms;
        var o = r.carriages
            .flatMap(function (e) {
              return e.coaches;
            })
            .some(function (e) {
              return 2 === e.decks.length;
            })
            ? " - " + a["paoSeatmapUi.paoDeckgrid.label." + n.deckType]
            : "",
          i = ""
            .concat(a["paoSeatmapUi.paoCoachSelector.coachSelectorLabel"], " ")
            .concat(t.number)
            .concat(o);
        return (0, ce.jsx)(Qt, {
          styles:
            ".deck-label-container{width:100%}@media(max-width: 639px){.deck-label-container{height:4em;background-color:var(--primary-color);position:relative}}.deck-label{width:100%;font-size:1.4em;word-break:break-word;text-align:center}@media(min-width: 640px){.deck-label{padding:0 0 .5em 0;font-weight:bold;color:var(--primary-color)}}@media(max-width: 639px){.deck-label{position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);color:#fff}}",
          children: (0, ce.jsx)("div", {
            className: "deck-label-container",
            children: (0, ce.jsx)("div", {
              className: "deck-label",
              children: i,
            }),
          }),
        });
      };
      var Ca = function (e) {
          return (0, ce.jsx)(Qt, {
            styles:
              ".pao-layout-with-passengers{height:100%;width:100%;padding:0;margin:0;display:-webkit-box;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;list-style-type:none}@media(min-width: 640px){.pao-layout-with-passengers{padding-top:.5em;overflow-y:auto;overflow-x:hidden}}@media(max-width: 639px){.pao-layout-with-passengers{overflow-y:hidden}}@media(min-width: 640px){.seatmap-content-list-item{height:100%;min-height:32em}}@media(max-width: 639px){.seatmap-content-list-item{height:calc(100% - 4.6em)}}.pao-layout-with-passengers{display:flex;flex-direction:column}.pao-layout-with-passengers .seatmap-content{height:100%}.pao-layout-with-passengers .seatmap-footer{height:4.6em}.seatmap-content{display:flex}@media(min-width: 640px){.seatmap-content{flex-direction:column}.seatmap-content .seat-selector{flex:auto}}@media(max-width: 639px){.seatmap-content{flex-direction:row}.seatmap-content .deck-selector{order:2}.seatmap-content .seat-selector{flex:auto;order:1}.seatmap-content .passanger-selector{order:3}}.seatmap-content .deck-selector{display:flex}.seatmap-content .seat-selector{display:flex}.seatmap-content .passanger-selector{display:flex}.summary{display:none}@media(min-width: 640px){.deck-selector{flex-direction:row}.deck-selector .button-legend{order:2;display:flex;flex:initial;margin-top:1em;margin-right:.7em}.deck-selector .coach-deck-selector{order:1;display:flex;flex:auto}}@media(max-width: 639px){.deck-selector{flex-direction:column}.deck-selector .button-legend{height:2.5em;padding:.5em 0;margin:0 auto}.deck-selector .coach-deck-selector{height:calc(100% - 3.5em)}}@media(max-width: 639px){.seat-selector{overflow-x:hidden;overflow-y:scroll;scrollbar-width:none;width:18.6em;height:100%}.seat-selector::-webkit-scrollbar{display:none}}.seat-selector{flex-direction:column}.seat-selector .pao-deck-grid-container{display:flex;flex:auto}@media(min-width: 640px){.pao-deck-grid-container{max-height:24em}}@media(max-width: 639px){.seatmap-footer{z-index:10;box-shadow:0 2px 15px rgba(0,0,0,.5)}}.action-buttons{width:100%;height:100%}",
            scoped: !1,
            children: (0, ce.jsxs)("ul", {
              className: "pao-layout-with-passengers",
              children: [
                (0, ce.jsx)(Cr, {}),
                (0, ce.jsx)("section", {
                  className: "summary",
                  "aria-describedby": "summaryDescription",
                  children: (0, ce.jsx)(Sr, {}),
                }),
                (0, ce.jsx)("li", {
                  className: "seatmap-content-list-item",
                  children: (0, ce.jsxs)("div", {
                    className: "seatmap-content",
                    children: [
                      (0, ce.jsxs)("div", {
                        className: "deck-selector",
                        children: [
                          (0, ce.jsx)("div", {
                            className: "button-legend",
                            children: (0, ce.jsx)(ir, { iconDisplay: !0 }),
                          }),
                          (0, ce.jsx)("section", {
                            className: "coach-deck-selector",
                            children: (0, ce.jsx)(ka, {}),
                          }),
                        ],
                      }),
                      (0, ce.jsxs)("div", {
                        className: "seat-selector",
                        children: [
                          (0, ce.jsx)("section", {
                            className: "deck-label-wrapper",
                            children: (0, ce.jsx)(Sa, {}),
                          }),
                          (0, ce.jsx)("section", {
                            className: "travel-space-wrapper",
                            children: (0, ce.jsx)(lr, {}),
                          }),
                          (0, ce.jsx)("section", {
                            className: "pao-deck-grid-container",
                            children: (0, ce.jsx)(Rn, {}),
                          }),
                        ],
                      }),
                      (0, ce.jsx)("div", {
                        className: "passanger-selector",
                        children: (0, ce.jsx)(Yr, {}),
                      }),
                    ],
                  }),
                }),
                (0, ce.jsx)("li", {
                  className: "seatmap-footer",
                  children: (0, ce.jsx)("section", {
                    className: "action-buttons",
                    children: (0, ce.jsx)(Yn, {
                      cancelSelection: e.cancelSelection,
                      validateSelection: e.validateSelection,
                      darkNegativeButton: !0,
                    }),
                  }),
                }),
              ],
            }),
          });
        },
        Ea = function (e) {
          return ve().displayPassenger
            ? (0, ce.jsx)(Ca, {
                cancelSelection: e.cancelSelection,
                validateSelection: e.validateSelection,
              })
            : (0, ce.jsx)(Er, {
                cancelSelection: e.cancelSelection,
                validateSelection: e.validateSelection,
              });
        },
        Oa = function () {
          var t = me();
          function n() {
            t(J.changeOrientation(window.innerWidth >= M.VERTICAL_TRESHOLD));
          }
          return (
            (0, e.useEffect)(function () {
              n();
              var e = ["orientationchange", "resize"];
              return (
                e.forEach(function (e) {
                  return window.addEventListener(e, n);
                }),
                function () {
                  e.forEach(function (e) {
                    return window.removeEventListener(e, n);
                  });
                }
              );
            }),
            (0, ce.jsx)(ce.Fragment, {})
          );
        },
        Aa = function (t) {
          var n = me();
          return (
            (0, e.useEffect)(
              function () {
                return n(J.initState(t.seatMapData, t.numberOfPassengers));
              },
              [t, n],
            ),
            (0, ce.jsx)(ce.Fragment, {})
          );
        };
      var ja = function (t) {
        function n(e) {
          e ? t.onClickConfirm() : t.onClickCancel();
        }
        var r = (0, e.useRef)(null),
          a = (0, e.useRef)(null);
        function o(e) {
          return function (t) {
            t.preventDefault();
            if (void 0 !== t) {
              var o = t.key;
              o === nn.Escape && n(!1),
                [nn.Space, nn.Enter].includes(o) && n(e),
                [
                  nn.Tab,
                  nn.ArrowLeft,
                  nn.ArrowRight,
                  nn.ArrowUp,
                  nn.ArrowDown,
                ].includes(o) &&
                  (e && null !== a.current && a.current.focus(),
                  e || null === r.current || r.current.focus());
            }
          };
        }
        (0, e.useEffect)(
          function () {
            var e;
            t.isShown &&
              r.current &&
              r.current !==
                (null === (e = r.current.shadowRoot) || void 0 === e
                  ? void 0
                  : e.activeElement) &&
              r.current.focus();
          },
          [t.isShown],
        );
        var i = "dialogTitle",
          l = "dialogDescription";
        return (0, ce.jsx)(Qt, {
          styles:
            ".confirm-dialog{width:27em}@media(max-width: 639px){.confirm-dialog{max-width:100%}}.confirm-dialog .title{color:var(--primary-color);font-size:2em;margin:.5em 1em .5em 1em}.confirm-dialog .divider{border-bottom:1px solid var(--secondary-color);border-top:0;margin:0}.confirm-dialog .body{padding:0 2em 0 2em;list-style-type:none;display:-webkit-box;-webkit-box-orient:vertical}.confirm-dialog .body .message-wrapper{text-align:left;margin:.5em 0 1.5em 0;padding:0}.confirm-dialog .body .message-wrapper .message{background-color:rgba(var(--ternary-color-rgb), 0.1);padding:1.5em 1.5em 1em 1.5em;border-radius:.5em}.confirm-dialog .body .message-wrapper .message span{color:var(--ternary-color-rgb);font-size:1.4em}.confirm-dialog .body .message-wrapper .message .line{margin:0 0 1em 0}.confirm-dialog .body button{min-height:2em;width:100%;border:0;border-radius:.3em;font-size:1.6em;outline:none;cursor:pointer;background-color:var(--primary-color);color:#fff;margin:0 0 .6em 0;padding:0}.confirm-dialog .body button:focus{outline-offset:-0.3em;outline:1px dashed currentColor}.confirm-dialog .body .negative-button{background-color:var(--ternary-color)}",
          scoped: !1,
          children: (0, ce.jsxs)("div", {
            className: "confirm-dialog",
            "aria-hidden": !1,
            role: "dialog",
            "aria-labelledby": i,
            "aria-describedby": l,
            children: [
              (0, ce.jsx)("div", { className: "title", children: t.title }),
              (0, ce.jsx)(ye, { id: i, text: t.title }),
              (0, ce.jsx)(ye, { id: l, text: t.message }),
              (0, ce.jsx)("hr", { className: "divider" }),
              (0, ce.jsxs)("ul", {
                className: "body",
                role: "group",
                children: [
                  (0, ce.jsx)("div", {
                    className: "message-wrapper",
                    children: (0, ce.jsx)("div", {
                      className: "message",
                      role: "textbox",
                      children: (0, ce.jsx)("span", {
                        children: t.message.split("\n").map(function (e, t) {
                          return (0, ce.jsx)(
                            "p",
                            { className: "line", children: e },
                            t,
                          );
                        }),
                      }),
                    }),
                  }),
                  (0, ce.jsx)("button", {
                    ref: r,
                    tabIndex: 0,
                    onClick: function () {
                      return n(!0);
                    },
                    onKeyDown: o(!0),
                    children: t.confirmButtonText,
                  }),
                  (0, ce.jsx)("button", {
                    className: "negative-button",
                    ref: a,
                    tabIndex: 0,
                    onClick: function () {
                      return n(!1);
                    },
                    onKeyDown: o(!1),
                    children: t.cancelButtonText,
                  }),
                ],
              }),
            ],
          }),
        });
      };
      var La =
          ".error-dialog{width:45em}@media(max-width: 639px){.error-dialog{max-width:100%}}.error-dialog .message{color:var(--ternary-color);font-size:1.4em;opacity:.9;padding:10px;margin-bottom:10px}.error-dialog .action-area{text-align:right;padding:10px;opacity:.9}.error-dialog .action-area button{-webkit-transition:background-color .5s ease;transition:background-color .5s ease;max-height:4em;min-height:2em;padding:0 .625em;border:0;border-radius:.1875em;font-size:1.6em;margin:.1875em;outline:none;cursor:pointer;background-color:var(--primary-color);color:#fff}",
        Na = J.closeErrorDialog(),
        Ta = function () {
          var e = me(),
            t = ve().errorDisplayHandler,
            n = ge().terms,
            r = function () {
              e(Na);
            },
            a = "error";
          if (null === t.confirmEvent)
            return (0, ce.jsx)(Qt, {
              styles: La,
              scoped: !1,
              children: (0, ce.jsxs)("div", {
                "aria-hidden": !1,
                "aria-labelledby": we.getLabel(a),
                role: "dialog",
                children: [
                  (0, ce.jsx)(xe, { id: a, label: n[t.errorId] }),
                  (0, ce.jsx)(or, {
                    show: t.displayError,
                    actionToDispatchOnClose: Na,
                    children: (0, ce.jsx)("div", {
                      className: "error-dialog",
                      children: (0, ce.jsx)("div", {
                        className: "message",
                        children: n[t.errorId],
                      }),
                    }),
                  }),
                ],
              }),
            });
          var o = n[t.errorId + ".header"] || n["paoSeatmapUi.warning.header"],
            i = n[t.errorId],
            l = n[t.errorId + ".confirm"] || n["paoSeatmapUi.warning.confirm"],
            c = n[t.errorId + ".cancel"] || n["paoSeatmapUi.warning.cancel"];
          return (0, ce.jsx)(Qt, {
            styles: La,
            scoped: !1,
            children: (0, ce.jsx)(or, {
              show: t.displayError,
              onBackgroundClick: r,
              displayCloseButton: !1,
              children: (0, ce.jsx)(ja, {
                title: o,
                message: i,
                confirmButtonText: l,
                cancelButtonText: c,
                onClickCancel: r,
                onClickConfirm: function () {
                  null !== t.confirmEvent && e(t.confirmEvent);
                },
                isShown: t.displayError,
              }),
            }),
          });
        };
      function Pa(e) {
        var t =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
          n = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
        if (null === n) return "0, 0, 0";
        var r = Math.round(parseInt(n[1], 16) * t),
          a = Math.round(parseInt(n[2], 16) * t),
          o = Math.round(parseInt(n[3], 16) * t);
        return "".concat(r, ", ").concat(a, ", ").concat(o);
      }
      function Da(e) {
        var t = e.split(", ");
        return (
          "#" +
          (
            (1 << 24) +
            (parseInt(t[0], 10) << 16) +
            (parseInt(t[1], 10) << 8) +
            parseInt(t[2], 10)
          )
            .toString(16)
            .slice(1)
        );
      }
      function za(e) {
        var t =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
          n = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
        if (null === n) return "0, 0, 0";
        var r = Math.round(parseInt(n[1], 16)),
          a = Math.round(parseInt(n[2], 16)) * (1 - t) + 255 * t,
          o = Math.round(parseInt(n[3], 16)) * (1 - t) + 255 * t;
        return ""
          .concat(r * (1 - t) + 255 * t, ", ")
          .concat(a, ", ")
          .concat(o);
      }
      var Ma = function (t) {
          var n = (0, e.useRef)(null);
          if (
            ((0, e.useEffect)(function () {
              return (function (e, t) {
                var n = e.current;
                if (null === n) return;
                var r = M.DEFAULT_COLOR[t.data.trainCategory];
                if (void 0 === r) return;
                var a = t.primaryColor || r.primary,
                  o = t.secondaryColor || r.secondary,
                  i = t.ternaryColor || r.ternary,
                  l = t.quaternaryColor || r.quaternary,
                  c = Pa(a),
                  s = Pa(a, M.COLOR_PRIMARY_BIS_RATIO),
                  u = Pa(o),
                  d = za(o, M.COLOR_SECONDARY_DISABLED_OPACITY),
                  p = za(o, M.COLOR_SECONDARY_DISABLED_BORDER_OPACITY),
                  f = Pa(i),
                  m = Pa(l),
                  h = Da(s),
                  g = Da(d),
                  v = Da(p);
                n.setAttribute(
                  "style",
                  "\n    --primary-color: "
                    .concat(a, ";\n    --primary-highlighted-color: ")
                    .concat(h, ";\n    --secondary-color: ")
                    .concat(o, ";\n    --secondary-color-disabled: ")
                    .concat(g, ";\n    --secondary-color-disabled-border: ")
                    .concat(v, ";\n    --ternary-color: ")
                    .concat(i, ";\n    --quaternary-color: ")
                    .concat(l, ";\n    \n    --primary-color-rgb: ")
                    .concat(c, ";\n    --primary-highlighted-color-rgb: ")
                    .concat(s, ";\n    --secondary-color-rgb: ")
                    .concat(u, ";\n    --ternary-color-rgb: ")
                    .concat(f, ";\n    --quaternary-color-rgb: ")
                    .concat(m, ";\n    "),
                );
              })(n, t);
            }),
            null === t.data)
          )
            return (
              console.log("Donn\xe9es manquantes"), (0, ce.jsx)(ce.Fragment, {})
            );
          console.log("Rendu du composant 'App'."),
            console.debug("props : ", t);
          var r = Number.parseInt(t.numberOfPassengers),
            a = M.TRAIN_TYPES_WITH_PASSENGER_SEATMAP.includes(
              t.data.trainCategory,
            );
          return (0, ce.jsx)(fe, {
            trainType: t.data.trainCategory,
            children: (0, ce.jsx)(Qt, {
              styles:
                '*{box-sizing:inherit;font-family:"avenirRoman",sans-serif}.seatmap{margin:auto;overflow:hidden;position:relative;font-size:62.5%}@media(min-width: 640px){.seatmap{height:calc(95% - 1em);margin:.4rem auto 0 auto;max-width:99%;width:90.6rem;max-height:41.5em}.seatmap.with-passengers{max-height:55em}}@media(max-width: 639px){.seatmap{height:100%;width:auto}}',
              children: (0, ce.jsxs)("div", {
                className: "seatmap ".concat(a ? "with-passengers" : ""),
                ref: n,
                children: [
                  (0, ce.jsx)(Oa, {}),
                  (0, ce.jsx)(Aa, {
                    seatMapData: t.data,
                    numberOfPassengers: r,
                  }),
                  (0, ce.jsx)(Ta, {}),
                  (0, ce.jsx)(Ea, {
                    cancelSelection: function () {
                      return (function (e) {
                        var t = e.current;
                        if (null === t) return;
                        console.log("pao-seatmap-ui-canceled ... ");
                        var n = new CustomEvent("pao-seatmap-ui-canceled", {
                          bubbles: !0,
                          composed: !0,
                        });
                        t.dispatchEvent(n);
                      })(n);
                    },
                    validateSelection: function (e) {
                      return (function (e, t) {
                        var n = e.current;
                        if (null === n) return;
                        console.log("pao-seatmap-ui-selected ... ", {
                          detail: t,
                        });
                        var r = new CustomEvent("pao-seatmap-ui-selected", {
                          bubbles: !0,
                          composed: !0,
                          detail: t,
                        });
                        n.dispatchEvent(r);
                      })(n, e);
                    },
                  }),
                ],
              }),
            }),
          });
        },
        Ia = function () {
          var e = document.getElementsByTagName("head")[0];
          if (null !== document.getElementById("font-pao-seatmap")) return;
          var t = document.createComment("font de pao-seatmap");
          e.append(t);
          var n = document.createElement("style");
          (n.id = "font-pao-seatmap"),
            (n.innerHTML =
              '\n  /******* font de pao-seatmap *******/\n  @font-face {\n    font-family: \'avenirRoman\';\n    src: url("data:application/x-font-woff;charset=utf-8;base64,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") format("woff");\n  }\n  '),
            e.append(n);
        };
      customElements.define(
        "pao-seatmap-ui",
        (function (e, t, n) {
          return A(
            e,
            arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
            {
              mount: function (e, r, a) {
                var o = t.createElement(r, a);
                if ("createRoot" in n) {
                  var i = n.createRoot(e);
                  return (
                    i.render(o), { container: e, root: i, ReactComponent: r }
                  );
                }
                if ("render" in n)
                  return n.render(o, e), { container: e, ReactComponent: r };
                throw new Error("Invalid ReactDOM instance provided.");
              },
              unmount: function (e) {
                var t = e.container,
                  r = e.root;
                r
                  ? r.unmount()
                  : "unmountComponentAtNode" in n &&
                    n.unmountComponentAtNode(t);
              },
              update: function (e, r) {
                var a = e.container,
                  o = e.root,
                  i = e.ReactComponent,
                  l = t.createElement(i, r);
                o ? o.render(l) : "render" in n && n.render(l, a);
              },
            },
          );
        })(
          function (e) {
            return (
              Ia(),
              (0, ce.jsx)(Ma, {
                numberOfPassengers: e.numberOfPassengers,
                primaryColor: e.primaryColor,
                secondaryColor: e.secondaryColor,
                ternaryColor: e.ternaryColor,
                quaternaryColor: e.quaternaryColor,
                data: e.data,
              })
            );
          },
          e,
          r,
          {
            shadow: "open",
            props: {
              numberOfPassengers: "string",
              primaryColor: "string",
              secondaryColor: "string",
              ternaryColor: "string",
              quaternaryColor: "string",
              data: "json",
            },
          },
        ),
      );
    })();
})();
